/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.12.7.0 (NJsonSchema v9.10.6.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput | null): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processIsTenantAvailable(response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>Observable.throw(response_);
        });
    }

    protected processIsTenantAvailable(response: HttpResponse<Blob>): Observable<IsTenantAvailableOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    register(input: RegisterInput | null): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processRegister(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRegister(response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegister(response: HttpResponse<Blob>): Observable<RegisterOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<RegisterOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendPasswordResetCode(input: SendPasswordResetCodeInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendPasswordResetCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendPasswordResetCode(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordInput | null): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processResetPassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processResetPassword(response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>Observable.throw(response_);
        });
    }

    protected processResetPassword(response: HttpResponse<Blob>): Observable<ResetPasswordOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetPasswordOutput.fromJS(resultData200) : new ResetPasswordOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ResetPasswordOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailActivationLink(input: SendEmailActivationLinkInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendEmailActivationLink(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailActivationLink(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activateEmail(input: ActivateEmailInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processActivateEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processActivateEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivateEmail(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    impersonate(input: ImpersonateInput | null): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processImpersonate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processImpersonate(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processImpersonate(response: HttpResponse<Blob>): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processBackToImpersonator(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processBackToImpersonator(response: HttpResponse<Blob>): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    switchToLinkedAccount(input: SwitchToLinkedAccountInput | null): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSwitchToLinkedAccount(response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(response_);
        });
    }

    protected processSwitchToLinkedAccount(response: HttpResponse<Blob>): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<SwitchToLinkedAccountOutput>(<any>null);
    }
}

@Injectable()
export class ActivitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @programingId (optional) 
     * @thematicAreaId (optional) 
     * @responsibleId (optional) 
     * @activityTypeId (optional) 
     * @dayId (optional) 
     * @roomId (optional) 
     * @hasConflict (optional) 
     * @status (optional) 
     * @onTheCalendar (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, programingId: number | null, thematicAreaId: number | null, responsibleId: number | null, activityTypeId: number | null, dayId: number | null, roomId: number | null, hasConflict: boolean | null, status: Status | null, onTheCalendar: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (programingId !== undefined)
            url_ += "ProgramingId=" + encodeURIComponent("" + programingId) + "&"; 
        if (thematicAreaId !== undefined)
            url_ += "ThematicAreaId=" + encodeURIComponent("" + thematicAreaId) + "&"; 
        if (responsibleId !== undefined)
            url_ += "ResponsibleId=" + encodeURIComponent("" + responsibleId) + "&"; 
        if (activityTypeId !== undefined)
            url_ += "ActivityTypeId=" + encodeURIComponent("" + activityTypeId) + "&"; 
        if (dayId !== undefined)
            url_ += "DayId=" + encodeURIComponent("" + dayId) + "&"; 
        if (roomId !== undefined)
            url_ += "RoomId=" + encodeURIComponent("" + roomId) + "&"; 
        if (hasConflict !== undefined)
            url_ += "HasConflict=" + encodeURIComponent("" + hasConflict) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (onTheCalendar !== undefined)
            url_ += "OnTheCalendar=" + encodeURIComponent("" + onTheCalendar) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActivityForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActivityForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetActivityForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetActivityForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetActivityForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetActivityForViewDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @programingId (optional) 
     * @thematicAreaId (optional) 
     * @responsibleId (optional) 
     * @activityTypeId (optional) 
     * @dayId (optional) 
     * @roomId (optional) 
     * @hasConflict (optional) 
     * @status (optional) 
     * @onTheCalendar (optional) 
     * @return Success
     */
    getActivitiesToExcel(filter: string | null, programingId: number | null, thematicAreaId: number | null, responsibleId: number | null, activityTypeId: number | null, dayId: number | null, roomId: number | null, hasConflict: boolean | null, status: Status2 | null, onTheCalendar: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivitiesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (programingId !== undefined)
            url_ += "ProgramingId=" + encodeURIComponent("" + programingId) + "&"; 
        if (thematicAreaId !== undefined)
            url_ += "ThematicAreaId=" + encodeURIComponent("" + thematicAreaId) + "&"; 
        if (responsibleId !== undefined)
            url_ += "ResponsibleId=" + encodeURIComponent("" + responsibleId) + "&"; 
        if (activityTypeId !== undefined)
            url_ += "ActivityTypeId=" + encodeURIComponent("" + activityTypeId) + "&"; 
        if (dayId !== undefined)
            url_ += "DayId=" + encodeURIComponent("" + dayId) + "&"; 
        if (roomId !== undefined)
            url_ += "RoomId=" + encodeURIComponent("" + roomId) + "&"; 
        if (hasConflict !== undefined)
            url_ += "HasConflict=" + encodeURIComponent("" + hasConflict) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (onTheCalendar !== undefined)
            url_ += "OnTheCalendar=" + encodeURIComponent("" + onTheCalendar) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivitiesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivitiesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivitiesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @onTheCalendar (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getActivitiesForSelect(term: string | null, programingId: number, onTheCalendar: boolean | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfActivityListDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivitiesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (programingId === undefined || programingId === null)
            throw new Error("The parameter 'programingId' must be defined and cannot be null.");
        else
            url_ += "ProgramingId=" + encodeURIComponent("" + programingId) + "&"; 
        if (onTheCalendar !== undefined)
            url_ += "OnTheCalendar=" + encodeURIComponent("" + onTheCalendar) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivitiesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivitiesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivitiesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfActivityListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityListDto.fromJS(resultData200) : new ListResultDtoOfActivityListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfActivityListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActivityForView(id: number): Observable<GetActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivityForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityForView(response_);
                } catch (e) {
                    return <Observable<GetActivityForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetActivityForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityForView(response: HttpResponse<Blob>): Observable<GetActivityForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetActivityForViewDto.fromJS(resultData200) : new GetActivityForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetActivityForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActivityForEdit(id: number): Observable<GetActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivityForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityForEdit(response_);
                } catch (e) {
                    return <Observable<GetActivityForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetActivityForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityForEdit(response: HttpResponse<Blob>): Observable<GetActivityForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetActivityForEditOutput.fromJS(resultData200) : new GetActivityForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetActivityForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditActivityDto | null): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Activities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<number> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @participations (optional) 
     * @return Success
     */
    setGuestRolesAsync(participations: CreateOrEditParticipationDto[] | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activities/SetGuestRolesAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(participations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSetGuestRolesAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSetGuestRolesAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetGuestRolesAsync(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activities/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    finishActivity(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activities/FinishActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processFinishActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processFinishActivity(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processFinishActivity(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @term (optional) 
     * @programmingId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getGuestsForSelect(term: string | null, programmingId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfGuestListDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetGuestsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfGuestListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGuestListDto.fromJS(resultData200) : new ListResultDtoOfGuestListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfGuestListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getGuestRolesForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfGuestRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetGuestRolesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestRolesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestRolesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestRoleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestRoleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestRolesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfGuestRoleDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGuestRoleDto.fromJS(resultData200) : new ListResultDtoOfGuestRoleDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfGuestRoleDto>(<any>null);
    }
}

@Injectable()
export class ActivityTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetActivityTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActivityTemplateForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActivityTemplateForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetActivityTemplateForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetActivityTemplateForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetActivityTemplateForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetActivityTemplateForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActivityTemplateForView(id: number): Observable<GetActivityTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetActivityTemplateForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityTemplateForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityTemplateForView(response_);
                } catch (e) {
                    return <Observable<GetActivityTemplateForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetActivityTemplateForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityTemplateForView(response: HttpResponse<Blob>): Observable<GetActivityTemplateForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetActivityTemplateForViewDto.fromJS(resultData200) : new GetActivityTemplateForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetActivityTemplateForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActivityTemplateForEdit(id: number): Observable<GetActivityTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetActivityTemplateForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityTemplateForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityTemplateForEdit(response_);
                } catch (e) {
                    return <Observable<GetActivityTemplateForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetActivityTemplateForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityTemplateForEdit(response: HttpResponse<Blob>): Observable<GetActivityTemplateForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetActivityTemplateForEditOutput.fromJS(resultData200) : new GetActivityTemplateForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetActivityTemplateForEditOutput>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getActivityTemplatesForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfActivityTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetActivityTemplatesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityTemplatesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityTemplatesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityTemplateListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityTemplateListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityTemplatesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfActivityTemplateListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityTemplateListDto.fromJS(resultData200) : new ListResultDtoOfActivityTemplateListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfActivityTemplateListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditActivityTemplateDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ActivityTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetActivityTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActivityTypeForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActivityTypeForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetActivityTypeForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetActivityTypeForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetActivityTypeForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetActivityTypeForViewDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getActivityTypesForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfActivityTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetActivityTypesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityTypesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityTypeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityTypeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityTypesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfActivityTypeListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityTypeListDto.fromJS(resultData200) : new ListResultDtoOfActivityTypeListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfActivityTypeListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActivityTypeForView(id: number): Observable<GetActivityTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetActivityTypeForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityTypeForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityTypeForView(response_);
                } catch (e) {
                    return <Observable<GetActivityTypeForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetActivityTypeForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityTypeForView(response: HttpResponse<Blob>): Observable<GetActivityTypeForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetActivityTypeForViewDto.fromJS(resultData200) : new GetActivityTypeForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetActivityTypeForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActivityTypeForEdit(id: number): Observable<GetActivityTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetActivityTypeForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityTypeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityTypeForEdit(response_);
                } catch (e) {
                    return <Observable<GetActivityTypeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetActivityTypeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityTypeForEdit(response: HttpResponse<Blob>): Observable<GetActivityTypeForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetActivityTypeForEditOutput.fromJS(resultData200) : new GetActivityTypeForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetActivityTypeForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditActivityTypeDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activate(input: ActivateDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processActivate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processActivate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivate(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class AdminActivitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @activityType (optional) 
     * @dateRange_BeginDate (optional) 
     * @dateRange_EndDate (optional) 
     * @jobPositionId (optional) 
     * @userId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, activityType: string | null, dateRange_BeginDate: moment.Moment | null, dateRange_EndDate: moment.Moment | null, jobPositionId: number | null, userId: number | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetAdminActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (activityType !== undefined)
            url_ += "ActivityType=" + encodeURIComponent("" + activityType) + "&"; 
        if (dateRange_BeginDate !== undefined)
            url_ += "DateRange.BeginDate=" + encodeURIComponent(dateRange_BeginDate ? "" + dateRange_BeginDate.toJSON() : "") + "&"; 
        if (dateRange_EndDate !== undefined)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toJSON() : "") + "&"; 
        if (jobPositionId !== undefined)
            url_ += "JobPositionId=" + encodeURIComponent("" + jobPositionId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAdminActivityForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAdminActivityForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetAdminActivityForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAdminActivityForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetAdminActivityForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetAdminActivityForViewDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getActivityTypesForSelect(filter: string | null): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/GetActivityTypesForSelect?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetActivityTypesForSelect(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityTypesForSelect(response: HttpResponse<Blob>): Observable<string[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAdminActivityForView(id: number): Observable<GetAdminActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/GetAdminActivityForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAdminActivityForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAdminActivityForView(response_);
                } catch (e) {
                    return <Observable<GetAdminActivityForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAdminActivityForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAdminActivityForView(response: HttpResponse<Blob>): Observable<GetAdminActivityForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAdminActivityForEditOutput.fromJS(resultData200) : new GetAdminActivityForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetAdminActivityForEditOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAdminActivityForEdit(id: number | null): Observable<GetAdminActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/GetAdminActivityForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAdminActivityForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAdminActivityForEdit(response_);
                } catch (e) {
                    return <Observable<GetAdminActivityForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAdminActivityForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAdminActivityForEdit(response: HttpResponse<Blob>): Observable<GetAdminActivityForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAdminActivityForEditOutput.fromJS(resultData200) : new GetAdminActivityForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetAdminActivityForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditAdminActivityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @activityType (optional) 
     * @dateRange_BeginDate (optional) 
     * @dateRange_EndDate (optional) 
     * @jobPositionId (optional) 
     * @userId (optional) 
     * @return Success
     */
    getAdminActivitiesToExcel(filter: string | null, activityType: string | null, dateRange_BeginDate: moment.Moment | null, dateRange_EndDate: moment.Moment | null, jobPositionId: number | null, userId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/GetAdminActivitiesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (activityType !== undefined)
            url_ += "ActivityType=" + encodeURIComponent("" + activityType) + "&"; 
        if (dateRange_BeginDate !== undefined)
            url_ += "DateRange.BeginDate=" + encodeURIComponent(dateRange_BeginDate ? "" + dateRange_BeginDate.toJSON() : "") + "&"; 
        if (dateRange_EndDate !== undefined)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toJSON() : "") + "&"; 
        if (jobPositionId !== undefined)
            url_ += "JobPositionId=" + encodeURIComponent("" + jobPositionId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAdminActivitiesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAdminActivitiesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAdminActivitiesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @activityType (optional) 
     * @dateRange_BeginDate (optional) 
     * @dateRange_EndDate (optional) 
     * @jobPositionId (optional) 
     * @userId (optional) 
     * @return Success
     */
    getAdminActivitiesToPdf(filter: string | null, activityType: string | null, dateRange_BeginDate: moment.Moment | null, dateRange_EndDate: moment.Moment | null, jobPositionId: number | null, userId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminActivities/GetAdminActivitiesToPdf?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (activityType !== undefined)
            url_ += "ActivityType=" + encodeURIComponent("" + activityType) + "&"; 
        if (dateRange_BeginDate !== undefined)
            url_ += "DateRange.BeginDate=" + encodeURIComponent(dateRange_BeginDate ? "" + dateRange_BeginDate.toJSON() : "") + "&"; 
        if (dateRange_EndDate !== undefined)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toJSON() : "") + "&"; 
        if (jobPositionId !== undefined)
            url_ += "JobPositionId=" + encodeURIComponent("" + jobPositionId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAdminActivitiesToPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAdminActivitiesToPdf(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAdminActivitiesToPdf(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class AnnuitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @yearFilter (optional) 
     * @statusIntegracao (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, yearFilter: number | null, statusIntegracao: StatusIntegracao | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetAnnuityForView> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAnnuityForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAnnuityForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetAnnuityForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAnnuityForView.fromJS(resultData200) : new PagedResultDtoOfGetAnnuityForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetAnnuityForView>(<any>null);
    }

    /**
     * @return Success
     */
    get(id: number): Observable<AnnuityDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<AnnuityDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AnnuityDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: HttpResponse<Blob>): Observable<AnnuityDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnuityDto.fromJS(resultData200) : new AnnuityDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<AnnuityDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @currentAnnuityId (optional) 
     * @return Success
     */
    getAnnuitiesForSelect(term: string | null, currentAnnuityId: number | null): Observable<ListResultDtoOfAnnuityListDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuitiesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (currentAnnuityId !== undefined)
            url_ += "CurrentAnnuityId=" + encodeURIComponent("" + currentAnnuityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnuitiesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAnnuitiesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAnnuityListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAnnuityListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnuitiesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfAnnuityListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAnnuityListDto.fromJS(resultData200) : new ListResultDtoOfAnnuityListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfAnnuityListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAnnuityForEdit(id: number | null): Observable<GetAnnuityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuityForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnuityForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAnnuityForEdit(response_);
                } catch (e) {
                    return <Observable<GetAnnuityForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAnnuityForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnuityForEdit(response: HttpResponse<Blob>): Observable<GetAnnuityForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAnnuityForEditOutput.fromJS(resultData200) : new GetAnnuityForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetAnnuityForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditAnnuityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateAnnuities(input: EntityDtoOfInt32 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GenerateAnnuities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processGenerateAnnuities(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGenerateAnnuities(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processGenerateAnnuities(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @yearFilter (optional) 
     * @statusIntegracao (optional) 
     * @return Success
     */
    getAnnuitiesToExcel(filter: string | null, yearFilter: number | null, statusIntegracao: StatusIntegracao2 | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuitiesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnuitiesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAnnuitiesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnuitiesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAnnuityForPayment(id: number): Observable<AnnuityEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuityForPayment?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnuityForPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAnnuityForPayment(response_);
                } catch (e) {
                    return <Observable<AnnuityEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AnnuityEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnuityForPayment(response: HttpResponse<Blob>): Observable<AnnuityEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnuityEditDto.fromJS(resultData200) : new AnnuityEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<AnnuityEditDto>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment, endDate: moment.Moment, userName: string | null, serviceName: string | null, methodName: string | null, browserInfo: string | null, hasException: boolean | null, minExecutionDuration: number | null, maxExecutionDuration: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAuditLogs(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogs(response: HttpResponse<Blob>): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAuditLogListDto.fromJS(resultData200) : new PagedResultDtoOfAuditLogListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment, endDate: moment.Moment, userName: string | null, serviceName: string | null, methodName: string | null, browserInfo: string | null, hasException: boolean | null, minExecutionDuration: number | null, maxExecutionDuration: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAuditLogsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class BankAccountsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetBankAccountForView> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBankAccountForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBankAccountForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetBankAccountForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetBankAccountForView.fromJS(resultData200) : new PagedResultDtoOfGetBankAccountForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetBankAccountForView>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getBankAccountsForSelect(term: string | null): Observable<ListResultDtoOfBankAccountListDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetBankAccountsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetBankAccountsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBankAccountListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfBankAccountListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBankAccountsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfBankAccountListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfBankAccountListDto.fromJS(resultData200) : new ListResultDtoOfBankAccountListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfBankAccountListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBankAccountForEdit(id: number): Observable<GetBankAccountForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetBankAccountForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetBankAccountForEdit(response_);
                } catch (e) {
                    return <Observable<GetBankAccountForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetBankAccountForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetBankAccountForEdit(response: HttpResponse<Blob>): Observable<GetBankAccountForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetBankAccountForEditOutput.fromJS(resultData200) : new GetBankAccountForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetBankAccountForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBankAccountDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @descriptionFilter (optional) 
     * @bankCodeFilter (optional) 
     * @agencyDigitFilter (optional) 
     * @checkingAccountFilter (optional) 
     * @checkingAccountDigitFilter (optional) 
     * @holderNameFilter (optional) 
     * @cnpjFilter (optional) 
     * @return Success
     */
    getBankAccountsToExcel(filter: string | null, descriptionFilter: string | null, bankCodeFilter: string | null, agencyDigitFilter: string | null, checkingAccountFilter: string | null, checkingAccountDigitFilter: string | null, holderNameFilter: string | null, cnpjFilter: string | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (bankCodeFilter !== undefined)
            url_ += "BankCodeFilter=" + encodeURIComponent("" + bankCodeFilter) + "&"; 
        if (agencyDigitFilter !== undefined)
            url_ += "AgencyDigitFilter=" + encodeURIComponent("" + agencyDigitFilter) + "&"; 
        if (checkingAccountFilter !== undefined)
            url_ += "CheckingAccountFilter=" + encodeURIComponent("" + checkingAccountFilter) + "&"; 
        if (checkingAccountDigitFilter !== undefined)
            url_ += "CheckingAccountDigitFilter=" + encodeURIComponent("" + checkingAccountDigitFilter) + "&"; 
        if (holderNameFilter !== undefined)
            url_ += "HolderNameFilter=" + encodeURIComponent("" + holderNameFilter) + "&"; 
        if (cnpjFilter !== undefined)
            url_ += "CnpjFilter=" + encodeURIComponent("" + cnpjFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetBankAccountsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetBankAccountsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBankAccountsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllCaches(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCaches(response: HttpResponse<Blob>): Observable<ListResultDtoOfCacheDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCacheDto.fromJS(resultData200) : new ListResultDtoOfCacheDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    clearCache(input: EntityDtoOfString | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processClearCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processClearCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCache(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processClearAllCaches(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearAllCaches(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class CalendarsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetCalendarForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCalendarForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCalendarForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetCalendarForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetCalendarForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCalendarForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetCalendarForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCalendarForView(id: number): Observable<GetCalendarForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetCalendarForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCalendarForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCalendarForView(response_);
                } catch (e) {
                    return <Observable<GetCalendarForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCalendarForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCalendarForView(response: HttpResponse<Blob>): Observable<GetCalendarForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCalendarForViewDto.fromJS(resultData200) : new GetCalendarForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCalendarForViewDto>(<any>null);
    }

    /**
     * @calendarId (optional) 
     * @programmingId (optional) 
     * @return Success
     */
    getCalendarForEdit(calendarId: number | null, programmingId: number | null): Observable<GetCalendarForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetCalendarForEdit?";
        if (calendarId !== undefined)
            url_ += "CalendarId=" + encodeURIComponent("" + calendarId) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCalendarForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCalendarForEdit(response_);
                } catch (e) {
                    return <Observable<GetCalendarForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCalendarForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCalendarForEdit(response: HttpResponse<Blob>): Observable<GetCalendarForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCalendarForEditOutput.fromJS(resultData200) : new GetCalendarForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCalendarForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: CreateOrEditCalendarDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCalendarToExcel(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetCalendarToExcel?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCalendarToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCalendarToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCalendarToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @calendarId (optional) 
     * @programmingId (optional) 
     * @return Success
     */
    getCalendarToWord(calendarId: number | null, programmingId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetCalendarToWord?";
        if (calendarId !== undefined)
            url_ += "CalendarId=" + encodeURIComponent("" + calendarId) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCalendarToWord(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCalendarToWord(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCalendarToWord(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCalendarActivityForView(calendarActivityId: number): Observable<GetCalendarActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetCalendarActivityForView?";
        if (calendarActivityId === undefined || calendarActivityId === null)
            throw new Error("The parameter 'calendarActivityId' must be defined and cannot be null.");
        else
            url_ += "calendarActivityId=" + encodeURIComponent("" + calendarActivityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCalendarActivityForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCalendarActivityForView(response_);
                } catch (e) {
                    return <Observable<GetCalendarActivityForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCalendarActivityForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCalendarActivityForView(response: HttpResponse<Blob>): Observable<GetCalendarActivityForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCalendarActivityForViewDto.fromJS(resultData200) : new GetCalendarActivityForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCalendarActivityForViewDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addOrEditActivity(input: CreateOrEditCalendarActivityDto | null): Observable<CreateOrEditCalendarActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/AddOrEditActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddOrEditActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddOrEditActivity(response_);
                } catch (e) {
                    return <Observable<CreateOrEditCalendarActivityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditCalendarActivityOutput>><any>Observable.throw(response_);
        });
    }

    protected processAddOrEditActivity(response: HttpResponse<Blob>): Observable<CreateOrEditCalendarActivityOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditCalendarActivityOutput.fromJS(resultData200) : new CreateOrEditCalendarActivityOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditCalendarActivityOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addActivity(input: CreateOrEditCalendarActivityDto | null): Observable<CreateOrEditCalendarActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/AddActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddActivity(response_);
                } catch (e) {
                    return <Observable<CreateOrEditCalendarActivityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditCalendarActivityOutput>><any>Observable.throw(response_);
        });
    }

    protected processAddActivity(response: HttpResponse<Blob>): Observable<CreateOrEditCalendarActivityOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditCalendarActivityOutput.fromJS(resultData200) : new CreateOrEditCalendarActivityOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditCalendarActivityOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateActivity(input: CreateOrEditCalendarActivityDto | null): Observable<CreateOrEditCalendarActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/UpdateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateActivity(response_);
                } catch (e) {
                    return <Observable<CreateOrEditCalendarActivityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditCalendarActivityOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateActivity(response: HttpResponse<Blob>): Observable<CreateOrEditCalendarActivityOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditCalendarActivityOutput.fromJS(resultData200) : new CreateOrEditCalendarActivityOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditCalendarActivityOutput>(<any>null);
    }

    /**
     * @return Success
     */
    removeActivity(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/RemoveActivity?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processRemoveActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRemoveActivity(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveActivity(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @day (optional) 
     * @programmingId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getEventDaysForSelect(day: moment.Moment | null, programmingId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfEventDayListDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetEventDaysForSelect?";
        if (day !== undefined)
            url_ += "Day=" + encodeURIComponent(day ? "" + day.toJSON() : "") + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventDaysForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventDaysForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventDayListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEventDayListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventDaysForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfEventDayListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEventDayListDto.fromJS(resultData200) : new ListResultDtoOfEventDayListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEventDayListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @programmingId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getEventRoomsForSelect(term: string | null, programmingId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfEventRoomListDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetEventRoomsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventRoomsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventRoomsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventRoomListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEventRoomListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventRoomsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfEventRoomListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEventRoomListDto.fromJS(resultData200) : new ListResultDtoOfEventRoomListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEventRoomListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @day (optional) 
     * @calendarId (optional) 
     * @programmingId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getEventRoomDaysForSelect(term: string | null, day: moment.Moment | null, calendarId: number | null, programmingId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfEventRoomDayListDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendars/GetEventRoomDaysForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (day !== undefined)
            url_ += "Day=" + encodeURIComponent(day ? "" + day.toJSON() : "") + "&"; 
        if (calendarId !== undefined)
            url_ += "CalendarId=" + encodeURIComponent("" + calendarId) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventRoomDaysForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventRoomDaysForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventRoomDayListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEventRoomDayListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventRoomDaysForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfEventRoomDayListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEventRoomDayListDto.fromJS(resultData200) : new ListResultDtoOfEventRoomDayListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEventRoomDayListDto>(<any>null);
    }
}

@Injectable()
export class CategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCategoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfCategoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfCategoryDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfCategoryDto.fromJS(resultData200) : new PagedResultDtoOfCategoryDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfCategoryDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @isExempt (optional) 
     * @isActive (optional) 
     * @withReadmission (optional) 
     * @return Success
     */
    getForSelect(term: string | null, isExempt: boolean | null, isActive: boolean | null, withReadmission: boolean | null): Observable<ListResultDtoOfCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isExempt !== undefined)
            url_ += "IsExempt=" + encodeURIComponent("" + isExempt) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (withReadmission !== undefined)
            url_ += "WithReadmission=" + encodeURIComponent("" + withReadmission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCategoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCategoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfCategoryDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCategoryDto.fromJS(resultData200) : new ListResultDtoOfCategoryDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfCategoryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getForEdit(id: number): Observable<CreateOrEditCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetForEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrEditCategoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditCategoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetForEdit(response: HttpResponse<Blob>): Observable<CreateOrEditCategoryDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditCategoryDto.fromJS(resultData200) : new CreateOrEditCategoryDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditCategoryDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCategoryDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Category/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Category/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class CertificatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    requestPreview(input: GetCertificatePreviewInput | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/RequestPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processRequestPreview(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRequestPreview(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processRequestPreview(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    validate(input: ValidateCertificateInput | null): Observable<ValidateCertificateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/Validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processValidate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processValidate(response_);
                } catch (e) {
                    return <Observable<ValidateCertificateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValidateCertificateOutput>><any>Observable.throw(response_);
        });
    }

    protected processValidate(response: HttpResponse<Blob>): Observable<ValidateCertificateOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValidateCertificateOutput.fromJS(resultData200) : new ValidateCertificateOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ValidateCertificateOutput>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_);
                } catch (e) {
                    return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponse<Blob>): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserChatFriendsWithSettingsOutput.fromJS(resultData200) : new GetUserChatFriendsWithSettingsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetUserChatFriendsWithSettingsOutput>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | null, userId: number, minMessageId: number | null): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserChatMessages(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatMessages(response: HttpResponse<Blob>): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfChatMessageDto.fromJS(resultData200) : new ListResultDtoOfChatMessageDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfChatMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(input: MarkAllUnreadMessagesOfUserAsReadInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class CnabsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @withErrors (optional) 
     * @uploadDateRange_BeginDate (optional) 
     * @uploadDateRange_EndDate (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, withErrors: boolean | null, uploadDateRange_BeginDate: moment.Moment | null, uploadDateRange_EndDate: moment.Moment | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetCnabForView> {
        let url_ = this.baseUrl + "/api/services/app/Cnabs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (withErrors !== undefined)
            url_ += "WithErrors=" + encodeURIComponent("" + withErrors) + "&"; 
        if (uploadDateRange_BeginDate !== undefined)
            url_ += "UploadDateRange.BeginDate=" + encodeURIComponent(uploadDateRange_BeginDate ? "" + uploadDateRange_BeginDate.toJSON() : "") + "&"; 
        if (uploadDateRange_EndDate !== undefined)
            url_ += "UploadDateRange.EndDate=" + encodeURIComponent(uploadDateRange_EndDate ? "" + uploadDateRange_EndDate.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCnabForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCnabForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetCnabForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetCnabForView.fromJS(resultData200) : new PagedResultDtoOfGetCnabForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetCnabForView>(<any>null);
    }

    /**
     * @return Success
     */
    getCnabForEdit(id: number): Observable<GetCnabForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cnabs/GetCnabForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCnabForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCnabForEdit(response_);
                } catch (e) {
                    return <Observable<GetCnabForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCnabForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCnabForEdit(response: HttpResponse<Blob>): Observable<GetCnabForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCnabForEditOutput.fromJS(resultData200) : new GetCnabForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCnabForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCnabDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cnabs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    confirmPayment(input: ConfirmPaymentInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cnabs/ConfirmPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processConfirmPayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfirmPayment(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @withErrors (optional) 
     * @uploadDateRange_BeginDate (optional) 
     * @uploadDateRange_EndDate (optional) 
     * @return Success
     */
    getCnabsToExcel(filter: string | null, withErrors: boolean | null, uploadDateRange_BeginDate: moment.Moment | null, uploadDateRange_EndDate: moment.Moment | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Cnabs/GetCnabsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (withErrors !== undefined)
            url_ += "WithErrors=" + encodeURIComponent("" + withErrors) + "&"; 
        if (uploadDateRange_BeginDate !== undefined)
            url_ += "UploadDateRange.BeginDate=" + encodeURIComponent(uploadDateRange_BeginDate ? "" + uploadDateRange_BeginDate.toJSON() : "") + "&"; 
        if (uploadDateRange_EndDate !== undefined)
            url_ += "UploadDateRange.EndDate=" + encodeURIComponent(uploadDateRange_EndDate ? "" + uploadDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCnabsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCnabsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCnabsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === undefined || onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' must be defined and cannot be null.");
        else
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEditionsForCombobox(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForCombobox(response: HttpResponse<Blob>): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200) : new ListResultDtoOfSubscribableEditionComboboxItemDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindUsersInput | null): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: HttpResponse<Blob>): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetDefaultEditionName(response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDefaultEditionName(response: HttpResponse<Blob>): Observable<GetDefaultEditionNameOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDefaultEditionNameOutput.fromJS(resultData200) : new GetDefaultEditionNameOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class CostCenterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @term (optional) 
     * @isActive (optional) 
     * @filterType (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @return Success
     */
    getCostCenters(term: string | null, isActive: boolean | null, filterType: FilterType | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null): Observable<ListResultDtoOfCostCenterDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetCostCenters?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&"; 
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCostCenters(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCostCenters(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCostCenterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCostCenterDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCostCenters(response: HttpResponse<Blob>): Observable<ListResultDtoOfCostCenterDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCostCenterDto.fromJS(resultData200) : new ListResultDtoOfCostCenterDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfCostCenterDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @paymentChargeType (optional) 
     * @status (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getCostCenterPaymentCharges(id: number, filter: string | null, paymentChargeType: string | null, status: Status3 | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfCostCenterPaymentChargeListDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetCostCenterPaymentCharges?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentChargeType !== undefined)
            url_ += "PaymentChargeType=" + encodeURIComponent("" + paymentChargeType) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCostCenterPaymentCharges(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCostCenterPaymentCharges(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCostCenterPaymentChargeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfCostCenterPaymentChargeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCostCenterPaymentCharges(response: HttpResponse<Blob>): Observable<PagedResultDtoOfCostCenterPaymentChargeListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfCostCenterPaymentChargeListDto.fromJS(resultData200) : new PagedResultDtoOfCostCenterPaymentChargeListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfCostCenterPaymentChargeListDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @paymentChargeType (optional) 
     * @status (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @return Success
     */
    getCostCenterPaymentChargesToExcel(id: number, filter: string | null, paymentChargeType: string | null, status: Status4 | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetCostCenterPaymentChargesToExcel?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentChargeType !== undefined)
            url_ += "PaymentChargeType=" + encodeURIComponent("" + paymentChargeType) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCostCenterPaymentChargesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCostCenterPaymentChargesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCostCenterPaymentChargesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @isActive (optional) 
     * @filterType (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @return Success
     */
    getCostCentersForSelect(term: string | null, isActive: boolean | null, filterType: FilterType2 | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null): Observable<ListResultDtoOfCostCenterListDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetCostCentersForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&"; 
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCostCentersForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCostCentersForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCostCenterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCostCenterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCostCentersForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfCostCenterListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCostCenterListDto.fromJS(resultData200) : new ListResultDtoOfCostCenterListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfCostCenterListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @isActive (optional) 
     * @filterType (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @return Success
     */
    getCostCentersWithLevel(term: string | null, isActive: boolean | null, filterType: FilterType3 | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null): Observable<ListResultDtoOfCostCenterWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetCostCentersWithLevel?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&"; 
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCostCentersWithLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCostCentersWithLevel(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCostCenterWithLevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCostCenterWithLevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCostCentersWithLevel(response: HttpResponse<Blob>): Observable<ListResultDtoOfCostCenterWithLevelDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCostCenterWithLevelDto.fromJS(resultData200) : new ListResultDtoOfCostCenterWithLevelDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfCostCenterWithLevelDto>(<any>null);
    }

    /**
     * @return Success
     */
    removePaymentChargeFromCostCenter(paymentChargeId: number, organizationUnitId: number, removeFromParents: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/RemovePaymentChargeFromCostCenter?";
        if (paymentChargeId === undefined || paymentChargeId === null)
            throw new Error("The parameter 'paymentChargeId' must be defined and cannot be null.");
        else
            url_ += "PaymentChargeId=" + encodeURIComponent("" + paymentChargeId) + "&"; 
        if (organizationUnitId === undefined || organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' must be defined and cannot be null.");
        else
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        if (removeFromParents === undefined || removeFromParents === null)
            throw new Error("The parameter 'removeFromParents' must be defined and cannot be null.");
        else
            url_ += "RemoveFromParents=" + encodeURIComponent("" + removeFromParents) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processRemovePaymentChargeFromCostCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRemovePaymentChargeFromCostCenter(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemovePaymentChargeFromCostCenter(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addPaymentChargeToCostCenter(input: PaymentChargesToCostCenterInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/AddPaymentChargeToCostCenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddPaymentChargeToCostCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddPaymentChargeToCostCenter(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddPaymentChargeToCostCenter(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCostCenter(input: CreateCostCenterInput | null): Observable<CostCenterDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/CreateCostCenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateCostCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateCostCenter(response_);
                } catch (e) {
                    return <Observable<CostCenterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CostCenterDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateCostCenter(response: HttpResponse<Blob>): Observable<CostCenterDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CostCenterDto.fromJS(resultData200) : new CostCenterDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CostCenterDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCostCenter(input: UpdateCostCenterInput | null): Observable<CostCenterDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/UpdateCostCenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCostCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateCostCenter(response_);
                } catch (e) {
                    return <Observable<CostCenterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CostCenterDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCostCenter(response: HttpResponse<Blob>): Observable<CostCenterDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CostCenterDto.fromJS(resultData200) : new CostCenterDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CostCenterDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findPaymentCharges(input: FindCostCenterPaymentChargesInput | null): Observable<PagedResultDtoOfCostCenterPaymentChargeListDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/FindPaymentCharges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processFindPaymentCharges(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processFindPaymentCharges(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCostCenterPaymentChargeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfCostCenterPaymentChargeListDto>><any>Observable.throw(response_);
        });
    }

    protected processFindPaymentCharges(response: HttpResponse<Blob>): Observable<PagedResultDtoOfCostCenterPaymentChargeListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfCostCenterPaymentChargeListDto.fromJS(resultData200) : new PagedResultDtoOfCostCenterPaymentChargeListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfCostCenterPaymentChargeListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activate(input: ActivateDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processActivate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processActivate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivate(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class CouponsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @groupId (optional) 
     * @userId (optional) 
     * @updatedManually (optional) 
     * @used (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, groupId: number | null, userId: number | null, updatedManually: boolean | null, used: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetCouponForView> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (updatedManually !== undefined)
            url_ += "UpdatedManually=" + encodeURIComponent("" + updatedManually) + "&"; 
        if (used !== undefined)
            url_ += "Used=" + encodeURIComponent("" + used) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCouponForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCouponForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetCouponForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetCouponForView.fromJS(resultData200) : new PagedResultDtoOfGetCouponForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetCouponForView>(<any>null);
    }

    /**
     * @return Success
     */
    getCouponForEdit(id: number): Observable<GetCouponForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCouponForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCouponForEdit(response_);
                } catch (e) {
                    return <Observable<GetCouponForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCouponForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCouponForEdit(response: HttpResponse<Blob>): Observable<GetCouponForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCouponForEditOutput.fromJS(resultData200) : new GetCouponForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCouponForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCouponDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @couponGroupId (optional) 
     * @userId (optional) 
     * @updatedManually (optional) 
     * @used (optional) 
     * @return Success
     */
    getCouponsToExcel(filter: string | null, couponGroupId: number | null, userId: number | null, updatedManually: boolean | null, used: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (couponGroupId !== undefined)
            url_ += "CouponGroupId=" + encodeURIComponent("" + couponGroupId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (updatedManually !== undefined)
            url_ += "UpdatedManually=" + encodeURIComponent("" + updatedManually) + "&"; 
        if (used !== undefined)
            url_ += "Used=" + encodeURIComponent("" + used) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCouponsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCouponsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCouponsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @couponCode (optional) 
     * @eventId (optional) 
     * @return Success
     */
    validateCouponByCode(couponCode: string | null, eventId: number | null): Observable<ValidateCouponOutput> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/ValidateCouponByCode?";
        if (couponCode !== undefined)
            url_ += "couponCode=" + encodeURIComponent("" + couponCode) + "&"; 
        if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processValidateCouponByCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processValidateCouponByCode(response_);
                } catch (e) {
                    return <Observable<ValidateCouponOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValidateCouponOutput>><any>Observable.throw(response_);
        });
    }

    protected processValidateCouponByCode(response: HttpResponse<Blob>): Observable<ValidateCouponOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValidateCouponOutput.fromJS(resultData200) : new ValidateCouponOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ValidateCouponOutput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @eventId (optional) 
     * @responsibleId (optional) 
     * @used (optional) 
     * @expirationDateRange_BeginDate (optional) 
     * @expirationDateRange_EndDate (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAllCouponGroup(filter: string | null, eventId: number | null, responsibleId: number | null, used: boolean | null, expirationDateRange_BeginDate: moment.Moment | null, expirationDateRange_EndDate: moment.Moment | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetCouponGroupForView> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetAllCouponGroup?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (responsibleId !== undefined)
            url_ += "ResponsibleId=" + encodeURIComponent("" + responsibleId) + "&"; 
        if (used !== undefined)
            url_ += "Used=" + encodeURIComponent("" + used) + "&"; 
        if (expirationDateRange_BeginDate !== undefined)
            url_ += "ExpirationDateRange.BeginDate=" + encodeURIComponent(expirationDateRange_BeginDate ? "" + expirationDateRange_BeginDate.toJSON() : "") + "&"; 
        if (expirationDateRange_EndDate !== undefined)
            url_ += "ExpirationDateRange.EndDate=" + encodeURIComponent(expirationDateRange_EndDate ? "" + expirationDateRange_EndDate.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCouponGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllCouponGroup(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCouponGroupForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCouponGroupForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCouponGroup(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetCouponGroupForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetCouponGroupForView.fromJS(resultData200) : new PagedResultDtoOfGetCouponGroupForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetCouponGroupForView>(<any>null);
    }

    /**
     * @return Success
     */
    getCouponGroupForEdit(id: number): Observable<GetCouponGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponGroupForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCouponGroupForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCouponGroupForEdit(response_);
                } catch (e) {
                    return <Observable<GetCouponGroupForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCouponGroupForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCouponGroupForEdit(response: HttpResponse<Blob>): Observable<GetCouponGroupForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCouponGroupForEditOutput.fromJS(resultData200) : new GetCouponGroupForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCouponGroupForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditCouponGroup(input: CreateOrEditCouponGroupDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/CreateOrEditCouponGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditCouponGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditCouponGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditCouponGroup(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteCouponGroup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/DeleteCouponGroup?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteCouponGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteCouponGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteCouponGroup(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addCouponsInGroup(input: AddCuponsInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/AddCouponsInGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddCouponsInGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddCouponsInGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddCouponsInGroup(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getResponsiblesForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfCouponResponsibleSelectListDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetResponsiblesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetResponsiblesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetResponsiblesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCouponResponsibleSelectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCouponResponsibleSelectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetResponsiblesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfCouponResponsibleSelectListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCouponResponsibleSelectListDto.fromJS(resultData200) : new ListResultDtoOfCouponResponsibleSelectListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfCouponResponsibleSelectListDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @eventId (optional) 
     * @responsibleId (optional) 
     * @used (optional) 
     * @expirationDateRange_BeginDate (optional) 
     * @expirationDateRange_EndDate (optional) 
     * @return Success
     */
    getCouponGroupsToExcel(filter: string | null, eventId: number | null, responsibleId: number | null, used: boolean | null, expirationDateRange_BeginDate: moment.Moment | null, expirationDateRange_EndDate: moment.Moment | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponGroupsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (responsibleId !== undefined)
            url_ += "ResponsibleId=" + encodeURIComponent("" + responsibleId) + "&"; 
        if (used !== undefined)
            url_ += "Used=" + encodeURIComponent("" + used) + "&"; 
        if (expirationDateRange_BeginDate !== undefined)
            url_ += "ExpirationDateRange.BeginDate=" + encodeURIComponent(expirationDateRange_BeginDate ? "" + expirationDateRange_BeginDate.toJSON() : "") + "&"; 
        if (expirationDateRange_EndDate !== undefined)
            url_ += "ExpirationDateRange.EndDate=" + encodeURIComponent(expirationDateRange_EndDate ? "" + expirationDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCouponGroupsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCouponGroupsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCouponGroupsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class CredentialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @eventId (optional) 
     * @userIdFilter (optional) 
     * @exhibitorIdFilter (optional) 
     * @nameFilter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, eventId: number | null, userIdFilter: number | null, exhibitorIdFilter: number | null, nameFilter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetCredentialForView> {
        let url_ = this.baseUrl + "/api/services/app/Credentials/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (exhibitorIdFilter !== undefined)
            url_ += "ExhibitorIdFilter=" + encodeURIComponent("" + exhibitorIdFilter) + "&"; 
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCredentialForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCredentialForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetCredentialForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetCredentialForView.fromJS(resultData200) : new PagedResultDtoOfGetCredentialForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetCredentialForView>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCredentials(input: CreateCredentialsInput | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Credentials/CreateCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateCredentials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateCredentials(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateCredentials(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCredential(input: CreateOrEditCredentialDto | null): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Credentials/CreateCredential";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateCredential(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateCredential(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateCredential(response: HttpResponse<Blob>): Observable<number> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @filter (optional) 
     * @eventId (optional) 
     * @userIdFilter (optional) 
     * @exhibitorIdFilter (optional) 
     * @nameFilter (optional) 
     * @return Success
     */
    getCredentialsToExcel(filter: string | null, eventId: number | null, userIdFilter: number | null, exhibitorIdFilter: number | null, nameFilter: string | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Credentials/GetCredentialsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (exhibitorIdFilter !== undefined)
            url_ += "ExhibitorIdFilter=" + encodeURIComponent("" + exhibitorIdFilter) + "&"; 
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCredentialsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCredentialsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCredentialsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment | null): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendAndGetDate(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDate(response: HttpResponse<Blob>): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment | null): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendAndGetDateTime(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateTime(response: HttpResponse<Blob>): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment | null, endDate: moment.Moment | null): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendAndGetDateRange(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateRange(response: HttpResponse<Blob>): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string | null): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCountries(response: HttpResponse<Blob>): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @selectedCountries (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(selectedCountries: NameValueOfString[] | null): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedCountries);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendAndGetSelectedCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetSelectedCountries(response: HttpResponse<Blob>): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string | null): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendAndGetValue(response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<StringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetValue(response: HttpResponse<Blob>): Observable<StringOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StringOutput.fromJS(resultData200) : new StringOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<StringOutput>(<any>null);
    }
}

@Injectable()
export class DocumentTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @descriptionFilter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, descriptionFilter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetDocumentTypeForView> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTypes/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDocumentTypeForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDocumentTypeForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetDocumentTypeForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetDocumentTypeForView.fromJS(resultData200) : new PagedResultDtoOfGetDocumentTypeForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetDocumentTypeForView>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getDocumentTypesForSelect(term: string | null): Observable<ListResultDtoOfDocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTypes/GetDocumentTypesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetDocumentTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetDocumentTypesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDocumentTypeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDocumentTypeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDocumentTypesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfDocumentTypeDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDocumentTypeDto.fromJS(resultData200) : new ListResultDtoOfDocumentTypeDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfDocumentTypeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDocumentTypeForEdit(id: number): Observable<GetDocumentTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTypes/GetDocumentTypeForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetDocumentTypeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetDocumentTypeForEdit(response_);
                } catch (e) {
                    return <Observable<GetDocumentTypeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDocumentTypeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDocumentTypeForEdit(response: HttpResponse<Blob>): Observable<GetDocumentTypeForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDocumentTypeForEditOutput.fromJS(resultData200) : new GetDocumentTypeForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetDocumentTypeForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditDocumentTypeDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTypes/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEditions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEditions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditions(response: HttpResponse<Blob>): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEditionListDto.fromJS(resultData200) : new ListResultDtoOfEditionListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | null): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEditionForEdit(response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionForEdit(response: HttpResponse<Blob>): Observable<GetEditionEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionEditOutput.fromJS(resultData200) : new GetEditionEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEditionEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateEdition(input: CreateOrUpdateEditionDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrUpdateEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateEdition(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteEdition(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEdition(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @selectedEditionId (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | null, addAllItem: boolean, onlyFreeItems: boolean): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&"; 
        if (addAllItem === undefined || addAllItem === null)
            throw new Error("The parameter 'addAllItem' must be defined and cannot be null.");
        else
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&"; 
        if (onlyFreeItems === undefined || onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' must be defined and cannot be null.");
        else
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEditionComboboxItems(response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionComboboxItems(response: HttpResponse<Blob>): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<SubscribableEditionComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class EnterpriseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @type (optional) 
     * @situationId (optional) 
     * @statusIntegracao (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getEnterprises(filter: string | null, type: Type | null, situationId: number | null, statusIntegracao: StatusIntegracao3 | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfEnterpriseDto> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/GetEnterprises?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEnterprises(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEnterprises(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEnterpriseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfEnterpriseDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEnterprises(response: HttpResponse<Blob>): Observable<PagedResultDtoOfEnterpriseDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEnterpriseDto.fromJS(resultData200) : new PagedResultDtoOfEnterpriseDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfEnterpriseDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @type (optional) 
     * @situationId (optional) 
     * @return Success
     */
    getEnterpriseForSelectAsync(term: string | null, type: Type2 | null, situationId: number | null): Observable<ListResultDtoOfEnterpriseListDto> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/GetEnterpriseForSelectAsync?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEnterpriseForSelectAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEnterpriseForSelectAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEnterpriseListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEnterpriseListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEnterpriseForSelectAsync(response: HttpResponse<Blob>): Observable<ListResultDtoOfEnterpriseListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEnterpriseListDto.fromJS(resultData200) : new ListResultDtoOfEnterpriseListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEnterpriseListDto>(<any>null);
    }

    /**
     * @enterpriseIds (optional) 
     * @return Success
     */
    getEnterpriseAddressTags(enterpriseIds: number[] | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/GetEnterpriseAddressTags?";
        if (enterpriseIds !== undefined)
            enterpriseIds && enterpriseIds.forEach(item => { url_ += "EnterpriseIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEnterpriseAddressTags(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEnterpriseAddressTags(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEnterpriseAddressTags(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEnterpriseForEdit(id: number | null): Observable<GetEnterpriseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/GetEnterpriseForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEnterpriseForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEnterpriseForEdit(response_);
                } catch (e) {
                    return <Observable<GetEnterpriseForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEnterpriseForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEnterpriseForEdit(response: HttpResponse<Blob>): Observable<GetEnterpriseForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEnterpriseForEditOutput.fromJS(resultData200) : new GetEnterpriseForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEnterpriseForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createEnterprise(input: CreateEnterpriseInput | null): Observable<EnterpriseDto> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/CreateEnterprise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateEnterprise(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateEnterprise(response_);
                } catch (e) {
                    return <Observable<EnterpriseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EnterpriseDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateEnterprise(response: HttpResponse<Blob>): Observable<EnterpriseDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EnterpriseDto.fromJS(resultData200) : new EnterpriseDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EnterpriseDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEnterprise(input: UpdateEnterpriseInput | null): Observable<EnterpriseDto> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/UpdateEnterprise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEnterprise(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateEnterprise(response_);
                } catch (e) {
                    return <Observable<EnterpriseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EnterpriseDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEnterprise(response: HttpResponse<Blob>): Observable<EnterpriseDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EnterpriseDto.fromJS(resultData200) : new EnterpriseDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EnterpriseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEnterpriseToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/GetEnterpriseToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEnterpriseToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEnterpriseToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEnterpriseToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEnterpriseListCIGAM(): Observable<any[]> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/GetEnterpriseListCIGAM";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEnterpriseListCIGAM(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEnterpriseListCIGAM(response_);
                } catch (e) {
                    return <Observable<any[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<any[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEnterpriseListCIGAM(response: HttpResponse<Blob>): Observable<any[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<any[]>(<any>null);
    }

    /**
     * @return Success
     */
    deleteEnterprise(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Enterprise/DeleteEnterprise?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEnterprise(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteEnterprise(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEnterprise(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EvaluatorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @specialityIdFilter (optional) 
     * @subspecialityIdFilter (optional) 
     * @institutionWorkIdFilter (optional) 
     * @eventWorkIdFilter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, specialityIdFilter: number | null, subspecialityIdFilter: number | null, institutionWorkIdFilter: number | null, eventWorkIdFilter: number | null, invitationWorkStatusFilter: number, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetEvaluatorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (specialityIdFilter !== undefined)
            url_ += "SpecialityIdFilter=" + encodeURIComponent("" + specialityIdFilter) + "&"; 
        if (subspecialityIdFilter !== undefined)
            url_ += "SubspecialityIdFilter=" + encodeURIComponent("" + subspecialityIdFilter) + "&"; 
        if (institutionWorkIdFilter !== undefined)
            url_ += "InstitutionWorkIdFilter=" + encodeURIComponent("" + institutionWorkIdFilter) + "&"; 
        if (eventWorkIdFilter !== undefined)
            url_ += "EventWorkIdFilter=" + encodeURIComponent("" + eventWorkIdFilter) + "&"; 
        if (invitationWorkStatusFilter === undefined || invitationWorkStatusFilter === null)
            throw new Error("The parameter 'invitationWorkStatusFilter' must be defined and cannot be null.");
        else
            url_ += "InvitationWorkStatusFilter=" + encodeURIComponent("" + invitationWorkStatusFilter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEvaluatorForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEvaluatorForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetEvaluatorForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetEvaluatorForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetEvaluatorForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetEvaluatorForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEvaluatorForEdit(id: number): Observable<GetEvaluatorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/GetEvaluatorForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluatorForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEvaluatorForEdit(response_);
                } catch (e) {
                    return <Observable<GetEvaluatorForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEvaluatorForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluatorForEdit(response: HttpResponse<Blob>): Observable<GetEvaluatorForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEvaluatorForEditOutput.fromJS(resultData200) : new GetEvaluatorForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEvaluatorForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEvaluatorByUserForView(userId: number, eventWorkId: number): Observable<GetEvaluatorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/GetEvaluatorByUserForView?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (eventWorkId === undefined || eventWorkId === null)
            throw new Error("The parameter 'eventWorkId' must be defined and cannot be null.");
        else
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluatorByUserForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEvaluatorByUserForView(response_);
                } catch (e) {
                    return <Observable<GetEvaluatorForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEvaluatorForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluatorByUserForView(response: HttpResponse<Blob>): Observable<GetEvaluatorForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEvaluatorForEditOutput.fromJS(resultData200) : new GetEvaluatorForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEvaluatorForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEvaluatorDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @specialityIdFilter (optional) 
     * @subspecialityIdFilter (optional) 
     * @institutionWorkIdFilter (optional) 
     * @eventWorkIdFilter (optional) 
     * @return Success
     */
    getEvaluatorsToExcel(filter: string | null, specialityIdFilter: number | null, subspecialityIdFilter: number | null, institutionWorkIdFilter: number | null, eventWorkIdFilter: number | null, invitationWorkStatusFilter: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/GetEvaluatorsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (specialityIdFilter !== undefined)
            url_ += "SpecialityIdFilter=" + encodeURIComponent("" + specialityIdFilter) + "&"; 
        if (subspecialityIdFilter !== undefined)
            url_ += "SubspecialityIdFilter=" + encodeURIComponent("" + subspecialityIdFilter) + "&"; 
        if (institutionWorkIdFilter !== undefined)
            url_ += "InstitutionWorkIdFilter=" + encodeURIComponent("" + institutionWorkIdFilter) + "&"; 
        if (eventWorkIdFilter !== undefined)
            url_ += "EventWorkIdFilter=" + encodeURIComponent("" + eventWorkIdFilter) + "&"; 
        if (invitationWorkStatusFilter === undefined || invitationWorkStatusFilter === null)
            throw new Error("The parameter 'invitationWorkStatusFilter' must be defined and cannot be null.");
        else
            url_ += "InvitationWorkStatusFilter=" + encodeURIComponent("" + invitationWorkStatusFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluatorsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEvaluatorsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluatorsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @subspecialityId (optional) 
     * @authors (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getValidEvaluatorsForSelect(term: string | null, eventWorkId: number, specialityId: number, subspecialityId: number | null, institutionWorkId: number, authors: number[] | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfUserSelectListDto> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/GetValidEvaluatorsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventWorkId === undefined || eventWorkId === null)
            throw new Error("The parameter 'eventWorkId' must be defined and cannot be null.");
        else
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        if (specialityId === undefined || specialityId === null)
            throw new Error("The parameter 'specialityId' must be defined and cannot be null.");
        else
            url_ += "SpecialityId=" + encodeURIComponent("" + specialityId) + "&"; 
        if (subspecialityId !== undefined)
            url_ += "subspecialityId=" + encodeURIComponent("" + subspecialityId) + "&"; 
        if (institutionWorkId === undefined || institutionWorkId === null)
            throw new Error("The parameter 'institutionWorkId' must be defined and cannot be null.");
        else
            url_ += "institutionWorkId=" + encodeURIComponent("" + institutionWorkId) + "&"; 
        if (authors !== undefined)
            authors && authors.forEach(item => { url_ += "Authors=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetValidEvaluatorsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetValidEvaluatorsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserSelectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserSelectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetValidEvaluatorsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfUserSelectListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserSelectListDto.fromJS(resultData200) : new ListResultDtoOfUserSelectListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfUserSelectListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getEvaluatorsForSelect(term: string | null, eventWorkId: number, onlyNotInvited: boolean, onlyAcceptedInvite: boolean, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfUserSelectListDto> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/GetEvaluatorsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventWorkId === undefined || eventWorkId === null)
            throw new Error("The parameter 'eventWorkId' must be defined and cannot be null.");
        else
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        if (onlyNotInvited === undefined || onlyNotInvited === null)
            throw new Error("The parameter 'onlyNotInvited' must be defined and cannot be null.");
        else
            url_ += "OnlyNotInvited=" + encodeURIComponent("" + onlyNotInvited) + "&"; 
        if (onlyAcceptedInvite === undefined || onlyAcceptedInvite === null)
            throw new Error("The parameter 'onlyAcceptedInvite' must be defined and cannot be null.");
        else
            url_ += "OnlyAcceptedInvite=" + encodeURIComponent("" + onlyAcceptedInvite) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluatorsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEvaluatorsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserSelectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserSelectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluatorsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfUserSelectListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserSelectListDto.fromJS(resultData200) : new ListResultDtoOfUserSelectListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfUserSelectListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkExistEvaluator(input: GetEvaluatorInput | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Evaluators/CheckExistEvaluator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCheckExistEvaluator(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCheckExistEvaluator(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckExistEvaluator(response: HttpResponse<Blob>): Observable<boolean> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class EventsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @eventTypeDescription (optional) 
     * @statusIntegracao (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, eventTypeDescription: string | null, statusIntegracao: StatusIntegracao4 | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetAllEventsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventTypeDescription !== undefined)
            url_ += "EventTypeDescription=" + encodeURIComponent("" + eventTypeDescription) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllEventsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllEventsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetAllEventsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllEventsOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllEventsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetAllEventsOutput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @onlyWithPlacesAvailable (optional) 
     * @onlyWithOpenRegistrations (optional) 
     * @eventTypeDescription (optional) 
     * @userId (optional) 
     * @onLocal (optional) 
     * @showOnlyCategoriesOnLocal (optional) 
     * @skipCount (optional) 
     * @takeCount (optional) 
     * @eventsFilter (optional) 
     * @showRelatedEvents (optional) 
     * @return Success
     */
    getEventsForSignUp(filter: string | null, onlyWithPlacesAvailable: boolean | null, onlyWithOpenRegistrations: boolean | null, eventTypeDescription: string | null, userId: number | null, onLocal: boolean | null, showOnlyCategoriesOnLocal: boolean | null, skipCount: number | null, takeCount: number | null, eventsFilter: number[] | null, showRelatedEvents: boolean | null): Observable<EventForRegistrationPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsForSignUp?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (onlyWithPlacesAvailable !== undefined)
            url_ += "OnlyWithPlacesAvailable=" + encodeURIComponent("" + onlyWithPlacesAvailable) + "&"; 
        if (onlyWithOpenRegistrations !== undefined)
            url_ += "OnlyWithOpenRegistrations=" + encodeURIComponent("" + onlyWithOpenRegistrations) + "&"; 
        if (eventTypeDescription !== undefined)
            url_ += "EventTypeDescription=" + encodeURIComponent("" + eventTypeDescription) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (onLocal !== undefined)
            url_ += "OnLocal=" + encodeURIComponent("" + onLocal) + "&"; 
        if (showOnlyCategoriesOnLocal !== undefined)
            url_ += "ShowOnlyCategoriesOnLocal=" + encodeURIComponent("" + showOnlyCategoriesOnLocal) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (takeCount !== undefined)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&"; 
        if (eventsFilter !== undefined)
            eventsFilter && eventsFilter.forEach(item => { url_ += "EventsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (showRelatedEvents !== undefined)
            url_ += "ShowRelatedEvents=" + encodeURIComponent("" + showRelatedEvents) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventsForSignUp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventsForSignUp(response_);
                } catch (e) {
                    return <Observable<EventForRegistrationPagedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EventForRegistrationPagedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventsForSignUp(response: HttpResponse<Blob>): Observable<EventForRegistrationPagedResultDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EventForRegistrationPagedResultDto.fromJS(resultData200) : new EventForRegistrationPagedResultDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EventForRegistrationPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEventForSignUp(id: number): Observable<GetEventForRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventForSignUp?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventForSignUp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventForSignUp(response_);
                } catch (e) {
                    return <Observable<GetEventForRegistrationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEventForRegistrationOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEventForSignUp(response: HttpResponse<Blob>): Observable<GetEventForRegistrationOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEventForRegistrationOutput.fromJS(resultData200) : new GetEventForRegistrationOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEventForRegistrationOutput>(<any>null);
    }

    /**
     * @term (optional) 
     * @currentEventId (optional) 
     * @hasProgramming (optional) 
     * @hasSurvey (optional) 
     * @onlyCurrentEventDependents (optional) 
     * @eventTypeId (optional) 
     * @hasEventWork (optional) 
     * @onlyFutureEvents (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getEventsForSelect(term: string | null, currentEventId: number | null, hasProgramming: boolean | null, hasSurvey: boolean | null, onlyCurrentEventDependents: boolean | null, eventTypeId: number | null, hasEventWork: boolean | null, onlyFutureEvents: boolean | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfEventListDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (currentEventId !== undefined)
            url_ += "CurrentEventId=" + encodeURIComponent("" + currentEventId) + "&"; 
        if (hasProgramming !== undefined)
            url_ += "HasProgramming=" + encodeURIComponent("" + hasProgramming) + "&"; 
        if (hasSurvey !== undefined)
            url_ += "HasSurvey=" + encodeURIComponent("" + hasSurvey) + "&"; 
        if (onlyCurrentEventDependents !== undefined)
            url_ += "OnlyCurrentEventDependents=" + encodeURIComponent("" + onlyCurrentEventDependents) + "&"; 
        if (eventTypeId !== undefined)
            url_ += "EventTypeId=" + encodeURIComponent("" + eventTypeId) + "&"; 
        if (hasEventWork !== undefined)
            url_ += "HasEventWork=" + encodeURIComponent("" + hasEventWork) + "&"; 
        if (onlyFutureEvents !== undefined)
            url_ += "OnlyFutureEvents=" + encodeURIComponent("" + onlyFutureEvents) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEventListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfEventListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEventListDto.fromJS(resultData200) : new ListResultDtoOfEventListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEventListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getCategoryDeadlines(term: string | null, eventId: number, distinct: boolean): Observable<ListResultDtoOfEventCategoryDeadlineDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetCategoryDeadlines?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined and cannot be null.");
        else
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (distinct === undefined || distinct === null)
            throw new Error("The parameter 'distinct' must be defined and cannot be null.");
        else
            url_ += "Distinct=" + encodeURIComponent("" + distinct) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCategoryDeadlines(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCategoryDeadlines(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventCategoryDeadlineDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEventCategoryDeadlineDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCategoryDeadlines(response: HttpResponse<Blob>): Observable<ListResultDtoOfEventCategoryDeadlineDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEventCategoryDeadlineDto.fromJS(resultData200) : new ListResultDtoOfEventCategoryDeadlineDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEventCategoryDeadlineDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEventForEdit(id: number | null): Observable<GetEventForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventForEdit(response_);
                } catch (e) {
                    return <Observable<GetEventForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEventForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEventForEdit(response: HttpResponse<Blob>): Observable<GetEventForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEventForEditOutput.fromJS(resultData200) : new GetEventForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEventForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateEvent(input: CreateOrEditEventDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CreateOrUpdateEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateEvent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrUpdateEvent(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateEvent(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEventImage(input: UpdateEventImageInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/UpdateEventImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEventImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateEventImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEventImage(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getEventImage(id: number): Observable<GetEventImageOutput> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventImage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventImage(response_);
                } catch (e) {
                    return <Observable<GetEventImageOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEventImageOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEventImage(response: HttpResponse<Blob>): Observable<GetEventImageOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEventImageOutput.fromJS(resultData200) : new GetEventImageOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEventImageOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEventImageById(eventImageId: string): Observable<GetEventImageOutput> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventImageById?";
        if (eventImageId === undefined || eventImageId === null)
            throw new Error("The parameter 'eventImageId' must be defined and cannot be null.");
        else
            url_ += "eventImageId=" + encodeURIComponent("" + eventImageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventImageById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventImageById(response_);
                } catch (e) {
                    return <Observable<GetEventImageOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEventImageOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEventImageById(response: HttpResponse<Blob>): Observable<GetEventImageOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEventImageOutput.fromJS(resultData200) : new GetEventImageOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEventImageOutput>(<any>null);
    }

    /**
     * @return Success
     */
    deleteEvent(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/DeleteEvent?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteEvent(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEvent(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    copyEvent(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CopyEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCopyEvent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCopyEvent(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCopyEvent(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPendingTransferRegistrationsForEdit(id: number): Observable<GetPendingTransfersForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetPendingTransferRegistrationsForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPendingTransferRegistrationsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPendingTransferRegistrationsForEdit(response_);
                } catch (e) {
                    return <Observable<GetPendingTransfersForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPendingTransfersForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPendingTransferRegistrationsForEdit(response: HttpResponse<Blob>): Observable<GetPendingTransfersForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPendingTransfersForEditOutput.fromJS(resultData200) : new GetPendingTransfersForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetPendingTransfersForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    transferRegistrationsToNextEvent(input: TransferRegistrationsDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/TransferRegistrationsToNextEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processTransferRegistrationsToNextEvent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processTransferRegistrationsToNextEvent(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransferRegistrationsToNextEvent(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    publish(input: PublishEventInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/Publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processPublish(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processPublish(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPublish(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addToGoogleCalendar(input: PublishEventInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/AddToGoogleCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddToGoogleCalendar(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddToGoogleCalendar(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddToGoogleCalendar(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    removeFromGoogleCalendar(eventId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/RemoveFromGoogleCalendar?";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined and cannot be null.");
        else
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processRemoveFromGoogleCalendar(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRemoveFromGoogleCalendar(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveFromGoogleCalendar(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancelPublish(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CancelPublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCancelPublish(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCancelPublish(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancelPublish(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @statusIntegracao (optional) 
     * @return Success
     */
    getEventsToExcel(filter: string | null, statusIntegracao: StatusIntegracao5 | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEventsScheduleForEdit(): Observable<EventsScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsScheduleForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventsScheduleForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventsScheduleForEdit(response_);
                } catch (e) {
                    return <Observable<EventsScheduleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EventsScheduleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventsScheduleForEdit(response: HttpResponse<Blob>): Observable<EventsScheduleDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EventsScheduleDto.fromJS(resultData200) : new EventsScheduleDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EventsScheduleDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditEventsSchedule(input: EventsScheduleDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CreateOrEditEventsSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditEventsSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditEventsSchedule(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditEventsSchedule(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EventTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetAllEventTypesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllEventTypesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllEventTypesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetAllEventTypesOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllEventTypesOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllEventTypesOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetAllEventTypesOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEventTypeForEdit(id: number): Observable<GetEventTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/GetEventTypeForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventTypeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventTypeForEdit(response_);
                } catch (e) {
                    return <Observable<GetEventTypeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEventTypeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEventTypeForEdit(response: HttpResponse<Blob>): Observable<GetEventTypeForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEventTypeForEditOutput.fromJS(resultData200) : new GetEventTypeForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEventTypeForEditOutput>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getEventTypesForSelect(term: string | null): Observable<ListResultDtoOfEventTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/GetEventTypesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventTypesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventTypeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEventTypeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventTypesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfEventTypeListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEventTypeListDto.fromJS(resultData200) : new ListResultDtoOfEventTypeListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEventTypeListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEventTypeDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EventWorksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @eventId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, eventId: number | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetEventWorkForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventWorkForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventWorkForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetEventWorkForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetEventWorkForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetEventWorkForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetEventWorkForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEventWorkForView(id: number): Observable<GetEventWorkForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/GetEventWorkForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventWorkForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventWorkForView(response_);
                } catch (e) {
                    return <Observable<GetEventWorkForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEventWorkForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventWorkForView(response: HttpResponse<Blob>): Observable<GetEventWorkForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEventWorkForViewDto.fromJS(resultData200) : new GetEventWorkForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEventWorkForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentEventWorkForView(): Observable<GetEventWorkForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/GetCurrentEventWorkForView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentEventWorkForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCurrentEventWorkForView(response_);
                } catch (e) {
                    return <Observable<GetEventWorkForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEventWorkForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentEventWorkForView(response: HttpResponse<Blob>): Observable<GetEventWorkForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEventWorkForViewDto.fromJS(resultData200) : new GetEventWorkForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEventWorkForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEventWorkForEdit(id: number): Observable<CreateOrUpdateEventWorkInput> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/GetEventWorkForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventWorkForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventWorkForEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateEventWorkInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateEventWorkInput>><any>Observable.throw(response_);
        });
    }

    protected processGetEventWorkForEdit(response: HttpResponse<Blob>): Observable<CreateOrUpdateEventWorkInput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateEventWorkInput.fromJS(resultData200) : new CreateOrUpdateEventWorkInput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrUpdateEventWorkInput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrUpdateEventWorkInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @eventId (optional) 
     * @return Success
     */
    getEventWorksToExcel(filter: string | null, eventId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/GetEventWorksToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventWorksToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventWorksToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventWorksToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getEventWorksForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfEventWorkListDto> {
        let url_ = this.baseUrl + "/api/services/app/EventWorks/GetEventWorksForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventWorksForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventWorksForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventWorkListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEventWorkListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEventWorksForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfEventWorkListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEventWorkListDto.fromJS(resultData200) : new ListResultDtoOfEventWorkListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfEventWorkListDto>(<any>null);
    }
}

@Injectable()
export class FinancialSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetFinancialSettingsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFinancialSettingsForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFinancialSettingsForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetFinancialSettingsForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetFinancialSettingsForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetFinancialSettingsForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetFinancialSettingsForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFinancialSettingsForEdit(id: number): Observable<GetFinancialSettingsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FinancialSettings/GetFinancialSettingsForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetFinancialSettingsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetFinancialSettingsForEdit(response_);
                } catch (e) {
                    return <Observable<GetFinancialSettingsForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFinancialSettingsForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFinancialSettingsForEdit(response: HttpResponse<Blob>): Observable<GetFinancialSettingsForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFinancialSettingsForEditOutput.fromJS(resultData200) : new GetFinancialSettingsForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetFinancialSettingsForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditFinancialSettingsDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinancialSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinancialSettings/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequest(input: CreateFriendshipRequestInput | null): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequest(response: HttpResponse<Blob>): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(input: CreateFriendshipRequestByUserNameInput | null): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponse<Blob>): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blockUser(input: BlockUserInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processBlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processBlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlockUser(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unblockUser(input: UnblockUserInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUnblockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUnblockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnblockUser(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    acceptFriendshipRequest(input: AcceptFriendshipRequestInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAcceptFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAcceptFriendshipRequest(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class GuestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @programmingId (optional) 
     * @scheduleSubmitted (optional) 
     * @invitationStatus (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, programmingId: number | null, scheduleSubmitted: boolean | null, invitationStatus: InvitationStatus | null, country: string | null, countryState: string | null, city: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetGuestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (scheduleSubmitted !== undefined)
            url_ += "ScheduleSubmitted=" + encodeURIComponent("" + scheduleSubmitted) + "&"; 
        if (invitationStatus !== undefined)
            url_ += "InvitationStatus=" + encodeURIComponent("" + invitationStatus) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGuestForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGuestForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetGuestForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetGuestForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGuestForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetGuestForViewDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @programmingId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getGuestsForSelect(term: string | null, programmingId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfGuestListDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfGuestListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGuestListDto.fromJS(resultData200) : new ListResultDtoOfGuestListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfGuestListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getGuestForEdit(id: number): Observable<GetGuestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestForEdit(response_);
                } catch (e) {
                    return <Observable<GetGuestForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGuestForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestForEdit(response: HttpResponse<Blob>): Observable<GetGuestForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetGuestForEditOutput.fromJS(resultData200) : new GetGuestForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetGuestForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getGuestForView(id: number): Observable<GetGuestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestForView(response_);
                } catch (e) {
                    return <Observable<GetGuestForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGuestForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestForView(response: HttpResponse<Blob>): Observable<GetGuestForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetGuestForViewDto.fromJS(resultData200) : new GetGuestForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetGuestForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getGuestSchedule(id: number): Observable<GuestScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestSchedule?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestSchedule(response_);
                } catch (e) {
                    return <Observable<GuestScheduleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GuestScheduleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestSchedule(response: HttpResponse<Blob>): Observable<GuestScheduleDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GuestScheduleDto.fromJS(resultData200) : new GuestScheduleDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GuestScheduleDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendScheduleByEmail(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/SendScheduleByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendScheduleByEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendScheduleByEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendScheduleByEmail(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGuestDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @programmingId (optional) 
     * @scheduleSubmitted (optional) 
     * @invitationStatus (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @return Success
     */
    getGuestsToExcel(filter: string | null, programmingId: number | null, scheduleSubmitted: boolean | null, invitationStatus: InvitationStatus2 | null, country: string | null, countryState: string | null, city: string | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (scheduleSubmitted !== undefined)
            url_ += "ScheduleSubmitted=" + encodeURIComponent("" + scheduleSubmitted) + "&"; 
        if (invitationStatus !== undefined)
            url_ += "InvitationStatus=" + encodeURIComponent("" + invitationStatus) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getGuestRolesForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfGuestRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestRolesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGuestRolesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGuestRolesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestRoleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestRoleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGuestRolesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfGuestRoleDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGuestRoleDto.fromJS(resultData200) : new ListResultDtoOfGuestRoleDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfGuestRoleDto>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDashboardStatisticsData(incomeStatisticsDateInterval: IncomeStatisticsDateInterval, startDate: moment.Moment, endDate: moment.Moment): Observable<HostDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardStatisticsData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetDashboardStatisticsData(response_);
                } catch (e) {
                    return <Observable<HostDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardStatisticsData(response: HttpResponse<Blob>): Observable<HostDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostDashboardData.fromJS(resultData200) : new HostDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<HostDashboardData>(<any>null);
    }

    /**
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: IncomeStatisticsDateInterval2, startDate: moment.Moment, endDate: moment.Moment): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetIncomeStatistics(response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIncomeStatistics(response: HttpResponse<Blob>): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIncomeStatisticsDataOutput.fromJS(resultData200) : new GetIncomeStatisticsDataOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment, endDate: moment.Moment): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEditionTenantStatistics(response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionTenantStatistics(response: HttpResponse<Blob>): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionTenantStatisticsOutput.fromJS(resultData200) : new GetEditionTenantStatisticsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetEditionTenantStatisticsOutput>(<any>null);
    }

    /**
     * @userId (optional) 
     * @getReceivablesInput_UserId (optional) 
     * @getReceivablesInput_EnterpriseId (optional) 
     * @getReceivablesInput_Filter (optional) 
     * @getReceivablesInput_Status (optional) 
     * @getReceivablesInput_PaymentChargeType (optional) 
     * @getEventsInput_Filter (optional) 
     * @getEventsInput_OnlyWithPlacesAvailable (optional) 
     * @getEventsInput_OnlyWithOpenRegistrations (optional) 
     * @getEventsInput_EventTypeDescription (optional) 
     * @getEventsInput_UserId (optional) 
     * @getEventsInput_OnLocal (optional) 
     * @getEventsInput_ShowOnlyCategoriesOnLocal (optional) 
     * @getEventsInput_SkipCount (optional) 
     * @getEventsInput_TakeCount (optional) 
     * @getEventsInput_EventsFilter (optional) 
     * @getEventsInput_ShowRelatedEvents (optional) 
     * @return Success
     */
    getMemberDashboardData(userId: number | null, getReceivablesInput_UserId: number | null, getReceivablesInput_EnterpriseId: number | null, getReceivablesInput_Filter: string | null, getReceivablesInput_Status: Status5 | null, getReceivablesInput_PaymentChargeType: string | null, getEventsInput_Filter: string | null, getEventsInput_OnlyWithPlacesAvailable: boolean | null, getEventsInput_OnlyWithOpenRegistrations: boolean | null, getEventsInput_EventTypeDescription: string | null, getEventsInput_UserId: number | null, getEventsInput_OnLocal: boolean | null, getEventsInput_ShowOnlyCategoriesOnLocal: boolean | null, getEventsInput_SkipCount: number | null, getEventsInput_TakeCount: number | null, getEventsInput_EventsFilter: number[] | null, getEventsInput_ShowRelatedEvents: boolean | null): Observable<MemberDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetMemberDashboardData?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (getReceivablesInput_UserId !== undefined)
            url_ += "GetReceivablesInput.UserId=" + encodeURIComponent("" + getReceivablesInput_UserId) + "&"; 
        if (getReceivablesInput_EnterpriseId !== undefined)
            url_ += "GetReceivablesInput.EnterpriseId=" + encodeURIComponent("" + getReceivablesInput_EnterpriseId) + "&"; 
        if (getReceivablesInput_Filter !== undefined)
            url_ += "GetReceivablesInput.Filter=" + encodeURIComponent("" + getReceivablesInput_Filter) + "&"; 
        if (getReceivablesInput_Status !== undefined)
            url_ += "GetReceivablesInput.Status=" + encodeURIComponent("" + getReceivablesInput_Status) + "&"; 
        if (getReceivablesInput_PaymentChargeType !== undefined)
            url_ += "GetReceivablesInput.PaymentChargeType=" + encodeURIComponent("" + getReceivablesInput_PaymentChargeType) + "&"; 
        if (getEventsInput_Filter !== undefined)
            url_ += "GetEventsInput.Filter=" + encodeURIComponent("" + getEventsInput_Filter) + "&"; 
        if (getEventsInput_OnlyWithPlacesAvailable !== undefined)
            url_ += "GetEventsInput.OnlyWithPlacesAvailable=" + encodeURIComponent("" + getEventsInput_OnlyWithPlacesAvailable) + "&"; 
        if (getEventsInput_OnlyWithOpenRegistrations !== undefined)
            url_ += "GetEventsInput.OnlyWithOpenRegistrations=" + encodeURIComponent("" + getEventsInput_OnlyWithOpenRegistrations) + "&"; 
        if (getEventsInput_EventTypeDescription !== undefined)
            url_ += "GetEventsInput.EventTypeDescription=" + encodeURIComponent("" + getEventsInput_EventTypeDescription) + "&"; 
        if (getEventsInput_UserId !== undefined)
            url_ += "GetEventsInput.UserId=" + encodeURIComponent("" + getEventsInput_UserId) + "&"; 
        if (getEventsInput_OnLocal !== undefined)
            url_ += "GetEventsInput.OnLocal=" + encodeURIComponent("" + getEventsInput_OnLocal) + "&"; 
        if (getEventsInput_ShowOnlyCategoriesOnLocal !== undefined)
            url_ += "GetEventsInput.ShowOnlyCategoriesOnLocal=" + encodeURIComponent("" + getEventsInput_ShowOnlyCategoriesOnLocal) + "&"; 
        if (getEventsInput_SkipCount !== undefined)
            url_ += "GetEventsInput.SkipCount=" + encodeURIComponent("" + getEventsInput_SkipCount) + "&"; 
        if (getEventsInput_TakeCount !== undefined)
            url_ += "GetEventsInput.TakeCount=" + encodeURIComponent("" + getEventsInput_TakeCount) + "&"; 
        if (getEventsInput_EventsFilter !== undefined)
            getEventsInput_EventsFilter && getEventsInput_EventsFilter.forEach(item => { url_ += "GetEventsInput.EventsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (getEventsInput_ShowRelatedEvents !== undefined)
            url_ += "GetEventsInput.ShowRelatedEvents=" + encodeURIComponent("" + getEventsInput_ShowRelatedEvents) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetMemberDashboardData(response_);
                } catch (e) {
                    return <Observable<MemberDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<MemberDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberDashboardData(response: HttpResponse<Blob>): Observable<MemberDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberDashboardData.fromJS(resultData200) : new MemberDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<MemberDashboardData>(<any>null);
    }

    /**
     * @eventId (optional) 
     * @return Success
     */
    getEventDashboardData(eventId: number | null, startDate: moment.Moment, endDate: moment.Moment): Observable<EventDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEventDashboardData?";
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventDashboardData(response_);
                } catch (e) {
                    return <Observable<EventDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<EventDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetEventDashboardData(response: HttpResponse<Blob>): Observable<EventDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EventDashboardData.fromJS(resultData200) : new EventDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EventDashboardData>(<any>null);
    }

    /**
     * @programmingId (optional) 
     * @return Success
     */
    getCientificDashboardData(programmingId: number | null, startDate: moment.Moment, endDate: moment.Moment): Observable<CientificDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetCientificDashboardData?";
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCientificDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCientificDashboardData(response_);
                } catch (e) {
                    return <Observable<CientificDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<CientificDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetCientificDashboardData(response: HttpResponse<Blob>): Observable<CientificDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CientificDashboardData.fromJS(resultData200) : new CientificDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CientificDashboardData>(<any>null);
    }

    /**
     * @annuityId (optional) 
     * @return Success
     */
    getAnnuityDashboardData(annuityId: number | null, startDate: moment.Moment, endDate: moment.Moment): Observable<AnnuityDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetAnnuityDashboardData?";
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnuityDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAnnuityDashboardData(response_);
                } catch (e) {
                    return <Observable<AnnuityDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<AnnuityDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnuityDashboardData(response: HttpResponse<Blob>): Observable<AnnuityDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnuityDashboardData.fromJS(resultData200) : new AnnuityDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<AnnuityDashboardData>(<any>null);
    }

    /**
     * @eventId (optional) 
     * @annuityId (optional) 
     * @return Success
     */
    getFinancialDashboardData(eventId: number | null, annuityId: number | null, cashFlowStatisticsDateInterval: CashFlowStatisticsDateInterval, startDate: moment.Moment, endDate: moment.Moment): Observable<FinancialDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetFinancialDashboardData?";
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (cashFlowStatisticsDateInterval === undefined || cashFlowStatisticsDateInterval === null)
            throw new Error("The parameter 'cashFlowStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "CashFlowStatisticsDateInterval=" + encodeURIComponent("" + cashFlowStatisticsDateInterval) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetFinancialDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetFinancialDashboardData(response_);
                } catch (e) {
                    return <Observable<FinancialDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<FinancialDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetFinancialDashboardData(response: HttpResponse<Blob>): Observable<FinancialDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FinancialDashboardData.fromJS(resultData200) : new FinancialDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FinancialDashboardData>(<any>null);
    }

    /**
     * @return Success
     */
    getCashFlowStatistics(cashFlowStatisticsDateInterval: CashFlowStatisticsDateInterval2, startDate: moment.Moment, endDate: moment.Moment): Observable<GetICashFlowStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetCashFlowStatistics?";
        if (cashFlowStatisticsDateInterval === undefined || cashFlowStatisticsDateInterval === null)
            throw new Error("The parameter 'cashFlowStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "CashFlowStatisticsDateInterval=" + encodeURIComponent("" + cashFlowStatisticsDateInterval) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCashFlowStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCashFlowStatistics(response_);
                } catch (e) {
                    return <Observable<GetICashFlowStatisticsDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetICashFlowStatisticsDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCashFlowStatistics(response: HttpResponse<Blob>): Observable<GetICashFlowStatisticsDataOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetICashFlowStatisticsDataOutput.fromJS(resultData200) : new GetICashFlowStatisticsDataOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetICashFlowStatisticsDataOutput>(<any>null);
    }

    /**
     * @eventWorkId (optional) 
     * @userId (optional) 
     * @return Success
     */
    getEventWorkDashboardData(eventWorkId: number | null, userId: number | null, startDate: moment.Moment, endDate: moment.Moment): Observable<EventWorkDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEventWorkDashboardData?";
        if (eventWorkId !== undefined)
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventWorkDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventWorkDashboardData(response_);
                } catch (e) {
                    return <Observable<EventWorkDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<EventWorkDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetEventWorkDashboardData(response: HttpResponse<Blob>): Observable<EventWorkDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EventWorkDashboardData.fromJS(resultData200) : new EventWorkDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EventWorkDashboardData>(<any>null);
    }

    /**
     * @eventWorkId (optional) 
     * @userId (optional) 
     * @return Success
     */
    getEventWorkMyWorksDashboardData(eventWorkId: number | null, userId: number | null, startDate: moment.Moment, endDate: moment.Moment): Observable<EventWorkDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEventWorkMyWorksDashboardData?";
        if (eventWorkId !== undefined)
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventWorkMyWorksDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventWorkMyWorksDashboardData(response_);
                } catch (e) {
                    return <Observable<EventWorkDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<EventWorkDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetEventWorkMyWorksDashboardData(response: HttpResponse<Blob>): Observable<EventWorkDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EventWorkDashboardData.fromJS(resultData200) : new EventWorkDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EventWorkDashboardData>(<any>null);
    }

    /**
     * @eventWorkId (optional) 
     * @userId (optional) 
     * @return Success
     */
    getEventWorkEvaluatorDashboardData(eventWorkId: number | null, userId: number | null, startDate: moment.Moment, endDate: moment.Moment): Observable<EventWorkDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEventWorkEvaluatorDashboardData?";
        if (eventWorkId !== undefined)
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEventWorkEvaluatorDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEventWorkEvaluatorDashboardData(response_);
                } catch (e) {
                    return <Observable<EventWorkDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<EventWorkDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetEventWorkEvaluatorDashboardData(response: HttpResponse<Blob>): Observable<EventWorkDashboardData> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EventWorkDashboardData.fromJS(resultData200) : new EventWorkDashboardData();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EventWorkDashboardData>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: HttpResponse<Blob>): Observable<HostSettingsEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostSettingsEditDto.fromJS(resultData200) : new HostSettingsEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<HostSettingsEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSerproAsync(): Observable<SerproSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetSerproAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSerproAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSerproAsync(response_);
                } catch (e) {
                    return <Observable<SerproSettingsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SerproSettingsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSerproAsync(response: HttpResponse<Blob>): Observable<SerproSettingsDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SerproSettingsDto.fromJS(resultData200) : new SerproSettingsDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<SerproSettingsDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCigamAsync(): Observable<CigamSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetCigamAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCigamAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCigamAsync(response_);
                } catch (e) {
                    return <Observable<CigamSettingsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CigamSettingsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCigamAsync(response: HttpResponse<Blob>): Observable<CigamSettingsDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CigamSettingsDto.fromJS(resultData200) : new CigamSettingsDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CigamSettingsDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: HostSettingsEditDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setup(input: InstallDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSetup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSetup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetup(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAppSettingsJson(response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAppSettingsJson(response: HttpResponse<Blob>): Observable<AppSettingsJsonDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCheckDatabase(response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>Observable.throw(response_);
        });
    }

    protected processCheckDatabase(response: HttpResponse<Blob>): Observable<CheckDatabaseOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckDatabaseOutput.fromJS(resultData200) : new CheckDatabaseOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CheckDatabaseOutput>(<any>null);
    }
}

@Injectable()
export class InstitutionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfInstitutionDto> {
        let url_ = this.baseUrl + "/api/services/app/Institutions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfInstitutionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfInstitutionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfInstitutionDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfInstitutionDto.fromJS(resultData200) : new PagedResultDtoOfInstitutionDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfInstitutionDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getInstitutionsForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfInstitutionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Institutions/GetInstitutionsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInstitutionsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInstitutionsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInstitutionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfInstitutionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInstitutionsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfInstitutionListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInstitutionListDto.fromJS(resultData200) : new ListResultDtoOfInstitutionListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfInstitutionListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInstitutionForEdit(id: number): Observable<CreateOrEditInstitutionDto> {
        let url_ = this.baseUrl + "/api/services/app/Institutions/GetInstitutionForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInstitutionForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInstitutionForEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrEditInstitutionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditInstitutionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInstitutionForEdit(response: HttpResponse<Blob>): Observable<CreateOrEditInstitutionDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditInstitutionDto.fromJS(resultData200) : new CreateOrEditInstitutionDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditInstitutionDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditInstitutionDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Institutions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Institutions/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class InstitutionWorksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @countryNameFilter (optional) 
     * @stateNameFilter (optional) 
     * @cityFilter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, countryNameFilter: string | null, stateNameFilter: string | null, cityFilter: string | null, statusFilter: number, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetInstitutionWorkForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InstitutionWorks/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (countryNameFilter !== undefined)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&"; 
        if (stateNameFilter !== undefined)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&"; 
        if (cityFilter !== undefined)
            url_ += "CityFilter=" + encodeURIComponent("" + cityFilter) + "&"; 
        if (statusFilter === undefined || statusFilter === null)
            throw new Error("The parameter 'statusFilter' must be defined and cannot be null.");
        else
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInstitutionWorkForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInstitutionWorkForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetInstitutionWorkForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetInstitutionWorkForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetInstitutionWorkForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetInstitutionWorkForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInstitutionWorkForEdit(id: number): Observable<GetInstitutionWorkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InstitutionWorks/GetInstitutionWorkForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInstitutionWorkForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInstitutionWorkForEdit(response_);
                } catch (e) {
                    return <Observable<GetInstitutionWorkForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInstitutionWorkForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInstitutionWorkForEdit(response: HttpResponse<Blob>): Observable<GetInstitutionWorkForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInstitutionWorkForEditOutput.fromJS(resultData200) : new GetInstitutionWorkForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInstitutionWorkForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditInstitutionWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InstitutionWorks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InstitutionWorks/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @countryNameFilter (optional) 
     * @stateNameFilter (optional) 
     * @cityFilter (optional) 
     * @return Success
     */
    getInstitutionWorksToExcel(filter: string | null, countryNameFilter: string | null, stateNameFilter: string | null, cityFilter: string | null, statusFilter: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/InstitutionWorks/GetInstitutionWorksToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (countryNameFilter !== undefined)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&"; 
        if (stateNameFilter !== undefined)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&"; 
        if (cityFilter !== undefined)
            url_ += "CityFilter=" + encodeURIComponent("" + cityFilter) + "&"; 
        if (statusFilter === undefined || statusFilter === null)
            throw new Error("The parameter 'statusFilter' must be defined and cannot be null.");
        else
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInstitutionWorksToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInstitutionWorksToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInstitutionWorksToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getForSelect(filter: string | null): Observable<InstitutionWorkDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InstitutionWorks/GetForSelect?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetForSelect(response_);
                } catch (e) {
                    return <Observable<InstitutionWorkDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<InstitutionWorkDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetForSelect(response: HttpResponse<Blob>): Observable<InstitutionWorkDto[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(InstitutionWorkDto.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<InstitutionWorkDto[]>(<any>null);
    }
}

@Injectable()
export class InvitationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @creatorUserId (optional) 
     * @guestId (optional) 
     * @programmingId (optional) 
     * @hasInvitationRefused (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, creatorUserId: number | null, guestId: number | null, programmingId: number | null, hasInvitationRefused: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetInvitationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&"; 
        if (guestId !== undefined)
            url_ += "GuestId=" + encodeURIComponent("" + guestId) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (hasInvitationRefused !== undefined)
            url_ += "HasInvitationRefused=" + encodeURIComponent("" + hasInvitationRefused) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInvitationForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInvitationForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetInvitationForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetInvitationForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetInvitationForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetInvitationForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInvitationForView(id: number): Observable<GetInvitationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetInvitationForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationForView(response_);
                } catch (e) {
                    return <Observable<GetInvitationForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationForView(response: HttpResponse<Blob>): Observable<GetInvitationForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationForViewDto.fromJS(resultData200) : new GetInvitationForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationForViewDto>(<any>null);
    }

    /**
     * @invitationId (optional) 
     * @programmingId (optional) 
     * @return Success
     */
    getInvitationForEdit(invitationId: number | null, guestId: number, programmingId: number | null): Observable<GetInvitationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetInvitationForEdit?";
        if (invitationId !== undefined)
            url_ += "InvitationId=" + encodeURIComponent("" + invitationId) + "&"; 
        if (guestId === undefined || guestId === null)
            throw new Error("The parameter 'guestId' must be defined and cannot be null.");
        else
            url_ += "GuestId=" + encodeURIComponent("" + guestId) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationForEdit(response_);
                } catch (e) {
                    return <Observable<GetInvitationForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationForEdit(response: HttpResponse<Blob>): Observable<GetInvitationForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationForEditOutput.fromJS(resultData200) : new GetInvitationForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditInvitationDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendInvitation(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/SendInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendInvitation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendInvitation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendInvitation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @creatorUserId (optional) 
     * @guestId (optional) 
     * @programmingId (optional) 
     * @hasInvitationRefused (optional) 
     * @return Success
     */
    getInvitationsToExcel(filter: string | null, creatorUserId: number | null, guestId: number | null, programmingId: number | null, hasInvitationRefused: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetInvitationsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&"; 
        if (guestId !== undefined)
            url_ += "GuestId=" + encodeURIComponent("" + guestId) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        if (hasInvitationRefused !== undefined)
            url_ += "HasInvitationRefused=" + encodeURIComponent("" + hasInvitationRefused) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @creatorUserId (optional) 
     * @guestId (optional) 
     * @programmingId (optional) 
     * @return Success
     */
    getRefusedInvitationsToExcel(filter: string | null, creatorUserId: number | null, guestId: number | null, programmingId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetRefusedInvitationsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&"; 
        if (guestId !== undefined)
            url_ += "GuestId=" + encodeURIComponent("" + guestId) + "&"; 
        if (programmingId !== undefined)
            url_ += "ProgrammingId=" + encodeURIComponent("" + programmingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetRefusedInvitationsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetRefusedInvitationsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRefusedInvitationsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInvitations(input: CreateInvitationsInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/CreateInvitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateInvitations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateInvitations(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInvitations(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendInvitations(input: SendInvitationsInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/SendInvitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendInvitations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendInvitations(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendInvitations(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getResponseForView(id: number): Observable<GetInvitationResponseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetResponseForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetResponseForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetResponseForView(response_);
                } catch (e) {
                    return <Observable<GetInvitationResponseForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationResponseForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetResponseForView(response: HttpResponse<Blob>): Observable<GetInvitationResponseForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationResponseForEditOutput.fromJS(resultData200) : new GetInvitationResponseForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationResponseForEditOutput>(<any>null);
    }

    /**
     * @invitationId (optional) 
     * @id (optional) 
     * @return Success
     */
    getResponseForEdit(invitationId: number | null, id: number | null): Observable<GetInvitationResponseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetResponseForEdit?";
        if (invitationId !== undefined)
            url_ += "InvitationId=" + encodeURIComponent("" + invitationId) + "&"; 
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetResponseForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetResponseForEdit(response_);
                } catch (e) {
                    return <Observable<GetInvitationResponseForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationResponseForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetResponseForEdit(response: HttpResponse<Blob>): Observable<GetInvitationResponseForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationResponseForEditOutput.fromJS(resultData200) : new GetInvitationResponseForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationResponseForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditResponse(input: CreateOrEditInvitationResponseDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/CreateOrEditResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditResponse(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditResponse(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditResponse(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getInvitationConfigByProgrammingId(id: number): Observable<GetInvitationConfigForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetInvitationConfigByProgrammingId?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationConfigByProgrammingId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationConfigByProgrammingId(response_);
                } catch (e) {
                    return <Observable<GetInvitationConfigForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationConfigForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationConfigByProgrammingId(response: HttpResponse<Blob>): Observable<GetInvitationConfigForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationConfigForEditOutput.fromJS(resultData200) : new GetInvitationConfigForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationConfigForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getInvitationConfigForEdit(id: number): Observable<GetInvitationConfigForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/GetInvitationConfigForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationConfigForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationConfigForEdit(response_);
                } catch (e) {
                    return <Observable<GetInvitationConfigForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationConfigForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationConfigForEdit(response: HttpResponse<Blob>): Observable<GetInvitationConfigForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationConfigForEditOutput.fromJS(resultData200) : new GetInvitationConfigForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationConfigForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditConfig(input: CreateOrEditInvitationConfigDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invitations/CreateOrEditConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditConfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditConfig(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditConfig(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class InvitationWorksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @evaluatorIdFilter (optional) 
     * @inviteStatusFilter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, statusFilter: number, evaluatorIdFilter: number | null, inviteStatusFilter: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetInvitationWorkForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (statusFilter === undefined || statusFilter === null)
            throw new Error("The parameter 'statusFilter' must be defined and cannot be null.");
        else
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (evaluatorIdFilter !== undefined)
            url_ += "EvaluatorIdFilter=" + encodeURIComponent("" + evaluatorIdFilter) + "&"; 
        if (inviteStatusFilter !== undefined)
            url_ += "InviteStatusFilter=" + encodeURIComponent("" + inviteStatusFilter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInvitationWorkForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInvitationWorkForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetInvitationWorkForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetInvitationWorkForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetInvitationWorkForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetInvitationWorkForViewDto>(<any>null);
    }

    /**
     * @invitationWorkId (optional) 
     * @evaluatorId (optional) 
     * @eventWorkId (optional) 
     * @return Success
     */
    getInvitationWorkForEdit(invitationWorkId: number | null, evaluatorId: number | null, eventWorkId: number | null): Observable<GetInvitationWorkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/GetInvitationWorkForEdit?";
        if (invitationWorkId !== undefined)
            url_ += "InvitationWorkId=" + encodeURIComponent("" + invitationWorkId) + "&"; 
        if (evaluatorId !== undefined)
            url_ += "EvaluatorId=" + encodeURIComponent("" + evaluatorId) + "&"; 
        if (eventWorkId !== undefined)
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationWorkForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationWorkForEdit(response_);
                } catch (e) {
                    return <Observable<GetInvitationWorkForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationWorkForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationWorkForEdit(response: HttpResponse<Blob>): Observable<GetInvitationWorkForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationWorkForEditOutput.fromJS(resultData200) : new GetInvitationWorkForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationWorkForEditOutput>(<any>null);
    }

    /**
     * @invitationWorkId (optional) 
     * @evaluatorId (optional) 
     * @eventWorkId (optional) 
     * @return Success
     */
    getInvitationWorkForView(invitationWorkId: number | null, evaluatorId: number | null, eventWorkId: number | null): Observable<GetInvitationWorkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/GetInvitationWorkForView?";
        if (invitationWorkId !== undefined)
            url_ += "InvitationWorkId=" + encodeURIComponent("" + invitationWorkId) + "&"; 
        if (evaluatorId !== undefined)
            url_ += "EvaluatorId=" + encodeURIComponent("" + evaluatorId) + "&"; 
        if (eventWorkId !== undefined)
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationWorkForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationWorkForView(response_);
                } catch (e) {
                    return <Observable<GetInvitationWorkForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInvitationWorkForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationWorkForView(response: HttpResponse<Blob>): Observable<GetInvitationWorkForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInvitationWorkForEditOutput.fromJS(resultData200) : new GetInvitationWorkForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInvitationWorkForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditInvitationWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @evaluatorIdFilter (optional) 
     * @inviteStatusFilter (optional) 
     * @return Success
     */
    getInvitationWorksToExcel(filter: string | null, statusFilter: number, evaluatorIdFilter: number | null, inviteStatusFilter: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/GetInvitationWorksToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (statusFilter === undefined || statusFilter === null)
            throw new Error("The parameter 'statusFilter' must be defined and cannot be null.");
        else
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (evaluatorIdFilter !== undefined)
            url_ += "EvaluatorIdFilter=" + encodeURIComponent("" + evaluatorIdFilter) + "&"; 
        if (inviteStatusFilter !== undefined)
            url_ += "InviteStatusFilter=" + encodeURIComponent("" + inviteStatusFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvitationWorksToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvitationWorksToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInvitationWorksToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendInvitations(input: SendInvitationWorksInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/SendInvitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendInvitations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendInvitations(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendInvitations(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInvitations(input: CreateInvitationWorksInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/CreateInvitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateInvitations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateInvitations(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInvitations(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditResponseInvitation(input: InvitationWorkResponseDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvitationWorks/CreateOrEditResponseInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditResponseInvitation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditResponseInvitation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditResponseInvitation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInvoiceInfo(id: number): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInvoiceInfo(response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InvoiceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoiceInfo(response: HttpResponse<Blob>): Observable<InvoiceDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InvoiceDto.fromJS(resultData200) : new InvoiceDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<InvoiceDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInvoice(input: CreateInvoiceDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInvoice(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ItauPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateTicketFile(input: GetItauTicketDto | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ItauPayment/GenerateTicketFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processGenerateTicketFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGenerateTicketFile(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateTicketFile(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class JobPositionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @approveRegistration (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, approveRegistration: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfJobPositionDto> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (approveRegistration !== undefined)
            url_ += "ApproveRegistration=" + encodeURIComponent("" + approveRegistration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfJobPositionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfJobPositionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfJobPositionDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfJobPositionDto.fromJS(resultData200) : new PagedResultDtoOfJobPositionDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfJobPositionDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getJobPositionsForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfJobPositionListDto> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/GetJobPositionsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetJobPositionsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetJobPositionsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfJobPositionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfJobPositionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetJobPositionsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfJobPositionListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfJobPositionListDto.fromJS(resultData200) : new ListResultDtoOfJobPositionListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfJobPositionListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getJobPositionDetailsForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfJobPositionDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/GetJobPositionDetailsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetJobPositionDetailsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetJobPositionDetailsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfJobPositionDetailListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfJobPositionDetailListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetJobPositionDetailsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfJobPositionDetailListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfJobPositionDetailListDto.fromJS(resultData200) : new ListResultDtoOfJobPositionDetailListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfJobPositionDetailListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getJobpositionForEdit(id: number | null): Observable<GetJobPositionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/GetJobpositionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetJobpositionForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetJobpositionForEdit(response_);
                } catch (e) {
                    return <Observable<GetJobPositionForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetJobPositionForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetJobpositionForEdit(response: HttpResponse<Blob>): Observable<GetJobPositionForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetJobPositionForEditOutput.fromJS(resultData200) : new GetJobPositionForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetJobPositionForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateJobPosition(input: CreateOrEditJobPosition | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/CreateOrUpdateJobPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateJobPosition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrUpdateJobPosition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateJobPosition(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteJobposition(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/DeleteJobposition?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteJobposition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteJobposition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteJobposition(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetLanguages(response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguages(response: HttpResponse<Blob>): Observable<GetLanguagesOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetLanguagesOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | null): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetLanguageForEdit(response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageForEdit(response: HttpResponse<Blob>): Observable<GetLanguageForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguageForEditOutput.fromJS(resultData200) : new GetLanguageForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLanguage(input: CreateOrUpdateLanguageInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrUpdateLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLanguage(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteLanguage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLanguage(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setDefaultLanguage(input: SetDefaultLanguageInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSetDefaultLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDefaultLanguage(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @baseLanguageName (optional) 
     * @targetValueFilter (optional) 
     * @filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number, skipCount: number, sorting: string | null, sourceName: string, baseLanguageName: string | null, targetLanguageName: string, targetValueFilter: string | null, filterText: string | null): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&"; 
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&"; 
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&"; 
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&"; 
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetLanguageTexts(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageTexts(response: HttpResponse<Blob>): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLanguageTextListDto.fromJS(resultData200) : new PagedResultDtoOfLanguageTextListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateLanguageText(input: UpdateLanguageTextInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateLanguageText(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateLanguageText(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MemberAnnuityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @categoryDeadLineId (optional) 
     * @year (optional) 
     * @annuityId (optional) 
     * @isResident (optional) 
     * @baseId (optional) 
     * @paymentStatus (optional) 
     * @documentationStatus (optional) 
     * @gender (optional) 
     * @statusIntegracao (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @itsReadmission (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, categoryId: number | null, categoryLevelId: number | null, categoryDeadLineId: number | null, year: number | null, annuityId: number | null, isResident: boolean | null, baseId: number | null, paymentStatus: PaymentStatus | null, documentationStatus: DocumentationStatus | null, gender: Gender | null, statusIntegracao: StatusIntegracao6 | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, itsReadmission: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetMemberAnnuityForView> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (categoryDeadLineId !== undefined)
            url_ += "CategoryDeadLineId=" + encodeURIComponent("" + categoryDeadLineId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        if (documentationStatus !== undefined)
            url_ += "DocumentationStatus=" + encodeURIComponent("" + documentationStatus) + "&"; 
        if (gender !== undefined)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (itsReadmission !== undefined)
            url_ += "ItsReadmission=" + encodeURIComponent("" + itsReadmission) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMemberAnnuityForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMemberAnnuityForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetMemberAnnuityForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetMemberAnnuityForView.fromJS(resultData200) : new PagedResultDtoOfGetMemberAnnuityForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetMemberAnnuityForView>(<any>null);
    }

    /**
     * @annuityYear (optional) 
     * @paymentStatus (optional) 
     * @return Success
     */
    getUserMemberAnnuities(userId: number, annuityYear: number | null, paymentStatus: PaymentStatus2 | null): Observable<ListResultDtoOfMemberAnnuityListDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/GetUserMemberAnnuities?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (annuityYear !== undefined)
            url_ += "AnnuityYear=" + encodeURIComponent("" + annuityYear) + "&"; 
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserMemberAnnuities(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserMemberAnnuities(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMemberAnnuityListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMemberAnnuityListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserMemberAnnuities(response: HttpResponse<Blob>): Observable<ListResultDtoOfMemberAnnuityListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMemberAnnuityListDto.fromJS(resultData200) : new ListResultDtoOfMemberAnnuityListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfMemberAnnuityListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMemberAnnuityForEdit(id: number | null): Observable<GetMemberAnnuityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/GetMemberAnnuityForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberAnnuityForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetMemberAnnuityForEdit(response_);
                } catch (e) {
                    return <Observable<GetMemberAnnuityForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMemberAnnuityForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberAnnuityForEdit(response: HttpResponse<Blob>): Observable<GetMemberAnnuityForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMemberAnnuityForEditOutput.fromJS(resultData200) : new GetMemberAnnuityForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetMemberAnnuityForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditMemberAnnuityDto | null): Observable<CreateOrEditMemberAnnuityOutput> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrEditMemberAnnuityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditMemberAnnuityOutput>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<CreateOrEditMemberAnnuityOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditMemberAnnuityOutput.fromJS(resultData200) : new CreateOrEditMemberAnnuityOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditMemberAnnuityOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateValues(input: UpdateMemberAnnuityValuesInput | null): Observable<PaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/UpdateValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateValues(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateValues(response_);
                } catch (e) {
                    return <Observable<PaymentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateValues(response: HttpResponse<Blob>): Observable<PaymentDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentDto.fromJS(resultData200) : new PaymentDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PaymentDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    confirmSbaPayment(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/ConfirmSbaPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processConfirmSbaPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processConfirmSbaPayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfirmSbaPayment(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    approveDocumentation(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/ApproveDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processApproveDocumentation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processApproveDocumentation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processApproveDocumentation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    disapproveDocumentation(input: DisaproveDocDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/DisapproveDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processDisapproveDocumentation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDisapproveDocumentation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDisapproveDocumentation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @categoryDeadLineId (optional) 
     * @annuityId (optional) 
     * @year (optional) 
     * @isResident (optional) 
     * @baseId (optional) 
     * @paymentStatus (optional) 
     * @documentationStatus (optional) 
     * @gender (optional) 
     * @statusIntegracao (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @itsReadmission (optional) 
     * @return Success
     */
    getMemberAnnuitiesToExcel(filter: string | null, categoryId: number | null, categoryLevelId: number | null, categoryDeadLineId: number | null, annuityId: number | null, year: number | null, isResident: boolean | null, baseId: number | null, paymentStatus: PaymentStatus3 | null, documentationStatus: DocumentationStatus2 | null, gender: Gender2 | null, statusIntegracao: StatusIntegracao7 | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, itsReadmission: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberAnnuity/GetMemberAnnuitiesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (categoryDeadLineId !== undefined)
            url_ += "CategoryDeadLineId=" + encodeURIComponent("" + categoryDeadLineId) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        if (documentationStatus !== undefined)
            url_ += "DocumentationStatus=" + encodeURIComponent("" + documentationStatus) + "&"; 
        if (gender !== undefined)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (itsReadmission !== undefined)
            url_ += "ItsReadmission=" + encodeURIComponent("" + itsReadmission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberAnnuitiesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetMemberAnnuitiesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberAnnuitiesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @state (optional) 
     * @return Success
     */
    getUserNotifications(state: State | null, maxResultCount: number, skipCount: number): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserNotifications(response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserNotifications(response: HttpResponse<Blob>): Observable<GetNotificationsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationsOutput.fromJS(resultData200) : new GetNotificationsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSetAllNotificationsAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetAllNotificationsAsRead(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setNotificationAsRead(input: EntityDtoOfGuid | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSetNotificationAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetNotificationAsRead(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetNotificationSettings(response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetNotificationSettings(response: HttpResponse<Blob>): Observable<GetNotificationSettingsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationSettingsOutput.fromJS(resultData200) : new GetNotificationSettingsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotificationSettings(input: UpdateNotificationSettingsInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateNotificationSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotificationSettings(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class OrdersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetOrderForView> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOrderForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOrderForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetOrderForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetOrderForView.fromJS(resultData200) : new PagedResultDtoOfGetOrderForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetOrderForView>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getOrderForEdit(id: number | null): Observable<GetOrderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetOrderForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetOrderForEdit(response_);
                } catch (e) {
                    return <Observable<GetOrderForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOrderForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetOrderForEdit(response: HttpResponse<Blob>): Observable<GetOrderForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetOrderForEditOutput.fromJS(resultData200) : new GetOrderForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetOrderForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditOrderDto | null): Observable<CreateOrEditOrderOutput> {
        let url_ = this.baseUrl + "/api/services/app/Orders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrEditOrderOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditOrderOutput>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<CreateOrEditOrderOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditOrderOutput.fromJS(resultData200) : new CreateOrEditOrderOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditOrderOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendConfirmPaymentEmail(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/SendConfirmPaymentEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendConfirmPaymentEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendConfirmPaymentEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendConfirmPaymentEmail(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateValues(input: CreateOrEditOrderDto | null): Observable<CreateOrEditOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/UpdateValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateValues(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateValues(response_);
                } catch (e) {
                    return <Observable<CreateOrEditOrderDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditOrderDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateValues(response: HttpResponse<Blob>): Observable<CreateOrEditOrderDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditOrderDto.fromJS(resultData200) : new CreateOrEditOrderDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditOrderDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancel(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCancel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCancel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancel(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteOrder(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/DeleteOrder?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteOrder(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetOrganizationUnits(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnits(response: HttpResponse<Blob>): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @return Success
     */
    getChildren(id: number): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetChildren?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetChildren(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetChildren(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetChildren(response: HttpResponse<Blob>): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number, sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetOrganizationUnitUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnitUsers(response: HttpResponse<Blob>): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationUnitUserListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrganizationUnit(input: CreateOrganizationUnitInput | null): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrganizationUnit(response: HttpResponse<Blob>): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateOrganizationUnit(input: UpdateOrganizationUnitInput | null): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateOrganizationUnit(response: HttpResponse<Blob>): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    moveOrganizationUnit(input: MoveOrganizationUnitInput | null): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processMoveOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processMoveOrganizationUnit(response: HttpResponse<Blob>): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteOrganizationUnit(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteOrganizationUnit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number, organizationUnitId: number, removeFromParents: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (organizationUnitId === undefined || organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' must be defined and cannot be null.");
        else
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        if (removeFromParents === undefined || removeFromParents === null)
            throw new Error("The parameter 'removeFromParents' must be defined and cannot be null.");
        else
            url_ += "RemoveFromParents=" + encodeURIComponent("" + removeFromParents) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(input: UsersToOrganizationUnitInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindOrganizationUnitUsersInput | null): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: HttpResponse<Blob>): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | null): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentInfo(response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentInfo(response: HttpResponse<Blob>): Observable<PaymentInfoDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentInfoDto.fromJS(resultData200) : new PaymentInfoDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PaymentInfoDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPayment(input: CreatePaymentDto | null): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreatePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreatePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreatePayment(response: HttpResponse<Blob>): Observable<any> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    executePayment(input: ExecutePaymentDto | null): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExecutePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processExecutePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processExecutePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processExecutePayment(response: HttpResponse<Blob>): Observable<any> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentHistory(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentHistory(response: HttpResponse<Blob>): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200) : new PagedResultDtoOfSubscriptionPaymentListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }
}

@Injectable()
export class PaymentChargesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getAllPaymentChargeTypesForSelect(filter: string | null): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetAllPaymentChargeTypesForSelect?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPaymentChargeTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllPaymentChargeTypesForSelect(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPaymentChargeTypesForSelect(response: HttpResponse<Blob>): Observable<string[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @status (optional) 
     * @paymentChargeTypes (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @receiptDateRange_BeginDate (optional) 
     * @receiptDateRange_EndDate (optional) 
     * @paymentMethodId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @pendingAnnuityId (optional) 
     * @userId (optional) 
     * @enterpriseId (optional) 
     * @bankAccountId (optional) 
     * @costCenterId (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @situationId (optional) 
     * @memberStatusId (optional) 
     * @ids (optional) 
     * @itsReadmission (optional) 
     * @itsInstallment (optional) 
     * @updatedRede (optional) 
     * @baseId (optional) 
     * @statusIntegracao (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAllReceivable(filter: string | null, status: Status6 | null, paymentChargeTypes: string[] | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, receiptDateRange_BeginDate: moment.Moment | null, receiptDateRange_EndDate: moment.Moment | null, paymentMethodId: number | null, eventId: number | null, coursesIds: number[] | null, annuityId: number | null, pendingAnnuityId: number | null, userId: number | null, enterpriseId: number | null, bankAccountId: number | null, costCenterId: number | null, categoryId: number | null, categoryLevelId: number | null, situationId: number | null, memberStatusId: number | null, ids: number[] | null, itsReadmission: boolean | null, itsInstallment: boolean | null, updatedRede: boolean | null, baseId: number | null, statusIntegracao: StatusIntegracao8 | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetReceivableForView> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetAllReceivable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (paymentChargeTypes !== undefined)
            paymentChargeTypes && paymentChargeTypes.forEach(item => { url_ += "PaymentChargeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (receiptDateRange_BeginDate !== undefined)
            url_ += "ReceiptDateRange.BeginDate=" + encodeURIComponent(receiptDateRange_BeginDate ? "" + receiptDateRange_BeginDate.toJSON() : "") + "&"; 
        if (receiptDateRange_EndDate !== undefined)
            url_ += "ReceiptDateRange.EndDate=" + encodeURIComponent(receiptDateRange_EndDate ? "" + receiptDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (pendingAnnuityId !== undefined)
            url_ += "PendingAnnuityId=" + encodeURIComponent("" + pendingAnnuityId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (itsReadmission !== undefined)
            url_ += "ItsReadmission=" + encodeURIComponent("" + itsReadmission) + "&"; 
        if (itsInstallment !== undefined)
            url_ += "ItsInstallment=" + encodeURIComponent("" + itsInstallment) + "&"; 
        if (updatedRede !== undefined)
            url_ += "UpdatedRede=" + encodeURIComponent("" + updatedRede) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllReceivable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllReceivable(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReceivableForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReceivableForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAllReceivable(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetReceivableForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetReceivableForView.fromJS(resultData200) : new PagedResultDtoOfGetReceivableForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetReceivableForView>(<any>null);
    }

    /**
     * @userId (optional) 
     * @enterpriseId (optional) 
     * @filter (optional) 
     * @status (optional) 
     * @paymentChargeType (optional) 
     * @return Success
     */
    getReceivables(userId: number | null, enterpriseId: number | null, filter: string | null, status: Status7 | null, paymentChargeType: string | null): Observable<ListResultDtoOfReceivableListDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetReceivables?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (paymentChargeType !== undefined)
            url_ += "PaymentChargeType=" + encodeURIComponent("" + paymentChargeType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetReceivables(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetReceivables(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfReceivableListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfReceivableListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetReceivables(response: HttpResponse<Blob>): Observable<ListResultDtoOfReceivableListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfReceivableListDto.fromJS(resultData200) : new ListResultDtoOfReceivableListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfReceivableListDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @receivableId (optional) 
     * @return Success
     */
    getReceivableForSelect(term: string | null, receivableId: number | null): Observable<ListResultDtoOfReceivableListDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetReceivableForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (receivableId !== undefined)
            url_ += "ReceivableId=" + encodeURIComponent("" + receivableId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetReceivableForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetReceivableForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfReceivableListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfReceivableListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetReceivableForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfReceivableListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfReceivableListDto.fromJS(resultData200) : new ListResultDtoOfReceivableListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfReceivableListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getReceivableForEdit(id: number | null): Observable<GetReceveibleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetReceivableForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetReceivableForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetReceivableForEdit(response_);
                } catch (e) {
                    return <Observable<GetReceveibleForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetReceveibleForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetReceivableForEdit(response: HttpResponse<Blob>): Observable<GetReceveibleForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetReceveibleForEditOutput.fromJS(resultData200) : new GetReceveibleForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetReceveibleForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getTrasactionData(id: number): Observable<TransactionRespondeDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetTrasactionData?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTrasactionData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTrasactionData(response_);
                } catch (e) {
                    return <Observable<TransactionRespondeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionRespondeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTrasactionData(response: HttpResponse<Blob>): Observable<TransactionRespondeDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionRespondeDto.fromJS(resultData200) : new TransactionRespondeDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TransactionRespondeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInstallments(id: number): Observable<GetInstallmentsDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetInstallments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetInstallments(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetInstallments(response_);
                } catch (e) {
                    return <Observable<GetInstallmentsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetInstallmentsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInstallments(response: HttpResponse<Blob>): Observable<GetInstallmentsDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetInstallmentsDto.fromJS(resultData200) : new GetInstallmentsDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetInstallmentsDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateInstallments(input: UpdateInstallmentDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/UpdateInstallments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateInstallments(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateInstallments(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateInstallments(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    syncInstallments(input: SyncInstallmentsDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/SyncInstallments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSyncInstallments(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSyncInstallments(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSyncInstallments(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @name (optional) 
     * @note (optional) 
     * @return Success
     */
    getReceipt(receivableId: number, name: string | null, note: string | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetReceipt?";
        if (receivableId === undefined || receivableId === null)
            throw new Error("The parameter 'receivableId' must be defined and cannot be null.");
        else
            url_ += "ReceivableId=" + encodeURIComponent("" + receivableId) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetReceipt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetReceipt(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetReceipt(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTicket(sendByEmail: boolean, id: number): Observable<PaymentResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetTicket?";
        if (sendByEmail === undefined || sendByEmail === null)
            throw new Error("The parameter 'sendByEmail' must be defined and cannot be null.");
        else
            url_ += "SendByEmail=" + encodeURIComponent("" + sendByEmail) + "&"; 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTicket(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTicket(response_);
                } catch (e) {
                    return <Observable<PaymentResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentResponse>><any>Observable.throw(response_);
        });
    }

    protected processGetTicket(response: HttpResponse<Blob>): Observable<PaymentResponse> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentResponse.fromJS(resultData200) : new PaymentResponse();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PaymentResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getNewTicket(sendByEmail: boolean, id: number): Observable<PaymentResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetNewTicket?";
        if (sendByEmail === undefined || sendByEmail === null)
            throw new Error("The parameter 'sendByEmail' must be defined and cannot be null.");
        else
            url_ += "SendByEmail=" + encodeURIComponent("" + sendByEmail) + "&"; 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetNewTicket(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetNewTicket(response_);
                } catch (e) {
                    return <Observable<PaymentResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentResponse>><any>Observable.throw(response_);
        });
    }

    protected processGetNewTicket(response: HttpResponse<Blob>): Observable<PaymentResponse> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentResponse.fromJS(resultData200) : new PaymentResponse();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PaymentResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateTicketFile(input: GetItauTicketDto | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GenerateTicketFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processGenerateTicketFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGenerateTicketFile(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateTicketFile(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @dueDate (optional) 
     * @amount (optional) 
     * @filter (optional) 
     * @status (optional) 
     * @paymentChargeTypes (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @receiptDateRange_BeginDate (optional) 
     * @receiptDateRange_EndDate (optional) 
     * @paymentMethodId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @pendingAnnuityId (optional) 
     * @userId (optional) 
     * @enterpriseId (optional) 
     * @bankAccountId (optional) 
     * @costCenterId (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @situationId (optional) 
     * @memberStatusId (optional) 
     * @ids (optional) 
     * @itsReadmission (optional) 
     * @itsInstallment (optional) 
     * @baseId (optional) 
     * @updatedRede (optional) 
     * @statusIntegracao (optional) 
     * @fields (optional) 
     * @return Success
     */
    getTickets(dueDate: moment.Moment | null, amount: number | null, filter: string | null, status: Status8 | null, paymentChargeTypes: string[] | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, receiptDateRange_BeginDate: moment.Moment | null, receiptDateRange_EndDate: moment.Moment | null, paymentMethodId: number | null, eventId: number | null, coursesIds: number[] | null, annuityId: number | null, pendingAnnuityId: number | null, userId: number | null, enterpriseId: number | null, bankAccountId: number | null, costCenterId: number | null, categoryId: number | null, categoryLevelId: number | null, situationId: number | null, memberStatusId: number | null, ids: number[] | null, itsReadmission: boolean | null, itsInstallment: boolean | null, baseId: number | null, updatedRede: boolean | null, statusIntegracao: StatusIntegracao9 | null, fields: string[] | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetTickets?";
        if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toJSON() : "") + "&"; 
        if (amount !== undefined)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (paymentChargeTypes !== undefined)
            paymentChargeTypes && paymentChargeTypes.forEach(item => { url_ += "PaymentChargeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (receiptDateRange_BeginDate !== undefined)
            url_ += "ReceiptDateRange.BeginDate=" + encodeURIComponent(receiptDateRange_BeginDate ? "" + receiptDateRange_BeginDate.toJSON() : "") + "&"; 
        if (receiptDateRange_EndDate !== undefined)
            url_ += "ReceiptDateRange.EndDate=" + encodeURIComponent(receiptDateRange_EndDate ? "" + receiptDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (pendingAnnuityId !== undefined)
            url_ += "PendingAnnuityId=" + encodeURIComponent("" + pendingAnnuityId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (itsReadmission !== undefined)
            url_ += "ItsReadmission=" + encodeURIComponent("" + itsReadmission) + "&"; 
        if (itsInstallment !== undefined)
            url_ += "ItsInstallment=" + encodeURIComponent("" + itsInstallment) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (updatedRede !== undefined)
            url_ += "UpdatedRede=" + encodeURIComponent("" + updatedRede) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "Fields=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTickets(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTickets(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processGetTickets(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTickets(input: SendTicketsInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/SendTickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendTickets(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendTickets(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTickets(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditReceivable(input: CreateOrEditReceivableDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/CreateOrEditReceivable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditReceivable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditReceivable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditReceivable(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    finishPayment(input: EntityDtoOfInt64 | null): Observable<AddPaymentOutput> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/FinishPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processFinishPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processFinishPayment(response_);
                } catch (e) {
                    return <Observable<AddPaymentOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<AddPaymentOutput>><any>Observable.throw(response_);
        });
    }

    protected processFinishPayment(response: HttpResponse<Blob>): Observable<AddPaymentOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AddPaymentOutput.fromJS(resultData200) : new AddPaymentOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<AddPaymentOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addPayment(input: AddPaymentInput | null): Observable<AddPaymentOutput> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/AddPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddPayment(response_);
                } catch (e) {
                    return <Observable<AddPaymentOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<AddPaymentOutput>><any>Observable.throw(response_);
        });
    }

    protected processAddPayment(response: HttpResponse<Blob>): Observable<AddPaymentOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AddPaymentOutput.fromJS(resultData200) : new AddPaymentOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<AddPaymentOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancelReceivable(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/CancelReceivable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCancelReceivable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCancelReceivable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancelReceivable(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteReceivable(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/DeleteReceivable?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteReceivable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteReceivable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteReceivable(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @status (optional) 
     * @paymentChargeTypes (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @receiptDateRange_BeginDate (optional) 
     * @receiptDateRange_EndDate (optional) 
     * @paymentMethodId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @pendingAnnuityId (optional) 
     * @userId (optional) 
     * @enterpriseId (optional) 
     * @bankAccountId (optional) 
     * @costCenterId (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @situationId (optional) 
     * @memberStatusId (optional) 
     * @ids (optional) 
     * @itsReadmission (optional) 
     * @itsInstallment (optional) 
     * @baseId (optional) 
     * @updatedRede (optional) 
     * @statusIntegracao (optional) 
     * @fields (optional) 
     * @return Success
     */
    getReceivablesToExcel(filter: string | null, status: Status9 | null, paymentChargeTypes: string[] | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, receiptDateRange_BeginDate: moment.Moment | null, receiptDateRange_EndDate: moment.Moment | null, paymentMethodId: number | null, eventId: number | null, coursesIds: number[] | null, annuityId: number | null, pendingAnnuityId: number | null, userId: number | null, enterpriseId: number | null, bankAccountId: number | null, costCenterId: number | null, categoryId: number | null, categoryLevelId: number | null, situationId: number | null, memberStatusId: number | null, ids: number[] | null, itsReadmission: boolean | null, itsInstallment: boolean | null, baseId: number | null, updatedRede: boolean | null, statusIntegracao: StatusIntegracao10 | null, fields: string[] | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetReceivablesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (paymentChargeTypes !== undefined)
            paymentChargeTypes && paymentChargeTypes.forEach(item => { url_ += "PaymentChargeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (receiptDateRange_BeginDate !== undefined)
            url_ += "ReceiptDateRange.BeginDate=" + encodeURIComponent(receiptDateRange_BeginDate ? "" + receiptDateRange_BeginDate.toJSON() : "") + "&"; 
        if (receiptDateRange_EndDate !== undefined)
            url_ += "ReceiptDateRange.EndDate=" + encodeURIComponent(receiptDateRange_EndDate ? "" + receiptDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (pendingAnnuityId !== undefined)
            url_ += "PendingAnnuityId=" + encodeURIComponent("" + pendingAnnuityId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (itsReadmission !== undefined)
            url_ += "ItsReadmission=" + encodeURIComponent("" + itsReadmission) + "&"; 
        if (itsInstallment !== undefined)
            url_ += "ItsInstallment=" + encodeURIComponent("" + itsInstallment) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (updatedRede !== undefined)
            url_ += "UpdatedRede=" + encodeURIComponent("" + updatedRede) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "Fields=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetReceivablesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetReceivablesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetReceivablesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @status (optional) 
     * @paymentChargeTypes (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @receiptDateRange_BeginDate (optional) 
     * @receiptDateRange_EndDate (optional) 
     * @paymentMethodId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @pendingAnnuityId (optional) 
     * @userId (optional) 
     * @enterpriseId (optional) 
     * @bankAccountId (optional) 
     * @costCenterId (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @situationId (optional) 
     * @memberStatusId (optional) 
     * @ids (optional) 
     * @itsReadmission (optional) 
     * @itsInstallment (optional) 
     * @baseId (optional) 
     * @updatedRede (optional) 
     * @statusIntegracao (optional) 
     * @fields (optional) 
     * @return Success
     */
    getUserAddressTags(filter: string | null, status: Status10 | null, paymentChargeTypes: string[] | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, receiptDateRange_BeginDate: moment.Moment | null, receiptDateRange_EndDate: moment.Moment | null, paymentMethodId: number | null, eventId: number | null, coursesIds: number[] | null, annuityId: number | null, pendingAnnuityId: number | null, userId: number | null, enterpriseId: number | null, bankAccountId: number | null, costCenterId: number | null, categoryId: number | null, categoryLevelId: number | null, situationId: number | null, memberStatusId: number | null, ids: number[] | null, itsReadmission: boolean | null, itsInstallment: boolean | null, baseId: number | null, updatedRede: boolean | null, statusIntegracao: StatusIntegracao11 | null, fields: string[] | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetUserAddressTags?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (paymentChargeTypes !== undefined)
            paymentChargeTypes && paymentChargeTypes.forEach(item => { url_ += "PaymentChargeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (receiptDateRange_BeginDate !== undefined)
            url_ += "ReceiptDateRange.BeginDate=" + encodeURIComponent(receiptDateRange_BeginDate ? "" + receiptDateRange_BeginDate.toJSON() : "") + "&"; 
        if (receiptDateRange_EndDate !== undefined)
            url_ += "ReceiptDateRange.EndDate=" + encodeURIComponent(receiptDateRange_EndDate ? "" + receiptDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (pendingAnnuityId !== undefined)
            url_ += "PendingAnnuityId=" + encodeURIComponent("" + pendingAnnuityId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (itsReadmission !== undefined)
            url_ += "ItsReadmission=" + encodeURIComponent("" + itsReadmission) + "&"; 
        if (itsInstallment !== undefined)
            url_ += "ItsInstallment=" + encodeURIComponent("" + itsInstallment) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (updatedRede !== undefined)
            url_ += "UpdatedRede=" + encodeURIComponent("" + updatedRede) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "Fields=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserAddressTags(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserAddressTags(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserAddressTags(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @type (optional) 
     * @status (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @dueDateRange_BeginDate (optional) 
     * @dueDateRange_EndDate (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @userId (optional) 
     * @enterpriseId (optional) 
     * @bankAccountId (optional) 
     * @costCenterId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAllPayable(filter: string | null, type: Type3 | null, status: Status11 | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, dueDateRange_BeginDate: moment.Moment | null, dueDateRange_EndDate: moment.Moment | null, eventId: number | null, coursesIds: number[] | null, annuityId: number | null, userId: number | null, enterpriseId: number | null, bankAccountId: number | null, costCenterId: number | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetPayableForView> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetAllPayable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (dueDateRange_BeginDate !== undefined)
            url_ += "DueDateRange.BeginDate=" + encodeURIComponent(dueDateRange_BeginDate ? "" + dueDateRange_BeginDate.toJSON() : "") + "&"; 
        if (dueDateRange_EndDate !== undefined)
            url_ += "DueDateRange.EndDate=" + encodeURIComponent(dueDateRange_EndDate ? "" + dueDateRange_EndDate.toJSON() : "") + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPayable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllPayable(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPayableForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPayableForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPayable(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetPayableForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetPayableForView.fromJS(resultData200) : new PagedResultDtoOfGetPayableForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetPayableForView>(<any>null);
    }

    /**
     * @return Success
     */
    getPayableForEdit(id: number): Observable<GetPayableForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetPayableForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPayableForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPayableForEdit(response_);
                } catch (e) {
                    return <Observable<GetPayableForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPayableForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPayableForEdit(response: HttpResponse<Blob>): Observable<GetPayableForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPayableForEditOutput.fromJS(resultData200) : new GetPayableForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetPayableForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditPayable(input: CreateOrEditPayableDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/CreateOrEditPayable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditPayable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditPayable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditPayable(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @type (optional) 
     * @status (optional) 
     * @createDateRange_BeginDate (optional) 
     * @createDateRange_EndDate (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @dueDateRange_BeginDate (optional) 
     * @dueDateRange_EndDate (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @enterpriseId (optional) 
     * @userId (optional) 
     * @bankAccountId (optional) 
     * @costCenterId (optional) 
     * @return Success
     */
    getPayablesToExcel(filter: string | null, type: Type4 | null, status: Status12 | null, createDateRange_BeginDate: moment.Moment | null, createDateRange_EndDate: moment.Moment | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, dueDateRange_BeginDate: moment.Moment | null, dueDateRange_EndDate: moment.Moment | null, eventId: number | null, coursesIds: number[] | null, annuityId: number | null, enterpriseId: number | null, userId: number | null, bankAccountId: number | null, costCenterId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/GetPayablesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (createDateRange_BeginDate !== undefined)
            url_ += "CreateDateRange.BeginDate=" + encodeURIComponent(createDateRange_BeginDate ? "" + createDateRange_BeginDate.toJSON() : "") + "&"; 
        if (createDateRange_EndDate !== undefined)
            url_ += "CreateDateRange.EndDate=" + encodeURIComponent(createDateRange_EndDate ? "" + createDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (dueDateRange_BeginDate !== undefined)
            url_ += "DueDateRange.BeginDate=" + encodeURIComponent(dueDateRange_BeginDate ? "" + dueDateRange_BeginDate.toJSON() : "") + "&"; 
        if (dueDateRange_EndDate !== undefined)
            url_ += "DueDateRange.EndDate=" + encodeURIComponent(dueDateRange_EndDate ? "" + dueDateRange_EndDate.toJSON() : "") + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPayablesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPayablesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPayablesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancelPayable(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/CancelPayable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCancelPayable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCancelPayable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancelPayable(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deletePayable(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/DeletePayable?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeletePayable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeletePayable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePayable(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCreditCardFeeCigam(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/CreateCreditCardFeeCigam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateCreditCardFeeCigam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateCreditCardFeeCigam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateCreditCardFeeCigam(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTicketFeeCigam(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/CreateTicketFeeCigam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateTicketFeeCigam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateTicketFeeCigam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTicketFeeCigam(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    liquidarLancamentoCigam(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentCharges/LiquidarLancamentoCigam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processLiquidarLancamentoCigam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processLiquidarLancamentoCigam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processLiquidarLancamentoCigam(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentMethodsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @onlyActives (optional) 
     * @onlyDefaultToReceivable (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, onlyActives: boolean | null, onlyDefaultToReceivable: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetPaymentMethodForView> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (onlyActives !== undefined)
            url_ += "OnlyActives=" + encodeURIComponent("" + onlyActives) + "&"; 
        if (onlyDefaultToReceivable !== undefined)
            url_ += "OnlyDefaultToReceivable=" + encodeURIComponent("" + onlyDefaultToReceivable) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPaymentMethodForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPaymentMethodForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetPaymentMethodForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetPaymentMethodForView.fromJS(resultData200) : new PagedResultDtoOfGetPaymentMethodForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetPaymentMethodForView>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getPaymentMethodsForSelect(term: string | null, onlyActives: boolean, onlyDefaultToReceivable: boolean): Observable<ListResultDtoOfPaymentMethodEditDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPaymentMethodsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (onlyActives === undefined || onlyActives === null)
            throw new Error("The parameter 'onlyActives' must be defined and cannot be null.");
        else
            url_ += "OnlyActives=" + encodeURIComponent("" + onlyActives) + "&"; 
        if (onlyDefaultToReceivable === undefined || onlyDefaultToReceivable === null)
            throw new Error("The parameter 'onlyDefaultToReceivable' must be defined and cannot be null.");
        else
            url_ += "OnlyDefaultToReceivable=" + encodeURIComponent("" + onlyDefaultToReceivable) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentMethodsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentMethodsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPaymentMethodEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPaymentMethodEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentMethodsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfPaymentMethodEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPaymentMethodEditDto.fromJS(resultData200) : new ListResultDtoOfPaymentMethodEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfPaymentMethodEditDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @annuityId (optional) 
     * @annuityCategoryDeadlineIds (optional) 
     * @eventsIds (optional) 
     * @eventCategoryDeadlineIds (optional) 
     * @return Success
     */
    getOrderPaymentMethodsForSelect(term: string | null, onlyActives: boolean, onlyDefaultToReceivable: boolean, annuityId: number | null, annuityCategoryDeadlineIds: number[] | null, eventsIds: number[] | null, eventCategoryDeadlineIds: number[] | null): Observable<ListResultDtoOfPaymentMethodEditDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetOrderPaymentMethodsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (onlyActives === undefined || onlyActives === null)
            throw new Error("The parameter 'onlyActives' must be defined and cannot be null.");
        else
            url_ += "OnlyActives=" + encodeURIComponent("" + onlyActives) + "&"; 
        if (onlyDefaultToReceivable === undefined || onlyDefaultToReceivable === null)
            throw new Error("The parameter 'onlyDefaultToReceivable' must be defined and cannot be null.");
        else
            url_ += "OnlyDefaultToReceivable=" + encodeURIComponent("" + onlyDefaultToReceivable) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (annuityCategoryDeadlineIds !== undefined)
            annuityCategoryDeadlineIds && annuityCategoryDeadlineIds.forEach(item => { url_ += "AnnuityCategoryDeadlineIds=" + encodeURIComponent("" + item) + "&"; });
        if (eventsIds !== undefined)
            eventsIds && eventsIds.forEach(item => { url_ += "EventsIds=" + encodeURIComponent("" + item) + "&"; });
        if (eventCategoryDeadlineIds !== undefined)
            eventCategoryDeadlineIds && eventCategoryDeadlineIds.forEach(item => { url_ += "EventCategoryDeadlineIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetOrderPaymentMethodsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetOrderPaymentMethodsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPaymentMethodEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPaymentMethodEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrderPaymentMethodsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfPaymentMethodEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPaymentMethodEditDto.fromJS(resultData200) : new ListResultDtoOfPaymentMethodEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfPaymentMethodEditDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getPaymentMethodTypesForSelect(filter: string | null): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPaymentMethodTypesForSelect?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentMethodTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentMethodTypesForSelect(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentMethodTypesForSelect(response: HttpResponse<Blob>): Observable<string[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @isActive (optional) 
     * @return Success
     */
    getAllCardBrands(filter: string | null, isActive: boolean | null): Observable<CardBrandDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetAllCardBrands?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCardBrands(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllCardBrands(response_);
                } catch (e) {
                    return <Observable<CardBrandDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CardBrandDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCardBrands(response: HttpResponse<Blob>): Observable<CardBrandDto[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CardBrandDto.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CardBrandDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentMethodForEdit(id: number): Observable<GetPaymentMethodForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPaymentMethodForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentMethodForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentMethodForEdit(response_);
                } catch (e) {
                    return <Observable<GetPaymentMethodForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPaymentMethodForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentMethodForEdit(response: HttpResponse<Blob>): Observable<GetPaymentMethodForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPaymentMethodForEditOutput.fromJS(resultData200) : new GetPaymentMethodForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetPaymentMethodForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPaymentMethodDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @paymentMethodType (optional) 
     * @bankAccountId (optional) 
     * @bankAccount_TenantId (optional) 
     * @bankAccount_Description (optional) 
     * @bankAccount_BankCode (optional) 
     * @bankAccount_Agency (optional) 
     * @bankAccount_AgencyDigit (optional) 
     * @bankAccount_CheckingAccount (optional) 
     * @bankAccount_CheckingAccountDigit (optional) 
     * @bankAccount_HolderName (optional) 
     * @bankAccount_Cnpj (optional) 
     * @bankAccount_DeleterUserId (optional) 
     * @bankAccount_DeletionTime (optional) 
     * @bankAccount_LastModificationTime (optional) 
     * @bankAccount_LastModifierUserId (optional) 
     * @bankAccount_CreatorUserId (optional) 
     * @permissions (optional) 
     * @deleterUserId (optional) 
     * @deletionTime (optional) 
     * @lastModificationTime (optional) 
     * @lastModifierUserId (optional) 
     * @creatorUserId (optional) 
     * @return Success
     */
    getPaymentMethodDtoByType(tenantId: number | null, isActive: boolean, description: string, environmentType: EnvironmentType, maxFee: number, isDefaultToReceivable: boolean, paymentMethodType: string | null, bankAccountId: number | null, bankAccount_TenantId: number | null, bankAccount_Description: string | null, bankAccount_BankCode: string | null, bankAccount_Agency: string | null, bankAccount_AgencyDigit: string | null, bankAccount_CheckingAccount: string | null, bankAccount_CheckingAccountDigit: string | null, bankAccount_HolderName: string | null, bankAccount_Cnpj: string | null, bankAccount_IsDeleted: boolean, bankAccount_DeleterUserId: number | null, bankAccount_DeletionTime: moment.Moment | null, bankAccount_LastModificationTime: moment.Moment | null, bankAccount_LastModifierUserId: number | null, bankAccount_CreationTime: moment.Moment, bankAccount_CreatorUserId: number | null, bankAccount_Id: number, permissions: any[] | null, isDeleted: boolean, deleterUserId: number | null, deletionTime: moment.Moment | null, lastModificationTime: moment.Moment | null, lastModifierUserId: number | null, creationTime: moment.Moment, creatorUserId: number | null, id: number): Observable<CreateOrEditPaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPaymentMethodDtoByType?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (description === undefined || description === null)
            throw new Error("The parameter 'description' must be defined and cannot be null.");
        else
            url_ += "Description=" + encodeURIComponent("" + description) + "&"; 
        if (environmentType === undefined || environmentType === null)
            throw new Error("The parameter 'environmentType' must be defined and cannot be null.");
        else
            url_ += "EnvironmentType=" + encodeURIComponent("" + environmentType) + "&"; 
        if (maxFee === undefined || maxFee === null)
            throw new Error("The parameter 'maxFee' must be defined and cannot be null.");
        else
            url_ += "MaxFee=" + encodeURIComponent("" + maxFee) + "&"; 
        if (isDefaultToReceivable === undefined || isDefaultToReceivable === null)
            throw new Error("The parameter 'isDefaultToReceivable' must be defined and cannot be null.");
        else
            url_ += "IsDefaultToReceivable=" + encodeURIComponent("" + isDefaultToReceivable) + "&"; 
        if (paymentMethodType !== undefined)
            url_ += "PaymentMethodType=" + encodeURIComponent("" + paymentMethodType) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (bankAccount_TenantId !== undefined)
            url_ += "BankAccount.TenantId=" + encodeURIComponent("" + bankAccount_TenantId) + "&"; 
        if (bankAccount_Description !== undefined)
            url_ += "BankAccount.Description=" + encodeURIComponent("" + bankAccount_Description) + "&"; 
        if (bankAccount_BankCode !== undefined)
            url_ += "BankAccount.BankCode=" + encodeURIComponent("" + bankAccount_BankCode) + "&"; 
        if (bankAccount_Agency !== undefined)
            url_ += "BankAccount.Agency=" + encodeURIComponent("" + bankAccount_Agency) + "&"; 
        if (bankAccount_AgencyDigit !== undefined)
            url_ += "BankAccount.AgencyDigit=" + encodeURIComponent("" + bankAccount_AgencyDigit) + "&"; 
        if (bankAccount_CheckingAccount !== undefined)
            url_ += "BankAccount.CheckingAccount=" + encodeURIComponent("" + bankAccount_CheckingAccount) + "&"; 
        if (bankAccount_CheckingAccountDigit !== undefined)
            url_ += "BankAccount.CheckingAccountDigit=" + encodeURIComponent("" + bankAccount_CheckingAccountDigit) + "&"; 
        if (bankAccount_HolderName !== undefined)
            url_ += "BankAccount.HolderName=" + encodeURIComponent("" + bankAccount_HolderName) + "&"; 
        if (bankAccount_Cnpj !== undefined)
            url_ += "BankAccount.Cnpj=" + encodeURIComponent("" + bankAccount_Cnpj) + "&"; 
        if (bankAccount_IsDeleted === undefined || bankAccount_IsDeleted === null)
            throw new Error("The parameter 'bankAccount_IsDeleted' must be defined and cannot be null.");
        else
            url_ += "BankAccount.IsDeleted=" + encodeURIComponent("" + bankAccount_IsDeleted) + "&"; 
        if (bankAccount_DeleterUserId !== undefined)
            url_ += "BankAccount.DeleterUserId=" + encodeURIComponent("" + bankAccount_DeleterUserId) + "&"; 
        if (bankAccount_DeletionTime !== undefined)
            url_ += "BankAccount.DeletionTime=" + encodeURIComponent(bankAccount_DeletionTime ? "" + bankAccount_DeletionTime.toJSON() : "") + "&"; 
        if (bankAccount_LastModificationTime !== undefined)
            url_ += "BankAccount.LastModificationTime=" + encodeURIComponent(bankAccount_LastModificationTime ? "" + bankAccount_LastModificationTime.toJSON() : "") + "&"; 
        if (bankAccount_LastModifierUserId !== undefined)
            url_ += "BankAccount.LastModifierUserId=" + encodeURIComponent("" + bankAccount_LastModifierUserId) + "&"; 
        if (bankAccount_CreationTime === undefined || bankAccount_CreationTime === null)
            throw new Error("The parameter 'bankAccount_CreationTime' must be defined and cannot be null.");
        else
            url_ += "BankAccount.CreationTime=" + encodeURIComponent(bankAccount_CreationTime ? "" + bankAccount_CreationTime.toJSON() : "") + "&"; 
        if (bankAccount_CreatorUserId !== undefined)
            url_ += "BankAccount.CreatorUserId=" + encodeURIComponent("" + bankAccount_CreatorUserId) + "&"; 
        if (bankAccount_Id === undefined || bankAccount_Id === null)
            throw new Error("The parameter 'bankAccount_Id' must be defined and cannot be null.");
        else
            url_ += "BankAccount.Id=" + encodeURIComponent("" + bankAccount_Id) + "&"; 
        if (permissions !== undefined)
            permissions && permissions.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "Permissions[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        if (isDeleted === undefined || isDeleted === null)
            throw new Error("The parameter 'isDeleted' must be defined and cannot be null.");
        else
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (deleterUserId !== undefined)
            url_ += "DeleterUserId=" + encodeURIComponent("" + deleterUserId) + "&"; 
        if (deletionTime !== undefined)
            url_ += "DeletionTime=" + encodeURIComponent(deletionTime ? "" + deletionTime.toJSON() : "") + "&"; 
        if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toJSON() : "") + "&"; 
        if (lastModifierUserId !== undefined)
            url_ += "LastModifierUserId=" + encodeURIComponent("" + lastModifierUserId) + "&"; 
        if (creationTime === undefined || creationTime === null)
            throw new Error("The parameter 'creationTime' must be defined and cannot be null.");
        else
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toJSON() : "") + "&"; 
        if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&"; 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentMethodDtoByType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentMethodDtoByType(response_);
                } catch (e) {
                    return <Observable<CreateOrEditPaymentMethodDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditPaymentMethodDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentMethodDtoByType(response: HttpResponse<Blob>): Observable<CreateOrEditPaymentMethodDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditPaymentMethodDto.fromJS(resultData200) : new CreateOrEditPaymentMethodDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditPaymentMethodDto>(<any>null);
    }

    /**
     * @description (optional) 
     * @paymentMethodType (optional) 
     * @bankAccountId (optional) 
     * @bankAccount_Description (optional) 
     * @bankAccount_CheckingAccount (optional) 
     * @bankAccount_CheckingAccountDigit (optional) 
     * @cardBrands (optional) 
     * @id (optional) 
     * @return Success
     */
    getPaymentMethodByType(description: string | null, environmentType: EnvironmentType2, maxFee: number, isActive: boolean, paymentMethodType: string | null, isDefaultToReceivable: boolean, bankAccountId: number | null, bankAccount_Description: string | null, bankAccount_CheckingAccount: string | null, bankAccount_CheckingAccountDigit: string | null, bankAccount_Id: number, cardBrands: any[] | null, id: number | null): Observable<PaymentMethod> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPaymentMethodByType?";
        if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&"; 
        if (environmentType === undefined || environmentType === null)
            throw new Error("The parameter 'environmentType' must be defined and cannot be null.");
        else
            url_ += "EnvironmentType=" + encodeURIComponent("" + environmentType) + "&"; 
        if (maxFee === undefined || maxFee === null)
            throw new Error("The parameter 'maxFee' must be defined and cannot be null.");
        else
            url_ += "MaxFee=" + encodeURIComponent("" + maxFee) + "&"; 
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (paymentMethodType !== undefined)
            url_ += "PaymentMethodType=" + encodeURIComponent("" + paymentMethodType) + "&"; 
        if (isDefaultToReceivable === undefined || isDefaultToReceivable === null)
            throw new Error("The parameter 'isDefaultToReceivable' must be defined and cannot be null.");
        else
            url_ += "IsDefaultToReceivable=" + encodeURIComponent("" + isDefaultToReceivable) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (bankAccount_Description !== undefined)
            url_ += "BankAccount.Description=" + encodeURIComponent("" + bankAccount_Description) + "&"; 
        if (bankAccount_CheckingAccount !== undefined)
            url_ += "BankAccount.CheckingAccount=" + encodeURIComponent("" + bankAccount_CheckingAccount) + "&"; 
        if (bankAccount_CheckingAccountDigit !== undefined)
            url_ += "BankAccount.CheckingAccountDigit=" + encodeURIComponent("" + bankAccount_CheckingAccountDigit) + "&"; 
        if (bankAccount_Id === undefined || bankAccount_Id === null)
            throw new Error("The parameter 'bankAccount_Id' must be defined and cannot be null.");
        else
            url_ += "BankAccount.Id=" + encodeURIComponent("" + bankAccount_Id) + "&"; 
        if (cardBrands !== undefined)
            cardBrands && cardBrands.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "CardBrands[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentMethodByType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentMethodByType(response_);
                } catch (e) {
                    return <Observable<PaymentMethod>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentMethod>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentMethodByType(response: HttpResponse<Blob>): Observable<PaymentMethod> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentMethod.fromJS(resultData200) : new PaymentMethod();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PaymentMethod>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getPaymentMethodsToExcel(filter: string | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPaymentMethodsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentMethodsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPaymentMethodsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentMethodsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllPermissions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPermissions(response: HttpResponse<Blob>): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200) : new ListResultDtoOfFlatPermissionWithLevelDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponse<Blob>): Observable<CurrentUserProfileEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentUserProfileEditDto.fromJS(resultData200) : new CurrentUserProfileEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponse<Blob>): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200) : new UpdateGoogleAuthenticatorKeyOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @return Success
     */
    sendVerificationSms(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendVerificationSms(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendVerificationSms(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    verifySmsCode(input: VerifySmsCodeInputDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processVerifySmsCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processVerifySmsCode(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCurrentUserProfile(input: CurrentUserProfileEditDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateCurrentUserProfile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCurrentUserProfile(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processChangePassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processChangePassword(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangePassword(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProfilePicture(input: UpdateProfilePictureInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateProfilePicture(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProfilePicture(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPasswordComplexitySetting(response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPasswordComplexitySetting(response: HttpResponse<Blob>): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPasswordComplexitySettingOutput.fromJS(resultData200) : new GetPasswordComplexitySettingOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetProfilePicture(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePicture(response: HttpResponse<Blob>): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @profilePictureId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string | null, userId: number, tenantId: number | null): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetFriendProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetFriendProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFriendProfilePictureById(response: HttpResponse<Blob>): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePictureById(profilePictureId: string): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === undefined || profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' must be defined and cannot be null.");
        else
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePictureById(response: HttpResponse<Blob>): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processChangeLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeLanguage(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ProgrammingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @eventId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, eventId: number | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetProgrammingForView> {
        let url_ = this.baseUrl + "/api/services/app/Programmings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProgrammingForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProgrammingForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetProgrammingForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetProgrammingForView.fromJS(resultData200) : new PagedResultDtoOfGetProgrammingForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetProgrammingForView>(<any>null);
    }

    /**
     * @term (optional) 
     * @currentEventId (optional) 
     * @return Success
     */
    getProgrammingsForSelect(term: string | null, currentEventId: number | null): Observable<ListResultDtoOfProgrammingListDto> {
        let url_ = this.baseUrl + "/api/services/app/Programmings/GetProgrammingsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (currentEventId !== undefined)
            url_ += "CurrentEventId=" + encodeURIComponent("" + currentEventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetProgrammingsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetProgrammingsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProgrammingListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProgrammingListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProgrammingsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfProgrammingListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProgrammingListDto.fromJS(resultData200) : new ListResultDtoOfProgrammingListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfProgrammingListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProgrammingForEdit(id: number): Observable<GetProgrammingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Programmings/GetProgrammingForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetProgrammingForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetProgrammingForEdit(response_);
                } catch (e) {
                    return <Observable<GetProgrammingForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgrammingForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProgrammingForEdit(response: HttpResponse<Blob>): Observable<GetProgrammingForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProgrammingForEditOutput.fromJS(resultData200) : new GetProgrammingForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetProgrammingForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProgrammingDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Programmings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ProtocolsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @protocolType (optional) 
     * @dateRange_BeginDate (optional) 
     * @dateRange_EndDate (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, protocolType: string | null, dateRange_BeginDate: moment.Moment | null, dateRange_EndDate: moment.Moment | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetProtocolForView> {
        let url_ = this.baseUrl + "/api/services/app/Protocols/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (protocolType !== undefined)
            url_ += "ProtocolType=" + encodeURIComponent("" + protocolType) + "&"; 
        if (dateRange_BeginDate !== undefined)
            url_ += "DateRange.BeginDate=" + encodeURIComponent(dateRange_BeginDate ? "" + dateRange_BeginDate.toJSON() : "") + "&"; 
        if (dateRange_EndDate !== undefined)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProtocolForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProtocolForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetProtocolForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetProtocolForView.fromJS(resultData200) : new PagedResultDtoOfGetProtocolForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetProtocolForView>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getProtocolTypesForSelect(filter: string | null): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Protocols/GetProtocolTypesForSelect?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetProtocolTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetProtocolTypesForSelect(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProtocolTypesForSelect(response: HttpResponse<Blob>): Observable<string[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProtocolForEdit(id: number): Observable<GetProtocolForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Protocols/GetProtocolForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetProtocolForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetProtocolForEdit(response_);
                } catch (e) {
                    return <Observable<GetProtocolForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProtocolForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProtocolForEdit(response: HttpResponse<Blob>): Observable<GetProtocolForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProtocolForEditOutput.fromJS(resultData200) : new GetProtocolForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetProtocolForEditOutput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @protocolType (optional) 
     * @dateRange_BeginDate (optional) 
     * @dateRange_EndDate (optional) 
     * @return Success
     */
    getProtocolsToExcel(filter: string | null, protocolType: string | null, dateRange_BeginDate: moment.Moment | null, dateRange_EndDate: moment.Moment | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Protocols/GetProtocolsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (protocolType !== undefined)
            url_ += "ProtocolType=" + encodeURIComponent("" + protocolType) + "&"; 
        if (dateRange_BeginDate !== undefined)
            url_ += "DateRange.BeginDate=" + encodeURIComponent(dateRange_BeginDate ? "" + dateRange_BeginDate.toJSON() : "") + "&"; 
        if (dateRange_EndDate !== undefined)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetProtocolsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetProtocolsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProtocolsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProtocolDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Protocols/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Protocols/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class RegionalsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRegionals(): Observable<ListResultDtoOfRegionalDto> {
        let url_ = this.baseUrl + "/api/services/app/Regionals/GetRegionals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetRegionals(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetRegionals(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRegionalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRegionalDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRegionals(response: HttpResponse<Blob>): Observable<ListResultDtoOfRegionalDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRegionalDto.fromJS(resultData200) : new ListResultDtoOfRegionalDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfRegionalDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createRegional(input: CreateRegionalInput | null): Observable<RegionalDto> {
        let url_ = this.baseUrl + "/api/services/app/Regionals/CreateRegional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateRegional(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateRegional(response_);
                } catch (e) {
                    return <Observable<RegionalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegionalDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateRegional(response: HttpResponse<Blob>): Observable<RegionalDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegionalDto.fromJS(resultData200) : new RegionalDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<RegionalDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateRegional(input: UpdateRegionalInput | null): Observable<RegionalDto> {
        let url_ = this.baseUrl + "/api/services/app/Regionals/UpdateRegional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRegional(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateRegional(response_);
                } catch (e) {
                    return <Observable<RegionalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegionalDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRegional(response: HttpResponse<Blob>): Observable<RegionalDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegionalDto.fromJS(resultData200) : new RegionalDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<RegionalDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setDefaultRegional(input: UpdateRegionalInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Regionals/SetDefaultRegional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSetDefaultRegional(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSetDefaultRegional(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDefaultRegional(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class RegistrationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @hasPresence (optional) 
     * @annuityPaid (optional) 
     * @categoryId (optional) 
     * @categoryDeadLineId (optional) 
     * @memberStatusId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @paymentStatus (optional) 
     * @situation (optional) 
     * @statusIntegracao (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @isResident (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @ids (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, hasPresence: boolean | null, annuityPaid: boolean | null, categoryId: number | null, categoryDeadLineId: number | null, memberStatusId: number | null, eventId: number | null, coursesIds: number[] | null, paymentStatus: PaymentStatus4 | null, situation: Situation | null, statusIntegracao: StatusIntegracao12 | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, isResident: boolean | null, country: string | null, countryState: string | null, city: string | null, ids: number[] | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetRegistrationForView> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (hasPresence !== undefined)
            url_ += "HasPresence=" + encodeURIComponent("" + hasPresence) + "&"; 
        if (annuityPaid !== undefined)
            url_ += "AnnuityPaid=" + encodeURIComponent("" + annuityPaid) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryDeadLineId !== undefined)
            url_ += "CategoryDeadLineId=" + encodeURIComponent("" + categoryDeadLineId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        if (situation !== undefined)
            url_ += "Situation=" + encodeURIComponent("" + situation) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegistrationForView>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegistrationForView>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetRegistrationForView> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetRegistrationForView.fromJS(resultData200) : new PagedResultDtoOfGetRegistrationForView();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetRegistrationForView>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getForEdit(id: number | null): Observable<GetRegistrationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetForEdit(response_);
                } catch (e) {
                    return <Observable<GetRegistrationForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRegistrationForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetForEdit(response: HttpResponse<Blob>): Observable<GetRegistrationForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRegistrationForEditOutput.fromJS(resultData200) : new GetRegistrationForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetRegistrationForEditOutput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @hasPresence (optional) 
     * @annuityPaid (optional) 
     * @categoryId (optional) 
     * @categoryDeadLineId (optional) 
     * @memberStatusId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @paymentStatus (optional) 
     * @situation (optional) 
     * @statusIntegracao (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @isResident (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @ids (optional) 
     * @return Success
     */
    getRegistrationsToExcel(filter: string | null, hasPresence: boolean | null, annuityPaid: boolean | null, categoryId: number | null, categoryDeadLineId: number | null, memberStatusId: number | null, eventId: number | null, coursesIds: number[] | null, paymentStatus: PaymentStatus5 | null, situation: Situation2 | null, statusIntegracao: StatusIntegracao13 | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, isResident: boolean | null, country: string | null, countryState: string | null, city: string | null, ids: number[] | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetRegistrationsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (hasPresence !== undefined)
            url_ += "HasPresence=" + encodeURIComponent("" + hasPresence) + "&"; 
        if (annuityPaid !== undefined)
            url_ += "AnnuityPaid=" + encodeURIComponent("" + annuityPaid) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryDeadLineId !== undefined)
            url_ += "CategoryDeadLineId=" + encodeURIComponent("" + categoryDeadLineId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        if (situation !== undefined)
            url_ += "Situation=" + encodeURIComponent("" + situation) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetRegistrationsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetRegistrationsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRegistrationsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRegistrationByAdminDto | null): Observable<CreateOrEditRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<CreateOrEditRegistrationOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditRegistrationOutput.fromJS(resultData200) : new CreateOrEditRegistrationOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditRegistrationOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditByAdmin(input: CreateOrEditRegistrationByAdminDto | null): Observable<CreateOrEditRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CreateOrEditByAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditByAdmin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditByAdmin(response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditByAdmin(response: HttpResponse<Blob>): Observable<CreateOrEditRegistrationOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditRegistrationOutput.fromJS(resultData200) : new CreateOrEditRegistrationOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditRegistrationOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUserForRegistration(input: RegistrationUserEditDto | null): Observable<UserEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CreateUserForRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateUserForRegistration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateUserForRegistration(response_);
                } catch (e) {
                    return <Observable<UserEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UserEditDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateUserForRegistration(response: HttpResponse<Blob>): Observable<UserEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserEditDto.fromJS(resultData200) : new UserEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<UserEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkExistingRegistration(input: CreateOrEditRegistrationByAdminDto | null): Observable<CreateOrEditRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CheckExistingRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCheckExistingRegistration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCheckExistingRegistration(response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(response_);
        });
    }

    protected processCheckExistingRegistration(response: HttpResponse<Blob>): Observable<CreateOrEditRegistrationOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditRegistrationOutput.fromJS(resultData200) : new CreateOrEditRegistrationOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditRegistrationOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: CreateOrEditRegistrationByAdminDto | null): Observable<CreateOrEditRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: HttpResponse<Blob>): Observable<CreateOrEditRegistrationOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditRegistrationOutput.fromJS(resultData200) : new CreateOrEditRegistrationOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditRegistrationOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateRegistrationPaymentValuesAsync(input: UpdatePaymentInput | null): Observable<PaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/UpdateRegistrationPaymentValuesAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRegistrationPaymentValuesAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateRegistrationPaymentValuesAsync(response_);
                } catch (e) {
                    return <Observable<PaymentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRegistrationPaymentValuesAsync(response: HttpResponse<Blob>): Observable<PaymentDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentDto.fromJS(resultData200) : new PaymentDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PaymentDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotes(input: UpdateNotesDto | null): Observable<NoteEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/UpdateNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateNotes(response_);
                } catch (e) {
                    return <Observable<NoteEditDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NoteEditDto[]>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotes(response: HttpResponse<Blob>): Observable<NoteEditDto[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NoteEditDto.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<NoteEditDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    approve(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processApprove(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processApprove(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processApprove(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendRegistrationApprovedEmail(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/SendRegistrationApprovedEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendRegistrationApprovedEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendRegistrationApprovedEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendRegistrationApprovedEmail(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    disapprove(input: DisapproveRegistrationInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/Disapprove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processDisapprove(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDisapprove(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDisapprove(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancel(input: CancelRegistrationInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCancel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCancel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancel(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setPresence(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/SetPresence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSetPresence(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSetPresence(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetPresence(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deletePresence(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/DeletePresence?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeletePresence(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeletePresence(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePresence(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    transferToAnotherEvent(input: TransferRegistrationAnotherEventDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/TransferToAnotherEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processTransferToAnotherEvent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processTransferToAnotherEvent(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransferToAnotherEvent(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    transferToAnotherUser(input: TransferRegistrationDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/TransferToAnotherUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processTransferToAnotherUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processTransferToAnotherUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransferToAnotherUser(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadPresenceToRegistrations(input: UploadPresenceToRegistrationsDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/UploadPresenceToRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUploadPresenceToRegistrations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUploadPresenceToRegistrations(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadPresenceToRegistrations(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @hasPresence (optional) 
     * @annuityPaid (optional) 
     * @categoryId (optional) 
     * @categoryDeadLineId (optional) 
     * @memberStatusId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @paymentStatus (optional) 
     * @situation (optional) 
     * @statusIntegracao (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @isResident (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @ids (optional) 
     * @return Success
     */
    getCredentials(envelopeTicket: boolean, filter: string | null, hasPresence: boolean | null, annuityPaid: boolean | null, categoryId: number | null, categoryDeadLineId: number | null, memberStatusId: number | null, eventId: number | null, coursesIds: number[] | null, paymentStatus: PaymentStatus6 | null, situation: Situation3 | null, statusIntegracao: StatusIntegracao14 | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, isResident: boolean | null, country: string | null, countryState: string | null, city: string | null, ids: number[] | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetCredentials?";
        if (envelopeTicket === undefined || envelopeTicket === null)
            throw new Error("The parameter 'envelopeTicket' must be defined and cannot be null.");
        else
            url_ += "EnvelopeTicket=" + encodeURIComponent("" + envelopeTicket) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (hasPresence !== undefined)
            url_ += "HasPresence=" + encodeURIComponent("" + hasPresence) + "&"; 
        if (annuityPaid !== undefined)
            url_ += "AnnuityPaid=" + encodeURIComponent("" + annuityPaid) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryDeadLineId !== undefined)
            url_ += "CategoryDeadLineId=" + encodeURIComponent("" + categoryDeadLineId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        if (situation !== undefined)
            url_ += "Situation=" + encodeURIComponent("" + situation) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCredentials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCredentials(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCredentials(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @hasPresence (optional) 
     * @annuityPaid (optional) 
     * @categoryId (optional) 
     * @categoryDeadLineId (optional) 
     * @memberStatusId (optional) 
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @paymentStatus (optional) 
     * @situation (optional) 
     * @statusIntegracao (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @isResident (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @ids (optional) 
     * @return Success
     */
    getUserAddressTags(filter: string | null, hasPresence: boolean | null, annuityPaid: boolean | null, categoryId: number | null, categoryDeadLineId: number | null, memberStatusId: number | null, eventId: number | null, coursesIds: number[] | null, paymentStatus: PaymentStatus7 | null, situation: Situation4 | null, statusIntegracao: StatusIntegracao15 | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, isResident: boolean | null, country: string | null, countryState: string | null, city: string | null, ids: number[] | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetUserAddressTags?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (hasPresence !== undefined)
            url_ += "HasPresence=" + encodeURIComponent("" + hasPresence) + "&"; 
        if (annuityPaid !== undefined)
            url_ += "AnnuityPaid=" + encodeURIComponent("" + annuityPaid) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryDeadLineId !== undefined)
            url_ += "CategoryDeadLineId=" + encodeURIComponent("" + categoryDeadLineId) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        if (situation !== undefined)
            url_ += "Situation=" + encodeURIComponent("" + situation) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserAddressTags(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserAddressTags(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserAddressTags(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @event (optional) 
     * @activityId (optional) 
     * @module (optional) 
     * @topic (optional) 
     * @role (optional) 
     * @surveyId (optional) 
     * @return Success
     */
    getCertificate(event: string | null, registrationId: number, isCNA: boolean, activityId: number | null, module: string | null, topic: string | null, role: string | null, type: Type5, surveyId: number | null, answeredSurvey: boolean, workId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetCertificate?";
        if (event !== undefined)
            url_ += "Event=" + encodeURIComponent("" + event) + "&"; 
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined and cannot be null.");
        else
            url_ += "RegistrationId=" + encodeURIComponent("" + registrationId) + "&"; 
        if (isCNA === undefined || isCNA === null)
            throw new Error("The parameter 'isCNA' must be defined and cannot be null.");
        else
            url_ += "IsCNA=" + encodeURIComponent("" + isCNA) + "&"; 
        if (activityId !== undefined)
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&"; 
        if (module !== undefined)
            url_ += "Module=" + encodeURIComponent("" + module) + "&"; 
        if (topic !== undefined)
            url_ += "Topic=" + encodeURIComponent("" + topic) + "&"; 
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (answeredSurvey === undefined || answeredSurvey === null)
            throw new Error("The parameter 'answeredSurvey' must be defined and cannot be null.");
        else
            url_ += "AnsweredSurvey=" + encodeURIComponent("" + answeredSurvey) + "&"; 
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined and cannot be null.");
        else
            url_ += "WorkId=" + encodeURIComponent("" + workId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCertificate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCertificate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCertificate(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @eventId (optional) 
     * @annuityId (optional) 
     * @return Success
     */
    getUserForRegistration(userId: number, eventId: number | null, annuityId: number | null): Observable<RegistrationUserDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetUserForRegistration?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserForRegistration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserForRegistration(response_);
                } catch (e) {
                    return <Observable<RegistrationUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegistrationUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserForRegistration(response: HttpResponse<Blob>): Observable<RegistrationUserDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegistrationUserDto.fromJS(resultData200) : new RegistrationUserDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<RegistrationUserDto>(<any>null);
    }

    /**
     * @eventTypeDescription (optional) 
     * @situation (optional) 
     * @paymentStatus (optional) 
     * @registrationId (optional) 
     * @return Success
     */
    getUserRegistrations(userId: number, eventTypeDescription: string | null, situation: Situation5 | null, paymentStatus: PaymentStatus8 | null, registrationId: number | null): Observable<ListResultDtoOfUserRegistrationListDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetUserRegistrations?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (eventTypeDescription !== undefined)
            url_ += "EventTypeDescription=" + encodeURIComponent("" + eventTypeDescription) + "&"; 
        if (situation !== undefined)
            url_ += "Situation=" + encodeURIComponent("" + situation) + "&"; 
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&"; 
        if (registrationId !== undefined)
            url_ += "RegistrationId=" + encodeURIComponent("" + registrationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserRegistrations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserRegistrations(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserRegistrationListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserRegistrationListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserRegistrations(response: HttpResponse<Blob>): Observable<ListResultDtoOfUserRegistrationListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserRegistrationListDto.fromJS(resultData200) : new ListResultDtoOfUserRegistrationListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfUserRegistrationListDto>(<any>null);
    }
}

@Injectable()
export class ReportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @customer (optional) 
     * @paymentChargeType (optional) 
     * @costCenterId (optional) 
     * @eventId (optional) 
     * @enterpriseId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @bankAccountId (optional) 
     * @paymentMethodId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getExtract(customer: string | null, paymentChargeType: string | null, costCenterId: number | null, eventId: number | null, enterpriseId: number | null, coursesIds: number[] | null, annuityId: number | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, bankAccountId: number | null, paymentMethodId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<GetExtractOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetExtract?";
        if (customer !== undefined)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&"; 
        if (paymentChargeType !== undefined)
            url_ += "PaymentChargeType=" + encodeURIComponent("" + paymentChargeType) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetExtract(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetExtract(response_);
                } catch (e) {
                    return <Observable<GetExtractOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetExtractOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetExtract(response: HttpResponse<Blob>): Observable<GetExtractOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetExtractOutput.fromJS(resultData200) : new GetExtractOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetExtractOutput>(<any>null);
    }

    /**
     * @customer (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @paymentChargeType (optional) 
     * @costCenterId (optional) 
     * @eventId (optional) 
     * @enterpriseId (optional) 
     * @coursesIds (optional) 
     * @sorting (optional) 
     * @annuityId (optional) 
     * @bankAccountId (optional) 
     * @paymentMethodId (optional) 
     * @return Success
     */
    getExtractToExcel(customer: string | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, paymentChargeType: string | null, costCenterId: number | null, eventId: number | null, enterpriseId: number | null, coursesIds: number[] | null, sorting: string | null, annuityId: number | null, bankAccountId: number | null, paymentMethodId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetExtractToExcel?";
        if (customer !== undefined)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentChargeType !== undefined)
            url_ += "PaymentChargeType=" + encodeURIComponent("" + paymentChargeType) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetExtractToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetExtractToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetExtractToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @bankAccountId (optional) 
     * @expirationDateRange_BeginDate (optional) 
     * @expirationDateRange_EndDate (optional) 
     * @return Success
     */
    getCashFlowAsync(eventId: number | null, coursesIds: number[] | null, annuityId: number | null, bankAccountId: number | null, expirationDateRange_BeginDate: moment.Moment | null, expirationDateRange_EndDate: moment.Moment | null): Observable<GetCashFlowOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCashFlowAsync?";
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (expirationDateRange_BeginDate !== undefined)
            url_ += "ExpirationDateRange.BeginDate=" + encodeURIComponent(expirationDateRange_BeginDate ? "" + expirationDateRange_BeginDate.toJSON() : "") + "&"; 
        if (expirationDateRange_EndDate !== undefined)
            url_ += "ExpirationDateRange.EndDate=" + encodeURIComponent(expirationDateRange_EndDate ? "" + expirationDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCashFlowAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCashFlowAsync(response_);
                } catch (e) {
                    return <Observable<GetCashFlowOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCashFlowOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCashFlowAsync(response: HttpResponse<Blob>): Observable<GetCashFlowOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCashFlowOutput.fromJS(resultData200) : new GetCashFlowOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCashFlowOutput>(<any>null);
    }

    /**
     * @eventId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @bankAccountId (optional) 
     * @expirationDateRange_BeginDate (optional) 
     * @expirationDateRange_EndDate (optional) 
     * @return Success
     */
    getCashFlowToExcel(eventId: number | null, coursesIds: number[] | null, annuityId: number | null, bankAccountId: number | null, expirationDateRange_BeginDate: moment.Moment | null, expirationDateRange_EndDate: moment.Moment | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCashFlowToExcel?";
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (expirationDateRange_BeginDate !== undefined)
            url_ += "ExpirationDateRange.BeginDate=" + encodeURIComponent(expirationDateRange_BeginDate ? "" + expirationDateRange_BeginDate.toJSON() : "") + "&"; 
        if (expirationDateRange_EndDate !== undefined)
            url_ += "ExpirationDateRange.EndDate=" + encodeURIComponent(expirationDateRange_EndDate ? "" + expirationDateRange_EndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCashFlowToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCashFlowToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCashFlowToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @eventId (optional) 
     * @return Success
     */
    getSurveyTabulation(surveyId: number | null, eventId: number | null): Observable<GetSurveyTabulationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSurveyTabulation?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyTabulation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyTabulation(response_);
                } catch (e) {
                    return <Observable<GetSurveyTabulationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSurveyTabulationOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyTabulation(response: HttpResponse<Blob>): Observable<GetSurveyTabulationOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSurveyTabulationOutput.fromJS(resultData200) : new GetSurveyTabulationOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSurveyTabulationOutput>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @eventId (optional) 
     * @return Success
     */
    getSurveyTabulationToPdf(surveyId: number | null, eventId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSurveyTabulationToPdf?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyTabulationToPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyTabulationToPdf(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyTabulationToPdf(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @eventId (optional) 
     * @return Success
     */
    getSurveyTabulationToExcel(surveyId: number | null, eventId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSurveyTabulationToExcel?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyTabulationToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyTabulationToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyTabulationToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getQuestionComments(questionId: number, sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfQuestionCommentDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetQuestionComments?";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined and cannot be null.");
        else
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetQuestionComments(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetQuestionComments(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfQuestionCommentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfQuestionCommentDto>><any>Observable.throw(response_);
        });
    }

    protected processGetQuestionComments(response: HttpResponse<Blob>): Observable<PagedResultDtoOfQuestionCommentDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfQuestionCommentDto.fromJS(resultData200) : new PagedResultDtoOfQuestionCommentDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfQuestionCommentDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCommentsToExcel(questionId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCommentsToExcel?";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined and cannot be null.");
        else
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCommentsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCommentsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCommentsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @questionId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getSurveyContacts(surveyId: number | null, questionId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfSurveyContactDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSurveyContacts?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyContacts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyContacts(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSurveyContactDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSurveyContactDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyContacts(response: HttpResponse<Blob>): Observable<PagedResultDtoOfSurveyContactDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSurveyContactDto.fromJS(resultData200) : new PagedResultDtoOfSurveyContactDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfSurveyContactDto>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @questionId (optional) 
     * @return Success
     */
    getSurveyContactsToExcel(surveyId: number | null, questionId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSurveyContactsToExcel?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyContactsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyContactsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyContactsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @eventId (optional) 
     * @surveyId (optional) 
     * @return Success
     */
    getSurveyParticipantsToExcel(eventId: number | null, surveyId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSurveyParticipantsToExcel?";
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyParticipantsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyParticipantsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyParticipantsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @customer (optional) 
     * @paymentChargeType (optional) 
     * @costCenterId (optional) 
     * @eventId (optional) 
     * @enterpriseId (optional) 
     * @coursesIds (optional) 
     * @annuityId (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @bankAccountId (optional) 
     * @paymentMethodId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getReceipts(customer: string | null, paymentChargeType: string | null, costCenterId: number | null, eventId: number | null, enterpriseId: number | null, coursesIds: number[] | null, annuityId: number | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, bankAccountId: number | null, paymentMethodId: number | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<GetReceiptsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetReceipts?";
        if (customer !== undefined)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&"; 
        if (paymentChargeType !== undefined)
            url_ += "PaymentChargeType=" + encodeURIComponent("" + paymentChargeType) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetReceipts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetReceipts(response_);
                } catch (e) {
                    return <Observable<GetReceiptsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetReceiptsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetReceipts(response: HttpResponse<Blob>): Observable<GetReceiptsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetReceiptsOutput.fromJS(resultData200) : new GetReceiptsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetReceiptsOutput>(<any>null);
    }

    /**
     * @customer (optional) 
     * @paymentDateRange_BeginDate (optional) 
     * @paymentDateRange_EndDate (optional) 
     * @paymentChargeType (optional) 
     * @costCenterId (optional) 
     * @eventId (optional) 
     * @enterpriseId (optional) 
     * @coursesIds (optional) 
     * @sorting (optional) 
     * @annuityId (optional) 
     * @bankAccountId (optional) 
     * @paymentMethodId (optional) 
     * @return Success
     */
    getReceiptsToExcel(customer: string | null, paymentDateRange_BeginDate: moment.Moment | null, paymentDateRange_EndDate: moment.Moment | null, paymentChargeType: string | null, costCenterId: number | null, eventId: number | null, enterpriseId: number | null, coursesIds: number[] | null, sorting: string | null, annuityId: number | null, bankAccountId: number | null, paymentMethodId: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetReceiptsToExcel?";
        if (customer !== undefined)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&"; 
        if (paymentDateRange_BeginDate !== undefined)
            url_ += "PaymentDateRange.BeginDate=" + encodeURIComponent(paymentDateRange_BeginDate ? "" + paymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (paymentDateRange_EndDate !== undefined)
            url_ += "PaymentDateRange.EndDate=" + encodeURIComponent(paymentDateRange_EndDate ? "" + paymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (paymentChargeType !== undefined)
            url_ += "PaymentChargeType=" + encodeURIComponent("" + paymentChargeType) + "&"; 
        if (costCenterId !== undefined)
            url_ += "CostCenterId=" + encodeURIComponent("" + costCenterId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (enterpriseId !== undefined)
            url_ += "EnterpriseId=" + encodeURIComponent("" + enterpriseId) + "&"; 
        if (coursesIds !== undefined)
            coursesIds && coursesIds.forEach(item => { url_ += "CoursesIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (bankAccountId !== undefined)
            url_ += "BankAccountId=" + encodeURIComponent("" + bankAccountId) + "&"; 
        if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetReceiptsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetReceiptsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetReceiptsToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetRoles(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRoles(response: HttpResponse<Blob>): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetRoleForEdit(response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRoleForEdit(response: HttpResponse<Blob>): Observable<GetRoleForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateRole(input: CreateOrUpdateRoleInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrUpdateRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateRole(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteRole(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCurrentLoginInformations(response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentLoginInformations(response: HttpResponse<Blob>): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateUserSignInToken(response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserSignInToken(response: HttpResponse<Blob>): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<UpdateUserSignInTokenOutput>(<any>null);
    }
}

@Injectable()
export class SettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetSettingsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Settings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSettingsForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSettingsForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetSettingsForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetSettingsForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSettingsForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetSettingsForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSettingsForEdit(id: number): Observable<GetSettingsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Settings/GetSettingsForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSettingsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSettingsForEdit(response_);
                } catch (e) {
                    return <Observable<GetSettingsForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSettingsForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSettingsForEdit(response: HttpResponse<Blob>): Observable<GetSettingsForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSettingsForEditOutput.fromJS(resultData200) : new GetSettingsForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSettingsForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSettingsDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Settings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Settings/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SituationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetAllSituationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Situations/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSituationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSituationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetAllSituationsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSituationsOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSituationsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetAllSituationsOutput>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getSituationsForSelect(term: string | null, type: Type6): Observable<ListResultDtoOfSituationListDto> {
        let url_ = this.baseUrl + "/api/services/app/Situations/GetSituationsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSituationsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSituationsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSituationListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSituationListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSituationsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfSituationListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSituationListDto.fromJS(resultData200) : new ListResultDtoOfSituationListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfSituationListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSituationForEdit(id: number): Observable<GetSituationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Situations/GetSituationForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSituationForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSituationForEdit(response_);
                } catch (e) {
                    return <Observable<GetSituationForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSituationForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSituationForEdit(response: HttpResponse<Blob>): Observable<GetSituationForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSituationForEditOutput.fromJS(resultData200) : new GetSituationForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSituationForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSituationDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Situations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Situations/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SpecialitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @isActive (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, isActive: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetSpecialityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSpecialityForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSpecialityForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetSpecialityForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetSpecialityForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSpecialityForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetSpecialityForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSpecialityForEdit(id: number): Observable<GetSpecialityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/GetSpecialityForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSpecialityForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSpecialityForEdit(response_);
                } catch (e) {
                    return <Observable<GetSpecialityForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSpecialityForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSpecialityForEdit(response: HttpResponse<Blob>): Observable<GetSpecialityForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSpecialityForEditOutput.fromJS(resultData200) : new GetSpecialityForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSpecialityForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSpecialityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @isActive (optional) 
     * @return Success
     */
    getSpecialitiesToExcel(filter: string | null, isActive: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/GetSpecialitiesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSpecialitiesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSpecialitiesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSpecialitiesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @isActive (optional) 
     * @return Success
     */
    getForSelect(isActive: boolean | null): Observable<SpecialityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/GetForSelect?";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetForSelect(response_);
                } catch (e) {
                    return <Observable<SpecialityDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SpecialityDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetForSelect(response: HttpResponse<Blob>): Observable<SpecialityDto[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SpecialityDto.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<SpecialityDto[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @isActive (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAllSubspecialities(specialityId: number, filter: string | null, isActive: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetSubspecialityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/GetAllSubspecialities?";
        if (specialityId === undefined || specialityId === null)
            throw new Error("The parameter 'specialityId' must be defined and cannot be null.");
        else
            url_ += "SpecialityId=" + encodeURIComponent("" + specialityId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSubspecialities(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllSubspecialities(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSubspecialityForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSubspecialityForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSubspecialities(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetSubspecialityForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetSubspecialityForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSubspecialityForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetSubspecialityForViewDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditSubspeciality(input: CreateOrEditSubspecialityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/CreateOrEditSubspeciality";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditSubspeciality(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditSubspeciality(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditSubspeciality(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSubspeciality(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/DeleteSubspeciality?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSubspeciality(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteSubspeciality(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSubspeciality(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @isActive (optional) 
     * @return Success
     */
    getSubspecialitiesToExcel(specialityId: number, filter: string | null, isActive: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Specialities/GetSubspecialitiesToExcel?";
        if (specialityId === undefined || specialityId === null)
            throw new Error("The parameter 'specialityId' must be defined and cannot be null.");
        else
            url_ += "SpecialityId=" + encodeURIComponent("" + specialityId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSubspecialitiesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSubspecialitiesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSubspecialitiesToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId === undefined || upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' must be defined and cannot be null.");
        else
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUpgradeTenantToEquivalentEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpgradeTenantToEquivalentEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpgradeTenantToEquivalentEdition(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SurveysServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @category (optional) 
     * @eventId (optional) 
     * @dateRange_BeginDate (optional) 
     * @dateRange_EndDate (optional) 
     * @isActive (optional) 
     * @requireAnswer (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, category: number | null, eventId: number | null, dateRange_BeginDate: moment.Moment | null, dateRange_EndDate: moment.Moment | null, isActive: boolean | null, requireAnswer: boolean | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetSurveyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (dateRange_BeginDate !== undefined)
            url_ += "DateRange.BeginDate=" + encodeURIComponent(dateRange_BeginDate ? "" + dateRange_BeginDate.toJSON() : "") + "&"; 
        if (dateRange_EndDate !== undefined)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toJSON() : "") + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (requireAnswer !== undefined)
            url_ += "RequireAnswer=" + encodeURIComponent("" + requireAnswer) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetSurveyForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetSurveyForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetSurveyForViewDto>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @eventId (optional) 
     * @return Success
     */
    getSurveyForView(surveyId: number | null, eventId: number | null): Observable<GetSurveyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetSurveyForView?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyForView(response_);
                } catch (e) {
                    return <Observable<GetSurveyForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSurveyForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyForView(response: HttpResponse<Blob>): Observable<GetSurveyForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSurveyForViewDto.fromJS(resultData200) : new GetSurveyForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSurveyForViewDto>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @eventId (optional) 
     * @return Success
     */
    getSurveyForEdit(surveyId: number | null, eventId: number | null): Observable<GetSurveyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetSurveyForEdit?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyForEdit(response_);
                } catch (e) {
                    return <Observable<GetSurveyForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSurveyForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyForEdit(response: HttpResponse<Blob>): Observable<GetSurveyForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSurveyForEditOutput.fromJS(resultData200) : new GetSurveyForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSurveyForEditOutput>(<any>null);
    }

    /**
     * @surveyId (optional) 
     * @eventId (optional) 
     * @return Success
     */
    getSurveyForAnswer(surveyId: number | null, eventId: number | null): Observable<GetSurveyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetSurveyForAnswer?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyForAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyForAnswer(response_);
                } catch (e) {
                    return <Observable<GetSurveyForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSurveyForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyForAnswer(response: HttpResponse<Blob>): Observable<GetSurveyForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSurveyForEditOutput.fromJS(resultData200) : new GetSurveyForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSurveyForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    copySurvey(input: CopySurveyInput | null): Observable<CreateOrEditSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/CopySurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCopySurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCopySurvey(response_);
                } catch (e) {
                    return <Observable<CreateOrEditSurveyDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditSurveyDto>><any>Observable.throw(response_);
        });
    }

    protected processCopySurvey(response: HttpResponse<Blob>): Observable<CreateOrEditSurveyDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditSurveyDto.fromJS(resultData200) : new CreateOrEditSurveyDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<CreateOrEditSurveyDto>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @category (optional) 
     * @eventId (optional) 
     * @dateRange_BeginDate (optional) 
     * @dateRange_EndDate (optional) 
     * @isActive (optional) 
     * @requireAnswer (optional) 
     * @return Success
     */
    getSurveysToExcel(filter: string | null, category: number | null, eventId: number | null, dateRange_BeginDate: moment.Moment | null, dateRange_EndDate: moment.Moment | null, isActive: boolean | null, requireAnswer: boolean | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetSurveysToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&"; 
        if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (dateRange_BeginDate !== undefined)
            url_ += "DateRange.BeginDate=" + encodeURIComponent(dateRange_BeginDate ? "" + dateRange_BeginDate.toJSON() : "") + "&"; 
        if (dateRange_EndDate !== undefined)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toJSON() : "") + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (requireAnswer !== undefined)
            url_ += "RequireAnswer=" + encodeURIComponent("" + requireAnswer) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveysToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveysToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveysToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activate(input: ActivateDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processActivate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processActivate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivate(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createAnswer(input: CreateOrEditSurveyAnswerDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/CreateAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateAnswer(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    skipAnswer(input: CreateOrEditSurveyAnswerDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/SkipAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSkipAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSkipAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSkipAnswer(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getSurveyAnswerForView(id: number): Observable<GetSurveyAnswerForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetSurveyAnswerForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyAnswerForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyAnswerForView(response_);
                } catch (e) {
                    return <Observable<GetSurveyAnswerForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSurveyAnswerForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyAnswerForView(response: HttpResponse<Blob>): Observable<GetSurveyAnswerForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSurveyAnswerForViewDto.fromJS(resultData200) : new GetSurveyAnswerForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSurveyAnswerForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getQrCode(surveyId: number, width: number, height: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetQrCode?";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined and cannot be null.");
        else
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&"; 
        if (width === undefined || width === null)
            throw new Error("The parameter 'width' must be defined and cannot be null.");
        else
            url_ += "Width=" + encodeURIComponent("" + width) + "&"; 
        if (height === undefined || height === null)
            throw new Error("The parameter 'height' must be defined and cannot be null.");
        else
            url_ += "Height=" + encodeURIComponent("" + height) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetQrCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetQrCode(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetQrCode(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class SurveyWorksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @eventWorkIdFilter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, eventWorkIdFilter: number | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetSurveyWorkForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventWorkIdFilter !== undefined)
            url_ += "EventWorkIdFilter=" + encodeURIComponent("" + eventWorkIdFilter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyWorkForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyWorkForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetSurveyWorkForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetSurveyWorkForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyWorkForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetSurveyWorkForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSurveyWorkForEdit(id: number): Observable<GetSurveyWorkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/GetSurveyWorkForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyWorkForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyWorkForEdit(response_);
                } catch (e) {
                    return <Observable<GetSurveyWorkForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSurveyWorkForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyWorkForEdit(response: HttpResponse<Blob>): Observable<GetSurveyWorkForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSurveyWorkForEditOutput.fromJS(resultData200) : new GetSurveyWorkForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSurveyWorkForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSurveyWorkForEvaluate(eventWorkId: number, category: Category): Observable<GetSurveyWorkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/GetSurveyWorkForEvaluate?";
        if (eventWorkId === undefined || eventWorkId === null)
            throw new Error("The parameter 'eventWorkId' must be defined and cannot be null.");
        else
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined and cannot be null.");
        else
            url_ += "Category=" + encodeURIComponent("" + category) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyWorkForEvaluate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyWorkForEvaluate(response_);
                } catch (e) {
                    return <Observable<GetSurveyWorkForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSurveyWorkForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyWorkForEvaluate(response: HttpResponse<Blob>): Observable<GetSurveyWorkForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSurveyWorkForEditOutput.fromJS(resultData200) : new GetSurveyWorkForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSurveyWorkForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @eventWorkIdFilter (optional) 
     * @return Success
     */
    getSurveyWorksToExcel(filter: string | null, eventWorkIdFilter: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/GetSurveyWorksToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventWorkIdFilter !== undefined)
            url_ += "EventWorkIdFilter=" + encodeURIComponent("" + eventWorkIdFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyWorksToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSurveyWorksToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyWorksToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditResumeEvaluation(input: CreateOrEditSurveyAnswerWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/CreateOrEditResumeEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditResumeEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEditResumeEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditResumeEvaluation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createResumeEvaluation(input: CreateOrEditSurveyAnswerWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/CreateResumeEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateResumeEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateResumeEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateResumeEvaluation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateResumeEvaluation(input: CreateOrEditSurveyAnswerWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/UpdateResumeEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateResumeEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateResumeEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateResumeEvaluation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPresentationEvaluation(input: WorkPresentationEvaluationDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyWorks/CreatePresentationEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreatePresentationEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreatePresentationEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePresentationEvaluation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @subscriptionEndDateStart (optional) 
     * @subscriptionEndDateEnd (optional) 
     * @creationDateStart (optional) 
     * @creationDateEnd (optional) 
     * @editionId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getTenants(filter: string | null, subscriptionEndDateStart: moment.Moment | null, subscriptionEndDateEnd: moment.Moment | null, creationDateStart: moment.Moment | null, creationDateEnd: moment.Moment | null, editionId: number | null, editionIdSpecified: boolean, sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&"; 
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&"; 
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&"; 
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&"; 
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&"; 
        if (editionIdSpecified === undefined || editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' must be defined and cannot be null.");
        else
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTenants(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenants(response: HttpResponse<Blob>): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTenant(input: CreateTenantInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTenant(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantForEdit(id: number): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTenantForEdit(response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantForEdit(response: HttpResponse<Blob>): Observable<TenantEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantEditDto.fromJS(resultData200) : new TenantEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TenantEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenant(input: TenantEditDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenant(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteTenant(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTenant(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantFeaturesForEdit(id: number): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponse<Blob>): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTenantFeaturesEditOutput.fromJS(resultData200) : new GetTenantFeaturesEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenantFeatures(input: UpdateTenantFeaturesInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateTenantFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenantFeatures(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processResetTenantSpecificFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetTenantSpecificFeatures(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockTenantAdmin(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUnlockTenantAdmin(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockTenantAdmin(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetMemberActivity(response_);
                } catch (e) {
                    return <Observable<GetMemberActivityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMemberActivityOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberActivity(response: HttpResponse<Blob>): Observable<GetMemberActivityOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMemberActivityOutput.fromJS(resultData200) : new GetMemberActivityOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetMemberActivityOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetDashboardData(response_);
                } catch (e) {
                    return <Observable<GetDashboardDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDashboardDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardData(response: HttpResponse<Blob>): Observable<GetDashboardDataOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDashboardDataOutput.fromJS(resultData200) : new GetDashboardDataOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetDashboardDataOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod2): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSalesSummary(response_);
                } catch (e) {
                    return <Observable<GetSalesSummaryOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSalesSummaryOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSalesSummary(response: HttpResponse<Blob>): Observable<GetSalesSummaryOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSalesSummaryOutput.fromJS(resultData200) : new GetSalesSummaryOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetSalesSummaryOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getWorldMap(input: any | null): Observable<GetWorldMapOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetWorldMap?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetWorldMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetWorldMap(response_);
                } catch (e) {
                    return <Observable<GetWorldMapOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetWorldMapOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetWorldMap(response: HttpResponse<Blob>): Observable<GetWorldMapOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetWorldMapOutput.fromJS(resultData200) : new GetWorldMapOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetWorldMapOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getGeneralStats(input: any | null): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetGeneralStats(response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetGeneralStats(response: HttpResponse<Blob>): Observable<GetGeneralStatsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetGeneralStatsOutput.fromJS(resultData200) : new GetGeneralStatsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetGeneralStatsOutput>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerTenant(input: RegisterTenantInput | null): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRegisterTenant(response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegisterTenant(response: HttpResponse<Blob>): Observable<RegisterTenantOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterTenantOutput.fromJS(resultData200) : new RegisterTenantOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEditionsForSelect(response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForSelect(response: HttpResponse<Blob>): Observable<EditionsSelectOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionsSelectOutput.fromJS(resultData200) : new EditionsSelectOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EditionsSelectOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEdition(editionId: number): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === undefined || editionId === null)
            throw new Error("The parameter 'editionId' must be defined and cannot be null.");
        else
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEdition(response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEdition(response: HttpResponse<Blob>): Observable<EditionSelectDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionSelectDto.fromJS(resultData200) : new EditionSelectDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EditionSelectDto>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: HttpResponse<Blob>): Observable<TenantSettingsEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantSettingsEditDto.fromJS(resultData200) : new TenantSettingsEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: TenantSettingsEditDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processClearLogo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processClearLogo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearLogo(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processClearCustomCss(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCustomCss(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TerminalSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetTerminalSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTerminalSettingForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTerminalSettingForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetTerminalSettingForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetTerminalSettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTerminalSettingForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetTerminalSettingForViewDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getTerminalSettingsForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfTerminalSettingsListDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalSettings/GetTerminalSettingsForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTerminalSettingsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTerminalSettingsForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTerminalSettingsListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTerminalSettingsListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTerminalSettingsForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfTerminalSettingsListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTerminalSettingsListDto.fromJS(resultData200) : new ListResultDtoOfTerminalSettingsListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfTerminalSettingsListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTerminalSettingForView(id: number): Observable<GetTerminalSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalSettings/GetTerminalSettingForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTerminalSettingForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTerminalSettingForView(response_);
                } catch (e) {
                    return <Observable<GetTerminalSettingForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTerminalSettingForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTerminalSettingForView(response: HttpResponse<Blob>): Observable<GetTerminalSettingForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTerminalSettingForViewDto.fromJS(resultData200) : new GetTerminalSettingForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetTerminalSettingForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTerminalSettingForEdit(id: number): Observable<GetTerminalSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TerminalSettings/GetTerminalSettingForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTerminalSettingForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTerminalSettingForEdit(response_);
                } catch (e) {
                    return <Observable<GetTerminalSettingForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTerminalSettingForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTerminalSettingForEdit(response: HttpResponse<Blob>): Observable<GetTerminalSettingForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTerminalSettingForEditOutput.fromJS(resultData200) : new GetTerminalSettingForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetTerminalSettingForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTerminalSettingDto | null): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TerminalSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<number> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TerminalSettings/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ThematicAreasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @programingId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, programingId: number | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetThematicAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (programingId !== undefined)
            url_ += "ProgramingId=" + encodeURIComponent("" + programingId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetThematicAreaForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetThematicAreaForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetThematicAreaForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetThematicAreaForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetThematicAreaForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetThematicAreaForViewDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getThematicAreasForSelect(term: string | null, programingId: number, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfThematicAreaListDto> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetThematicAreasForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (programingId === undefined || programingId === null)
            throw new Error("The parameter 'programingId' must be defined and cannot be null.");
        else
            url_ += "ProgramingId=" + encodeURIComponent("" + programingId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetThematicAreasForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetThematicAreasForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfThematicAreaListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfThematicAreaListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetThematicAreasForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfThematicAreaListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfThematicAreaListDto.fromJS(resultData200) : new ListResultDtoOfThematicAreaListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfThematicAreaListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getThematicAreaForView(id: number): Observable<GetThematicAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetThematicAreaForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetThematicAreaForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetThematicAreaForView(response_);
                } catch (e) {
                    return <Observable<GetThematicAreaForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetThematicAreaForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetThematicAreaForView(response: HttpResponse<Blob>): Observable<GetThematicAreaForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetThematicAreaForViewDto.fromJS(resultData200) : new GetThematicAreaForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetThematicAreaForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getThematicAreaForEdit(id: number): Observable<GetThematicAreaForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetThematicAreaForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetThematicAreaForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetThematicAreaForEdit(response_);
                } catch (e) {
                    return <Observable<GetThematicAreaForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetThematicAreaForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetThematicAreaForEdit(response: HttpResponse<Blob>): Observable<GetThematicAreaForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetThematicAreaForEditOutput.fromJS(resultData200) : new GetThematicAreaForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetThematicAreaForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditThematicAreaDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activate(input: ActivateDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processActivate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processActivate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivate(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTimezones(defaultTimezoneScope: DefaultTimezoneScope): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTimezones(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezones(response: HttpResponse<Blob>): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfNameValueDto.fromJS(resultData200) : new ListResultDtoOfNameValueDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | null): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetTimezoneComboboxItems(response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezoneComboboxItems(response: HttpResponse<Blob>): Observable<ComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel | null): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAuthenticate(response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticate(response: HttpResponse<Blob>): Observable<AuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getSharedAccessToken(userId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetSharedAccessToken?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetSharedAccessToken(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetSharedAccessToken(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetSharedAccessToken(response: HttpResponse<Blob>): Observable<string> {
        const status = response.status;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getChangePasswordRedirectInfo(): Observable<ChangePasswordRedirectInfoModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetChangePasswordRedirectInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetChangePasswordRedirectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetChangePasswordRedirectInfo(response_);
                } catch (e) {
                    return <Observable<ChangePasswordRedirectInfoModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ChangePasswordRedirectInfoModel>><any>Observable.throw(response_);
        });
    }

    protected processGetChangePasswordRedirectInfo(response: HttpResponse<Blob>): Observable<ChangePasswordRedirectInfoModel> {
        const status = response.status;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChangePasswordRedirectInfoModel.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ChangePasswordRedirectInfoModel>(<any>null);
    }

    /**
     * @model (optional)
     * @return Success
     */
    sendTwoFactorAuthCode(model: SendTwoFactorAuthCodeModel | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processSendTwoFactorAuthCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTwoFactorAuthCode(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | null): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processImpersonatedAuthenticate(response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processImpersonatedAuthenticate(response: HttpResponse<Blob>): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonatedAuthenticateResultModel.fromJS(resultData200) : new ImpersonatedAuthenticateResultModel();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | null): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processLinkedAccountAuthenticate(response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processLinkedAccountAuthenticate(response: HttpResponse<Blob>): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchedAccountAuthenticateResultModel.fromJS(resultData200) : new SwitchedAccountAuthenticateResultModel();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponse<Blob>): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processExternalAuthenticate(response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processExternalAuthenticate(response: HttpResponse<Blob>): Observable<ExternalAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @message (optional) 
     * @severity (optional) 
     * @return Success
     */
    testNotification(message: string | null, severity: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processTestNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processTestNotification(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTestNotification(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<UiCustomizationSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUiManagementSettings(response: HttpResponse<Blob>): Observable<UiCustomizationSettingsEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UiCustomizationSettingsEditDto.fromJS(resultData200) : new UiCustomizationSettingsEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<UiCustomizationSettingsEditDto>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateUiManagementSettings(settings: UiCustomizationSettingsEditDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUiManagementSettings(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(settings: UiCustomizationSettingsEditDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUseSystemDefaultSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUseSystemDefaultSettings(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @permission (optional) 
     * @role (optional) 
     * @memberStatusId (optional) 
     * @baseId (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @isResident (optional) 
     * @situationId (optional) 
     * @isActive (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @hasAddress (optional) 
     * @correspondenceSituation (optional) 
     * @changedByUser (optional) 
     * @cetId (optional) 
     * @annuityId (optional) 
     * @pendingAnnuityId (optional) 
     * @paidAnnuity (optional) 
     * @ids (optional) 
     * @annuityPaymentDateRange_BeginDate (optional) 
     * @annuityPaymentDateRange_EndDate (optional) 
     * @bornDateRange_BeginDate (optional) 
     * @bornDateRange_EndDate (optional) 
     * @documentationStatus (optional) 
     * @statusCpf (optional) 
     * @situationCpf (optional) 
     * @statusIntegracao (optional) 
     * @isExempt (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getUsers(filter: string | null, permission: string | null, role: number | null, memberStatusId: number | null, baseId: number | null, categoryId: number | null, categoryLevelId: number | null, isResident: boolean | null, situationId: number | null, isActive: boolean | null, country: string | null, countryState: string | null, city: string | null, hasAddress: boolean | null, correspondenceSituation: CorrespondenceSituation | null, changedByUser: boolean | null, cetId: number | null, annuityId: number | null, pendingAnnuityId: number | null, paidAnnuity: boolean | null, ids: number[] | null, annuityPaymentDateRange_BeginDate: moment.Moment | null, annuityPaymentDateRange_EndDate: moment.Moment | null, bornDateRange_BeginDate: moment.Moment | null, bornDateRange_EndDate: moment.Moment | null, documentationStatus: DocumentationStatus3 | null, statusCpf: StatusCpf | null, situationCpf: SituationCpf | null, statusIntegracao: StatusIntegracao16 | null, isExempt: boolean | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (hasAddress !== undefined)
            url_ += "HasAddress=" + encodeURIComponent("" + hasAddress) + "&"; 
        if (correspondenceSituation !== undefined)
            url_ += "CorrespondenceSituation=" + encodeURIComponent("" + correspondenceSituation) + "&"; 
        if (changedByUser !== undefined)
            url_ += "ChangedByUser=" + encodeURIComponent("" + changedByUser) + "&"; 
        if (cetId !== undefined)
            url_ += "CetId=" + encodeURIComponent("" + cetId) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (pendingAnnuityId !== undefined)
            url_ += "PendingAnnuityId=" + encodeURIComponent("" + pendingAnnuityId) + "&"; 
        if (paidAnnuity !== undefined)
            url_ += "PaidAnnuity=" + encodeURIComponent("" + paidAnnuity) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (annuityPaymentDateRange_BeginDate !== undefined)
            url_ += "AnnuityPaymentDateRange.BeginDate=" + encodeURIComponent(annuityPaymentDateRange_BeginDate ? "" + annuityPaymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (annuityPaymentDateRange_EndDate !== undefined)
            url_ += "AnnuityPaymentDateRange.EndDate=" + encodeURIComponent(annuityPaymentDateRange_EndDate ? "" + annuityPaymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (bornDateRange_BeginDate !== undefined)
            url_ += "BornDateRange.BeginDate=" + encodeURIComponent(bornDateRange_BeginDate ? "" + bornDateRange_BeginDate.toJSON() : "") + "&"; 
        if (bornDateRange_EndDate !== undefined)
            url_ += "BornDateRange.EndDate=" + encodeURIComponent(bornDateRange_EndDate ? "" + bornDateRange_EndDate.toJSON() : "") + "&"; 
        if (documentationStatus !== undefined)
            url_ += "DocumentationStatus=" + encodeURIComponent("" + documentationStatus) + "&"; 
        if (statusCpf !== undefined)
            url_ += "StatusCpf=" + encodeURIComponent("" + statusCpf) + "&"; 
        if (situationCpf !== undefined)
            url_ += "SituationCpf=" + encodeURIComponent("" + situationCpf) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        if (isExempt !== undefined)
            url_ += "IsExempt=" + encodeURIComponent("" + isExempt) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsers(response: HttpResponse<Blob>): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserListDto.fromJS(resultData200) : new PagedResultDtoOfUserListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getUsersForImport(sorting: string | null, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfUserListForImportDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersForImport?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUsersForImport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUsersForImport(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListForImportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListForImportDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsersForImport(response: HttpResponse<Blob>): Observable<PagedResultDtoOfUserListForImportDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserListForImportDto.fromJS(resultData200) : new PagedResultDtoOfUserListForImportDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfUserListForImportDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getUsersForSelect(term: string | null, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfUserSelectListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUsersForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUsersForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserSelectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserSelectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsersForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfUserSelectListDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserSelectListDto.fromJS(resultData200) : new ListResultDtoOfUserSelectListDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfUserSelectListDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @permission (optional) 
     * @role (optional) 
     * @memberStatusId (optional) 
     * @baseId (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @isResident (optional) 
     * @situationId (optional) 
     * @isActive (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @changedByUser (optional) 
     * @ids (optional) 
     * @bornDateRange_BeginDate (optional) 
     * @bornDateRange_EndDate (optional) 
     * @hasAddress (optional) 
     * @correspondenceSituation (optional) 
     * @cetId (optional) 
     * @annuityId (optional) 
     * @pendingAnnuityId (optional) 
     * @paidAnnuity (optional) 
     * @annuityPaymentDateRange_BeginDate (optional) 
     * @annuityPaymentDateRange_EndDate (optional) 
     * @documentationStatus (optional) 
     * @isExempt (optional) 
     * @statusCpf (optional) 
     * @situationCpf (optional) 
     * @statusIntegracao (optional) 
     * @return Success
     */
    getUsersToExcel(filter: string | null, permission: string | null, role: number | null, memberStatusId: number | null, baseId: number | null, categoryId: number | null, categoryLevelId: number | null, isResident: boolean | null, situationId: number | null, isActive: boolean | null, country: string | null, countryState: string | null, city: string | null, changedByUser: boolean | null, ids: number[] | null, bornDateRange_BeginDate: moment.Moment | null, bornDateRange_EndDate: moment.Moment | null, hasAddress: boolean | null, correspondenceSituation: CorrespondenceSituation2 | null, cetId: number | null, annuityId: number | null, pendingAnnuityId: number | null, paidAnnuity: boolean | null, annuityPaymentDateRange_BeginDate: moment.Moment | null, annuityPaymentDateRange_EndDate: moment.Moment | null, documentationStatus: DocumentationStatus4 | null, isExempt: boolean | null, statusCpf: StatusCpf2 | null, situationCpf: SituationCpf2 | null, statusIntegracao: StatusIntegracao17 | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (changedByUser !== undefined)
            url_ += "ChangedByUser=" + encodeURIComponent("" + changedByUser) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (bornDateRange_BeginDate !== undefined)
            url_ += "BornDateRange.BeginDate=" + encodeURIComponent(bornDateRange_BeginDate ? "" + bornDateRange_BeginDate.toJSON() : "") + "&"; 
        if (bornDateRange_EndDate !== undefined)
            url_ += "BornDateRange.EndDate=" + encodeURIComponent(bornDateRange_EndDate ? "" + bornDateRange_EndDate.toJSON() : "") + "&"; 
        if (hasAddress !== undefined)
            url_ += "HasAddress=" + encodeURIComponent("" + hasAddress) + "&"; 
        if (correspondenceSituation !== undefined)
            url_ += "CorrespondenceSituation=" + encodeURIComponent("" + correspondenceSituation) + "&"; 
        if (cetId !== undefined)
            url_ += "CetId=" + encodeURIComponent("" + cetId) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (pendingAnnuityId !== undefined)
            url_ += "PendingAnnuityId=" + encodeURIComponent("" + pendingAnnuityId) + "&"; 
        if (paidAnnuity !== undefined)
            url_ += "PaidAnnuity=" + encodeURIComponent("" + paidAnnuity) + "&"; 
        if (annuityPaymentDateRange_BeginDate !== undefined)
            url_ += "AnnuityPaymentDateRange.BeginDate=" + encodeURIComponent(annuityPaymentDateRange_BeginDate ? "" + annuityPaymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (annuityPaymentDateRange_EndDate !== undefined)
            url_ += "AnnuityPaymentDateRange.EndDate=" + encodeURIComponent(annuityPaymentDateRange_EndDate ? "" + annuityPaymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (documentationStatus !== undefined)
            url_ += "DocumentationStatus=" + encodeURIComponent("" + documentationStatus) + "&"; 
        if (isExempt !== undefined)
            url_ += "IsExempt=" + encodeURIComponent("" + isExempt) + "&"; 
        if (statusCpf !== undefined)
            url_ += "StatusCpf=" + encodeURIComponent("" + statusCpf) + "&"; 
        if (situationCpf !== undefined)
            url_ += "SituationCpf=" + encodeURIComponent("" + situationCpf) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUsersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsersToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserForView(id: number | null): Observable<GetUserForViewOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForView?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserForView(response_);
                } catch (e) {
                    return <Observable<GetUserForViewOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserForViewOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserForView(response: HttpResponse<Blob>): Observable<GetUserForViewOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserForViewOutput.fromJS(resultData200) : new GetUserForViewOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetUserForViewOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unmarkChangesByMember(input: NullableIdDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnmarkChangesByMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUnmarkChangesByMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUnmarkChangesByMember(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnmarkChangesByMember(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | null): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserForEdit(response: HttpResponse<Blob>): Observable<GetUserForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserForEditOutput.fromJS(resultData200) : new GetUserForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetUserForEditOutput>(<any>null);
    }

    /**
     * @documentId (optional) 
     * @fileExtension (optional) 
     * @id (optional) 
     * @return Success
     */
    getFile(documentId: string | null, fileExtension: string | null, id: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetFile?";
        if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&"; 
        if (fileExtension !== undefined)
            url_ += "FileExtension=" + encodeURIComponent("" + fileExtension) + "&"; 
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetFile(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFile(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateUser(input: CreateOrUpdateUserInput | null): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrUpdateUser(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateUser(response: HttpResponse<Blob>): Observable<number> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUser(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockUser(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUnlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUnlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockUser(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    requestCadastralUpdate(input: RequestCadastralUpdateInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RequestCadastralUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processRequestCadastralUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processRequestCadastralUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRequestCadastralUpdate(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUserPermissionsForEdit(id: number): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserPermissionsForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserPermissionsForEdit(response: HttpResponse<Blob>): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(input: EntityDtoOfInt64 | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processResetUserSpecificPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetUserSpecificPermissions(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUserPermissions(input: UpdateUserPermissionsInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateUserPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserPermissions(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addUserNote(input: CreateOrEditNoteDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/AddUserNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processAddUserNote(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processAddUserNote(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddUserNote(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUserCategories(id: number): Observable<ListResultDtoOfMemberCategoryEditDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserCategories?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserCategories(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMemberCategoryEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMemberCategoryEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserCategories(response: HttpResponse<Blob>): Observable<ListResultDtoOfMemberCategoryEditDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMemberCategoryEditDto.fromJS(resultData200) : new ListResultDtoOfMemberCategoryEditDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfMemberCategoryEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteUserCategory(userId: number, userCategoryId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUserCategory?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (userCategoryId === undefined || userCategoryId === null)
            throw new Error("The parameter 'userCategoryId' must be defined and cannot be null.");
        else
            url_ += "UserCategoryId=" + encodeURIComponent("" + userCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteUserCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteUserCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUserCategory(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUserCategory(input: CreateOrEditUserCategoryDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateUserCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserCategory(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeUserCategory(input: ChangeUserCategoryDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeUserCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processChangeUserCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processChangeUserCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeUserCategory(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @permission (optional) 
     * @role (optional) 
     * @memberStatusId (optional) 
     * @baseId (optional) 
     * @categoryId (optional) 
     * @categoryLevelId (optional) 
     * @isResident (optional) 
     * @situationId (optional) 
     * @isActive (optional) 
     * @country (optional) 
     * @countryState (optional) 
     * @city (optional) 
     * @changedByUser (optional) 
     * @ids (optional) 
     * @bornDateRange_BeginDate (optional) 
     * @bornDateRange_EndDate (optional) 
     * @hasAddress (optional) 
     * @correspondenceSituation (optional) 
     * @cetId (optional) 
     * @annuityId (optional) 
     * @pendingAnnuityId (optional) 
     * @paidAnnuity (optional) 
     * @annuityPaymentDateRange_BeginDate (optional) 
     * @annuityPaymentDateRange_EndDate (optional) 
     * @documentationStatus (optional) 
     * @isExempt (optional) 
     * @statusCpf (optional) 
     * @situationCpf (optional) 
     * @statusIntegracao (optional) 
     * @return Success
     */
    getUserAddressTags(filter: string | null, permission: string | null, role: number | null, memberStatusId: number | null, baseId: number | null, categoryId: number | null, categoryLevelId: number | null, isResident: boolean | null, situationId: number | null, isActive: boolean | null, country: string | null, countryState: string | null, city: string | null, changedByUser: boolean | null, ids: number[] | null, bornDateRange_BeginDate: moment.Moment | null, bornDateRange_EndDate: moment.Moment | null, hasAddress: boolean | null, correspondenceSituation: CorrespondenceSituation3 | null, cetId: number | null, annuityId: number | null, pendingAnnuityId: number | null, paidAnnuity: boolean | null, annuityPaymentDateRange_BeginDate: moment.Moment | null, annuityPaymentDateRange_EndDate: moment.Moment | null, documentationStatus: DocumentationStatus5 | null, isExempt: boolean | null, statusCpf: StatusCpf3 | null, situationCpf: SituationCpf3 | null, statusIntegracao: StatusIntegracao18 | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserAddressTags?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (memberStatusId !== undefined)
            url_ += "MemberStatusId=" + encodeURIComponent("" + memberStatusId) + "&"; 
        if (baseId !== undefined)
            url_ += "BaseId=" + encodeURIComponent("" + baseId) + "&"; 
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (categoryLevelId !== undefined)
            url_ += "CategoryLevelId=" + encodeURIComponent("" + categoryLevelId) + "&"; 
        if (isResident !== undefined)
            url_ += "IsResident=" + encodeURIComponent("" + isResident) + "&"; 
        if (situationId !== undefined)
            url_ += "SituationId=" + encodeURIComponent("" + situationId) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (countryState !== undefined)
            url_ += "CountryState=" + encodeURIComponent("" + countryState) + "&"; 
        if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (changedByUser !== undefined)
            url_ += "ChangedByUser=" + encodeURIComponent("" + changedByUser) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (bornDateRange_BeginDate !== undefined)
            url_ += "BornDateRange.BeginDate=" + encodeURIComponent(bornDateRange_BeginDate ? "" + bornDateRange_BeginDate.toJSON() : "") + "&"; 
        if (bornDateRange_EndDate !== undefined)
            url_ += "BornDateRange.EndDate=" + encodeURIComponent(bornDateRange_EndDate ? "" + bornDateRange_EndDate.toJSON() : "") + "&"; 
        if (hasAddress !== undefined)
            url_ += "HasAddress=" + encodeURIComponent("" + hasAddress) + "&"; 
        if (correspondenceSituation !== undefined)
            url_ += "CorrespondenceSituation=" + encodeURIComponent("" + correspondenceSituation) + "&"; 
        if (cetId !== undefined)
            url_ += "CetId=" + encodeURIComponent("" + cetId) + "&"; 
        if (annuityId !== undefined)
            url_ += "AnnuityId=" + encodeURIComponent("" + annuityId) + "&"; 
        if (pendingAnnuityId !== undefined)
            url_ += "PendingAnnuityId=" + encodeURIComponent("" + pendingAnnuityId) + "&"; 
        if (paidAnnuity !== undefined)
            url_ += "PaidAnnuity=" + encodeURIComponent("" + paidAnnuity) + "&"; 
        if (annuityPaymentDateRange_BeginDate !== undefined)
            url_ += "AnnuityPaymentDateRange.BeginDate=" + encodeURIComponent(annuityPaymentDateRange_BeginDate ? "" + annuityPaymentDateRange_BeginDate.toJSON() : "") + "&"; 
        if (annuityPaymentDateRange_EndDate !== undefined)
            url_ += "AnnuityPaymentDateRange.EndDate=" + encodeURIComponent(annuityPaymentDateRange_EndDate ? "" + annuityPaymentDateRange_EndDate.toJSON() : "") + "&"; 
        if (documentationStatus !== undefined)
            url_ += "DocumentationStatus=" + encodeURIComponent("" + documentationStatus) + "&"; 
        if (isExempt !== undefined)
            url_ += "IsExempt=" + encodeURIComponent("" + isExempt) + "&"; 
        if (statusCpf !== undefined)
            url_ += "StatusCpf=" + encodeURIComponent("" + statusCpf) + "&"; 
        if (situationCpf !== undefined)
            url_ += "SituationCpf=" + encodeURIComponent("" + situationCpf) + "&"; 
        if (statusIntegracao !== undefined)
            url_ += "StatusIntegracao=" + encodeURIComponent("" + statusIntegracao) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserAddressTags(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetUserAddressTags(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserAddressTags(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getMemberStatusForSelect(term: string | null): Observable<ListResultDtoOfMemberStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMemberStatusForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberStatusForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetMemberStatusForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMemberStatusDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMemberStatusDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberStatusForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfMemberStatusDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMemberStatusDto.fromJS(resultData200) : new ListResultDtoOfMemberStatusDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfMemberStatusDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @return Success
     */
    getBasesForSelect(term: string | null): Observable<ListResultDtoOfBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetBasesForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetBasesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetBasesForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBaseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfBaseDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBasesForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfBaseDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfBaseDto.fromJS(resultData200) : new ListResultDtoOfBaseDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfBaseDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getAllSpecialitiesForSelect(input: string | null): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllSpecialitiesForSelect?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSpecialitiesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllSpecialitiesForSelect(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSpecialitiesForSelect(response: HttpResponse<Blob>): Observable<string[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMemberStatus(input: UpdateMemberStatusInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateMemberStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMemberStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateMemberStatus(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMemberStatus(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    linkToUser(input: LinkToUserInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processLinkToUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processLinkToUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processLinkToUser(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number, skipCount: number, sorting: string | null): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetLinkedUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLinkedUsers(response: HttpResponse<Blob>): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLinkedUserDto.fromJS(resultData200) : new PagedResultDtoOfLinkedUserDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponse<Blob>): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLinkedUserDto.fromJS(resultData200) : new ListResultDtoOfLinkedUserDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlinkUser(input: UnlinkUserInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUnlinkUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlinkUser(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetRecentUserLoginAttempts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponse<Blob>): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200) : new ListResultDtoOfUserLoginAttemptDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetLatestWebLogs(response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLatestWebLogs(response: HttpResponse<Blob>): Observable<GetLatestWebLogsOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLatestWebLogsOutput.fromJS(resultData200) : new GetLatestWebLogsOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDownloadWebLogs(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadWebLogs(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class WorksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @userId (optional) 
     * @typeFilter (optional) 
     * @statusFilter (optional) 
     * @specialityIdFilter (optional) 
     * @subspecialityIdFilter (optional) 
     * @eventWorkIdFilter (optional) 
     * @authorIdFilter (optional) 
     * @presenterIdFilter (optional) 
     * @evaluatorIdFilter (optional) 
     * @solicitedPresentationTypeFilter (optional) 
     * @sentEPosterFilter (optional) 
     * @paidRegistrationFilter (optional) 
     * @evaluatedResumoFilter (optional) 
     * @evaluaterProfileFilter (optional) 
     * @onlyCertificateWorkFilter (optional) 
     * @approveTypeIdFilter (optional) 
     * @approveFilter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null, userId: number | null, typeFilter: number | null, statusFilter: number | null, specialityIdFilter: number | null, subspecialityIdFilter: number | null, eventWorkIdFilter: number | null, authorIdFilter: number | null, presenterIdFilter: number | null, evaluatorIdFilter: number | null, solicitedPresentationTypeFilter: number | null, sentEPosterFilter: boolean | null, paidRegistrationFilter: boolean | null, evaluatedResumoFilter: boolean | null, evaluaterProfileFilter: boolean | null, onlyCertificateWorkFilter: boolean | null, approveTypeIdFilter: number | null, approveFilter: number | null, sorting: string | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetWorkForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (specialityIdFilter !== undefined)
            url_ += "SpecialityIdFilter=" + encodeURIComponent("" + specialityIdFilter) + "&"; 
        if (subspecialityIdFilter !== undefined)
            url_ += "SubspecialityIdFilter=" + encodeURIComponent("" + subspecialityIdFilter) + "&"; 
        if (eventWorkIdFilter !== undefined)
            url_ += "EventWorkIdFilter=" + encodeURIComponent("" + eventWorkIdFilter) + "&"; 
        if (authorIdFilter !== undefined)
            url_ += "AuthorIdFilter=" + encodeURIComponent("" + authorIdFilter) + "&"; 
        if (presenterIdFilter !== undefined)
            url_ += "PresenterIdFilter=" + encodeURIComponent("" + presenterIdFilter) + "&"; 
        if (evaluatorIdFilter !== undefined)
            url_ += "EvaluatorIdFilter=" + encodeURIComponent("" + evaluatorIdFilter) + "&"; 
        if (solicitedPresentationTypeFilter !== undefined)
            url_ += "SolicitedPresentationTypeFilter=" + encodeURIComponent("" + solicitedPresentationTypeFilter) + "&"; 
        if (sentEPosterFilter !== undefined)
            url_ += "SentEPosterFilter=" + encodeURIComponent("" + sentEPosterFilter) + "&"; 
        if (paidRegistrationFilter !== undefined)
            url_ += "PaidRegistrationFilter=" + encodeURIComponent("" + paidRegistrationFilter) + "&"; 
        if (evaluatedResumoFilter !== undefined)
            url_ += "EvaluatedResumoFilter=" + encodeURIComponent("" + evaluatedResumoFilter) + "&"; 
        if (evaluaterProfileFilter !== undefined)
            url_ += "EvaluaterProfileFilter=" + encodeURIComponent("" + evaluaterProfileFilter) + "&"; 
        if (onlyCertificateWorkFilter !== undefined)
            url_ += "OnlyCertificateWorkFilter=" + encodeURIComponent("" + onlyCertificateWorkFilter) + "&"; 
        if (approveTypeIdFilter !== undefined)
            url_ += "ApproveTypeIdFilter=" + encodeURIComponent("" + approveTypeIdFilter) + "&"; 
        if (approveFilter !== undefined)
            url_ += "ApproveFilter=" + encodeURIComponent("" + approveFilter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetWorkForViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetWorkForViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponse<Blob>): Observable<PagedResultDtoOfGetWorkForViewDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetWorkForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetWorkForViewDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfGetWorkForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getWorkForView(id: number): Observable<GetWorkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetWorkForView?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetWorkForView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetWorkForView(response_);
                } catch (e) {
                    return <Observable<GetWorkForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetWorkForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetWorkForView(response: HttpResponse<Blob>): Observable<GetWorkForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetWorkForEditOutput.fromJS(resultData200) : new GetWorkForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetWorkForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getWorkForEdit(id: number): Observable<GetWorkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetWorkForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetWorkForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetWorkForEdit(response_);
                } catch (e) {
                    return <Observable<GetWorkForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetWorkForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetWorkForEdit(response: HttpResponse<Blob>): Observable<GetWorkForEditOutput> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetWorkForEditOutput.fromJS(resultData200) : new GetWorkForEditOutput();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<GetWorkForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadFileWork(input: UploadFileWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/UploadFileWork";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processUploadFileWork(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUploadFileWork(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadFileWork(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteWork(id: number, motiveDeleted: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/DeleteWork?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (motiveDeleted === undefined || motiveDeleted === null)
            throw new Error("The parameter 'motiveDeleted' must be defined and cannot be null.");
        else
            url_ += "MotiveDeleted=" + encodeURIComponent("" + motiveDeleted) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteWork(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteWork(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteWork(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @typeFilter (optional) 
     * @statusFilter (optional) 
     * @specialityIdFilter (optional) 
     * @subspecialityIdFilter (optional) 
     * @eventWorkIdFilter (optional) 
     * @authorIdFilter (optional) 
     * @presenterIdFilter (optional) 
     * @evaluatorIdFilter (optional) 
     * @solicitedPresentationTypeFilter (optional) 
     * @sentEPosterFilter (optional) 
     * @paidRegistrationFilter (optional) 
     * @evaluatedResumoFilter (optional) 
     * @approveTypeIdFilter (optional) 
     * @approveFilter (optional) 
     * @return Success
     */
    getWorksToExcel(filter: string | null, typeFilter: number | null, statusFilter: number | null, specialityIdFilter: number | null, subspecialityIdFilter: number | null, eventWorkIdFilter: number | null, authorIdFilter: number | null, presenterIdFilter: number | null, evaluatorIdFilter: number | null, solicitedPresentationTypeFilter: number | null, sentEPosterFilter: boolean | null, paidRegistrationFilter: boolean | null, evaluatedResumoFilter: boolean | null, approveTypeIdFilter: number | null, approveFilter: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetWorksToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (specialityIdFilter !== undefined)
            url_ += "SpecialityIdFilter=" + encodeURIComponent("" + specialityIdFilter) + "&"; 
        if (subspecialityIdFilter !== undefined)
            url_ += "SubspecialityIdFilter=" + encodeURIComponent("" + subspecialityIdFilter) + "&"; 
        if (eventWorkIdFilter !== undefined)
            url_ += "EventWorkIdFilter=" + encodeURIComponent("" + eventWorkIdFilter) + "&"; 
        if (authorIdFilter !== undefined)
            url_ += "AuthorIdFilter=" + encodeURIComponent("" + authorIdFilter) + "&"; 
        if (presenterIdFilter !== undefined)
            url_ += "PresenterIdFilter=" + encodeURIComponent("" + presenterIdFilter) + "&"; 
        if (evaluatorIdFilter !== undefined)
            url_ += "EvaluatorIdFilter=" + encodeURIComponent("" + evaluatorIdFilter) + "&"; 
        if (solicitedPresentationTypeFilter !== undefined)
            url_ += "SolicitedPresentationTypeFilter=" + encodeURIComponent("" + solicitedPresentationTypeFilter) + "&"; 
        if (sentEPosterFilter !== undefined)
            url_ += "SentEPosterFilter=" + encodeURIComponent("" + sentEPosterFilter) + "&"; 
        if (paidRegistrationFilter !== undefined)
            url_ += "PaidRegistrationFilter=" + encodeURIComponent("" + paidRegistrationFilter) + "&"; 
        if (evaluatedResumoFilter !== undefined)
            url_ += "EvaluatedResumoFilter=" + encodeURIComponent("" + evaluatedResumoFilter) + "&"; 
        if (approveTypeIdFilter !== undefined)
            url_ += "ApproveTypeIdFilter=" + encodeURIComponent("" + approveTypeIdFilter) + "&"; 
        if (approveFilter !== undefined)
            url_ += "ApproveFilter=" + encodeURIComponent("" + approveFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetWorksToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetWorksToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetWorksToExcel(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getWorkToWord(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetWorkToWord?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetWorkToWord(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetWorkToWord(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetWorkToWord(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @typeFilter (optional) 
     * @statusFilter (optional) 
     * @specialityIdFilter (optional) 
     * @subspecialityIdFilter (optional) 
     * @eventWorkIdFilter (optional) 
     * @authorIdFilter (optional) 
     * @presenterIdFilter (optional) 
     * @evaluatorIdFilter (optional) 
     * @solicitedPresentationTypeFilter (optional) 
     * @sentEPosterFilter (optional) 
     * @paidRegistrationFilter (optional) 
     * @evaluatedResumoFilter (optional) 
     * @evaluaterProfileFilter (optional) 
     * @workIdFilter (optional) 
     * @return Success
     */
    getWorksToWord(filter: string | null, typeFilter: number | null, statusFilter: number | null, specialityIdFilter: number | null, subspecialityIdFilter: number | null, eventWorkIdFilter: number | null, authorIdFilter: number | null, presenterIdFilter: number | null, evaluatorIdFilter: number | null, solicitedPresentationTypeFilter: number | null, sentEPosterFilter: boolean | null, paidRegistrationFilter: boolean | null, evaluatedResumoFilter: boolean | null, evaluaterProfileFilter: boolean | null, workIdFilter: number | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetWorksToWord?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (specialityIdFilter !== undefined)
            url_ += "SpecialityIdFilter=" + encodeURIComponent("" + specialityIdFilter) + "&"; 
        if (subspecialityIdFilter !== undefined)
            url_ += "SubspecialityIdFilter=" + encodeURIComponent("" + subspecialityIdFilter) + "&"; 
        if (eventWorkIdFilter !== undefined)
            url_ += "EventWorkIdFilter=" + encodeURIComponent("" + eventWorkIdFilter) + "&"; 
        if (authorIdFilter !== undefined)
            url_ += "AuthorIdFilter=" + encodeURIComponent("" + authorIdFilter) + "&"; 
        if (presenterIdFilter !== undefined)
            url_ += "PresenterIdFilter=" + encodeURIComponent("" + presenterIdFilter) + "&"; 
        if (evaluatorIdFilter !== undefined)
            url_ += "EvaluatorIdFilter=" + encodeURIComponent("" + evaluatorIdFilter) + "&"; 
        if (solicitedPresentationTypeFilter !== undefined)
            url_ += "SolicitedPresentationTypeFilter=" + encodeURIComponent("" + solicitedPresentationTypeFilter) + "&"; 
        if (sentEPosterFilter !== undefined)
            url_ += "SentEPosterFilter=" + encodeURIComponent("" + sentEPosterFilter) + "&"; 
        if (paidRegistrationFilter !== undefined)
            url_ += "PaidRegistrationFilter=" + encodeURIComponent("" + paidRegistrationFilter) + "&"; 
        if (evaluatedResumoFilter !== undefined)
            url_ += "EvaluatedResumoFilter=" + encodeURIComponent("" + evaluatedResumoFilter) + "&"; 
        if (evaluaterProfileFilter !== undefined)
            url_ += "EvaluaterProfileFilter=" + encodeURIComponent("" + evaluaterProfileFilter) + "&"; 
        if (workIdFilter !== undefined)
            url_ += "WorkIdFilter=" + encodeURIComponent("" + workIdFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetWorksToWord(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetWorksToWord(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetWorksToWord(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkPresenterIsValid(input: CheckWorksPresenterInput | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Works/CheckPresenterIsValid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCheckPresenterIsValid(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processCheckPresenterIsValid(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckPresenterIsValid(response: HttpResponse<Blob>): Observable<boolean> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEvaluators(input: UpdateWorkEvaluatorsInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/UpdateEvaluators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEvaluators(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateEvaluators(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEvaluators(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEvaluation(input: UpdateWorkEvaluationInput | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/UpdateEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processUpdateEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEvaluation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteEvaluation(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/DeleteEvaluation?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDeleteEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEvaluation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    drawEvaluators(input: EntityDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/DrawEvaluators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processDrawEvaluators(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processDrawEvaluators(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDrawEvaluators(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportEPosters(input: EntityDto | null): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/ExportEPosters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processExportEPosters(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processExportEPosters(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportEPosters(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @term (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getPresentationWorksForSelect(term: string | null, eventId: number, sorting: string | null, maxResultCount: number, skipCount: number): Observable<ListResultDtoOfWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetPresentationWorksForSelect?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined and cannot be null.");
        else
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetPresentationWorksForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetPresentationWorksForSelect(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfWorkDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfWorkDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPresentationWorksForSelect(response: HttpResponse<Blob>): Observable<ListResultDtoOfWorkDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfWorkDto.fromJS(resultData200) : new ListResultDtoOfWorkDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ListResultDtoOfWorkDto>(<any>null);
    }

    /**
     * @isActive (optional) 
     * @return Success
     */
    getWorkApprovalTypesForSelect(isActive: boolean | null): Observable<WorkApprovalTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetWorkApprovalTypesForSelect?";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetWorkApprovalTypesForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetWorkApprovalTypesForSelect(response_);
                } catch (e) {
                    return <Observable<WorkApprovalTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<WorkApprovalTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetWorkApprovalTypesForSelect(response: HttpResponse<Blob>): Observable<WorkApprovalTypeDto[]> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(WorkApprovalTypeDto.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<WorkApprovalTypeDto[]>(<any>null);
    }

    /**
     * @term (optional) 
     * @type (optional) 
     * @specialityId (optional) 
     * @subspecialityId (optional) 
     * @return Success
     */
    getAllEPosterWorks(term: string | null, eventWorkId: number, type: Type7 | null, specialityId: number | null, subspecialityId: number | null, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfEPosterWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetAllEPosterWorks?";
        if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventWorkId === undefined || eventWorkId === null)
            throw new Error("The parameter 'eventWorkId' must be defined and cannot be null.");
        else
            url_ += "EventWorkId=" + encodeURIComponent("" + eventWorkId) + "&"; 
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (specialityId !== undefined)
            url_ += "SpecialityId=" + encodeURIComponent("" + specialityId) + "&"; 
        if (subspecialityId !== undefined)
            url_ += "SubspecialityId=" + encodeURIComponent("" + subspecialityId) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAllEPosterWorks(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetAllEPosterWorks(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEPosterWorkDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfEPosterWorkDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllEPosterWorks(response: HttpResponse<Blob>): Observable<PagedResultDtoOfEPosterWorkDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEPosterWorkDto.fromJS(resultData200) : new PagedResultDtoOfEPosterWorkDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<PagedResultDtoOfEPosterWorkDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEPosterWork(id: number): Observable<EPosterWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetEPosterWork?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetEPosterWork(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetEPosterWork(response_);
                } catch (e) {
                    return <Observable<EPosterWorkDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EPosterWorkDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEPosterWork(response: HttpResponse<Blob>): Observable<EPosterWorkDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EPosterWorkDto.fromJS(resultData200) : new EPosterWorkDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<EPosterWorkDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    enabledPresentationEvaluation(input: EnabledPresentationEvaluationWorkDto | null): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Works/EnabledPresentationEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processEnabledPresentationEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processEnabledPresentationEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEnabledPresentationEvaluation(response: HttpResponse<Blob>): Observable<void> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCertificate(workId: number, type: Type8): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Works/GetCertificate?";
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined and cannot be null.");
        else
            url_ += "WorkId=" + encodeURIComponent("" + workId) + "&"; 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetCertificate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponse) {
                try {
                    return this.processGetCertificate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCertificate(response: HttpResponse<Blob>): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(response.body).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.body).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data; 
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }
}

export interface IRegisterOutput {
    canLogin: boolean | undefined;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId: number | undefined;
    resetCode: string;
    password: string;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IResetPasswordInput {
    userId: number | undefined;
    resetCode: string;
    password: string;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin: boolean | undefined;
    userName: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean | undefined;
    userName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId: number;
    confirmationCode: string;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        return data; 
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId: number | undefined;
    userId: number | undefined;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number | undefined;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number | undefined;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data; 
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number | undefined;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class PagedResultDtoOfGetActivityForViewDto implements IPagedResultDtoOfGetActivityForViewDto {
    totalCount: number | undefined;
    items: GetActivityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActivityForViewDto {
        let result = new PagedResultDtoOfGetActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetActivityForViewDto {
    totalCount: number | undefined;
    items: GetActivityForViewDto[] | undefined;
}

export class GetActivityForViewDto implements IGetActivityForViewDto {
    activity: ActivityDto | undefined;
    calendarActivity: CalendarActivityDto | undefined;
    blockConflicts: BlockConfictDto[] | undefined;

    constructor(data?: IGetActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activity = data["activity"] ? ActivityDto.fromJS(data["activity"]) : <any>undefined;
            this.calendarActivity = data["calendarActivity"] ? CalendarActivityDto.fromJS(data["calendarActivity"]) : <any>undefined;
            if (data["blockConflicts"] && data["blockConflicts"].constructor === Array) {
                this.blockConflicts = [];
                for (let item of data["blockConflicts"])
                    this.blockConflicts.push(BlockConfictDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActivityForViewDto {
        let result = new GetActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["calendarActivity"] = this.calendarActivity ? this.calendarActivity.toJSON() : <any>undefined;
        if (this.blockConflicts && this.blockConflicts.constructor === Array) {
            data["blockConflicts"] = [];
            for (let item of this.blockConflicts)
                data["blockConflicts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetActivityForViewDto {
    activity: ActivityDto | undefined;
    calendarActivity: CalendarActivityDto | undefined;
    blockConflicts: BlockConfictDto[] | undefined;
}

export class ActivityDto implements IActivityDto {
    description: string | undefined;
    duration: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaListDto | undefined;
    typeId: number | undefined;
    type: ActivityTypeListDto | undefined;
    finished: boolean | undefined;
    notes: string | undefined;
    topics: TopicDto[] | undefined;
    calendarActivityId: number | undefined;
    id: number | undefined;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.duration = data["duration"];
            this.thematicAreaId = data["thematicAreaId"];
            this.thematicArea = data["thematicArea"] ? ThematicAreaListDto.fromJS(data["thematicArea"]) : <any>undefined;
            this.typeId = data["typeId"];
            this.type = data["type"] ? ActivityTypeListDto.fromJS(data["type"]) : <any>undefined;
            this.finished = data["finished"];
            this.notes = data["notes"];
            if (data["topics"] && data["topics"].constructor === Array) {
                this.topics = [];
                for (let item of data["topics"])
                    this.topics.push(TopicDto.fromJS(item));
            }
            this.calendarActivityId = data["calendarActivityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityDto {
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["thematicAreaId"] = this.thematicAreaId;
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["finished"] = this.finished;
        data["notes"] = this.notes;
        if (this.topics && this.topics.constructor === Array) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        data["calendarActivityId"] = this.calendarActivityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityDto {
    description: string | undefined;
    duration: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaListDto | undefined;
    typeId: number | undefined;
    type: ActivityTypeListDto | undefined;
    finished: boolean | undefined;
    notes: string | undefined;
    topics: TopicDto[] | undefined;
    calendarActivityId: number | undefined;
    id: number | undefined;
}

export class CalendarActivityDto implements ICalendarActivityDto {
    description: string | undefined;
    tenantId: number | undefined;
    order: number | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    hasConflict: boolean | undefined;
    activityId: number | undefined;
    activity: ActivityDto | undefined;
    roomDayId: number | undefined;
    roomDay: EventRoomDayListDto | undefined;
    invitationActivities: InvitationActivityDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICalendarActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.tenantId = data["tenantId"];
            this.order = data["order"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.hasConflict = data["hasConflict"];
            this.activityId = data["activityId"];
            this.activity = data["activity"] ? ActivityDto.fromJS(data["activity"]) : <any>undefined;
            this.roomDayId = data["roomDayId"];
            this.roomDay = data["roomDay"] ? EventRoomDayListDto.fromJS(data["roomDay"]) : <any>undefined;
            if (data["invitationActivities"] && data["invitationActivities"].constructor === Array) {
                this.invitationActivities = [];
                for (let item of data["invitationActivities"])
                    this.invitationActivities.push(InvitationActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CalendarActivityDto {
        let result = new CalendarActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["order"] = this.order;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["hasConflict"] = this.hasConflict;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["roomDayId"] = this.roomDayId;
        data["roomDay"] = this.roomDay ? this.roomDay.toJSON() : <any>undefined;
        if (this.invitationActivities && this.invitationActivities.constructor === Array) {
            data["invitationActivities"] = [];
            for (let item of this.invitationActivities)
                data["invitationActivities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICalendarActivityDto {
    description: string | undefined;
    tenantId: number | undefined;
    order: number | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    hasConflict: boolean | undefined;
    activityId: number | undefined;
    activity: ActivityDto | undefined;
    roomDayId: number | undefined;
    roomDay: EventRoomDayListDto | undefined;
    invitationActivities: InvitationActivityDto[] | undefined;
    id: number | undefined;
}

export class BlockConfictDto implements IBlockConfictDto {
    calendarActivity: CalendarActivityDto | undefined;
    room: EventRoomListDto | undefined;
    participation: ParticipationDto | undefined;

    constructor(data?: IBlockConfictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarActivity = data["calendarActivity"] ? CalendarActivityDto.fromJS(data["calendarActivity"]) : <any>undefined;
            this.room = data["room"] ? EventRoomListDto.fromJS(data["room"]) : <any>undefined;
            this.participation = data["participation"] ? ParticipationDto.fromJS(data["participation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BlockConfictDto {
        let result = new BlockConfictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarActivity"] = this.calendarActivity ? this.calendarActivity.toJSON() : <any>undefined;
        data["room"] = this.room ? this.room.toJSON() : <any>undefined;
        data["participation"] = this.participation ? this.participation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBlockConfictDto {
    calendarActivity: CalendarActivityDto | undefined;
    room: EventRoomListDto | undefined;
    participation: ParticipationDto | undefined;
}

export class ThematicAreaListDto implements IThematicAreaListDto {
    description: string | undefined;
    responsible: UserSelectListDto | undefined;
    id: number | undefined;

    constructor(data?: IThematicAreaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.responsible = data["responsible"] ? UserSelectListDto.fromJS(data["responsible"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThematicAreaListDto {
        let result = new ThematicAreaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThematicAreaListDto {
    description: string | undefined;
    responsible: UserSelectListDto | undefined;
    id: number | undefined;
}

export class ActivityTypeListDto implements IActivityTypeListDto {
    id: number | undefined;
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;

    constructor(data?: IActivityTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): ActivityTypeListDto {
        let result = new ActivityTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        return data; 
    }
}

export interface IActivityTypeListDto {
    id: number | undefined;
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
}

export class TopicDto implements ITopicDto {
    duration: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    urlVideo: string | undefined;
    order: number | undefined;
    number: number | undefined;
    note: string | undefined;
    activityId: number | undefined;
    activity: ActivityListDto | undefined;
    type: TopicDtoType | undefined;
    participations: ParticipationDto[] | undefined;
    id: number | undefined;

    constructor(data?: ITopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.duration = data["duration"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.description = data["description"];
            this.urlVideo = data["urlVideo"];
            this.order = data["order"];
            this.number = data["number"];
            this.note = data["note"];
            this.activityId = data["activityId"];
            this.activity = data["activity"] ? ActivityListDto.fromJS(data["activity"]) : <any>undefined;
            this.type = data["type"];
            if (data["participations"] && data["participations"].constructor === Array) {
                this.participations = [];
                for (let item of data["participations"])
                    this.participations.push(ParticipationDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TopicDto {
        let result = new TopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["description"] = this.description;
        data["urlVideo"] = this.urlVideo;
        data["order"] = this.order;
        data["number"] = this.number;
        data["note"] = this.note;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["type"] = this.type;
        if (this.participations && this.participations.constructor === Array) {
            data["participations"] = [];
            for (let item of this.participations)
                data["participations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITopicDto {
    duration: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    urlVideo: string | undefined;
    order: number | undefined;
    number: number | undefined;
    note: string | undefined;
    activityId: number | undefined;
    activity: ActivityListDto | undefined;
    type: TopicDtoType | undefined;
    participations: ParticipationDto[] | undefined;
    id: number | undefined;
}

export class EventRoomDayListDto implements IEventRoomDayListDto {
    eventRoom: EventRoomListDto | undefined;
    eventDay: EventDayListDto | undefined;
    id: number | undefined;

    constructor(data?: IEventRoomDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventRoom = data["eventRoom"] ? EventRoomListDto.fromJS(data["eventRoom"]) : <any>undefined;
            this.eventDay = data["eventDay"] ? EventDayListDto.fromJS(data["eventDay"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventRoomDayListDto {
        let result = new EventRoomDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventRoom"] = this.eventRoom ? this.eventRoom.toJSON() : <any>undefined;
        data["eventDay"] = this.eventDay ? this.eventDay.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventRoomDayListDto {
    eventRoom: EventRoomListDto | undefined;
    eventDay: EventDayListDto | undefined;
    id: number | undefined;
}

export class InvitationActivityDto implements IInvitationActivityDto {
    approved: InvitationActivityDtoApproved | undefined;
    calendarActivityId: number | undefined;
    calendarActivity: CalendarActivityDto | undefined;
    invitationId: number | undefined;
    invitation: InvitationListDto | undefined;
    disapprovalReason: string | undefined;
    id: number | undefined;

    constructor(data?: IInvitationActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approved = data["approved"];
            this.calendarActivityId = data["calendarActivityId"];
            this.calendarActivity = data["calendarActivity"] ? CalendarActivityDto.fromJS(data["calendarActivity"]) : <any>undefined;
            this.invitationId = data["invitationId"];
            this.invitation = data["invitation"] ? InvitationListDto.fromJS(data["invitation"]) : <any>undefined;
            this.disapprovalReason = data["disapprovalReason"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InvitationActivityDto {
        let result = new InvitationActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approved"] = this.approved;
        data["calendarActivityId"] = this.calendarActivityId;
        data["calendarActivity"] = this.calendarActivity ? this.calendarActivity.toJSON() : <any>undefined;
        data["invitationId"] = this.invitationId;
        data["invitation"] = this.invitation ? this.invitation.toJSON() : <any>undefined;
        data["disapprovalReason"] = this.disapprovalReason;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInvitationActivityDto {
    approved: InvitationActivityDtoApproved | undefined;
    calendarActivityId: number | undefined;
    calendarActivity: CalendarActivityDto | undefined;
    invitationId: number | undefined;
    invitation: InvitationListDto | undefined;
    disapprovalReason: string | undefined;
    id: number | undefined;
}

export class EventRoomListDto implements IEventRoomListDto {
    description: string | undefined;
    shortDescription: string | undefined;
    numberOfVacancies: number | undefined;
    id: number | undefined;

    constructor(data?: IEventRoomListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.numberOfVacancies = data["numberOfVacancies"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventRoomListDto {
        let result = new EventRoomListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["numberOfVacancies"] = this.numberOfVacancies;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventRoomListDto {
    description: string | undefined;
    shortDescription: string | undefined;
    numberOfVacancies: number | undefined;
    id: number | undefined;
}

export class ParticipationDto implements IParticipationDto {
    guestId: number | undefined;
    guest: GuestListDto | undefined;
    readonly roleId: number | undefined;
    role: GuestRoleDto | undefined;
    topicId: number | undefined;
    topic: TopicListDto | undefined;

    constructor(data?: IParticipationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.guest = data["guest"] ? GuestListDto.fromJS(data["guest"]) : <any>undefined;
            (<any>this).roleId = data["roleId"];
            this.role = data["role"] ? GuestRoleDto.fromJS(data["role"]) : <any>undefined;
            this.topicId = data["topicId"];
            this.topic = data["topic"] ? TopicListDto.fromJS(data["topic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipationDto {
        let result = new ParticipationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["topicId"] = this.topicId;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IParticipationDto {
    guestId: number | undefined;
    guest: GuestListDto | undefined;
    roleId: number | undefined;
    role: GuestRoleDto | undefined;
    topicId: number | undefined;
    topic: TopicListDto | undefined;
}

export class UserSelectListDto implements IUserSelectListDto {
    name: string | undefined;
    userName: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    jobpositions: UserJobPositionEditDto[] | undefined;
    jobPosition: JobPositionListDto | undefined;
    id: number | undefined;

    constructor(data?: IUserSelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.userName = data["userName"];
            this.phoneNumber = data["phoneNumber"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            if (data["jobpositions"] && data["jobpositions"].constructor === Array) {
                this.jobpositions = [];
                for (let item of data["jobpositions"])
                    this.jobpositions.push(UserJobPositionEditDto.fromJS(item));
            }
            this.jobPosition = data["jobPosition"] ? JobPositionListDto.fromJS(data["jobPosition"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserSelectListDto {
        let result = new UserSelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        if (this.jobpositions && this.jobpositions.constructor === Array) {
            data["jobpositions"] = [];
            for (let item of this.jobpositions)
                data["jobpositions"].push(item.toJSON());
        }
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserSelectListDto {
    name: string | undefined;
    userName: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    jobpositions: UserJobPositionEditDto[] | undefined;
    jobPosition: JobPositionListDto | undefined;
    id: number | undefined;
}

export class ActivityListDto implements IActivityListDto {
    description: string | undefined;
    duration: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaListDto | undefined;
    typeId: number | undefined;
    type: ActivityTypeListDto | undefined;
    id: number | undefined;

    constructor(data?: IActivityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.duration = data["duration"];
            this.thematicAreaId = data["thematicAreaId"];
            this.thematicArea = data["thematicArea"] ? ThematicAreaListDto.fromJS(data["thematicArea"]) : <any>undefined;
            this.typeId = data["typeId"];
            this.type = data["type"] ? ActivityTypeListDto.fromJS(data["type"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityListDto {
        let result = new ActivityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["thematicAreaId"] = this.thematicAreaId;
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityListDto {
    description: string | undefined;
    duration: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaListDto | undefined;
    typeId: number | undefined;
    type: ActivityTypeListDto | undefined;
    id: number | undefined;
}

export class EventDayListDto implements IEventDayListDto {
    day: moment.Moment | undefined;
    color: string | undefined;
    beginHour: string | undefined;
    endHour: string | undefined;
    verifyAtivityConflicts: boolean | undefined;
    programmingId: number | undefined;
    id: number | undefined;

    constructor(data?: IEventDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"] ? moment(data["day"].toString()) : <any>undefined;
            this.color = data["color"];
            this.beginHour = data["beginHour"];
            this.endHour = data["endHour"];
            this.verifyAtivityConflicts = data["verifyAtivityConflicts"];
            this.programmingId = data["programmingId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventDayListDto {
        let result = new EventDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["beginHour"] = this.beginHour;
        data["endHour"] = this.endHour;
        data["verifyAtivityConflicts"] = this.verifyAtivityConflicts;
        data["programmingId"] = this.programmingId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventDayListDto {
    day: moment.Moment | undefined;
    color: string | undefined;
    beginHour: string | undefined;
    endHour: string | undefined;
    verifyAtivityConflicts: boolean | undefined;
    programmingId: number | undefined;
    id: number | undefined;
}

export class InvitationListDto implements IInvitationListDto {
    subject: string | undefined;
    email: string | undefined;
    guestId: number | undefined;
    guest: GuestDto | undefined;
    sendDate: moment.Moment | undefined;
    responseId: number | undefined;
    response: InvitationResponseListDto | undefined;
    id: number | undefined;

    constructor(data?: IInvitationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subject = data["subject"];
            this.email = data["email"];
            this.guestId = data["guestId"];
            this.guest = data["guest"] ? GuestDto.fromJS(data["guest"]) : <any>undefined;
            this.sendDate = data["sendDate"] ? moment(data["sendDate"].toString()) : <any>undefined;
            this.responseId = data["responseId"];
            this.response = data["response"] ? InvitationResponseListDto.fromJS(data["response"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InvitationListDto {
        let result = new InvitationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["email"] = this.email;
        data["guestId"] = this.guestId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["responseId"] = this.responseId;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInvitationListDto {
    subject: string | undefined;
    email: string | undefined;
    guestId: number | undefined;
    guest: GuestDto | undefined;
    sendDate: moment.Moment | undefined;
    responseId: number | undefined;
    response: InvitationResponseListDto | undefined;
    id: number | undefined;
}

export class GuestListDto implements IGuestListDto {
    name: string | undefined;
    email: string | undefined;
    userId: number | undefined;
    picture: string | undefined;
    numberOfParticipations: number | undefined;
    invitationStatus: string | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;

    constructor(data?: IGuestListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.email = data["email"];
            this.userId = data["userId"];
            this.picture = data["picture"];
            this.numberOfParticipations = data["numberOfParticipations"];
            this.invitationStatus = data["invitationStatus"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestListDto {
        let result = new GuestListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["picture"] = this.picture;
        data["numberOfParticipations"] = this.numberOfParticipations;
        data["invitationStatus"] = this.invitationStatus;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestListDto {
    name: string | undefined;
    email: string | undefined;
    userId: number | undefined;
    picture: string | undefined;
    numberOfParticipations: number | undefined;
    invitationStatus: string | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;
}

export class GuestRoleDto implements IGuestRoleDto {
    description: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: IGuestRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestRoleDto {
        let result = new GuestRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestRoleDto {
    description: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class TopicListDto implements ITopicListDto {
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    id: number | undefined;

    constructor(data?: ITopicListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TopicListDto {
        let result = new TopicListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITopicListDto {
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    id: number | undefined;
}

export class UserJobPositionEditDto implements IUserJobPositionEditDto {
    userId: number | undefined;
    jobPosition: JobPositionEditDto = new JobPositionEditDto();
    jobPositionDetail: JobPositionDetailEditDto = new JobPositionDetailEditDto();
    institution: InstitutionEditDto = new InstitutionEditDto();
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IUserJobPositionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.jobPosition = data["jobPosition"] ? JobPositionEditDto.fromJS(data["jobPosition"]) : new JobPositionEditDto();
            this.jobPositionDetail = data["jobPositionDetail"] ? JobPositionDetailEditDto.fromJS(data["jobPositionDetail"]) : new JobPositionDetailEditDto();
            this.institution = data["institution"] ? InstitutionEditDto.fromJS(data["institution"]) : new InstitutionEditDto();
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserJobPositionEditDto {
        let result = new UserJobPositionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        data["jobPositionDetail"] = this.jobPositionDetail ? this.jobPositionDetail.toJSON() : <any>undefined;
        data["institution"] = this.institution ? this.institution.toJSON() : <any>undefined;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserJobPositionEditDto {
    userId: number | undefined;
    jobPosition: JobPositionEditDto;
    jobPositionDetail: JobPositionDetailEditDto;
    institution: InstitutionEditDto;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    id: number | undefined;
}

export class JobPositionListDto implements IJobPositionListDto {
    id: number | undefined;
    name: string | undefined;
    approveRegistration: boolean | undefined;

    constructor(data?: IJobPositionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.approveRegistration = data["approveRegistration"];
        }
    }

    static fromJS(data: any): JobPositionListDto {
        let result = new JobPositionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["approveRegistration"] = this.approveRegistration;
        return data; 
    }
}

export interface IJobPositionListDto {
    id: number | undefined;
    name: string | undefined;
    approveRegistration: boolean | undefined;
}

export class GuestDto implements IGuestDto {
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    name: string;
    nameForCredential: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    rg: string | undefined;
    programmingId: number | undefined;
    lattes: string | undefined;
    scheduleSubmitted: boolean | undefined;
    registrationId: number | undefined;
    address: GuestAddressDto | undefined;
    phone: GuestPhoneDto | undefined;
    emails: UserEmailDto[] | undefined;
    id: number | undefined;

    constructor(data?: IGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.crm = data["crm"];
            this.crmUf = data["crmUf"];
            this.rg = data["rg"];
            this.programmingId = data["programmingId"];
            this.lattes = data["lattes"];
            this.scheduleSubmitted = data["scheduleSubmitted"];
            this.registrationId = data["registrationId"];
            this.address = data["address"] ? GuestAddressDto.fromJS(data["address"]) : <any>undefined;
            this.phone = data["phone"] ? GuestPhoneDto.fromJS(data["phone"]) : <any>undefined;
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestDto {
        let result = new GuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["crm"] = this.crm;
        data["crmUf"] = this.crmUf;
        data["rg"] = this.rg;
        data["programmingId"] = this.programmingId;
        data["lattes"] = this.lattes;
        data["scheduleSubmitted"] = this.scheduleSubmitted;
        data["registrationId"] = this.registrationId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestDto {
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    name: string;
    nameForCredential: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    rg: string | undefined;
    programmingId: number | undefined;
    lattes: string | undefined;
    scheduleSubmitted: boolean | undefined;
    registrationId: number | undefined;
    address: GuestAddressDto | undefined;
    phone: GuestPhoneDto | undefined;
    emails: UserEmailDto[] | undefined;
    id: number | undefined;
}

export class InvitationResponseListDto implements IInvitationResponseListDto {
    creationTime: moment.Moment | undefined;
    answerByAdmin: boolean | undefined;
    invitationId: number | undefined;
    id: number | undefined;

    constructor(data?: IInvitationResponseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.answerByAdmin = data["answerByAdmin"];
            this.invitationId = data["invitationId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InvitationResponseListDto {
        let result = new InvitationResponseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["answerByAdmin"] = this.answerByAdmin;
        data["invitationId"] = this.invitationId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInvitationResponseListDto {
    creationTime: moment.Moment | undefined;
    answerByAdmin: boolean | undefined;
    invitationId: number | undefined;
    id: number | undefined;
}

export class JobPositionEditDto implements IJobPositionEditDto {
    id: number | undefined;
    name: string;

    constructor(data?: IJobPositionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): JobPositionEditDto {
        let result = new JobPositionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IJobPositionEditDto {
    id: number | undefined;
    name: string;
}

export class JobPositionDetailEditDto implements IJobPositionDetailEditDto {
    description: string | undefined;

    constructor(data?: IJobPositionDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
        }
    }

    static fromJS(data: any): JobPositionDetailEditDto {
        let result = new JobPositionDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data; 
    }
}

export interface IJobPositionDetailEditDto {
    description: string | undefined;
}

export class InstitutionEditDto implements IInstitutionEditDto {
    name: string;

    constructor(data?: IInstitutionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): InstitutionEditDto {
        let result = new InstitutionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IInstitutionEditDto {
    name: string;
}

export class GuestAddressDto implements IGuestAddressDto {
    guestId: number | undefined;
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: GuestAddressDtoType;
    id: number | undefined;

    constructor(data?: IGuestAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestAddressDto {
        let result = new GuestAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestAddressDto {
    guestId: number | undefined;
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: GuestAddressDtoType;
    id: number | undefined;
}

export class GuestPhoneDto implements IGuestPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: GuestPhoneDtoType;
    id: number | undefined;

    constructor(data?: IGuestPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestPhoneDto {
        let result = new GuestPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: GuestPhoneDtoType;
    id: number | undefined;
}

export class UserEmailDto implements IUserEmailDto {
    emailAddress: string;
    id: number | undefined;

    constructor(data?: IUserEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserEmailDto {
        let result = new UserEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserEmailDto {
    emailAddress: string;
    id: number | undefined;
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string | undefined;
}

export class ListResultDtoOfActivityListDto implements IListResultDtoOfActivityListDto {
    items: ActivityListDto[] | undefined;

    constructor(data?: IListResultDtoOfActivityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityListDto {
        let result = new ListResultDtoOfActivityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityListDto {
    items: ActivityListDto[] | undefined;
}

export class GetActivityForEditOutput implements IGetActivityForEditOutput {
    activity: CreateOrEditActivityDto | undefined;
    calendarActivity: CreateOrEditCalendarActivityDto | undefined;
    onTheCalendar: boolean | undefined;
    refusedInvitations: RefusedInvitationDto[] | undefined;

    constructor(data?: IGetActivityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activity = data["activity"] ? CreateOrEditActivityDto.fromJS(data["activity"]) : <any>undefined;
            this.calendarActivity = data["calendarActivity"] ? CreateOrEditCalendarActivityDto.fromJS(data["calendarActivity"]) : <any>undefined;
            this.onTheCalendar = data["onTheCalendar"];
            if (data["refusedInvitations"] && data["refusedInvitations"].constructor === Array) {
                this.refusedInvitations = [];
                for (let item of data["refusedInvitations"])
                    this.refusedInvitations.push(RefusedInvitationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActivityForEditOutput {
        let result = new GetActivityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["calendarActivity"] = this.calendarActivity ? this.calendarActivity.toJSON() : <any>undefined;
        data["onTheCalendar"] = this.onTheCalendar;
        if (this.refusedInvitations && this.refusedInvitations.constructor === Array) {
            data["refusedInvitations"] = [];
            for (let item of this.refusedInvitations)
                data["refusedInvitations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetActivityForEditOutput {
    activity: CreateOrEditActivityDto | undefined;
    calendarActivity: CreateOrEditCalendarActivityDto | undefined;
    onTheCalendar: boolean | undefined;
    refusedInvitations: RefusedInvitationDto[] | undefined;
}

export class CreateOrEditActivityDto implements ICreateOrEditActivityDto {
    description: string | undefined;
    duration: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaListDto | undefined;
    typeId: number | undefined;
    type: ActivityTypeListDto | undefined;
    finished: boolean | undefined;
    notes: string | undefined;
    calendarActivityId: number | undefined;
    topics: CreateOrEditTopicDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.duration = data["duration"];
            this.thematicAreaId = data["thematicAreaId"];
            this.thematicArea = data["thematicArea"] ? ThematicAreaListDto.fromJS(data["thematicArea"]) : <any>undefined;
            this.typeId = data["typeId"];
            this.type = data["type"] ? ActivityTypeListDto.fromJS(data["type"]) : <any>undefined;
            this.finished = data["finished"];
            this.notes = data["notes"];
            this.calendarActivityId = data["calendarActivityId"];
            if (data["topics"] && data["topics"].constructor === Array) {
                this.topics = [];
                for (let item of data["topics"])
                    this.topics.push(CreateOrEditTopicDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActivityDto {
        let result = new CreateOrEditActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["thematicAreaId"] = this.thematicAreaId;
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["finished"] = this.finished;
        data["notes"] = this.notes;
        data["calendarActivityId"] = this.calendarActivityId;
        if (this.topics && this.topics.constructor === Array) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditActivityDto {
    description: string | undefined;
    duration: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaListDto | undefined;
    typeId: number | undefined;
    type: ActivityTypeListDto | undefined;
    finished: boolean | undefined;
    notes: string | undefined;
    calendarActivityId: number | undefined;
    topics: CreateOrEditTopicDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditCalendarActivityDto implements ICreateOrEditCalendarActivityDto {
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    hasConflict: boolean | undefined;
    activityId: number | undefined;
    activity: ActivityListDto | undefined;
    dayId: number | undefined;
    roomId: number | undefined;
    roomDayId: number | undefined;
    roomDay: EventRoomDayListDto | undefined;
    conflicts: BlockConfictDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCalendarActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.hasConflict = data["hasConflict"];
            this.activityId = data["activityId"];
            this.activity = data["activity"] ? ActivityListDto.fromJS(data["activity"]) : <any>undefined;
            this.dayId = data["dayId"];
            this.roomId = data["roomId"];
            this.roomDayId = data["roomDayId"];
            this.roomDay = data["roomDay"] ? EventRoomDayListDto.fromJS(data["roomDay"]) : <any>undefined;
            if (data["conflicts"] && data["conflicts"].constructor === Array) {
                this.conflicts = [];
                for (let item of data["conflicts"])
                    this.conflicts.push(BlockConfictDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCalendarActivityDto {
        let result = new CreateOrEditCalendarActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["hasConflict"] = this.hasConflict;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["dayId"] = this.dayId;
        data["roomId"] = this.roomId;
        data["roomDayId"] = this.roomDayId;
        data["roomDay"] = this.roomDay ? this.roomDay.toJSON() : <any>undefined;
        if (this.conflicts && this.conflicts.constructor === Array) {
            data["conflicts"] = [];
            for (let item of this.conflicts)
                data["conflicts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCalendarActivityDto {
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    hasConflict: boolean | undefined;
    activityId: number | undefined;
    activity: ActivityListDto | undefined;
    dayId: number | undefined;
    roomId: number | undefined;
    roomDayId: number | undefined;
    roomDay: EventRoomDayListDto | undefined;
    conflicts: BlockConfictDto[] | undefined;
    id: number | undefined;
}

export class RefusedInvitationDto implements IRefusedInvitationDto {
    guestId: number | undefined;
    invitationId: number | undefined;
    calendarActivityId: number | undefined;
    disapprovalReason: string | undefined;

    constructor(data?: IRefusedInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.invitationId = data["invitationId"];
            this.calendarActivityId = data["calendarActivityId"];
            this.disapprovalReason = data["disapprovalReason"];
        }
    }

    static fromJS(data: any): RefusedInvitationDto {
        let result = new RefusedInvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["invitationId"] = this.invitationId;
        data["calendarActivityId"] = this.calendarActivityId;
        data["disapprovalReason"] = this.disapprovalReason;
        return data; 
    }
}

export interface IRefusedInvitationDto {
    guestId: number | undefined;
    invitationId: number | undefined;
    calendarActivityId: number | undefined;
    disapprovalReason: string | undefined;
}

export class CreateOrEditTopicDto implements ICreateOrEditTopicDto {
    duration: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    urlVideo: string | undefined;
    order: number | undefined;
    number: number | undefined;
    note: string | undefined;
    activityId: number | undefined;
    activity: ActivityListDto | undefined;
    workId: number | undefined;
    work: WorkDto | undefined;
    workSelected: boolean | undefined;
    type: CreateOrEditTopicDtoType | undefined;
    participations: CreateOrEditParticipationDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.duration = data["duration"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.description = data["description"];
            this.urlVideo = data["urlVideo"];
            this.order = data["order"];
            this.number = data["number"];
            this.note = data["note"];
            this.activityId = data["activityId"];
            this.activity = data["activity"] ? ActivityListDto.fromJS(data["activity"]) : <any>undefined;
            this.workId = data["workId"];
            this.work = data["work"] ? WorkDto.fromJS(data["work"]) : <any>undefined;
            this.workSelected = data["workSelected"];
            this.type = data["type"];
            if (data["participations"] && data["participations"].constructor === Array) {
                this.participations = [];
                for (let item of data["participations"])
                    this.participations.push(CreateOrEditParticipationDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTopicDto {
        let result = new CreateOrEditTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["description"] = this.description;
        data["urlVideo"] = this.urlVideo;
        data["order"] = this.order;
        data["number"] = this.number;
        data["note"] = this.note;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["workId"] = this.workId;
        data["work"] = this.work ? this.work.toJSON() : <any>undefined;
        data["workSelected"] = this.workSelected;
        data["type"] = this.type;
        if (this.participations && this.participations.constructor === Array) {
            data["participations"] = [];
            for (let item of this.participations)
                data["participations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTopicDto {
    duration: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    urlVideo: string | undefined;
    order: number | undefined;
    number: number | undefined;
    note: string | undefined;
    activityId: number | undefined;
    activity: ActivityListDto | undefined;
    workId: number | undefined;
    work: WorkDto | undefined;
    workSelected: boolean | undefined;
    type: CreateOrEditTopicDtoType | undefined;
    participations: CreateOrEditParticipationDto[] | undefined;
    id: number | undefined;
}

export class WorkDto implements IWorkDto {
    title: string | undefined;
    resume: string | undefined;
    motiveDeleted: string | undefined;
    deletionTime: moment.Moment | undefined;
    file: string | undefined;
    figure: string | undefined;
    conflictOfInterests: string | undefined;
    sourceOfFunding: string | undefined;
    type: WorkDtoType | undefined;
    status: WorkDtoStatus | undefined;
    solicitedPresentationType: WorkDtoSolicitedPresentationType | undefined;
    resumeGrade: number | undefined;
    presentationGrade: number | undefined;
    finalGrade: number | undefined;
    presentationEvaluationEnabled: boolean | undefined;
    specialityId: number | undefined;
    subspecialityId: number | undefined;
    eventWorkId: number | undefined;
    institutionWorkId: number | undefined;
    authors: AuthorDto[] | undefined;
    approvals: WorkApprovalDto[] | undefined;
    keyWords: KeyWordDto[] | undefined;
    references: ReferenceDto[] | undefined;
    resumeEvaluations: WorkResumeEvaluationDto[] | undefined;
    id: number | undefined;

    constructor(data?: IWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.resume = data["resume"];
            this.motiveDeleted = data["motiveDeleted"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.file = data["file"];
            this.figure = data["figure"];
            this.conflictOfInterests = data["conflictOfInterests"];
            this.sourceOfFunding = data["sourceOfFunding"];
            this.type = data["type"];
            this.status = data["status"];
            this.solicitedPresentationType = data["solicitedPresentationType"];
            this.resumeGrade = data["resumeGrade"];
            this.presentationGrade = data["presentationGrade"];
            this.finalGrade = data["finalGrade"];
            this.presentationEvaluationEnabled = data["presentationEvaluationEnabled"];
            this.specialityId = data["specialityId"];
            this.subspecialityId = data["subspecialityId"];
            this.eventWorkId = data["eventWorkId"];
            this.institutionWorkId = data["institutionWorkId"];
            if (data["authors"] && data["authors"].constructor === Array) {
                this.authors = [];
                for (let item of data["authors"])
                    this.authors.push(AuthorDto.fromJS(item));
            }
            if (data["approvals"] && data["approvals"].constructor === Array) {
                this.approvals = [];
                for (let item of data["approvals"])
                    this.approvals.push(WorkApprovalDto.fromJS(item));
            }
            if (data["keyWords"] && data["keyWords"].constructor === Array) {
                this.keyWords = [];
                for (let item of data["keyWords"])
                    this.keyWords.push(KeyWordDto.fromJS(item));
            }
            if (data["references"] && data["references"].constructor === Array) {
                this.references = [];
                for (let item of data["references"])
                    this.references.push(ReferenceDto.fromJS(item));
            }
            if (data["resumeEvaluations"] && data["resumeEvaluations"].constructor === Array) {
                this.resumeEvaluations = [];
                for (let item of data["resumeEvaluations"])
                    this.resumeEvaluations.push(WorkResumeEvaluationDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WorkDto {
        let result = new WorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["resume"] = this.resume;
        data["motiveDeleted"] = this.motiveDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["file"] = this.file;
        data["figure"] = this.figure;
        data["conflictOfInterests"] = this.conflictOfInterests;
        data["sourceOfFunding"] = this.sourceOfFunding;
        data["type"] = this.type;
        data["status"] = this.status;
        data["solicitedPresentationType"] = this.solicitedPresentationType;
        data["resumeGrade"] = this.resumeGrade;
        data["presentationGrade"] = this.presentationGrade;
        data["finalGrade"] = this.finalGrade;
        data["presentationEvaluationEnabled"] = this.presentationEvaluationEnabled;
        data["specialityId"] = this.specialityId;
        data["subspecialityId"] = this.subspecialityId;
        data["eventWorkId"] = this.eventWorkId;
        data["institutionWorkId"] = this.institutionWorkId;
        if (this.authors && this.authors.constructor === Array) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        if (this.approvals && this.approvals.constructor === Array) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (this.keyWords && this.keyWords.constructor === Array) {
            data["keyWords"] = [];
            for (let item of this.keyWords)
                data["keyWords"].push(item.toJSON());
        }
        if (this.references && this.references.constructor === Array) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        if (this.resumeEvaluations && this.resumeEvaluations.constructor === Array) {
            data["resumeEvaluations"] = [];
            for (let item of this.resumeEvaluations)
                data["resumeEvaluations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkDto {
    title: string | undefined;
    resume: string | undefined;
    motiveDeleted: string | undefined;
    deletionTime: moment.Moment | undefined;
    file: string | undefined;
    figure: string | undefined;
    conflictOfInterests: string | undefined;
    sourceOfFunding: string | undefined;
    type: WorkDtoType | undefined;
    status: WorkDtoStatus | undefined;
    solicitedPresentationType: WorkDtoSolicitedPresentationType | undefined;
    resumeGrade: number | undefined;
    presentationGrade: number | undefined;
    finalGrade: number | undefined;
    presentationEvaluationEnabled: boolean | undefined;
    specialityId: number | undefined;
    subspecialityId: number | undefined;
    eventWorkId: number | undefined;
    institutionWorkId: number | undefined;
    authors: AuthorDto[] | undefined;
    approvals: WorkApprovalDto[] | undefined;
    keyWords: KeyWordDto[] | undefined;
    references: ReferenceDto[] | undefined;
    resumeEvaluations: WorkResumeEvaluationDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditParticipationDto implements ICreateOrEditParticipationDto {
    guestId: number;
    guest: CreateOrEditGuestDto | undefined;
    roleId: number;
    role: CreateOrEditGuestRoleDto | undefined;
    topicId: number;
    topic: TopicListDto | undefined;
    conflict: string | undefined;
    conflictActivityId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditParticipationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.guest = data["guest"] ? CreateOrEditGuestDto.fromJS(data["guest"]) : <any>undefined;
            this.roleId = data["roleId"];
            this.role = data["role"] ? CreateOrEditGuestRoleDto.fromJS(data["role"]) : <any>undefined;
            this.topicId = data["topicId"];
            this.topic = data["topic"] ? TopicListDto.fromJS(data["topic"]) : <any>undefined;
            this.conflict = data["conflict"];
            this.conflictActivityId = data["conflictActivityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditParticipationDto {
        let result = new CreateOrEditParticipationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["topicId"] = this.topicId;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        data["conflict"] = this.conflict;
        data["conflictActivityId"] = this.conflictActivityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditParticipationDto {
    guestId: number;
    guest: CreateOrEditGuestDto | undefined;
    roleId: number;
    role: CreateOrEditGuestRoleDto | undefined;
    topicId: number;
    topic: TopicListDto | undefined;
    conflict: string | undefined;
    conflictActivityId: number | undefined;
    id: number | undefined;
}

export class AuthorDto implements IAuthorDto {
    isPresenter: boolean | undefined;
    isCoauthor: boolean | undefined;
    hasPaidRegistration: boolean | undefined;
    category: AuthorDtoCategory | undefined;
    order: number | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    workId: number | undefined;
    id: number | undefined;

    constructor(data?: IAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPresenter = data["isPresenter"];
            this.isCoauthor = data["isCoauthor"];
            this.hasPaidRegistration = data["hasPaidRegistration"];
            this.category = data["category"];
            this.order = data["order"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.workId = data["workId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuthorDto {
        let result = new AuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPresenter"] = this.isPresenter;
        data["isCoauthor"] = this.isCoauthor;
        data["hasPaidRegistration"] = this.hasPaidRegistration;
        data["category"] = this.category;
        data["order"] = this.order;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["workId"] = this.workId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAuthorDto {
    isPresenter: boolean | undefined;
    isCoauthor: boolean | undefined;
    hasPaidRegistration: boolean | undefined;
    category: AuthorDtoCategory | undefined;
    order: number | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    workId: number | undefined;
    id: number | undefined;
}

export class WorkApprovalDto implements IWorkApprovalDto {
    typeId: number | undefined;
    type: WorkApprovalTypeDto | undefined;
    approved: WorkApprovalDtoApproved | undefined;
    file: string | undefined;
    id: number | undefined;

    constructor(data?: IWorkApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeId = data["typeId"];
            this.type = data["type"] ? WorkApprovalTypeDto.fromJS(data["type"]) : <any>undefined;
            this.approved = data["approved"];
            this.file = data["file"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WorkApprovalDto {
        let result = new WorkApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["approved"] = this.approved;
        data["file"] = this.file;
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkApprovalDto {
    typeId: number | undefined;
    type: WorkApprovalTypeDto | undefined;
    approved: WorkApprovalDtoApproved | undefined;
    file: string | undefined;
    id: number | undefined;
}

export class KeyWordDto implements IKeyWordDto {
    description: string | undefined;
    id: number | undefined;

    constructor(data?: IKeyWordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): KeyWordDto {
        let result = new KeyWordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IKeyWordDto {
    description: string | undefined;
    id: number | undefined;
}

export class ReferenceDto implements IReferenceDto {
    description: string | undefined;
    id: number | undefined;

    constructor(data?: IReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReferenceDto {
        let result = new ReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReferenceDto {
    description: string | undefined;
    id: number | undefined;
}

export class WorkResumeEvaluationDto implements IWorkResumeEvaluationDto {
    grade: number | undefined;
    finalized: boolean | undefined;
    workId: number | undefined;
    evaluatorId: number | undefined;
    evaluator: EvaluatorDto | undefined;
    answers: CreateOrEditSurveyAnswerWorkDto[] | undefined;
    id: number | undefined;

    constructor(data?: IWorkResumeEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.grade = data["grade"];
            this.finalized = data["finalized"];
            this.workId = data["workId"];
            this.evaluatorId = data["evaluatorId"];
            this.evaluator = data["evaluator"] ? EvaluatorDto.fromJS(data["evaluator"]) : <any>undefined;
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(CreateOrEditSurveyAnswerWorkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WorkResumeEvaluationDto {
        let result = new WorkResumeEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grade"] = this.grade;
        data["finalized"] = this.finalized;
        data["workId"] = this.workId;
        data["evaluatorId"] = this.evaluatorId;
        data["evaluator"] = this.evaluator ? this.evaluator.toJSON() : <any>undefined;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkResumeEvaluationDto {
    grade: number | undefined;
    finalized: boolean | undefined;
    workId: number | undefined;
    evaluatorId: number | undefined;
    evaluator: EvaluatorDto | undefined;
    answers: CreateOrEditSurveyAnswerWorkDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditGuestDto implements ICreateOrEditGuestDto {
    userId: number;
    user: UserSelectListDto | undefined;
    name: string | undefined;
    nameForCredential: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    rg: string | undefined;
    lattes: string | undefined;
    scheduleSubmitted: boolean | undefined;
    programmingId: number | undefined;
    registrationId: number | undefined;
    address: GuestAddressDto | undefined;
    phone: GuestPhoneDto | undefined;
    emails: GuestEmailDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.crm = data["crm"];
            this.crmUf = data["crmUf"];
            this.rg = data["rg"];
            this.lattes = data["lattes"];
            this.scheduleSubmitted = data["scheduleSubmitted"];
            this.programmingId = data["programmingId"];
            this.registrationId = data["registrationId"];
            this.address = data["address"] ? GuestAddressDto.fromJS(data["address"]) : <any>undefined;
            this.phone = data["phone"] ? GuestPhoneDto.fromJS(data["phone"]) : <any>undefined;
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(GuestEmailDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGuestDto {
        let result = new CreateOrEditGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["crm"] = this.crm;
        data["crmUf"] = this.crmUf;
        data["rg"] = this.rg;
        data["lattes"] = this.lattes;
        data["scheduleSubmitted"] = this.scheduleSubmitted;
        data["programmingId"] = this.programmingId;
        data["registrationId"] = this.registrationId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditGuestDto {
    userId: number;
    user: UserSelectListDto | undefined;
    name: string | undefined;
    nameForCredential: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    rg: string | undefined;
    lattes: string | undefined;
    scheduleSubmitted: boolean | undefined;
    programmingId: number | undefined;
    registrationId: number | undefined;
    address: GuestAddressDto | undefined;
    phone: GuestPhoneDto | undefined;
    emails: GuestEmailDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditGuestRoleDto implements ICreateOrEditGuestRoleDto {
    description: string;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditGuestRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGuestRoleDto {
        let result = new CreateOrEditGuestRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditGuestRoleDto {
    description: string;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class WorkApprovalTypeDto implements IWorkApprovalTypeDto {
    description: string | undefined;
    showToEvaluators: boolean | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: IWorkApprovalTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.showToEvaluators = data["showToEvaluators"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WorkApprovalTypeDto {
        let result = new WorkApprovalTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["showToEvaluators"] = this.showToEvaluators;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkApprovalTypeDto {
    description: string | undefined;
    showToEvaluators: boolean | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class EvaluatorDto implements IEvaluatorDto {
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    specialityId: number | undefined;
    institutionWorkId: number | undefined;
    eventWorkId: number | undefined;
    id: number | undefined;

    constructor(data?: IEvaluatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.specialityId = data["specialityId"];
            this.institutionWorkId = data["institutionWorkId"];
            this.eventWorkId = data["eventWorkId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluatorDto {
        let result = new EvaluatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["specialityId"] = this.specialityId;
        data["institutionWorkId"] = this.institutionWorkId;
        data["eventWorkId"] = this.eventWorkId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluatorDto {
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    specialityId: number | undefined;
    institutionWorkId: number | undefined;
    eventWorkId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSurveyAnswerWorkDto implements ICreateOrEditSurveyAnswerWorkDto {
    isActive: boolean | undefined;
    grade: number | undefined;
    notes: string | undefined;
    answerWork: CreateOrEditSurveyAnswerWorkDtoAnswerWork | undefined;
    publishWork: boolean | undefined;
    workResumeEvaluationId: number | undefined;
    finalized: boolean | undefined;
    answerWorks: CreateOrEditQuestionAnswerWorkDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSurveyAnswerWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.grade = data["grade"];
            this.notes = data["notes"];
            this.answerWork = data["answerWork"];
            this.publishWork = data["publishWork"];
            this.workResumeEvaluationId = data["workResumeEvaluationId"];
            this.finalized = data["finalized"];
            if (data["answerWorks"] && data["answerWorks"].constructor === Array) {
                this.answerWorks = [];
                for (let item of data["answerWorks"])
                    this.answerWorks.push(CreateOrEditQuestionAnswerWorkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyAnswerWorkDto {
        let result = new CreateOrEditSurveyAnswerWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["grade"] = this.grade;
        data["notes"] = this.notes;
        data["answerWork"] = this.answerWork;
        data["publishWork"] = this.publishWork;
        data["workResumeEvaluationId"] = this.workResumeEvaluationId;
        data["finalized"] = this.finalized;
        if (this.answerWorks && this.answerWorks.constructor === Array) {
            data["answerWorks"] = [];
            for (let item of this.answerWorks)
                data["answerWorks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSurveyAnswerWorkDto {
    isActive: boolean | undefined;
    grade: number | undefined;
    notes: string | undefined;
    answerWork: CreateOrEditSurveyAnswerWorkDtoAnswerWork | undefined;
    publishWork: boolean | undefined;
    workResumeEvaluationId: number | undefined;
    finalized: boolean | undefined;
    answerWorks: CreateOrEditQuestionAnswerWorkDto[] | undefined;
    id: number | undefined;
}

export class GuestEmailDto implements IGuestEmailDto {
    emailAddress: string;
    id: number | undefined;

    constructor(data?: IGuestEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestEmailDto {
        let result = new GuestEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestEmailDto {
    emailAddress: string;
    id: number | undefined;
}

export class CreateOrEditQuestionAnswerWorkDto implements ICreateOrEditQuestionAnswerWorkDto {
    questionWorkId: number | undefined;
    optionWorkId: number | undefined;
    textComment: string | undefined;

    constructor(data?: ICreateOrEditQuestionAnswerWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionWorkId = data["questionWorkId"];
            this.optionWorkId = data["optionWorkId"];
            this.textComment = data["textComment"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestionAnswerWorkDto {
        let result = new CreateOrEditQuestionAnswerWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionWorkId"] = this.questionWorkId;
        data["optionWorkId"] = this.optionWorkId;
        data["textComment"] = this.textComment;
        return data; 
    }
}

export interface ICreateOrEditQuestionAnswerWorkDto {
    questionWorkId: number | undefined;
    optionWorkId: number | undefined;
    textComment: string | undefined;
}

export class EntityDto implements IEntityDto {
    id: number | undefined;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDto {
    id: number | undefined;
}

export class ListResultDtoOfGuestListDto implements IListResultDtoOfGuestListDto {
    items: GuestListDto[] | undefined;

    constructor(data?: IListResultDtoOfGuestListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GuestListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGuestListDto {
        let result = new ListResultDtoOfGuestListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGuestListDto {
    items: GuestListDto[] | undefined;
}

export class ListResultDtoOfGuestRoleDto implements IListResultDtoOfGuestRoleDto {
    items: GuestRoleDto[] | undefined;

    constructor(data?: IListResultDtoOfGuestRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GuestRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGuestRoleDto {
        let result = new ListResultDtoOfGuestRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGuestRoleDto {
    items: GuestRoleDto[] | undefined;
}

export class PagedResultDtoOfGetActivityTemplateForViewDto implements IPagedResultDtoOfGetActivityTemplateForViewDto {
    totalCount: number | undefined;
    items: GetActivityTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActivityTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActivityTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActivityTemplateForViewDto {
        let result = new PagedResultDtoOfGetActivityTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetActivityTemplateForViewDto {
    totalCount: number | undefined;
    items: GetActivityTemplateForViewDto[] | undefined;
}

export class GetActivityTemplateForViewDto implements IGetActivityTemplateForViewDto {
    activityTemplate: ActivityTemplateDto | undefined;

    constructor(data?: IGetActivityTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityTemplate = data["activityTemplate"] ? ActivityTemplateDto.fromJS(data["activityTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTemplateForViewDto {
        let result = new GetActivityTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTemplate"] = this.activityTemplate ? this.activityTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTemplateForViewDto {
    activityTemplate: ActivityTemplateDto | undefined;
}

export class ActivityTemplateDto implements IActivityTemplateDto {
    description: string | undefined;
    activityTypes: ActivityTypeListDto[] | undefined;
    templateJson: string | undefined;
    id: number | undefined;

    constructor(data?: IActivityTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            if (data["activityTypes"] && data["activityTypes"].constructor === Array) {
                this.activityTypes = [];
                for (let item of data["activityTypes"])
                    this.activityTypes.push(ActivityTypeListDto.fromJS(item));
            }
            this.templateJson = data["templateJson"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityTemplateDto {
        let result = new ActivityTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (this.activityTypes && this.activityTypes.constructor === Array) {
            data["activityTypes"] = [];
            for (let item of this.activityTypes)
                data["activityTypes"].push(item.toJSON());
        }
        data["templateJson"] = this.templateJson;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityTemplateDto {
    description: string | undefined;
    activityTypes: ActivityTypeListDto[] | undefined;
    templateJson: string | undefined;
    id: number | undefined;
}

export class GetActivityTemplateForEditOutput implements IGetActivityTemplateForEditOutput {
    activityTemplate: CreateOrEditActivityTemplateDto | undefined;

    constructor(data?: IGetActivityTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityTemplate = data["activityTemplate"] ? CreateOrEditActivityTemplateDto.fromJS(data["activityTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTemplateForEditOutput {
        let result = new GetActivityTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTemplate"] = this.activityTemplate ? this.activityTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTemplateForEditOutput {
    activityTemplate: CreateOrEditActivityTemplateDto | undefined;
}

export class CreateOrEditActivityTemplateDto implements ICreateOrEditActivityTemplateDto {
    description: string;
    templateJson: string | undefined;
    activityType: ActivityTypeListDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditActivityTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.templateJson = data["templateJson"];
            if (data["activityType"] && data["activityType"].constructor === Array) {
                this.activityType = [];
                for (let item of data["activityType"])
                    this.activityType.push(ActivityTypeListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActivityTemplateDto {
        let result = new CreateOrEditActivityTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["templateJson"] = this.templateJson;
        if (this.activityType && this.activityType.constructor === Array) {
            data["activityType"] = [];
            for (let item of this.activityType)
                data["activityType"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditActivityTemplateDto {
    description: string;
    templateJson: string | undefined;
    activityType: ActivityTypeListDto[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfActivityTemplateListDto implements IListResultDtoOfActivityTemplateListDto {
    items: ActivityTemplateListDto[] | undefined;

    constructor(data?: IListResultDtoOfActivityTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityTemplateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityTemplateListDto {
        let result = new ListResultDtoOfActivityTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityTemplateListDto {
    items: ActivityTemplateListDto[] | undefined;
}

export class ActivityTemplateListDto implements IActivityTemplateListDto {
    description: string | undefined;
    templateJson: string | undefined;
    id: number | undefined;

    constructor(data?: IActivityTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.templateJson = data["templateJson"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityTemplateListDto {
        let result = new ActivityTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["templateJson"] = this.templateJson;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityTemplateListDto {
    description: string | undefined;
    templateJson: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetActivityTypeForViewDto implements IPagedResultDtoOfGetActivityTypeForViewDto {
    totalCount: number | undefined;
    items: GetActivityTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActivityTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActivityTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActivityTypeForViewDto {
        let result = new PagedResultDtoOfGetActivityTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetActivityTypeForViewDto {
    totalCount: number | undefined;
    items: GetActivityTypeForViewDto[] | undefined;
}

export class GetActivityTypeForViewDto implements IGetActivityTypeForViewDto {
    activityType: ActivityTypeDto | undefined;

    constructor(data?: IGetActivityTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityType = data["activityType"] ? ActivityTypeDto.fromJS(data["activityType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTypeForViewDto {
        let result = new GetActivityTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType ? this.activityType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTypeForViewDto {
    activityType: ActivityTypeDto | undefined;
}

export class ActivityTypeDto implements IActivityTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
    isSponsored: boolean | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: IActivityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
            this.isSponsored = data["isSponsored"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityTypeDto {
        let result = new ActivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        data["isSponsored"] = this.isSponsored;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
    isSponsored: boolean | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class ListResultDtoOfActivityTypeListDto implements IListResultDtoOfActivityTypeListDto {
    items: ActivityTypeListDto[] | undefined;

    constructor(data?: IListResultDtoOfActivityTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityTypeListDto {
        let result = new ListResultDtoOfActivityTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityTypeListDto {
    items: ActivityTypeListDto[] | undefined;
}

export class GetActivityTypeForEditOutput implements IGetActivityTypeForEditOutput {
    activityType: CreateOrEditActivityTypeDto | undefined;

    constructor(data?: IGetActivityTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityType = data["activityType"] ? CreateOrEditActivityTypeDto.fromJS(data["activityType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTypeForEditOutput {
        let result = new GetActivityTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType ? this.activityType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTypeForEditOutput {
    activityType: CreateOrEditActivityTypeDto | undefined;
}

export class CreateOrEditActivityTypeDto implements ICreateOrEditActivityTypeDto {
    description: string;
    shortDescription: string | undefined;
    color: string | undefined;
    isSponsored: boolean | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditActivityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
            this.isSponsored = data["isSponsored"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActivityTypeDto {
        let result = new CreateOrEditActivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        data["isSponsored"] = this.isSponsored;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditActivityTypeDto {
    description: string;
    shortDescription: string | undefined;
    color: string | undefined;
    isSponsored: boolean | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class ActivateDto implements IActivateDto {
    id: number | undefined;
    activate: boolean | undefined;

    constructor(data?: IActivateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.activate = data["activate"];
        }
    }

    static fromJS(data: any): ActivateDto {
        let result = new ActivateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activate"] = this.activate;
        return data; 
    }
}

export interface IActivateDto {
    id: number | undefined;
    activate: boolean | undefined;
}

export class PagedResultDtoOfGetAdminActivityForViewDto implements IPagedResultDtoOfGetAdminActivityForViewDto {
    totalCount: number | undefined;
    items: GetAdminActivityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAdminActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAdminActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAdminActivityForViewDto {
        let result = new PagedResultDtoOfGetAdminActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAdminActivityForViewDto {
    totalCount: number | undefined;
    items: GetAdminActivityForViewDto[] | undefined;
}

export class GetAdminActivityForViewDto implements IGetAdminActivityForViewDto {
    adminActivity: AdminActivityDto | undefined;

    constructor(data?: IGetAdminActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adminActivity = data["adminActivity"] ? AdminActivityDto.fromJS(data["adminActivity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdminActivityForViewDto {
        let result = new GetAdminActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminActivity"] = this.adminActivity ? this.adminActivity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAdminActivityForViewDto {
    adminActivity: AdminActivityDto | undefined;
}

export class AdminActivityDto implements IAdminActivityDto {
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;

    constructor(data?: IAdminActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activity = data["activity"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.activityType = data["activityType"];
            this.jobPositionId = data["jobPositionId"];
            this.jobPosition = data["jobPosition"] ? JobPositionListDto.fromJS(data["jobPosition"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AdminActivityDto {
        let result = new AdminActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["activityType"] = this.activityType;
        data["jobPositionId"] = this.jobPositionId;
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAdminActivityDto {
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;
}

export class GetAdminActivityForEditOutput implements IGetAdminActivityForEditOutput {
    adminActivity: CreateOrEditAdminActivityDto | undefined;

    constructor(data?: IGetAdminActivityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adminActivity = data["adminActivity"] ? CreateOrEditAdminActivityDto.fromJS(data["adminActivity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdminActivityForEditOutput {
        let result = new GetAdminActivityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminActivity"] = this.adminActivity ? this.adminActivity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAdminActivityForEditOutput {
    adminActivity: CreateOrEditAdminActivityDto | undefined;
}

export class CreateOrEditAdminActivityDto implements ICreateOrEditAdminActivityDto {
    boardActivity: CreateOrEditBoardActivityDto | undefined;
    commissionActivity: CreateOrEditCommissionActivityDto | undefined;
    collaboratorActivity: CreateOrEditCollaboratorActivityDto | undefined;
    activityType: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditAdminActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.boardActivity = data["boardActivity"] ? CreateOrEditBoardActivityDto.fromJS(data["boardActivity"]) : <any>undefined;
            this.commissionActivity = data["commissionActivity"] ? CreateOrEditCommissionActivityDto.fromJS(data["commissionActivity"]) : <any>undefined;
            this.collaboratorActivity = data["collaboratorActivity"] ? CreateOrEditCollaboratorActivityDto.fromJS(data["collaboratorActivity"]) : <any>undefined;
            this.activityType = data["activityType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAdminActivityDto {
        let result = new CreateOrEditAdminActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardActivity"] = this.boardActivity ? this.boardActivity.toJSON() : <any>undefined;
        data["commissionActivity"] = this.commissionActivity ? this.commissionActivity.toJSON() : <any>undefined;
        data["collaboratorActivity"] = this.collaboratorActivity ? this.collaboratorActivity.toJSON() : <any>undefined;
        data["activityType"] = this.activityType;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAdminActivityDto {
    boardActivity: CreateOrEditBoardActivityDto | undefined;
    commissionActivity: CreateOrEditCommissionActivityDto | undefined;
    collaboratorActivity: CreateOrEditCollaboratorActivityDto | undefined;
    activityType: string | undefined;
    id: number | undefined;
}

export class CreateOrEditBoardActivityDto implements ICreateOrEditBoardActivityDto {
    objective: string | undefined;
    horary: string | undefined;
    local: string | undefined;
    report: string | undefined;
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditBoardActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.objective = data["objective"];
            this.horary = data["horary"];
            this.local = data["local"];
            this.report = data["report"];
            this.activity = data["activity"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.activityType = data["activityType"];
            this.jobPositionId = data["jobPositionId"];
            this.jobPosition = data["jobPosition"] ? JobPositionListDto.fromJS(data["jobPosition"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBoardActivityDto {
        let result = new CreateOrEditBoardActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objective"] = this.objective;
        data["horary"] = this.horary;
        data["local"] = this.local;
        data["report"] = this.report;
        data["activity"] = this.activity;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["activityType"] = this.activityType;
        data["jobPositionId"] = this.jobPositionId;
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBoardActivityDto {
    objective: string | undefined;
    horary: string | undefined;
    local: string | undefined;
    report: string | undefined;
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;
}

export class CreateOrEditCommissionActivityDto implements ICreateOrEditCommissionActivityDto {
    objective: string | undefined;
    period: string | undefined;
    boardMeetings: string | undefined;
    commissionMeetings: string | undefined;
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCommissionActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.objective = data["objective"];
            this.period = data["period"];
            this.boardMeetings = data["boardMeetings"];
            this.commissionMeetings = data["commissionMeetings"];
            this.activity = data["activity"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.activityType = data["activityType"];
            this.jobPositionId = data["jobPositionId"];
            this.jobPosition = data["jobPosition"] ? JobPositionListDto.fromJS(data["jobPosition"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommissionActivityDto {
        let result = new CreateOrEditCommissionActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objective"] = this.objective;
        data["period"] = this.period;
        data["boardMeetings"] = this.boardMeetings;
        data["commissionMeetings"] = this.commissionMeetings;
        data["activity"] = this.activity;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["activityType"] = this.activityType;
        data["jobPositionId"] = this.jobPositionId;
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCommissionActivityDto {
    objective: string | undefined;
    period: string | undefined;
    boardMeetings: string | undefined;
    commissionMeetings: string | undefined;
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;
}

export class CreateOrEditCollaboratorActivityDto implements ICreateOrEditCollaboratorActivityDto {
    requester: string | undefined;
    requestDate: moment.Moment | undefined;
    deadline: string | undefined;
    report: string | undefined;
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCollaboratorActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requester = data["requester"];
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.deadline = data["deadline"];
            this.report = data["report"];
            this.activity = data["activity"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.activityType = data["activityType"];
            this.jobPositionId = data["jobPositionId"];
            this.jobPosition = data["jobPosition"] ? JobPositionListDto.fromJS(data["jobPosition"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCollaboratorActivityDto {
        let result = new CreateOrEditCollaboratorActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requester"] = this.requester;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["deadline"] = this.deadline;
        data["report"] = this.report;
        data["activity"] = this.activity;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["activityType"] = this.activityType;
        data["jobPositionId"] = this.jobPositionId;
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCollaboratorActivityDto {
    requester: string | undefined;
    requestDate: moment.Moment | undefined;
    deadline: string | undefined;
    report: string | undefined;
    activity: string | undefined;
    date: moment.Moment | undefined;
    activityType: string | undefined;
    jobPositionId: number | undefined;
    jobPosition: JobPositionListDto | undefined;
    userId: number | undefined;
    user: UserSelectListDto | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetAnnuityForView implements IPagedResultDtoOfGetAnnuityForView {
    totalCount: number | undefined;
    items: GetAnnuityForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAnnuityForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAnnuityForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAnnuityForView {
        let result = new PagedResultDtoOfGetAnnuityForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAnnuityForView {
    totalCount: number | undefined;
    items: GetAnnuityForView[] | undefined;
}

export class GetAnnuityForView implements IGetAnnuityForView {
    annuity: AnnuityDto | undefined;

    constructor(data?: IGetAnnuityForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuity = data["annuity"] ? AnnuityDto.fromJS(data["annuity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAnnuityForView {
        let result = new GetAnnuityForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAnnuityForView {
    annuity: AnnuityDto | undefined;
}

export class AnnuityDto implements IAnnuityDto {
    year: number;
    readmissionRate: number;
    daysAfterCategoryDeadline: number;
    codigoMaterial: string | undefined;
    statusIntegracao: AnnuityDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    associationVerificationDate: moment.Moment | undefined;
    categoryDeadlines: AnnuityCategoryDeadlineDto[] | undefined;
    paymentMethods: AnnuityPaymentMethodPermissionDto[] | undefined;
    id: number | undefined;

    constructor(data?: IAnnuityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.readmissionRate = data["readmissionRate"];
            this.daysAfterCategoryDeadline = data["daysAfterCategoryDeadline"];
            this.codigoMaterial = data["codigoMaterial"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.associationVerificationDate = data["associationVerificationDate"] ? moment(data["associationVerificationDate"].toString()) : <any>undefined;
            if (data["categoryDeadlines"] && data["categoryDeadlines"].constructor === Array) {
                this.categoryDeadlines = [];
                for (let item of data["categoryDeadlines"])
                    this.categoryDeadlines.push(AnnuityCategoryDeadlineDto.fromJS(item));
            }
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(AnnuityPaymentMethodPermissionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuityDto {
        let result = new AnnuityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["readmissionRate"] = this.readmissionRate;
        data["daysAfterCategoryDeadline"] = this.daysAfterCategoryDeadline;
        data["codigoMaterial"] = this.codigoMaterial;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["associationVerificationDate"] = this.associationVerificationDate ? this.associationVerificationDate.toISOString() : <any>undefined;
        if (this.categoryDeadlines && this.categoryDeadlines.constructor === Array) {
            data["categoryDeadlines"] = [];
            for (let item of this.categoryDeadlines)
                data["categoryDeadlines"].push(item.toJSON());
        }
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuityDto {
    year: number;
    readmissionRate: number;
    daysAfterCategoryDeadline: number;
    codigoMaterial: string | undefined;
    statusIntegracao: AnnuityDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    associationVerificationDate: moment.Moment | undefined;
    categoryDeadlines: AnnuityCategoryDeadlineDto[] | undefined;
    paymentMethods: AnnuityPaymentMethodPermissionDto[] | undefined;
    id: number | undefined;
}

export class AnnuityCategoryDeadlineDto implements IAnnuityCategoryDeadlineDto {
    value: number;
    itsReadmission: boolean | undefined;
    numberOfInstallments: number | undefined;
    deadline: moment.Moment;
    categoryId: number | undefined;
    category: CategoryListDto | undefined;
    annuityId: number | undefined;
    hasMemberAnnuities: boolean | undefined;
    id: number | undefined;

    constructor(data?: IAnnuityCategoryDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.itsReadmission = data["itsReadmission"];
            this.numberOfInstallments = data["numberOfInstallments"];
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : <any>undefined;
            this.categoryId = data["categoryId"];
            this.category = data["category"] ? CategoryListDto.fromJS(data["category"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.hasMemberAnnuities = data["hasMemberAnnuities"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuityCategoryDeadlineDto {
        let result = new AnnuityCategoryDeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["itsReadmission"] = this.itsReadmission;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["hasMemberAnnuities"] = this.hasMemberAnnuities;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuityCategoryDeadlineDto {
    value: number;
    itsReadmission: boolean | undefined;
    numberOfInstallments: number | undefined;
    deadline: moment.Moment;
    categoryId: number | undefined;
    category: CategoryListDto | undefined;
    annuityId: number | undefined;
    hasMemberAnnuities: boolean | undefined;
    id: number | undefined;
}

export class AnnuityPaymentMethodPermissionDto implements IAnnuityPaymentMethodPermissionDto {
    annuityId: number;
    isAllowed: boolean | undefined;
    fee: number | undefined;
    percentDiscount: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethodPermissionType: string | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    id: number | undefined;

    constructor(data?: IAnnuityPaymentMethodPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuityId = data["annuityId"];
            this.isAllowed = data["isAllowed"];
            this.fee = data["fee"];
            this.percentDiscount = data["percentDiscount"];
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethodPermissionType = data["paymentMethodPermissionType"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuityPaymentMethodPermissionDto {
        let result = new AnnuityPaymentMethodPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuityId"] = this.annuityId;
        data["isAllowed"] = this.isAllowed;
        data["fee"] = this.fee;
        data["percentDiscount"] = this.percentDiscount;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethodPermissionType"] = this.paymentMethodPermissionType;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuityPaymentMethodPermissionDto {
    annuityId: number;
    isAllowed: boolean | undefined;
    fee: number | undefined;
    percentDiscount: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethodPermissionType: string | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    id: number | undefined;
}

export class CategoryListDto implements ICategoryListDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryListDto {
        let result = new CategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategoryListDto {
    name: string | undefined;
    id: number | undefined;
}

export class PaymentMethodEditDto implements IPaymentMethodEditDto {
    description: string | undefined;
    environmentType: PaymentMethodEditDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;

    constructor(data?: IPaymentMethodEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(CardBrandDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodEditDto {
        let result = new PaymentMethodEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethodEditDto {
    description: string | undefined;
    environmentType: PaymentMethodEditDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;
}

export class BankAccountListDto implements IBankAccountListDto {
    description: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    id: number | undefined;

    constructor(data?: IBankAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.checkingAccount = data["checkingAccount"];
            this.checkingAccountDigit = data["checkingAccountDigit"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BankAccountListDto {
        let result = new BankAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["checkingAccount"] = this.checkingAccount;
        data["checkingAccountDigit"] = this.checkingAccountDigit;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBankAccountListDto {
    description: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    id: number | undefined;
}

export class CardBrandDto implements ICardBrandDto {
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICardBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CardBrandDto {
        let result = new CardBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICardBrandDto {
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class ListResultDtoOfAnnuityListDto implements IListResultDtoOfAnnuityListDto {
    items: AnnuityListDto[] | undefined;

    constructor(data?: IListResultDtoOfAnnuityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AnnuityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAnnuityListDto {
        let result = new ListResultDtoOfAnnuityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAnnuityListDto {
    items: AnnuityListDto[] | undefined;
}

export class AnnuityListDto implements IAnnuityListDto {
    year: number | undefined;
    associationVerificationDate: moment.Moment | undefined;
    costCenter: CostCenterListDto | undefined;
    id: number | undefined;

    constructor(data?: IAnnuityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.associationVerificationDate = data["associationVerificationDate"] ? moment(data["associationVerificationDate"].toString()) : <any>undefined;
            this.costCenter = data["costCenter"] ? CostCenterListDto.fromJS(data["costCenter"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuityListDto {
        let result = new AnnuityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["associationVerificationDate"] = this.associationVerificationDate ? this.associationVerificationDate.toISOString() : <any>undefined;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuityListDto {
    year: number | undefined;
    associationVerificationDate: moment.Moment | undefined;
    costCenter: CostCenterListDto | undefined;
    id: number | undefined;
}

export class CostCenterListDto implements ICostCenterListDto {
    id: number | undefined;
    displayName: string | undefined;
    shortDescription: string | undefined;
    isActive: boolean | undefined;
    filterType: CostCenterListDtoFilterType | undefined;

    constructor(data?: ICostCenterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.shortDescription = data["shortDescription"];
            this.isActive = data["isActive"];
            this.filterType = data["filterType"];
        }
    }

    static fromJS(data: any): CostCenterListDto {
        let result = new CostCenterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["shortDescription"] = this.shortDescription;
        data["isActive"] = this.isActive;
        data["filterType"] = this.filterType;
        return data; 
    }
}

export interface ICostCenterListDto {
    id: number | undefined;
    displayName: string | undefined;
    shortDescription: string | undefined;
    isActive: boolean | undefined;
    filterType: CostCenterListDtoFilterType | undefined;
}

export class GetAnnuityForEditOutput implements IGetAnnuityForEditOutput {
    annuity: CreateOrEditAnnuityDto | undefined;

    constructor(data?: IGetAnnuityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuity = data["annuity"] ? CreateOrEditAnnuityDto.fromJS(data["annuity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAnnuityForEditOutput {
        let result = new GetAnnuityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAnnuityForEditOutput {
    annuity: CreateOrEditAnnuityDto | undefined;
}

export class CreateOrEditAnnuityDto implements ICreateOrEditAnnuityDto {
    year: number | undefined;
    readmissionRate: number | undefined;
    daysAfterCategoryDeadline: number | undefined;
    associationVerificationDate: moment.Moment | undefined;
    codigoMaterial: string | undefined;
    codigoGrupo: string | undefined;
    codigoSubGrupo: string | undefined;
    codigoContaFinanceira: string | undefined;
    codigoContaGerencial: string | undefined;
    statusIntegracao: CreateOrEditAnnuityDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    categoryDeadlines: AnnuityCategoryDeadlineDto[] | undefined;
    paymentMethods: AnnuityPaymentMethodPermissionDto[] | undefined;
    memberAnnuities: MemberAnnuityEditDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditAnnuityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.readmissionRate = data["readmissionRate"];
            this.daysAfterCategoryDeadline = data["daysAfterCategoryDeadline"];
            this.associationVerificationDate = data["associationVerificationDate"] ? moment(data["associationVerificationDate"].toString()) : <any>undefined;
            this.codigoMaterial = data["codigoMaterial"];
            this.codigoGrupo = data["codigoGrupo"];
            this.codigoSubGrupo = data["codigoSubGrupo"];
            this.codigoContaFinanceira = data["codigoContaFinanceira"];
            this.codigoContaGerencial = data["codigoContaGerencial"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["categoryDeadlines"] && data["categoryDeadlines"].constructor === Array) {
                this.categoryDeadlines = [];
                for (let item of data["categoryDeadlines"])
                    this.categoryDeadlines.push(AnnuityCategoryDeadlineDto.fromJS(item));
            }
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(AnnuityPaymentMethodPermissionDto.fromJS(item));
            }
            if (data["memberAnnuities"] && data["memberAnnuities"].constructor === Array) {
                this.memberAnnuities = [];
                for (let item of data["memberAnnuities"])
                    this.memberAnnuities.push(MemberAnnuityEditDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAnnuityDto {
        let result = new CreateOrEditAnnuityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["readmissionRate"] = this.readmissionRate;
        data["daysAfterCategoryDeadline"] = this.daysAfterCategoryDeadline;
        data["associationVerificationDate"] = this.associationVerificationDate ? this.associationVerificationDate.toISOString() : <any>undefined;
        data["codigoMaterial"] = this.codigoMaterial;
        data["codigoGrupo"] = this.codigoGrupo;
        data["codigoSubGrupo"] = this.codigoSubGrupo;
        data["codigoContaFinanceira"] = this.codigoContaFinanceira;
        data["codigoContaGerencial"] = this.codigoContaGerencial;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.categoryDeadlines && this.categoryDeadlines.constructor === Array) {
            data["categoryDeadlines"] = [];
            for (let item of this.categoryDeadlines)
                data["categoryDeadlines"].push(item.toJSON());
        }
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        if (this.memberAnnuities && this.memberAnnuities.constructor === Array) {
            data["memberAnnuities"] = [];
            for (let item of this.memberAnnuities)
                data["memberAnnuities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAnnuityDto {
    year: number | undefined;
    readmissionRate: number | undefined;
    daysAfterCategoryDeadline: number | undefined;
    associationVerificationDate: moment.Moment | undefined;
    codigoMaterial: string | undefined;
    codigoGrupo: string | undefined;
    codigoSubGrupo: string | undefined;
    codigoContaFinanceira: string | undefined;
    codigoContaGerencial: string | undefined;
    statusIntegracao: CreateOrEditAnnuityDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    categoryDeadlines: AnnuityCategoryDeadlineDto[] | undefined;
    paymentMethods: AnnuityPaymentMethodPermissionDto[] | undefined;
    memberAnnuities: MemberAnnuityEditDto[] | undefined;
    id: number | undefined;
}

export class MemberAnnuityEditDto implements IMemberAnnuityEditDto {
    annuityId: number;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    documentationId: number | undefined;
    documentation: DocumentationDto | undefined;
    paidSBA: boolean | undefined;
    id: number | undefined;

    constructor(data?: IMemberAnnuityEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityEditDto.fromJS(data["annuity"]) : <any>undefined;
            this.memberId = data["memberId"];
            this.categoryDeadLineId = data["categoryDeadLineId"];
            this.categoryDeadLine = data["categoryDeadLine"] ? AnnuityCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.documentationId = data["documentationId"];
            this.documentation = data["documentation"] ? DocumentationDto.fromJS(data["documentation"]) : <any>undefined;
            this.paidSBA = data["paidSBA"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberAnnuityEditDto {
        let result = new MemberAnnuityEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["memberId"] = this.memberId;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["documentationId"] = this.documentationId;
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        data["paidSBA"] = this.paidSBA;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberAnnuityEditDto {
    annuityId: number;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    documentationId: number | undefined;
    documentation: DocumentationDto | undefined;
    paidSBA: boolean | undefined;
    id: number | undefined;
}

export class AnnuityEditDto implements IAnnuityEditDto {
    year: number;
    readmissionRate: number;
    daysAfterCategoryDeadline: number;
    associationVerificationDate: moment.Moment | undefined;
    categoryDeadlines: AnnuityCategoryDeadlineDto[] | undefined;
    paymentMethods: AnnuityPaymentMethodPermissionDto[] | undefined;

    constructor(data?: IAnnuityEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.readmissionRate = data["readmissionRate"];
            this.daysAfterCategoryDeadline = data["daysAfterCategoryDeadline"];
            this.associationVerificationDate = data["associationVerificationDate"] ? moment(data["associationVerificationDate"].toString()) : <any>undefined;
            if (data["categoryDeadlines"] && data["categoryDeadlines"].constructor === Array) {
                this.categoryDeadlines = [];
                for (let item of data["categoryDeadlines"])
                    this.categoryDeadlines.push(AnnuityCategoryDeadlineDto.fromJS(item));
            }
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(AnnuityPaymentMethodPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnnuityEditDto {
        let result = new AnnuityEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["readmissionRate"] = this.readmissionRate;
        data["daysAfterCategoryDeadline"] = this.daysAfterCategoryDeadline;
        data["associationVerificationDate"] = this.associationVerificationDate ? this.associationVerificationDate.toISOString() : <any>undefined;
        if (this.categoryDeadlines && this.categoryDeadlines.constructor === Array) {
            data["categoryDeadlines"] = [];
            for (let item of this.categoryDeadlines)
                data["categoryDeadlines"].push(item.toJSON());
        }
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAnnuityEditDto {
    year: number;
    readmissionRate: number;
    daysAfterCategoryDeadline: number;
    associationVerificationDate: moment.Moment | undefined;
    categoryDeadlines: AnnuityCategoryDeadlineDto[] | undefined;
    paymentMethods: AnnuityPaymentMethodPermissionDto[] | undefined;
}

export class DocumentationDto implements IDocumentationDto {
    note: string | undefined;
    status: DocumentationDtoStatus | undefined;
    documents: DocumentDto[] | undefined;
    id: number | undefined;

    constructor(data?: IDocumentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.note = data["note"];
            this.status = data["status"];
            if (data["documents"] && data["documents"].constructor === Array) {
                this.documents = [];
                for (let item of data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DocumentationDto {
        let result = new DocumentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["status"] = this.status;
        if (this.documents && this.documents.constructor === Array) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IDocumentationDto {
    note: string | undefined;
    status: DocumentationDtoStatus | undefined;
    documents: DocumentDto[] | undefined;
    id: number | undefined;
}

export class DocumentDto implements IDocumentDto {
    documentId: string | undefined;
    documentationId: number | undefined;
    emailConfigId: number | undefined;
    fileExtension: string | undefined;
    fileName: string | undefined;
    id: number | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentId = data["documentId"];
            this.documentationId = data["documentationId"];
            this.emailConfigId = data["emailConfigId"];
            this.fileExtension = data["fileExtension"];
            this.fileName = data["fileName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DocumentDto {
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentationId"] = this.documentationId;
        data["emailConfigId"] = this.emailConfigId;
        data["fileExtension"] = this.fileExtension;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDocumentDto {
    documentId: string | undefined;
    documentationId: number | undefined;
    emailConfigId: number | undefined;
    fileExtension: string | undefined;
    fileName: string | undefined;
    id: number | undefined;
}

export class EntityDtoOfInt32 implements IEntityDtoOfInt32 {
    id: number | undefined;

    constructor(data?: IEntityDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt32 {
        let result = new EntityDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt32 {
    id: number | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount: number | undefined;
    items: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number | undefined;
    items: AuditLogListDto[] | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment | undefined;
    executionDuration: number | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number | undefined;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment | undefined;
    executionDuration: number | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBankAccountForView implements IPagedResultDtoOfGetBankAccountForView {
    totalCount: number | undefined;
    items: GetBankAccountForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBankAccountForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBankAccountForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBankAccountForView {
        let result = new PagedResultDtoOfGetBankAccountForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBankAccountForView {
    totalCount: number | undefined;
    items: GetBankAccountForView[] | undefined;
}

export class GetBankAccountForView implements IGetBankAccountForView {
    bankAccount: BankAccountDto | undefined;

    constructor(data?: IGetBankAccountForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankAccount = data["bankAccount"] ? BankAccountDto.fromJS(data["bankAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBankAccountForView {
        let result = new GetBankAccountForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBankAccountForView {
    bankAccount: BankAccountDto | undefined;
}

export class BankAccountDto implements IBankAccountDto {
    description: string | undefined;
    bankCode: string | undefined;
    agency: string | undefined;
    agencyDigit: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    holderName: string | undefined;
    cnpj: string | undefined;
    id: number | undefined;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.bankCode = data["bankCode"];
            this.agency = data["agency"];
            this.agencyDigit = data["agencyDigit"];
            this.checkingAccount = data["checkingAccount"];
            this.checkingAccountDigit = data["checkingAccountDigit"];
            this.holderName = data["holderName"];
            this.cnpj = data["cnpj"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["bankCode"] = this.bankCode;
        data["agency"] = this.agency;
        data["agencyDigit"] = this.agencyDigit;
        data["checkingAccount"] = this.checkingAccount;
        data["checkingAccountDigit"] = this.checkingAccountDigit;
        data["holderName"] = this.holderName;
        data["cnpj"] = this.cnpj;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBankAccountDto {
    description: string | undefined;
    bankCode: string | undefined;
    agency: string | undefined;
    agencyDigit: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    holderName: string | undefined;
    cnpj: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfBankAccountListDto implements IListResultDtoOfBankAccountListDto {
    items: BankAccountListDto[] | undefined;

    constructor(data?: IListResultDtoOfBankAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(BankAccountListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfBankAccountListDto {
        let result = new ListResultDtoOfBankAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfBankAccountListDto {
    items: BankAccountListDto[] | undefined;
}

export class GetBankAccountForEditOutput implements IGetBankAccountForEditOutput {
    bankAccount: CreateOrEditBankAccountDto | undefined;

    constructor(data?: IGetBankAccountForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankAccount = data["bankAccount"] ? CreateOrEditBankAccountDto.fromJS(data["bankAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBankAccountForEditOutput {
        let result = new GetBankAccountForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBankAccountForEditOutput {
    bankAccount: CreateOrEditBankAccountDto | undefined;
}

export class CreateOrEditBankAccountDto implements ICreateOrEditBankAccountDto {
    description: string | undefined;
    bankCode: string | undefined;
    agency: string | undefined;
    agencyDigit: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    holderName: string | undefined;
    cnpj: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.bankCode = data["bankCode"];
            this.agency = data["agency"];
            this.agencyDigit = data["agencyDigit"];
            this.checkingAccount = data["checkingAccount"];
            this.checkingAccountDigit = data["checkingAccountDigit"];
            this.holderName = data["holderName"];
            this.cnpj = data["cnpj"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBankAccountDto {
        let result = new CreateOrEditBankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["bankCode"] = this.bankCode;
        data["agency"] = this.agency;
        data["agencyDigit"] = this.agencyDigit;
        data["checkingAccount"] = this.checkingAccount;
        data["checkingAccountDigit"] = this.checkingAccountDigit;
        data["holderName"] = this.holderName;
        data["cnpj"] = this.cnpj;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBankAccountDto {
    description: string | undefined;
    bankCode: string | undefined;
    agency: string | undefined;
    agencyDigit: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    holderName: string | undefined;
    cnpj: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class CacheDto implements ICacheDto {
    name: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class PagedResultDtoOfGetCalendarForViewDto implements IPagedResultDtoOfGetCalendarForViewDto {
    totalCount: number | undefined;
    items: GetCalendarForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCalendarForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCalendarForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCalendarForViewDto {
        let result = new PagedResultDtoOfGetCalendarForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCalendarForViewDto {
    totalCount: number | undefined;
    items: GetCalendarForViewDto[] | undefined;
}

export class GetCalendarForViewDto implements IGetCalendarForViewDto {
    calendar: CalendarDto | undefined;
    roomsDays: CalendarProgramyDto[] | undefined;

    constructor(data?: IGetCalendarForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendar = data["calendar"] ? CalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (data["roomsDays"] && data["roomsDays"].constructor === Array) {
                this.roomsDays = [];
                for (let item of data["roomsDays"])
                    this.roomsDays.push(CalendarProgramyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarForViewDto {
        let result = new GetCalendarForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (this.roomsDays && this.roomsDays.constructor === Array) {
            data["roomsDays"] = [];
            for (let item of this.roomsDays)
                data["roomsDays"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCalendarForViewDto {
    calendar: CalendarDto | undefined;
    roomsDays: CalendarProgramyDto[] | undefined;
}

export class CalendarDto implements ICalendarDto {
    approved: boolean | undefined;
    publishDate: moment.Moment | undefined;
    programmingId: number | undefined;
    programming: ProgrammingListDto | undefined;
    roomsDays: EventRoomDayDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approved = data["approved"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.programmingId = data["programmingId"];
            this.programming = data["programming"] ? ProgrammingListDto.fromJS(data["programming"]) : <any>undefined;
            if (data["roomsDays"] && data["roomsDays"].constructor === Array) {
                this.roomsDays = [];
                for (let item of data["roomsDays"])
                    this.roomsDays.push(EventRoomDayDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CalendarDto {
        let result = new CalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approved"] = this.approved;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["programmingId"] = this.programmingId;
        data["programming"] = this.programming ? this.programming.toJSON() : <any>undefined;
        if (this.roomsDays && this.roomsDays.constructor === Array) {
            data["roomsDays"] = [];
            for (let item of this.roomsDays)
                data["roomsDays"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICalendarDto {
    approved: boolean | undefined;
    publishDate: moment.Moment | undefined;
    programmingId: number | undefined;
    programming: ProgrammingListDto | undefined;
    roomsDays: EventRoomDayDto[] | undefined;
    id: number | undefined;
}

export class CalendarProgramyDto implements ICalendarProgramyDto {
    day: EventDayListDto | undefined;
    rooms: RoomActivitiesDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICalendarProgramyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"] ? EventDayListDto.fromJS(data["day"]) : <any>undefined;
            if (data["rooms"] && data["rooms"].constructor === Array) {
                this.rooms = [];
                for (let item of data["rooms"])
                    this.rooms.push(RoomActivitiesDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CalendarProgramyDto {
        let result = new CalendarProgramyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toJSON() : <any>undefined;
        if (this.rooms && this.rooms.constructor === Array) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICalendarProgramyDto {
    day: EventDayListDto | undefined;
    rooms: RoomActivitiesDto[] | undefined;
    id: number | undefined;
}

export class ProgrammingListDto implements IProgrammingListDto {
    eventName: string | undefined;
    eventShortName: string | undefined;
    eventId: number | undefined;
    id: number | undefined;

    constructor(data?: IProgrammingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventName = data["eventName"];
            this.eventShortName = data["eventShortName"];
            this.eventId = data["eventId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProgrammingListDto {
        let result = new ProgrammingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventName"] = this.eventName;
        data["eventShortName"] = this.eventShortName;
        data["eventId"] = this.eventId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProgrammingListDto {
    eventName: string | undefined;
    eventShortName: string | undefined;
    eventId: number | undefined;
    id: number | undefined;
}

export class EventRoomDayDto implements IEventRoomDayDto {
    eventRoomId: number | undefined;
    eventRoom: EventRoomDto | undefined;
    eventDayId: number | undefined;
    eventDay: EventDayDto | undefined;
    id: number | undefined;

    constructor(data?: IEventRoomDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventRoomId = data["eventRoomId"];
            this.eventRoom = data["eventRoom"] ? EventRoomDto.fromJS(data["eventRoom"]) : <any>undefined;
            this.eventDayId = data["eventDayId"];
            this.eventDay = data["eventDay"] ? EventDayDto.fromJS(data["eventDay"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventRoomDayDto {
        let result = new EventRoomDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventRoomId"] = this.eventRoomId;
        data["eventRoom"] = this.eventRoom ? this.eventRoom.toJSON() : <any>undefined;
        data["eventDayId"] = this.eventDayId;
        data["eventDay"] = this.eventDay ? this.eventDay.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventRoomDayDto {
    eventRoomId: number | undefined;
    eventRoom: EventRoomDto | undefined;
    eventDayId: number | undefined;
    eventDay: EventDayDto | undefined;
    id: number | undefined;
}

export class RoomActivitiesDto implements IRoomActivitiesDto {
    room: EventRoomListDto | undefined;
    activities: CreateOrEditCalendarActivityDto[] | undefined;
    id: number | undefined;

    constructor(data?: IRoomActivitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.room = data["room"] ? EventRoomListDto.fromJS(data["room"]) : <any>undefined;
            if (data["activities"] && data["activities"].constructor === Array) {
                this.activities = [];
                for (let item of data["activities"])
                    this.activities.push(CreateOrEditCalendarActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoomActivitiesDto {
        let result = new RoomActivitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["room"] = this.room ? this.room.toJSON() : <any>undefined;
        if (this.activities && this.activities.constructor === Array) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoomActivitiesDto {
    room: EventRoomListDto | undefined;
    activities: CreateOrEditCalendarActivityDto[] | undefined;
    id: number | undefined;
}

export class EventRoomDto implements IEventRoomDto {
    description: string | undefined;
    shortDescription: string | undefined;
    numberOfVacancies: number | undefined;
    programmingId: number | undefined;
    hasActivities: boolean | undefined;
    id: number | undefined;

    constructor(data?: IEventRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.numberOfVacancies = data["numberOfVacancies"];
            this.programmingId = data["programmingId"];
            this.hasActivities = data["hasActivities"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventRoomDto {
        let result = new EventRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["numberOfVacancies"] = this.numberOfVacancies;
        data["programmingId"] = this.programmingId;
        data["hasActivities"] = this.hasActivities;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventRoomDto {
    description: string | undefined;
    shortDescription: string | undefined;
    numberOfVacancies: number | undefined;
    programmingId: number | undefined;
    hasActivities: boolean | undefined;
    id: number | undefined;
}

export class EventDayDto implements IEventDayDto {
    day: moment.Moment | undefined;
    color: string | undefined;
    beginHour: string | undefined;
    endHour: string | undefined;
    verifyAtivityConflicts: boolean | undefined;
    programmingId: number | undefined;
    hasActivities: boolean | undefined;
    id: number | undefined;

    constructor(data?: IEventDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"] ? moment(data["day"].toString()) : <any>undefined;
            this.color = data["color"];
            this.beginHour = data["beginHour"];
            this.endHour = data["endHour"];
            this.verifyAtivityConflicts = data["verifyAtivityConflicts"];
            this.programmingId = data["programmingId"];
            this.hasActivities = data["hasActivities"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventDayDto {
        let result = new EventDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["beginHour"] = this.beginHour;
        data["endHour"] = this.endHour;
        data["verifyAtivityConflicts"] = this.verifyAtivityConflicts;
        data["programmingId"] = this.programmingId;
        data["hasActivities"] = this.hasActivities;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventDayDto {
    day: moment.Moment | undefined;
    color: string | undefined;
    beginHour: string | undefined;
    endHour: string | undefined;
    verifyAtivityConflicts: boolean | undefined;
    programmingId: number | undefined;
    hasActivities: boolean | undefined;
    id: number | undefined;
}

export class GetCalendarForEditOutput implements IGetCalendarForEditOutput {
    calendar: CreateOrEditCalendarDto | undefined;
    program: CalendarProgramyDto[] | undefined;

    constructor(data?: IGetCalendarForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendar = data["calendar"] ? CreateOrEditCalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (data["program"] && data["program"].constructor === Array) {
                this.program = [];
                for (let item of data["program"])
                    this.program.push(CalendarProgramyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarForEditOutput {
        let result = new GetCalendarForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (this.program && this.program.constructor === Array) {
            data["program"] = [];
            for (let item of this.program)
                data["program"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCalendarForEditOutput {
    calendar: CreateOrEditCalendarDto | undefined;
    program: CalendarProgramyDto[] | undefined;
}

export class CreateOrEditCalendarDto implements ICreateOrEditCalendarDto {
    approved: boolean | undefined;
    publishDate: moment.Moment | undefined;
    programmingId: number | undefined;
    programming: ProgrammingListDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approved = data["approved"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.programmingId = data["programmingId"];
            this.programming = data["programming"] ? ProgrammingListDto.fromJS(data["programming"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCalendarDto {
        let result = new CreateOrEditCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approved"] = this.approved;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["programmingId"] = this.programmingId;
        data["programming"] = this.programming ? this.programming.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCalendarDto {
    approved: boolean | undefined;
    publishDate: moment.Moment | undefined;
    programmingId: number | undefined;
    programming: ProgrammingListDto | undefined;
    id: number | undefined;
}

export class GetCalendarActivityForViewDto implements IGetCalendarActivityForViewDto {
    calendarActivity: CalendarActivityDto | undefined;
    conflicts: BlockConfictDto[] | undefined;
    topics: TopicDto[] | undefined;

    constructor(data?: IGetCalendarActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarActivity = data["calendarActivity"] ? CalendarActivityDto.fromJS(data["calendarActivity"]) : <any>undefined;
            if (data["conflicts"] && data["conflicts"].constructor === Array) {
                this.conflicts = [];
                for (let item of data["conflicts"])
                    this.conflicts.push(BlockConfictDto.fromJS(item));
            }
            if (data["topics"] && data["topics"].constructor === Array) {
                this.topics = [];
                for (let item of data["topics"])
                    this.topics.push(TopicDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarActivityForViewDto {
        let result = new GetCalendarActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarActivity"] = this.calendarActivity ? this.calendarActivity.toJSON() : <any>undefined;
        if (this.conflicts && this.conflicts.constructor === Array) {
            data["conflicts"] = [];
            for (let item of this.conflicts)
                data["conflicts"].push(item.toJSON());
        }
        if (this.topics && this.topics.constructor === Array) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCalendarActivityForViewDto {
    calendarActivity: CalendarActivityDto | undefined;
    conflicts: BlockConfictDto[] | undefined;
    topics: TopicDto[] | undefined;
}

export class CreateOrEditCalendarActivityOutput implements ICreateOrEditCalendarActivityOutput {
    blockConflicts: BlockConfictDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCalendarActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["blockConflicts"] && data["blockConflicts"].constructor === Array) {
                this.blockConflicts = [];
                for (let item of data["blockConflicts"])
                    this.blockConflicts.push(BlockConfictDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCalendarActivityOutput {
        let result = new CreateOrEditCalendarActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.blockConflicts && this.blockConflicts.constructor === Array) {
            data["blockConflicts"] = [];
            for (let item of this.blockConflicts)
                data["blockConflicts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCalendarActivityOutput {
    blockConflicts: BlockConfictDto[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfEventDayListDto implements IListResultDtoOfEventDayListDto {
    items: EventDayListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventDayListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventDayListDto {
        let result = new ListResultDtoOfEventDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventDayListDto {
    items: EventDayListDto[] | undefined;
}

export class ListResultDtoOfEventRoomListDto implements IListResultDtoOfEventRoomListDto {
    items: EventRoomListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventRoomListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventRoomListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventRoomListDto {
        let result = new ListResultDtoOfEventRoomListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventRoomListDto {
    items: EventRoomListDto[] | undefined;
}

export class ListResultDtoOfEventRoomDayListDto implements IListResultDtoOfEventRoomDayListDto {
    items: EventRoomDayListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventRoomDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventRoomDayListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventRoomDayListDto {
        let result = new ListResultDtoOfEventRoomDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventRoomDayListDto {
    items: EventRoomDayListDto[] | undefined;
}

export class PagedResultDtoOfCategoryDto implements IPagedResultDtoOfCategoryDto {
    totalCount: number | undefined;
    items: CategoryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCategoryDto {
        let result = new PagedResultDtoOfCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCategoryDto {
    totalCount: number | undefined;
    items: CategoryDto[] | undefined;
}

export class CategoryDto implements ICategoryDto {
    name: string;
    shortName: string | undefined;
    requiresDoc: boolean | undefined;
    isExempt: boolean | undefined;
    isResident: boolean | undefined;
    keepValueToNextCategory: boolean | undefined;
    keepInitialValueForBeginners: boolean | undefined;
    nextCategoryId: number | undefined;
    isActive: boolean | undefined;
    value: number | undefined;
    readmissionValue: number | undefined;
    levels: CategoryLevelDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.requiresDoc = data["requiresDoc"];
            this.isExempt = data["isExempt"];
            this.isResident = data["isResident"];
            this.keepValueToNextCategory = data["keepValueToNextCategory"];
            this.keepInitialValueForBeginners = data["keepInitialValueForBeginners"];
            this.nextCategoryId = data["nextCategoryId"];
            this.isActive = data["isActive"];
            this.value = data["value"];
            this.readmissionValue = data["readmissionValue"];
            if (data["levels"] && data["levels"].constructor === Array) {
                this.levels = [];
                for (let item of data["levels"])
                    this.levels.push(CategoryLevelDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryDto {
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["requiresDoc"] = this.requiresDoc;
        data["isExempt"] = this.isExempt;
        data["isResident"] = this.isResident;
        data["keepValueToNextCategory"] = this.keepValueToNextCategory;
        data["keepInitialValueForBeginners"] = this.keepInitialValueForBeginners;
        data["nextCategoryId"] = this.nextCategoryId;
        data["isActive"] = this.isActive;
        data["value"] = this.value;
        data["readmissionValue"] = this.readmissionValue;
        if (this.levels && this.levels.constructor === Array) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategoryDto {
    name: string;
    shortName: string | undefined;
    requiresDoc: boolean | undefined;
    isExempt: boolean | undefined;
    isResident: boolean | undefined;
    keepValueToNextCategory: boolean | undefined;
    keepInitialValueForBeginners: boolean | undefined;
    nextCategoryId: number | undefined;
    isActive: boolean | undefined;
    value: number | undefined;
    readmissionValue: number | undefined;
    levels: CategoryLevelDto[] | undefined;
    id: number | undefined;
}

export class CategoryLevelDto implements ICategoryLevelDto {
    name: string | undefined;
    order: number | undefined;
    categoryId: number | undefined;
    requiresDocumentationApproval: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICategoryLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.order = data["order"];
            this.categoryId = data["categoryId"];
            this.requiresDocumentationApproval = data["requiresDocumentationApproval"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryLevelDto {
        let result = new CategoryLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["categoryId"] = this.categoryId;
        data["requiresDocumentationApproval"] = this.requiresDocumentationApproval;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategoryLevelDto {
    name: string | undefined;
    order: number | undefined;
    categoryId: number | undefined;
    requiresDocumentationApproval: boolean | undefined;
    id: number | undefined;
}

export class ListResultDtoOfCategoryDto implements IListResultDtoOfCategoryDto {
    items: CategoryDto[] | undefined;

    constructor(data?: IListResultDtoOfCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCategoryDto {
        let result = new ListResultDtoOfCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCategoryDto {
    items: CategoryDto[] | undefined;
}

export class CreateOrEditCategoryDto implements ICreateOrEditCategoryDto {
    name: string;
    requiresDoc: boolean | undefined;
    isExempt: boolean | undefined;
    isResident: boolean | undefined;
    keepValueToNextCategory: boolean | undefined;
    keepInitialValueForBeginners: boolean | undefined;
    nextCategoryId: number | undefined;
    nextCategory: CategoryListDto | undefined;
    isActive: boolean | undefined;
    emailConfig: EmailConfigDto | undefined;
    levels: CategoryLevelDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.requiresDoc = data["requiresDoc"];
            this.isExempt = data["isExempt"];
            this.isResident = data["isResident"];
            this.keepValueToNextCategory = data["keepValueToNextCategory"];
            this.keepInitialValueForBeginners = data["keepInitialValueForBeginners"];
            this.nextCategoryId = data["nextCategoryId"];
            this.nextCategory = data["nextCategory"] ? CategoryListDto.fromJS(data["nextCategory"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.emailConfig = data["emailConfig"] ? EmailConfigDto.fromJS(data["emailConfig"]) : <any>undefined;
            if (data["levels"] && data["levels"].constructor === Array) {
                this.levels = [];
                for (let item of data["levels"])
                    this.levels.push(CategoryLevelDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCategoryDto {
        let result = new CreateOrEditCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["requiresDoc"] = this.requiresDoc;
        data["isExempt"] = this.isExempt;
        data["isResident"] = this.isResident;
        data["keepValueToNextCategory"] = this.keepValueToNextCategory;
        data["keepInitialValueForBeginners"] = this.keepInitialValueForBeginners;
        data["nextCategoryId"] = this.nextCategoryId;
        data["nextCategory"] = this.nextCategory ? this.nextCategory.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["emailConfig"] = this.emailConfig ? this.emailConfig.toJSON() : <any>undefined;
        if (this.levels && this.levels.constructor === Array) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCategoryDto {
    name: string;
    requiresDoc: boolean | undefined;
    isExempt: boolean | undefined;
    isResident: boolean | undefined;
    keepValueToNextCategory: boolean | undefined;
    keepInitialValueForBeginners: boolean | undefined;
    nextCategoryId: number | undefined;
    nextCategory: CategoryListDto | undefined;
    isActive: boolean | undefined;
    emailConfig: EmailConfigDto | undefined;
    levels: CategoryLevelDto[] | undefined;
    id: number | undefined;
}

export class EmailConfigDto implements IEmailConfigDto {
    text: string | undefined;
    texts: CreateOrEditLanguageTextDto[] | undefined;
    eventId: number | undefined;
    categoryId: number | undefined;
    attachments: DocumentEditDto[] | undefined;
    id: number | undefined;

    constructor(data?: IEmailConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.text = data["text"];
            if (data["texts"] && data["texts"].constructor === Array) {
                this.texts = [];
                for (let item of data["texts"])
                    this.texts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            this.eventId = data["eventId"];
            this.categoryId = data["categoryId"];
            if (data["attachments"] && data["attachments"].constructor === Array) {
                this.attachments = [];
                for (let item of data["attachments"])
                    this.attachments.push(DocumentEditDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EmailConfigDto {
        let result = new EmailConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (this.texts && this.texts.constructor === Array) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item.toJSON());
        }
        data["eventId"] = this.eventId;
        data["categoryId"] = this.categoryId;
        if (this.attachments && this.attachments.constructor === Array) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEmailConfigDto {
    text: string | undefined;
    texts: CreateOrEditLanguageTextDto[] | undefined;
    eventId: number | undefined;
    categoryId: number | undefined;
    attachments: DocumentEditDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditLanguageTextDto implements ICreateOrEditLanguageTextDto {
    tenantId: number | undefined;
    languageName: string | undefined;
    source: string | undefined;
    key: string | undefined;
    value: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditLanguageTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.languageName = data["languageName"];
            this.source = data["source"];
            this.key = data["key"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLanguageTextDto {
        let result = new CreateOrEditLanguageTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["languageName"] = this.languageName;
        data["source"] = this.source;
        data["key"] = this.key;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditLanguageTextDto {
    tenantId: number | undefined;
    languageName: string | undefined;
    source: string | undefined;
    key: string | undefined;
    value: string | undefined;
    id: number | undefined;
}

export class DocumentEditDto implements IDocumentEditDto {
    documentId: string | undefined;
    document: string | undefined;
    fileExtension: string | undefined;
    input: UpdateDocumentInput | undefined;
    fileName: string | undefined;
    id: number | undefined;

    constructor(data?: IDocumentEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentId = data["documentId"];
            this.document = data["document"];
            this.fileExtension = data["fileExtension"];
            this.input = data["input"] ? UpdateDocumentInput.fromJS(data["input"]) : <any>undefined;
            this.fileName = data["fileName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DocumentEditDto {
        let result = new DocumentEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["document"] = this.document;
        data["fileExtension"] = this.fileExtension;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDocumentEditDto {
    documentId: string | undefined;
    document: string | undefined;
    fileExtension: string | undefined;
    input: UpdateDocumentInput | undefined;
    fileName: string | undefined;
    id: number | undefined;
}

export class UpdateDocumentInput implements IUpdateDocumentInput {
    documentId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentId = data["documentId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateDocumentInput {
        let result = new UpdateDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateDocumentInput {
    documentId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class GetCertificatePreviewInput implements IGetCertificatePreviewInput {
    isCNA: boolean | undefined;
    event: CertificatePreviewEvent | undefined;
    eventWorId: number | undefined;
    type: GetCertificatePreviewInputType | undefined;

    constructor(data?: IGetCertificatePreviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCNA = data["isCNA"];
            this.event = data["event"] ? CertificatePreviewEvent.fromJS(data["event"]) : <any>undefined;
            this.eventWorId = data["eventWorId"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): GetCertificatePreviewInput {
        let result = new GetCertificatePreviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCNA"] = this.isCNA;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["eventWorId"] = this.eventWorId;
        data["type"] = this.type;
        return data; 
    }
}

export interface IGetCertificatePreviewInput {
    isCNA: boolean | undefined;
    event: CertificatePreviewEvent | undefined;
    eventWorId: number | undefined;
    type: GetCertificatePreviewInputType | undefined;
}

export class CertificatePreviewEvent implements ICertificatePreviewEvent {
    name: string | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    place: EventPlaceDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    id: number | undefined;

    constructor(data?: ICertificatePreviewEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            this.certificateConfig = data["certificateConfig"] ? CertificateConfigDto.fromJS(data["certificateConfig"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificatePreviewEvent {
        let result = new CertificatePreviewEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["certificateConfig"] = this.certificateConfig ? this.certificateConfig.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICertificatePreviewEvent {
    name: string | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    place: EventPlaceDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    id: number | undefined;
}

export class EventPlaceDto implements IEventPlaceDto {
    name: string;
    addresses: EventAddressDto[] | undefined;
    id: number | undefined;

    constructor(data?: IEventPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(EventAddressDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventPlaceDto {
        let result = new EventPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventPlaceDto {
    name: string;
    addresses: EventAddressDto[] | undefined;
    id: number | undefined;
}

export class CertificateConfigDto implements ICertificateConfigDto {
    defaultImageId: string | undefined;
    cnaImageId: string | undefined;
    workImageId: string | undefined;
    defaultImage: string | undefined;
    cnaImage: string | undefined;
    workImage: string | undefined;
    defaultImageInput: UpdateCertificateImageInput | undefined;
    cnaImageInput: UpdateCertificateImageInput | undefined;
    workImageInput: UpdateCertificateImageInput | undefined;
    texts: CertificateConfigTextDto[] | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    id: number | undefined;

    constructor(data?: ICertificateConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultImageId = data["defaultImageId"];
            this.cnaImageId = data["cnaImageId"];
            this.workImageId = data["workImageId"];
            this.defaultImage = data["defaultImage"];
            this.cnaImage = data["cnaImage"];
            this.workImage = data["workImage"];
            this.defaultImageInput = data["defaultImageInput"] ? UpdateCertificateImageInput.fromJS(data["defaultImageInput"]) : <any>undefined;
            this.cnaImageInput = data["cnaImageInput"] ? UpdateCertificateImageInput.fromJS(data["cnaImageInput"]) : <any>undefined;
            this.workImageInput = data["workImageInput"] ? UpdateCertificateImageInput.fromJS(data["workImageInput"]) : <any>undefined;
            if (data["texts"] && data["texts"].constructor === Array) {
                this.texts = [];
                for (let item of data["texts"])
                    this.texts.push(CertificateConfigTextDto.fromJS(item));
            }
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateConfigDto {
        let result = new CertificateConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultImageId"] = this.defaultImageId;
        data["cnaImageId"] = this.cnaImageId;
        data["workImageId"] = this.workImageId;
        data["defaultImage"] = this.defaultImage;
        data["cnaImage"] = this.cnaImage;
        data["workImage"] = this.workImage;
        data["defaultImageInput"] = this.defaultImageInput ? this.defaultImageInput.toJSON() : <any>undefined;
        data["cnaImageInput"] = this.cnaImageInput ? this.cnaImageInput.toJSON() : <any>undefined;
        data["workImageInput"] = this.workImageInput ? this.workImageInput.toJSON() : <any>undefined;
        if (this.texts && this.texts.constructor === Array) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item.toJSON());
        }
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICertificateConfigDto {
    defaultImageId: string | undefined;
    cnaImageId: string | undefined;
    workImageId: string | undefined;
    defaultImage: string | undefined;
    cnaImage: string | undefined;
    workImage: string | undefined;
    defaultImageInput: UpdateCertificateImageInput | undefined;
    cnaImageInput: UpdateCertificateImageInput | undefined;
    workImageInput: UpdateCertificateImageInput | undefined;
    texts: CertificateConfigTextDto[] | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    id: number | undefined;
}

export class EventAddressDto implements IEventAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: EventAddressDtoType;
    id: number | undefined;

    constructor(data?: IEventAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventAddressDto {
        let result = new EventAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: EventAddressDtoType;
    id: number | undefined;
}

export class UpdateCertificateImageInput implements IUpdateCertificateImageInput {
    certificateId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateCertificateImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.certificateId = data["certificateId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateCertificateImageInput {
        let result = new UpdateCertificateImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateId"] = this.certificateId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateCertificateImageInput {
    certificateId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class CertificateConfigTextDto implements ICertificateConfigTextDto {
    text: string | undefined;
    texts: CreateOrEditLanguageTextDto[] | undefined;
    certificateType: CertificateConfigTextDtoCertificateType | undefined;
    configId: number | undefined;
    id: number | undefined;

    constructor(data?: ICertificateConfigTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.text = data["text"];
            if (data["texts"] && data["texts"].constructor === Array) {
                this.texts = [];
                for (let item of data["texts"])
                    this.texts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            this.certificateType = data["certificateType"];
            this.configId = data["configId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateConfigTextDto {
        let result = new CertificateConfigTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (this.texts && this.texts.constructor === Array) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item.toJSON());
        }
        data["certificateType"] = this.certificateType;
        data["configId"] = this.configId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICertificateConfigTextDto {
    text: string | undefined;
    texts: CreateOrEditLanguageTextDto[] | undefined;
    certificateType: CertificateConfigTextDtoCertificateType | undefined;
    configId: number | undefined;
    id: number | undefined;
}

export class EventListDto implements IEventListDto {
    id: number | undefined;
    name: string | undefined;
    shortName: string | undefined;
    place: EventPlaceDto | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    costCenter: CostCenterListDto | undefined;

    constructor(data?: IEventListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.time = data["time"];
            this.costCenter = data["costCenter"] ? CostCenterListDto.fromJS(data["costCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventListDto {
        let result = new EventListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEventListDto {
    id: number | undefined;
    name: string | undefined;
    shortName: string | undefined;
    place: EventPlaceDto | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    costCenter: CostCenterListDto | undefined;
}

export class ValidateCertificateInput implements IValidateCertificateInput {
    userId: number | undefined;
    registrationId: number | undefined;

    constructor(data?: IValidateCertificateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.registrationId = data["registrationId"];
        }
    }

    static fromJS(data: any): ValidateCertificateInput {
        let result = new ValidateCertificateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["registrationId"] = this.registrationId;
        return data; 
    }
}

export interface IValidateCertificateInput {
    userId: number | undefined;
    registrationId: number | undefined;
}

export class ValidateCertificateOutput implements IValidateCertificateOutput {
    isValid: boolean | undefined;
    message: string | undefined;
    userName: string | undefined;
    eventName: string | undefined;
    category: string | undefined;

    constructor(data?: IValidateCertificateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isValid = data["isValid"];
            this.message = data["message"];
            this.userName = data["userName"];
            this.eventName = data["eventName"];
            this.category = data["category"];
        }
    }

    static fromJS(data: any): ValidateCertificateOutput {
        let result = new ValidateCertificateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["message"] = this.message;
        data["userName"] = this.userName;
        data["eventName"] = this.eventName;
        data["category"] = this.category;
        return data; 
    }
}

export interface IValidateCertificateOutput {
    isValid: boolean | undefined;
    message: string | undefined;
    userName: string | undefined;
    eventName: string | undefined;
    category: string | undefined;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment | undefined;
    friends: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : <any>undefined;
            if (data["friends"] && data["friends"].constructor === Array) {
                this.friends = [];
                for (let item of data["friends"])
                    this.friends.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (this.friends && this.friends.constructor === Array) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment | undefined;
    friends: FriendDto[] | undefined;
}

export class FriendDto implements IFriendDto {
    friendUserId: number | undefined;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number | undefined;
    isOnline: boolean | undefined;
    state: FriendDtoState | undefined;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data; 
    }
}

export interface IFriendDto {
    friendUserId: number | undefined;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number | undefined;
    isOnline: boolean | undefined;
    state: FriendDtoState | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ChatMessageDto implements IChatMessageDto {
    userId: number | undefined;
    tenantId: number | undefined;
    targetUserId: number | undefined;
    targetTenantId: number | undefined;
    side: ChatMessageDtoSide | undefined;
    readState: ChatMessageDtoReadState | undefined;
    receiverReadState: ChatMessageDtoReceiverReadState | undefined;
    message: string | undefined;
    creationTime: moment.Moment | undefined;
    sharedMessageId: string | undefined;
    id: number | undefined;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChatMessageDto {
    userId: number | undefined;
    tenantId: number | undefined;
    targetUserId: number | undefined;
    targetTenantId: number | undefined;
    side: ChatMessageDtoSide | undefined;
    readState: ChatMessageDtoReadState | undefined;
    receiverReadState: ChatMessageDtoReceiverReadState | undefined;
    message: string | undefined;
    creationTime: moment.Moment | undefined;
    sharedMessageId: string | undefined;
    id: number | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number | undefined;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number | undefined;
}

export class PagedResultDtoOfGetCnabForView implements IPagedResultDtoOfGetCnabForView {
    totalCount: number | undefined;
    items: GetCnabForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCnabForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCnabForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCnabForView {
        let result = new PagedResultDtoOfGetCnabForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCnabForView {
    totalCount: number | undefined;
    items: GetCnabForView[] | undefined;
}

export class GetCnabForView implements IGetCnabForView {
    cnab: CnabDto | undefined;
    totalReceived: number | undefined;
    errors: number | undefined;

    constructor(data?: IGetCnabForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnab = data["cnab"] ? CnabDto.fromJS(data["cnab"]) : <any>undefined;
            this.totalReceived = data["totalReceived"];
            this.errors = data["errors"];
        }
    }

    static fromJS(data: any): GetCnabForView {
        let result = new GetCnabForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnab"] = this.cnab ? this.cnab.toJSON() : <any>undefined;
        data["totalReceived"] = this.totalReceived;
        data["errors"] = this.errors;
        return data; 
    }
}

export interface IGetCnabForView {
    cnab: CnabDto | undefined;
    totalReceived: number | undefined;
    errors: number | undefined;
}

export class CnabDto implements ICnabDto {
    fileId: string | undefined;
    fileName: string | undefined;
    errorsDetails: string | undefined;
    successDetails: string | undefined;
    status: CnabDtoStatus | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICnabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.errorsDetails = data["errorsDetails"];
            this.successDetails = data["successDetails"];
            this.status = data["status"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CnabDto {
        let result = new CnabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["errorsDetails"] = this.errorsDetails;
        data["successDetails"] = this.successDetails;
        data["status"] = this.status;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICnabDto {
    fileId: string | undefined;
    fileName: string | undefined;
    errorsDetails: string | undefined;
    successDetails: string | undefined;
    status: CnabDtoStatus | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetCnabForEditOutput implements IGetCnabForEditOutput {
    cnab: CreateOrEditCnabDto | undefined;

    constructor(data?: IGetCnabForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnab = data["cnab"] ? CreateOrEditCnabDto.fromJS(data["cnab"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCnabForEditOutput {
        let result = new GetCnabForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnab"] = this.cnab ? this.cnab.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCnabForEditOutput {
    cnab: CreateOrEditCnabDto | undefined;
}

export class CreateOrEditCnabDto implements ICreateOrEditCnabDto {
    fileId: string | undefined;
    fileName: string | undefined;
    errorsDetails: string | undefined;
    successDetails: string | undefined;
    status: CreateOrEditCnabDtoStatus | undefined;
    input: UpdateFileInput | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCnabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.errorsDetails = data["errorsDetails"];
            this.successDetails = data["successDetails"];
            this.status = data["status"];
            this.input = data["input"] ? UpdateFileInput.fromJS(data["input"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCnabDto {
        let result = new CreateOrEditCnabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["errorsDetails"] = this.errorsDetails;
        data["successDetails"] = this.successDetails;
        data["status"] = this.status;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCnabDto {
    fileId: string | undefined;
    fileName: string | undefined;
    errorsDetails: string | undefined;
    successDetails: string | undefined;
    status: CreateOrEditCnabDtoStatus | undefined;
    input: UpdateFileInput | undefined;
    id: number | undefined;
}

export class UpdateFileInput implements IUpdateFileInput {
    fileId: number | undefined;
    fileName: string;
    fileType: string | undefined;
    fileToken: string | undefined;

    constructor(data?: IUpdateFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): UpdateFileInput {
        let result = new UpdateFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IUpdateFileInput {
    fileId: number | undefined;
    fileName: string;
    fileType: string | undefined;
    fileToken: string | undefined;
}

export class ConfirmPaymentInput implements IConfirmPaymentInput {
    cnabId: number | undefined;
    paymentIds: number[] | undefined;

    constructor(data?: IConfirmPaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnabId = data["cnabId"];
            if (data["paymentIds"] && data["paymentIds"].constructor === Array) {
                this.paymentIds = [];
                for (let item of data["paymentIds"])
                    this.paymentIds.push(item);
            }
        }
    }

    static fromJS(data: any): ConfirmPaymentInput {
        let result = new ConfirmPaymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnabId"] = this.cnabId;
        if (this.paymentIds && this.paymentIds.constructor === Array) {
            data["paymentIds"] = [];
            for (let item of this.paymentIds)
                data["paymentIds"].push(item);
        }
        return data; 
    }
}

export interface IConfirmPaymentInput {
    cnabId: number | undefined;
    paymentIds: number[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount: number | undefined;
    items: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number | undefined;
    items: NameValueDto[] | undefined;
}

export class NameValueDto implements INameValueDto {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class ListResultDtoOfCostCenterDto implements IListResultDtoOfCostCenterDto {
    items: CostCenterDto[] | undefined;

    constructor(data?: IListResultDtoOfCostCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CostCenterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCostCenterDto {
        let result = new ListResultDtoOfCostCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCostCenterDto {
    items: CostCenterDto[] | undefined;
}

export class CostCenterDto implements ICostCenterDto {
    shortDescription: string | undefined;
    filterType: CostCenterDtoFilterType | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    isActive: boolean | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICostCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shortDescription = data["shortDescription"];
            this.filterType = data["filterType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CostCenterDto {
        let result = new CostCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortDescription"] = this.shortDescription;
        data["filterType"] = this.filterType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICostCenterDto {
    shortDescription: string | undefined;
    filterType: CostCenterDtoFilterType | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    isActive: boolean | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfCostCenterPaymentChargeListDto implements IPagedResultDtoOfCostCenterPaymentChargeListDto {
    totalCount: number | undefined;
    items: CostCenterPaymentChargeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCostCenterPaymentChargeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CostCenterPaymentChargeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCostCenterPaymentChargeListDto {
        let result = new PagedResultDtoOfCostCenterPaymentChargeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCostCenterPaymentChargeListDto {
    totalCount: number | undefined;
    items: CostCenterPaymentChargeListDto[] | undefined;
}

export class CostCenterPaymentChargeListDto implements ICostCenterPaymentChargeListDto {
    id: string | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    status: CostCenterPaymentChargeListDtoStatus | undefined;
    amount: number | undefined;
    netAmount: number | undefined;
    discount: number | undefined;
    proratedReceiptDate: moment.Moment | undefined;
    proratedValue: number | undefined;
    allowProratedValue: number | undefined;

    constructor(data?: ICostCenterPaymentChargeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.status = data["status"];
            this.amount = data["amount"];
            this.netAmount = data["netAmount"];
            this.discount = data["discount"];
            this.proratedReceiptDate = data["proratedReceiptDate"] ? moment(data["proratedReceiptDate"].toString()) : <any>undefined;
            this.proratedValue = data["proratedValue"];
            this.allowProratedValue = data["allowProratedValue"];
        }
    }

    static fromJS(data: any): CostCenterPaymentChargeListDto {
        let result = new CostCenterPaymentChargeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["proratedReceiptDate"] = this.proratedReceiptDate ? this.proratedReceiptDate.toISOString() : <any>undefined;
        data["proratedValue"] = this.proratedValue;
        data["allowProratedValue"] = this.allowProratedValue;
        return data; 
    }
}

export interface ICostCenterPaymentChargeListDto {
    id: string | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    status: CostCenterPaymentChargeListDtoStatus | undefined;
    amount: number | undefined;
    netAmount: number | undefined;
    discount: number | undefined;
    proratedReceiptDate: moment.Moment | undefined;
    proratedValue: number | undefined;
    allowProratedValue: number | undefined;
}

export class ListResultDtoOfCostCenterListDto implements IListResultDtoOfCostCenterListDto {
    items: CostCenterListDto[] | undefined;

    constructor(data?: IListResultDtoOfCostCenterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CostCenterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCostCenterListDto {
        let result = new ListResultDtoOfCostCenterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCostCenterListDto {
    items: CostCenterListDto[] | undefined;
}

export class ListResultDtoOfCostCenterWithLevelDto implements IListResultDtoOfCostCenterWithLevelDto {
    items: CostCenterWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfCostCenterWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CostCenterWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCostCenterWithLevelDto {
        let result = new ListResultDtoOfCostCenterWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCostCenterWithLevelDto {
    items: CostCenterWithLevelDto[] | undefined;
}

export class CostCenterWithLevelDto implements ICostCenterWithLevelDto {
    level: number | undefined;
    parentName: string | undefined;
    id: number | undefined;
    displayName: string | undefined;
    shortDescription: string | undefined;
    isActive: boolean | undefined;
    filterType: CostCenterWithLevelDtoFilterType | undefined;

    constructor(data?: ICostCenterWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.shortDescription = data["shortDescription"];
            this.isActive = data["isActive"];
            this.filterType = data["filterType"];
        }
    }

    static fromJS(data: any): CostCenterWithLevelDto {
        let result = new CostCenterWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["shortDescription"] = this.shortDescription;
        data["isActive"] = this.isActive;
        data["filterType"] = this.filterType;
        return data; 
    }
}

export interface ICostCenterWithLevelDto {
    level: number | undefined;
    parentName: string | undefined;
    id: number | undefined;
    displayName: string | undefined;
    shortDescription: string | undefined;
    isActive: boolean | undefined;
    filterType: CostCenterWithLevelDtoFilterType | undefined;
}

export class PaymentChargesToCostCenterInput implements IPaymentChargesToCostCenterInput {
    paymentChargeIds: number[] | undefined;
    paymentCharges: PaymentChargesToCostCenterDto[] | undefined;
    organizationUnitId: number | undefined;
    addToParents: boolean | undefined;
    proratedReceiptDate: moment.Moment | undefined;
    proratedValue: number | undefined;

    constructor(data?: IPaymentChargesToCostCenterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["paymentChargeIds"] && data["paymentChargeIds"].constructor === Array) {
                this.paymentChargeIds = [];
                for (let item of data["paymentChargeIds"])
                    this.paymentChargeIds.push(item);
            }
            if (data["paymentCharges"] && data["paymentCharges"].constructor === Array) {
                this.paymentCharges = [];
                for (let item of data["paymentCharges"])
                    this.paymentCharges.push(PaymentChargesToCostCenterDto.fromJS(item));
            }
            this.organizationUnitId = data["organizationUnitId"];
            this.addToParents = data["addToParents"];
            this.proratedReceiptDate = data["proratedReceiptDate"] ? moment(data["proratedReceiptDate"].toString()) : <any>undefined;
            this.proratedValue = data["proratedValue"];
        }
    }

    static fromJS(data: any): PaymentChargesToCostCenterInput {
        let result = new PaymentChargesToCostCenterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paymentChargeIds && this.paymentChargeIds.constructor === Array) {
            data["paymentChargeIds"] = [];
            for (let item of this.paymentChargeIds)
                data["paymentChargeIds"].push(item);
        }
        if (this.paymentCharges && this.paymentCharges.constructor === Array) {
            data["paymentCharges"] = [];
            for (let item of this.paymentCharges)
                data["paymentCharges"].push(item.toJSON());
        }
        data["organizationUnitId"] = this.organizationUnitId;
        data["addToParents"] = this.addToParents;
        data["proratedReceiptDate"] = this.proratedReceiptDate ? this.proratedReceiptDate.toISOString() : <any>undefined;
        data["proratedValue"] = this.proratedValue;
        return data; 
    }
}

export interface IPaymentChargesToCostCenterInput {
    paymentChargeIds: number[] | undefined;
    paymentCharges: PaymentChargesToCostCenterDto[] | undefined;
    organizationUnitId: number | undefined;
    addToParents: boolean | undefined;
    proratedReceiptDate: moment.Moment | undefined;
    proratedValue: number | undefined;
}

export class PaymentChargesToCostCenterDto implements IPaymentChargesToCostCenterDto {
    id: number | undefined;
    proratedValue: number | undefined;
    proratedReceiptDate: moment.Moment | undefined;

    constructor(data?: IPaymentChargesToCostCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.proratedValue = data["proratedValue"];
            this.proratedReceiptDate = data["proratedReceiptDate"] ? moment(data["proratedReceiptDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentChargesToCostCenterDto {
        let result = new PaymentChargesToCostCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proratedValue"] = this.proratedValue;
        data["proratedReceiptDate"] = this.proratedReceiptDate ? this.proratedReceiptDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPaymentChargesToCostCenterDto {
    id: number | undefined;
    proratedValue: number | undefined;
    proratedReceiptDate: moment.Moment | undefined;
}

export class CreateCostCenterInput implements ICreateCostCenterInput {
    shortDescription: string | undefined;
    filterType: CreateCostCenterInputFilterType | undefined;
    eventId: number | undefined;
    annuityId: number | undefined;
    isActive: boolean | undefined;
    paymentCharges: PaymentChargeDto[] | undefined;
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateCostCenterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shortDescription = data["shortDescription"];
            this.filterType = data["filterType"];
            this.eventId = data["eventId"];
            this.annuityId = data["annuityId"];
            this.isActive = data["isActive"];
            if (data["paymentCharges"] && data["paymentCharges"].constructor === Array) {
                this.paymentCharges = [];
                for (let item of data["paymentCharges"])
                    this.paymentCharges.push(PaymentChargeDto.fromJS(item));
            }
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateCostCenterInput {
        let result = new CreateCostCenterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortDescription"] = this.shortDescription;
        data["filterType"] = this.filterType;
        data["eventId"] = this.eventId;
        data["annuityId"] = this.annuityId;
        data["isActive"] = this.isActive;
        if (this.paymentCharges && this.paymentCharges.constructor === Array) {
            data["paymentCharges"] = [];
            for (let item of this.paymentCharges)
                data["paymentCharges"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateCostCenterInput {
    shortDescription: string | undefined;
    filterType: CreateCostCenterInputFilterType | undefined;
    eventId: number | undefined;
    annuityId: number | undefined;
    isActive: boolean | undefined;
    paymentCharges: PaymentChargeDto[] | undefined;
    parentId: number | undefined;
    displayName: string;
}

export class PaymentChargeDto implements IPaymentChargeDto {
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: PaymentChargeDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IPaymentChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentChargeDto {
        let result = new PaymentChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentChargeDto {
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: PaymentChargeDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class UserListDto implements IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    nameForCredential: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean | undefined;
    pendingUpdate: boolean | undefined;
    situation: SituationListDto | undefined;
    roles: UserListRoleDto[] | undefined;
    emails: UserListEmailDto[] | undefined;
    phones: UserListPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    currentCategory: MemberCategoryEditDto | undefined;
    memberStatus: string | undefined;
    member: UserMemberEditDto | undefined;
    regionalName: string | undefined;
    hasUserJson: boolean | undefined;
    memberBase: string | undefined;
    statusCpf: UserListDtoStatusCpf | undefined;
    situationCpf: UserListDtoSituationCpf | undefined;
    statusIntegracao: UserListDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    associationDate: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.pendingUpdate = data["pendingUpdate"];
            this.situation = data["situation"] ? SituationListDto.fromJS(data["situation"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserListRoleDto.fromJS(item));
            }
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserListEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserListPhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(UserAddressDto.fromJS(item));
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.currentCategory = data["currentCategory"] ? MemberCategoryEditDto.fromJS(data["currentCategory"]) : <any>undefined;
            this.memberStatus = data["memberStatus"];
            this.member = data["member"] ? UserMemberEditDto.fromJS(data["member"]) : <any>undefined;
            this.regionalName = data["regionalName"];
            this.hasUserJson = data["hasUserJson"];
            this.memberBase = data["memberBase"];
            this.statusCpf = data["statusCpf"];
            this.situationCpf = data["situationCpf"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.nameValidSerpro = data["nameValidSerpro"];
            this.confirmedName = data["confirmedName"];
            this.associationDate = data["associationDate"] ? moment(data["associationDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["pendingUpdate"] = this.pendingUpdate;
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["currentCategory"] = this.currentCategory ? this.currentCategory.toJSON() : <any>undefined;
        data["memberStatus"] = this.memberStatus;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["regionalName"] = this.regionalName;
        data["hasUserJson"] = this.hasUserJson;
        data["memberBase"] = this.memberBase;
        data["statusCpf"] = this.statusCpf;
        data["situationCpf"] = this.situationCpf;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["nameValidSerpro"] = this.nameValidSerpro;
        data["confirmedName"] = this.confirmedName;
        data["associationDate"] = this.associationDate ? this.associationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    nameForCredential: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean | undefined;
    pendingUpdate: boolean | undefined;
    situation: SituationListDto | undefined;
    roles: UserListRoleDto[] | undefined;
    emails: UserListEmailDto[] | undefined;
    phones: UserListPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    currentCategory: MemberCategoryEditDto | undefined;
    memberStatus: string | undefined;
    member: UserMemberEditDto | undefined;
    regionalName: string | undefined;
    hasUserJson: boolean | undefined;
    memberBase: string | undefined;
    statusCpf: UserListDtoStatusCpf | undefined;
    situationCpf: UserListDtoSituationCpf | undefined;
    statusIntegracao: UserListDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    associationDate: moment.Moment | undefined;
    id: number | undefined;
}

export class EnterpriseListDto implements IEnterpriseListDto {
    id: number | undefined;
    cnpj: string | undefined;
    companyName: string | undefined;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    type: EnterpriseListDtoType | undefined;

    constructor(data?: IEnterpriseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.cnpj = data["cnpj"];
            this.companyName = data["companyName"];
            this.tradingName = data["tradingName"];
            this.enterpriseEmail = data["enterpriseEmail"];
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(EnterprisePhoneDto.fromJS(item));
            }
            this.type = data["type"];
        }
    }

    static fromJS(data: any): EnterpriseListDto {
        let result = new EnterpriseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cnpj"] = this.cnpj;
        data["companyName"] = this.companyName;
        data["tradingName"] = this.tradingName;
        data["enterpriseEmail"] = this.enterpriseEmail;
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data; 
    }
}

export interface IEnterpriseListDto {
    id: number | undefined;
    cnpj: string | undefined;
    companyName: string | undefined;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    type: EnterpriseListDtoType | undefined;
}

export class NoteDto implements INoteDto {
    description: string;
    id: number | undefined;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NoteDto {
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface INoteDto {
    description: string;
    id: number | undefined;
}

export class PaymentChargeCostCentersDto implements IPaymentChargeCostCentersDto {
    isDeleted: boolean | undefined;
    paymentChargeId: number | undefined;
    paymentCharge: PaymentChargeDto | undefined;
    costCenterId: number | undefined;
    costCenter: CostCenterDto | undefined;

    constructor(data?: IPaymentChargeCostCentersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.paymentChargeId = data["paymentChargeId"];
            this.paymentCharge = data["paymentCharge"] ? PaymentChargeDto.fromJS(data["paymentCharge"]) : <any>undefined;
            this.costCenterId = data["costCenterId"];
            this.costCenter = data["costCenter"] ? CostCenterDto.fromJS(data["costCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentChargeCostCentersDto {
        let result = new PaymentChargeCostCentersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["paymentChargeId"] = this.paymentChargeId;
        data["paymentCharge"] = this.paymentCharge ? this.paymentCharge.toJSON() : <any>undefined;
        data["costCenterId"] = this.costCenterId;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPaymentChargeCostCentersDto {
    isDeleted: boolean | undefined;
    paymentChargeId: number | undefined;
    paymentCharge: PaymentChargeDto | undefined;
    costCenterId: number | undefined;
    costCenter: CostCenterDto | undefined;
}

export class TransactionHistoryDto implements ITransactionHistoryDto {
    creationTime: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    paymentDate: moment.Moment | undefined;
    paymentValue: number | undefined;
    id: number | undefined;

    constructor(data?: ITransactionHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.paymentValue = data["paymentValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionHistoryDto {
        let result = new TransactionHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentValue"] = this.paymentValue;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionHistoryDto {
    creationTime: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    paymentDate: moment.Moment | undefined;
    paymentValue: number | undefined;
    id: number | undefined;
}

export class SituationListDto implements ISituationListDto {
    id: number | undefined;
    description: string | undefined;

    constructor(data?: ISituationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): SituationListDto {
        let result = new SituationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data; 
    }
}

export interface ISituationListDto {
    id: number | undefined;
    description: string | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IUserListRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
}

export class UserListEmailDto implements IUserListEmailDto {
    emailAddress: string;
    id: number | undefined;

    constructor(data?: IUserListEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListEmailDto {
        let result = new UserListEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListEmailDto {
    emailAddress: string;
    id: number | undefined;
}

export class UserListPhoneDto implements IUserListPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: UserListPhoneDtoType;
    id: number | undefined;

    constructor(data?: IUserListPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListPhoneDto {
        let result = new UserListPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: UserListPhoneDtoType;
    id: number | undefined;
}

export class UserAddressDto implements IUserAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: UserAddressDtoType;
    id: number | undefined;

    constructor(data?: IUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserAddressDto {
        let result = new UserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: UserAddressDtoType;
    id: number | undefined;
}

export class MemberCategoryEditDto implements IMemberCategoryEditDto {
    id: number | undefined;
    beginDate: moment.Moment;
    endDate: moment.Moment | undefined;
    note: string | undefined;
    categoryId: number;
    category: CategoryEditDto | undefined;
    categoryLevelId: number | undefined;
    categoryLevel: CategoryLevelDto | undefined;
    userId: number | undefined;

    constructor(data?: IMemberCategoryEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.note = data["note"];
            this.categoryId = data["categoryId"];
            this.category = data["category"] ? CategoryEditDto.fromJS(data["category"]) : <any>undefined;
            this.categoryLevelId = data["categoryLevelId"];
            this.categoryLevel = data["categoryLevel"] ? CategoryLevelDto.fromJS(data["categoryLevel"]) : <any>undefined;
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MemberCategoryEditDto {
        let result = new MemberCategoryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["categoryLevelId"] = this.categoryLevelId;
        data["categoryLevel"] = this.categoryLevel ? this.categoryLevel.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IMemberCategoryEditDto {
    id: number | undefined;
    beginDate: moment.Moment;
    endDate: moment.Moment | undefined;
    note: string | undefined;
    categoryId: number;
    category: CategoryEditDto | undefined;
    categoryLevelId: number | undefined;
    categoryLevel: CategoryLevelDto | undefined;
    userId: number | undefined;
}

export class UserMemberEditDto implements IUserMemberEditDto {
    registrySBA: string | undefined;
    rg: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    speciality: string | undefined;
    correspondenceSituation: UserMemberEditDtoCorrespondenceSituation | undefined;
    gender: UserMemberEditDtoGender | undefined;
    bornDate: moment.Moment;
    nationalityName: string | undefined;
    graduation: MemberGraduationEditDto | undefined;
    memberStatusId: number | undefined;
    status: MemberStatusDto | undefined;
    baseId: number | undefined;
    base: BaseDto | undefined;
    isReadmited: boolean | undefined;
    isForeign: boolean | undefined;
    complementaryData: MemberComplementaryDataEditDto | undefined;
    categories: MemberCategoryEditDto[] | undefined;

    constructor(data?: IUserMemberEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrySBA = data["registrySBA"];
            this.rg = data["rg"];
            this.crm = data["crm"];
            this.crmUf = data["crmUf"];
            this.speciality = data["speciality"];
            this.correspondenceSituation = data["correspondenceSituation"];
            this.gender = data["gender"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.nationalityName = data["nationalityName"];
            this.graduation = data["graduation"] ? MemberGraduationEditDto.fromJS(data["graduation"]) : <any>undefined;
            this.memberStatusId = data["memberStatusId"];
            this.status = data["status"] ? MemberStatusDto.fromJS(data["status"]) : <any>undefined;
            this.baseId = data["baseId"];
            this.base = data["base"] ? BaseDto.fromJS(data["base"]) : <any>undefined;
            this.isReadmited = data["isReadmited"];
            this.isForeign = data["isForeign"];
            this.complementaryData = data["complementaryData"] ? MemberComplementaryDataEditDto.fromJS(data["complementaryData"]) : <any>undefined;
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(MemberCategoryEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMemberEditDto {
        let result = new UserMemberEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrySBA"] = this.registrySBA;
        data["rg"] = this.rg;
        data["crm"] = this.crm;
        data["crmUf"] = this.crmUf;
        data["speciality"] = this.speciality;
        data["correspondenceSituation"] = this.correspondenceSituation;
        data["gender"] = this.gender;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["nationalityName"] = this.nationalityName;
        data["graduation"] = this.graduation ? this.graduation.toJSON() : <any>undefined;
        data["memberStatusId"] = this.memberStatusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["baseId"] = this.baseId;
        data["base"] = this.base ? this.base.toJSON() : <any>undefined;
        data["isReadmited"] = this.isReadmited;
        data["isForeign"] = this.isForeign;
        data["complementaryData"] = this.complementaryData ? this.complementaryData.toJSON() : <any>undefined;
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserMemberEditDto {
    registrySBA: string | undefined;
    rg: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    speciality: string | undefined;
    correspondenceSituation: UserMemberEditDtoCorrespondenceSituation | undefined;
    gender: UserMemberEditDtoGender | undefined;
    bornDate: moment.Moment;
    nationalityName: string | undefined;
    graduation: MemberGraduationEditDto | undefined;
    memberStatusId: number | undefined;
    status: MemberStatusDto | undefined;
    baseId: number | undefined;
    base: BaseDto | undefined;
    isReadmited: boolean | undefined;
    isForeign: boolean | undefined;
    complementaryData: MemberComplementaryDataEditDto | undefined;
    categories: MemberCategoryEditDto[] | undefined;
}

export class EnterprisePhoneDto implements IEnterprisePhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: EnterprisePhoneDtoType;
    id: number | undefined;

    constructor(data?: IEnterprisePhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EnterprisePhoneDto {
        let result = new EnterprisePhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEnterprisePhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: EnterprisePhoneDtoType;
    id: number | undefined;
}

export class CategoryEditDto implements ICategoryEditDto {
    name: string;
    shortName: string | undefined;
    requiresDoc: boolean | undefined;
    isExempt: boolean | undefined;
    isResident: boolean | undefined;
    keepValueToNextCategory: boolean | undefined;
    keepInitialValueForBeginners: boolean | undefined;
    nextCategoryId: number | undefined;
    isActive: boolean | undefined;
    levels: CategoryLevelDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICategoryEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.requiresDoc = data["requiresDoc"];
            this.isExempt = data["isExempt"];
            this.isResident = data["isResident"];
            this.keepValueToNextCategory = data["keepValueToNextCategory"];
            this.keepInitialValueForBeginners = data["keepInitialValueForBeginners"];
            this.nextCategoryId = data["nextCategoryId"];
            this.isActive = data["isActive"];
            if (data["levels"] && data["levels"].constructor === Array) {
                this.levels = [];
                for (let item of data["levels"])
                    this.levels.push(CategoryLevelDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryEditDto {
        let result = new CategoryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["requiresDoc"] = this.requiresDoc;
        data["isExempt"] = this.isExempt;
        data["isResident"] = this.isResident;
        data["keepValueToNextCategory"] = this.keepValueToNextCategory;
        data["keepInitialValueForBeginners"] = this.keepInitialValueForBeginners;
        data["nextCategoryId"] = this.nextCategoryId;
        data["isActive"] = this.isActive;
        if (this.levels && this.levels.constructor === Array) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategoryEditDto {
    name: string;
    shortName: string | undefined;
    requiresDoc: boolean | undefined;
    isExempt: boolean | undefined;
    isResident: boolean | undefined;
    keepValueToNextCategory: boolean | undefined;
    keepInitialValueForBeginners: boolean | undefined;
    nextCategoryId: number | undefined;
    isActive: boolean | undefined;
    levels: CategoryLevelDto[] | undefined;
    id: number | undefined;
}

export class MemberGraduationEditDto implements IMemberGraduationEditDto {
    educationalInstitution: string | undefined;
    countryState: string | undefined;
    graduationYear: number | undefined;
    beginYear: number | undefined;
    endYear: number | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    workplaces: MemberWorkplaceDto[] | undefined;
    id: number | undefined;

    constructor(data?: IMemberGraduationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.educationalInstitution = data["educationalInstitution"];
            this.countryState = data["countryState"];
            this.graduationYear = data["graduationYear"];
            this.beginYear = data["beginYear"];
            this.endYear = data["endYear"];
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            if (data["workplaces"] && data["workplaces"].constructor === Array) {
                this.workplaces = [];
                for (let item of data["workplaces"])
                    this.workplaces.push(MemberWorkplaceDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberGraduationEditDto {
        let result = new MemberGraduationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationalInstitution"] = this.educationalInstitution;
        data["countryState"] = this.countryState;
        data["graduationYear"] = this.graduationYear;
        data["beginYear"] = this.beginYear;
        data["endYear"] = this.endYear;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        if (this.workplaces && this.workplaces.constructor === Array) {
            data["workplaces"] = [];
            for (let item of this.workplaces)
                data["workplaces"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberGraduationEditDto {
    educationalInstitution: string | undefined;
    countryState: string | undefined;
    graduationYear: number | undefined;
    beginYear: number | undefined;
    endYear: number | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    workplaces: MemberWorkplaceDto[] | undefined;
    id: number | undefined;
}

export class MemberStatusDto implements IMemberStatusDto {
    isActive: boolean | undefined;
    description: string | undefined;
    paidAssociation: boolean | undefined;
    paidFederation: boolean | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;

    constructor(data?: IMemberStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.paidAssociation = data["paidAssociation"];
            this.paidFederation = data["paidFederation"];
            this.isDefault = data["isDefault"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberStatusDto {
        let result = new MemberStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["paidAssociation"] = this.paidAssociation;
        data["paidFederation"] = this.paidFederation;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberStatusDto {
    isActive: boolean | undefined;
    description: string | undefined;
    paidAssociation: boolean | undefined;
    paidFederation: boolean | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;
}

export class BaseDto implements IBaseDto {
    tenantId: number | undefined;
    description: string | undefined;
    generateAnnuity: boolean | undefined;
    requireSpeciality: boolean | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;

    constructor(data?: IBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.description = data["description"];
            this.generateAnnuity = data["generateAnnuity"];
            this.requireSpeciality = data["requireSpeciality"];
            this.isDefault = data["isDefault"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseDto {
        let result = new BaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["generateAnnuity"] = this.generateAnnuity;
        data["requireSpeciality"] = this.requireSpeciality;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBaseDto {
    tenantId: number | undefined;
    description: string | undefined;
    generateAnnuity: boolean | undefined;
    requireSpeciality: boolean | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;
}

export class MemberComplementaryDataEditDto implements IMemberComplementaryDataEditDto {
    adminSaesp: moment.Moment | undefined;
    adminAtv: moment.Moment | undefined;
    items: MemberComplementaryDataItemEditDto[] | undefined;

    constructor(data?: IMemberComplementaryDataEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adminSaesp = data["adminSaesp"] ? moment(data["adminSaesp"].toString()) : <any>undefined;
            this.adminAtv = data["adminAtv"] ? moment(data["adminAtv"].toString()) : <any>undefined;
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MemberComplementaryDataItemEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberComplementaryDataEditDto {
        let result = new MemberComplementaryDataEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminSaesp"] = this.adminSaesp ? this.adminSaesp.toISOString() : <any>undefined;
        data["adminAtv"] = this.adminAtv ? this.adminAtv.toISOString() : <any>undefined;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberComplementaryDataEditDto {
    adminSaesp: moment.Moment | undefined;
    adminAtv: moment.Moment | undefined;
    items: MemberComplementaryDataItemEditDto[] | undefined;
}

export class MemberWorkplaceDto implements IMemberWorkplaceDto {
    beginYear: number | undefined;
    endYear: number | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    id: number | undefined;

    constructor(data?: IMemberWorkplaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginYear = data["beginYear"];
            this.endYear = data["endYear"];
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberWorkplaceDto {
        let result = new MemberWorkplaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginYear"] = this.beginYear;
        data["endYear"] = this.endYear;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberWorkplaceDto {
    beginYear: number | undefined;
    endYear: number | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    id: number | undefined;
}

export class MemberComplementaryDataItemEditDto implements IMemberComplementaryDataItemEditDto {
    type: MemberComplementaryDataItemEditDtoType;
    examDate: moment.Moment | undefined;
    exam: string | undefined;
    secondExam: string | undefined;
    id: number | undefined;

    constructor(data?: IMemberComplementaryDataItemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.examDate = data["examDate"] ? moment(data["examDate"].toString()) : <any>undefined;
            this.exam = data["exam"];
            this.secondExam = data["secondExam"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberComplementaryDataItemEditDto {
        let result = new MemberComplementaryDataItemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["examDate"] = this.examDate ? this.examDate.toISOString() : <any>undefined;
        data["exam"] = this.exam;
        data["secondExam"] = this.secondExam;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberComplementaryDataItemEditDto {
    type: MemberComplementaryDataItemEditDtoType;
    examDate: moment.Moment | undefined;
    exam: string | undefined;
    secondExam: string | undefined;
    id: number | undefined;
}

export class UpdateCostCenterInput implements IUpdateCostCenterInput {
    shortDescription: string | undefined;
    filterType: UpdateCostCenterInputFilterType | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    isActive: boolean | undefined;
    paymentCharges: PaymentChargeDto[] | undefined;
    id: number | undefined;
    displayName: string;

    constructor(data?: IUpdateCostCenterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shortDescription = data["shortDescription"];
            this.filterType = data["filterType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.isActive = data["isActive"];
            if (data["paymentCharges"] && data["paymentCharges"].constructor === Array) {
                this.paymentCharges = [];
                for (let item of data["paymentCharges"])
                    this.paymentCharges.push(PaymentChargeDto.fromJS(item));
            }
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateCostCenterInput {
        let result = new UpdateCostCenterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortDescription"] = this.shortDescription;
        data["filterType"] = this.filterType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        if (this.paymentCharges && this.paymentCharges.constructor === Array) {
            data["paymentCharges"] = [];
            for (let item of this.paymentCharges)
                data["paymentCharges"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateCostCenterInput {
    shortDescription: string | undefined;
    filterType: UpdateCostCenterInputFilterType | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    isActive: boolean | undefined;
    paymentCharges: PaymentChargeDto[] | undefined;
    id: number | undefined;
    displayName: string;
}

export class FindCostCenterPaymentChargesInput implements IFindCostCenterPaymentChargesInput {
    costCenterId: number | undefined;
    paymentChargeType: string | undefined;
    onlyAllowProrated: boolean | undefined;
    status: FindCostCenterPaymentChargesInputStatus | undefined;
    createDateRange: DateRangeDto | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;

    constructor(data?: IFindCostCenterPaymentChargesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.costCenterId = data["costCenterId"];
            this.paymentChargeType = data["paymentChargeType"];
            this.onlyAllowProrated = data["onlyAllowProrated"];
            this.status = data["status"];
            this.createDateRange = data["createDateRange"] ? DateRangeDto.fromJS(data["createDateRange"]) : <any>undefined;
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindCostCenterPaymentChargesInput {
        let result = new FindCostCenterPaymentChargesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenterId"] = this.costCenterId;
        data["paymentChargeType"] = this.paymentChargeType;
        data["onlyAllowProrated"] = this.onlyAllowProrated;
        data["status"] = this.status;
        data["createDateRange"] = this.createDateRange ? this.createDateRange.toJSON() : <any>undefined;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindCostCenterPaymentChargesInput {
    costCenterId: number | undefined;
    paymentChargeType: string | undefined;
    onlyAllowProrated: boolean | undefined;
    status: FindCostCenterPaymentChargesInputStatus | undefined;
    createDateRange: DateRangeDto | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;
}

export class DateRangeDto implements IDateRangeDto {
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeDto {
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDateRangeDto {
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
}

export class PagedResultDtoOfGetCouponForView implements IPagedResultDtoOfGetCouponForView {
    totalCount: number | undefined;
    items: GetCouponForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCouponForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCouponForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCouponForView {
        let result = new PagedResultDtoOfGetCouponForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCouponForView {
    totalCount: number | undefined;
    items: GetCouponForView[] | undefined;
}

export class GetCouponForView implements IGetCouponForView {
    coupon: CouponDto | undefined;

    constructor(data?: IGetCouponForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coupon = data["coupon"] ? CouponDto.fromJS(data["coupon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCouponForView {
        let result = new GetCouponForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCouponForView {
    coupon: CouponDto | undefined;
}

export class CouponDto implements ICouponDto {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;
    updatedManually: boolean | undefined;
    readonly userId: number | undefined;
    user: UserListDto | undefined;
    registrationId: number | undefined;
    couponGroupId: number | undefined;
    group: CouponGroupSelectDto | undefined;
    id: number | undefined;

    constructor(data?: ICouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.updatedManually = data["updatedManually"];
            (<any>this).userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.registrationId = data["registrationId"];
            this.couponGroupId = data["couponGroupId"];
            this.group = data["group"] ? CouponGroupSelectDto.fromJS(data["group"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponDto {
        let result = new CouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["updatedManually"] = this.updatedManually;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["registrationId"] = this.registrationId;
        data["couponGroupId"] = this.couponGroupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponDto {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;
    updatedManually: boolean | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    registrationId: number | undefined;
    couponGroupId: number | undefined;
    group: CouponGroupSelectDto | undefined;
    id: number | undefined;
}

export class CouponGroupSelectDto implements ICouponGroupSelectDto {
    readonly code: string | undefined;
    readonly name: string | undefined;

    constructor(data?: ICouponGroupSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).code = data["code"];
            (<any>this).name = data["name"];
        }
    }

    static fromJS(data: any): CouponGroupSelectDto {
        let result = new CouponGroupSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICouponGroupSelectDto {
    code: string | undefined;
    name: string | undefined;
}

export class GetCouponForEditOutput implements IGetCouponForEditOutput {
    coupon: CreateOrEditCouponDto | undefined;

    constructor(data?: IGetCouponForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coupon = data["coupon"] ? CreateOrEditCouponDto.fromJS(data["coupon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCouponForEditOutput {
        let result = new GetCouponForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCouponForEditOutput {
    coupon: CreateOrEditCouponDto | undefined;
}

export class CreateOrEditCouponDto implements ICreateOrEditCouponDto {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    updatedManually: boolean | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    expirationDate: moment.Moment | undefined;
    registration: CouponEditRegistrationDto | undefined;
    couponGroupId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.updatedManually = data["updatedManually"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.registration = data["registration"] ? CouponEditRegistrationDto.fromJS(data["registration"]) : <any>undefined;
            this.couponGroupId = data["couponGroupId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCouponDto {
        let result = new CreateOrEditCouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["updatedManually"] = this.updatedManually;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["couponGroupId"] = this.couponGroupId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCouponDto {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    updatedManually: boolean | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    expirationDate: moment.Moment | undefined;
    registration: CouponEditRegistrationDto | undefined;
    couponGroupId: number | undefined;
    id: number | undefined;
}

export class CouponEditRegistrationDto implements ICouponEditRegistrationDto {
    category: string | undefined;
    nameForCredential: string | undefined;
    user: UserListDto | undefined;
    id: number | undefined;

    constructor(data?: ICouponEditRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.nameForCredential = data["nameForCredential"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponEditRegistrationDto {
        let result = new CouponEditRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["nameForCredential"] = this.nameForCredential;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponEditRegistrationDto {
    category: string | undefined;
    nameForCredential: string | undefined;
    user: UserListDto | undefined;
    id: number | undefined;
}

export class ValidateCouponOutput implements IValidateCouponOutput {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;

    constructor(data?: IValidateCouponOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidateCouponOutput {
        let result = new ValidateCouponOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IValidateCouponOutput {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;
}

export class PagedResultDtoOfGetCouponGroupForView implements IPagedResultDtoOfGetCouponGroupForView {
    totalCount: number | undefined;
    items: GetCouponGroupForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCouponGroupForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCouponGroupForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCouponGroupForView {
        let result = new PagedResultDtoOfGetCouponGroupForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCouponGroupForView {
    totalCount: number | undefined;
    items: GetCouponGroupForView[] | undefined;
}

export class GetCouponGroupForView implements IGetCouponGroupForView {
    couponGroup: CouponGroupDto | undefined;
    totalCoupons: number | undefined;
    totalCouponsNotUsed: number | undefined;

    constructor(data?: IGetCouponGroupForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.couponGroup = data["couponGroup"] ? CouponGroupDto.fromJS(data["couponGroup"]) : <any>undefined;
            this.totalCoupons = data["totalCoupons"];
            this.totalCouponsNotUsed = data["totalCouponsNotUsed"];
        }
    }

    static fromJS(data: any): GetCouponGroupForView {
        let result = new GetCouponGroupForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["couponGroup"] = this.couponGroup ? this.couponGroup.toJSON() : <any>undefined;
        data["totalCoupons"] = this.totalCoupons;
        data["totalCouponsNotUsed"] = this.totalCouponsNotUsed;
        return data; 
    }
}

export interface IGetCouponGroupForView {
    couponGroup: CouponGroupDto | undefined;
    totalCoupons: number | undefined;
    totalCouponsNotUsed: number | undefined;
}

export class CouponGroupDto implements ICouponGroupDto {
    readonly code: string | undefined;
    readonly name: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;
    responsibleId: number | undefined;
    responsible: CouponResponsibleDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    coupons: CouponDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICouponGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).code = data["code"];
            (<any>this).name = data["name"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? CouponResponsibleDto.fromJS(data["responsible"]) : <any>undefined;
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            if (data["coupons"] && data["coupons"].constructor === Array) {
                this.coupons = [];
                for (let item of data["coupons"])
                    this.coupons.push(CouponDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponGroupDto {
        let result = new CouponGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        if (this.coupons && this.coupons.constructor === Array) {
            data["coupons"] = [];
            for (let item of this.coupons)
                data["coupons"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponGroupDto {
    code: string | undefined;
    name: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;
    responsibleId: number | undefined;
    responsible: CouponResponsibleDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    coupons: CouponDto[] | undefined;
    id: number | undefined;
}

export class CouponResponsibleDto implements ICouponResponsibleDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    type: CouponResponsibleDtoType | undefined;
    id: number | undefined;

    constructor(data?: ICouponResponsibleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponResponsibleDto {
        let result = new CouponResponsibleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponResponsibleDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    type: CouponResponsibleDtoType | undefined;
    id: number | undefined;
}

export class GetCouponGroupForEditOutput implements IGetCouponGroupForEditOutput {
    couponGroup: CreateOrEditCouponGroupDto | undefined;

    constructor(data?: IGetCouponGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.couponGroup = data["couponGroup"] ? CreateOrEditCouponGroupDto.fromJS(data["couponGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCouponGroupForEditOutput {
        let result = new GetCouponGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["couponGroup"] = this.couponGroup ? this.couponGroup.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCouponGroupForEditOutput {
    couponGroup: CreateOrEditCouponGroupDto | undefined;
}

export class CreateOrEditCouponGroupDto implements ICreateOrEditCouponGroupDto {
    quantity: number | undefined;
    applyChangesToAll: boolean | undefined;
    code: string | undefined;
    name: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;
    responsibleId: number | undefined;
    responsible: CouponResponsibleDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    coupons: CouponEditDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCouponGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quantity = data["quantity"];
            this.applyChangesToAll = data["applyChangesToAll"];
            this.code = data["code"];
            this.name = data["name"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? CouponResponsibleDto.fromJS(data["responsible"]) : <any>undefined;
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            if (data["coupons"] && data["coupons"].constructor === Array) {
                this.coupons = [];
                for (let item of data["coupons"])
                    this.coupons.push(CouponEditDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCouponGroupDto {
        let result = new CreateOrEditCouponGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["applyChangesToAll"] = this.applyChangesToAll;
        data["code"] = this.code;
        data["name"] = this.name;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        if (this.coupons && this.coupons.constructor === Array) {
            data["coupons"] = [];
            for (let item of this.coupons)
                data["coupons"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCouponGroupDto {
    quantity: number | undefined;
    applyChangesToAll: boolean | undefined;
    code: string | undefined;
    name: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    expirationDate: moment.Moment | undefined;
    responsibleId: number | undefined;
    responsible: CouponResponsibleDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    coupons: CouponEditDto[] | undefined;
    id: number | undefined;
}

export class CouponEditDto implements ICouponEditDto {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    updatedManually: boolean | undefined;
    expirationDate: moment.Moment | undefined;
    readonly userId: number | undefined;
    user: UserListDto | undefined;
    registrationId: number | undefined;
    registration: RegistrationDto | undefined;
    couponGroupId: number | undefined;
    id: number | undefined;

    constructor(data?: ICouponEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.updatedManually = data["updatedManually"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            (<any>this).userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.registrationId = data["registrationId"];
            this.registration = data["registration"] ? RegistrationDto.fromJS(data["registration"]) : <any>undefined;
            this.couponGroupId = data["couponGroupId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponEditDto {
        let result = new CouponEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["updatedManually"] = this.updatedManually;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["registrationId"] = this.registrationId;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["couponGroupId"] = this.couponGroupId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponEditDto {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    updatedManually: boolean | undefined;
    expirationDate: moment.Moment | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    registrationId: number | undefined;
    registration: RegistrationDto | undefined;
    couponGroupId: number | undefined;
    id: number | undefined;
}

export class RegistrationDto implements IRegistrationDto {
    categoryId: number | undefined;
    hasPresence: boolean | undefined;
    situation: RegistrationDtoSituation | undefined;
    coupon: CouponDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    motiveDisapprove: string | undefined;
    newNotes: NoteEditDto[] | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: RegistrationDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: RegistrationDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.hasPresence = data["hasPresence"];
            this.situation = data["situation"];
            this.coupon = data["coupon"] ? CouponDto.fromJS(data["coupon"]) : <any>undefined;
            this.categoryDeadLineId = data["categoryDeadLineId"];
            this.categoryDeadLine = data["categoryDeadLine"] ? EventCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.motiveDisapprove = data["motiveDisapprove"];
            if (data["newNotes"] && data["newNotes"].constructor === Array) {
                this.newNotes = [];
                for (let item of data["newNotes"])
                    this.newNotes.push(NoteEditDto.fromJS(item));
            }
            this.orderId = data["orderId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationDto {
        let result = new RegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["hasPresence"] = this.hasPresence;
        data["situation"] = this.situation;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["motiveDisapprove"] = this.motiveDisapprove;
        if (this.newNotes && this.newNotes.constructor === Array) {
            data["newNotes"] = [];
            for (let item of this.newNotes)
                data["newNotes"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationDto {
    categoryId: number | undefined;
    hasPresence: boolean | undefined;
    situation: RegistrationDtoSituation | undefined;
    coupon: CouponDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    motiveDisapprove: string | undefined;
    newNotes: NoteEditDto[] | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: RegistrationDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: RegistrationDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class EventCategoryDeadlineDto implements IEventCategoryDeadlineDto {
    description: string | undefined;
    value: number | undefined;
    deadline: moment.Moment | undefined;
    numberOfInstallments: number | undefined;
    hasRegistrations: boolean | undefined;
    isAdministrative: boolean | undefined;
    onLocal: boolean | undefined;
    eventId: number | undefined;
    id: number | undefined;

    constructor(data?: IEventCategoryDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.value = data["value"];
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : <any>undefined;
            this.numberOfInstallments = data["numberOfInstallments"];
            this.hasRegistrations = data["hasRegistrations"];
            this.isAdministrative = data["isAdministrative"];
            this.onLocal = data["onLocal"];
            this.eventId = data["eventId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventCategoryDeadlineDto {
        let result = new EventCategoryDeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["value"] = this.value;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["hasRegistrations"] = this.hasRegistrations;
        data["isAdministrative"] = this.isAdministrative;
        data["onLocal"] = this.onLocal;
        data["eventId"] = this.eventId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventCategoryDeadlineDto {
    description: string | undefined;
    value: number | undefined;
    deadline: moment.Moment | undefined;
    numberOfInstallments: number | undefined;
    hasRegistrations: boolean | undefined;
    isAdministrative: boolean | undefined;
    onLocal: boolean | undefined;
    eventId: number | undefined;
    id: number | undefined;
}

export class NoteEditDto implements INoteEditDto {
    description: string;
    creationTime: moment.Moment | undefined;
    type: NoteEditDtoType | undefined;

    constructor(data?: INoteEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.type = data["type"];
        }
    }

    static fromJS(data: any): NoteEditDto {
        let result = new NoteEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data; 
    }
}

export interface INoteEditDto {
    description: string;
    creationTime: moment.Moment | undefined;
    type: NoteEditDtoType | undefined;
}

export class PaymentDto implements IPaymentDto {
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    readonly bankRate: number | undefined;
    readonly totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    cardBrand: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.totalPaid = data["totalPaid"];
            this.netAmount = data["netAmount"];
            this.appliedDiscount = data["appliedDiscount"];
            (<any>this).bankRate = data["bankRate"];
            (<any>this).totalNetAmountReceived = data["totalNetAmountReceived"];
            this.note = data["note"];
            this.receivableId = data["receivableId"];
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.cardBrand = data["cardBrand"];
            this.numberOfInstallments = data["numberOfInstallments"];
            if (data["installments"] && data["installments"].constructor === Array) {
                this.installments = [];
                for (let item of data["installments"])
                    this.installments.push(InstallmentDto.fromJS(item));
            }
            if (data["transactions"] && data["transactions"].constructor === Array) {
                this.transactions = [];
                for (let item of data["transactions"])
                    this.transactions.push(TransactionRespondeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentDto {
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["totalPaid"] = this.totalPaid;
        data["netAmount"] = this.netAmount;
        data["appliedDiscount"] = this.appliedDiscount;
        data["bankRate"] = this.bankRate;
        data["totalNetAmountReceived"] = this.totalNetAmountReceived;
        data["note"] = this.note;
        data["receivableId"] = this.receivableId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["cardBrand"] = this.cardBrand;
        data["numberOfInstallments"] = this.numberOfInstallments;
        if (this.installments && this.installments.constructor === Array) {
            data["installments"] = [];
            for (let item of this.installments)
                data["installments"].push(item.toJSON());
        }
        if (this.transactions && this.transactions.constructor === Array) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentDto {
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    bankRate: number | undefined;
    totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    cardBrand: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;
}

export class ReceivablePaymentMethodPermissionDto implements IReceivablePaymentMethodPermissionDto {
    receivableId: number | undefined;
    isAllowed: boolean | undefined;
    fee: number | undefined;
    percentDiscount: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethodPermissionType: string | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    id: number | undefined;

    constructor(data?: IReceivablePaymentMethodPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receivableId = data["receivableId"];
            this.isAllowed = data["isAllowed"];
            this.fee = data["fee"];
            this.percentDiscount = data["percentDiscount"];
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethodPermissionType = data["paymentMethodPermissionType"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReceivablePaymentMethodPermissionDto {
        let result = new ReceivablePaymentMethodPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivableId"] = this.receivableId;
        data["isAllowed"] = this.isAllowed;
        data["fee"] = this.fee;
        data["percentDiscount"] = this.percentDiscount;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethodPermissionType"] = this.paymentMethodPermissionType;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReceivablePaymentMethodPermissionDto {
    receivableId: number | undefined;
    isAllowed: boolean | undefined;
    fee: number | undefined;
    percentDiscount: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethodPermissionType: string | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    id: number | undefined;
}

export class PayableListDto implements IPayableListDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    description: string | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    id: number | undefined;

    constructor(data?: IPayableListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.description = data["description"];
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PayableListDto {
        let result = new PayableListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPayableListDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    description: string | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    id: number | undefined;
}

export class InstallmentDto implements IInstallmentDto {
    receiptDate: moment.Moment | undefined;
    amount: number | undefined;
    id: number | undefined;

    constructor(data?: IInstallmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptDate = data["receiptDate"] ? moment(data["receiptDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InstallmentDto {
        let result = new InstallmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInstallmentDto {
    receiptDate: moment.Moment | undefined;
    amount: number | undefined;
    id: number | undefined;
}

export class TransactionRespondeDto implements ITransactionRespondeDto {
    reference: string | undefined;
    tid: string | undefined;
    nsu: string | undefined;
    amount: number | undefined;
    date: string | undefined;
    installments: number | undefined;
    cardHolderName: string | undefined;
    kind: string | undefined;
    last4: string | undefined;
    cardBin: string | undefined;
    status: string | undefined;
    cardBrand: string | undefined;
    paymentId: number | undefined;
    netAmount: number | undefined;
    fee: number | undefined;
    id: number | undefined;

    constructor(data?: ITransactionRespondeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reference = data["reference"];
            this.tid = data["tid"];
            this.nsu = data["nsu"];
            this.amount = data["amount"];
            this.date = data["date"];
            this.installments = data["installments"];
            this.cardHolderName = data["cardHolderName"];
            this.kind = data["kind"];
            this.last4 = data["last4"];
            this.cardBin = data["cardBin"];
            this.status = data["status"];
            this.cardBrand = data["cardBrand"];
            this.paymentId = data["paymentId"];
            this.netAmount = data["netAmount"];
            this.fee = data["fee"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionRespondeDto {
        let result = new TransactionRespondeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["tid"] = this.tid;
        data["nsu"] = this.nsu;
        data["amount"] = this.amount;
        data["date"] = this.date;
        data["installments"] = this.installments;
        data["cardHolderName"] = this.cardHolderName;
        data["kind"] = this.kind;
        data["last4"] = this.last4;
        data["cardBin"] = this.cardBin;
        data["status"] = this.status;
        data["cardBrand"] = this.cardBrand;
        data["paymentId"] = this.paymentId;
        data["netAmount"] = this.netAmount;
        data["fee"] = this.fee;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionRespondeDto {
    reference: string | undefined;
    tid: string | undefined;
    nsu: string | undefined;
    amount: number | undefined;
    date: string | undefined;
    installments: number | undefined;
    cardHolderName: string | undefined;
    kind: string | undefined;
    last4: string | undefined;
    cardBin: string | undefined;
    status: string | undefined;
    cardBrand: string | undefined;
    paymentId: number | undefined;
    netAmount: number | undefined;
    fee: number | undefined;
    id: number | undefined;
}

export class AddCuponsInput implements IAddCuponsInput {
    id: number | undefined;
    quantity: number | undefined;

    constructor(data?: IAddCuponsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): AddCuponsInput {
        let result = new AddCuponsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        return data; 
    }
}

export interface IAddCuponsInput {
    id: number | undefined;
    quantity: number | undefined;
}

export class ListResultDtoOfCouponResponsibleSelectListDto implements IListResultDtoOfCouponResponsibleSelectListDto {
    items: CouponResponsibleSelectListDto[] | undefined;

    constructor(data?: IListResultDtoOfCouponResponsibleSelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CouponResponsibleSelectListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCouponResponsibleSelectListDto {
        let result = new ListResultDtoOfCouponResponsibleSelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCouponResponsibleSelectListDto {
    items: CouponResponsibleSelectListDto[] | undefined;
}

export class CouponResponsibleSelectListDto implements ICouponResponsibleSelectListDto {
    name: string | undefined;
    type: CouponResponsibleSelectListDtoType | undefined;
    id: number | undefined;

    constructor(data?: ICouponResponsibleSelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponResponsibleSelectListDto {
        let result = new CouponResponsibleSelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponResponsibleSelectListDto {
    name: string | undefined;
    type: CouponResponsibleSelectListDtoType | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCredentialForView implements IPagedResultDtoOfGetCredentialForView {
    totalCount: number | undefined;
    items: GetCredentialForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCredentialForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCredentialForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCredentialForView {
        let result = new PagedResultDtoOfGetCredentialForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCredentialForView {
    totalCount: number | undefined;
    items: GetCredentialForView[] | undefined;
}

export class GetCredentialForView implements IGetCredentialForView {
    credential: CredentialDto | undefined;

    constructor(data?: IGetCredentialForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.credential = data["credential"] ? CredentialDto.fromJS(data["credential"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCredentialForView {
        let result = new GetCredentialForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["credential"] = this.credential ? this.credential.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCredentialForView {
    credential: CredentialDto | undefined;
}

export class CredentialDto implements ICredentialDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    exhibitorId: number | undefined;
    exhibitor: EnterpriseListDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    registrationId: number | undefined;
    registration: RegistrationDto | undefined;
    name: string | undefined;
    city: string | undefined;
    creationTime: moment.Moment | undefined;
    isFree: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICredentialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.exhibitorId = data["exhibitorId"];
            this.exhibitor = data["exhibitor"] ? EnterpriseListDto.fromJS(data["exhibitor"]) : <any>undefined;
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.registrationId = data["registrationId"];
            this.registration = data["registration"] ? RegistrationDto.fromJS(data["registration"]) : <any>undefined;
            this.name = data["name"];
            this.city = data["city"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CredentialDto {
        let result = new CredentialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["exhibitorId"] = this.exhibitorId;
        data["exhibitor"] = this.exhibitor ? this.exhibitor.toJSON() : <any>undefined;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["registrationId"] = this.registrationId;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["city"] = this.city;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICredentialDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    exhibitorId: number | undefined;
    exhibitor: EnterpriseListDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    registrationId: number | undefined;
    registration: RegistrationDto | undefined;
    name: string | undefined;
    city: string | undefined;
    creationTime: moment.Moment | undefined;
    isFree: boolean | undefined;
    id: number | undefined;
}

export class CreateCredentialsInput implements ICreateCredentialsInput {
    credentials: CreateOrEditCredentialDto[] | undefined;

    constructor(data?: ICreateCredentialsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["credentials"] && data["credentials"].constructor === Array) {
                this.credentials = [];
                for (let item of data["credentials"])
                    this.credentials.push(CreateOrEditCredentialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCredentialsInput {
        let result = new CreateCredentialsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.credentials && this.credentials.constructor === Array) {
            data["credentials"] = [];
            for (let item of this.credentials)
                data["credentials"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateCredentialsInput {
    credentials: CreateOrEditCredentialDto[] | undefined;
}

export class CreateOrEditCredentialDto implements ICreateOrEditCredentialDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    exhibitorId: number | undefined;
    exhibitor: EnterpriseListDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    registrationId: number | undefined;
    name: string | undefined;
    city: string | undefined;
    isFree: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditCredentialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.exhibitorId = data["exhibitorId"];
            this.exhibitor = data["exhibitor"] ? EnterpriseListDto.fromJS(data["exhibitor"]) : <any>undefined;
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.registrationId = data["registrationId"];
            this.name = data["name"];
            this.city = data["city"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCredentialDto {
        let result = new CreateOrEditCredentialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["exhibitorId"] = this.exhibitorId;
        data["exhibitor"] = this.exhibitor ? this.exhibitor.toJSON() : <any>undefined;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["registrationId"] = this.registrationId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCredentialDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    exhibitorId: number | undefined;
    exhibitor: EnterpriseListDto | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    registrationId: number | undefined;
    name: string | undefined;
    city: string | undefined;
    isFree: boolean | undefined;
    id: number | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data; 
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class StringOutput implements IStringOutput {
    output: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.output = data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data; 
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class PagedResultDtoOfGetDocumentTypeForView implements IPagedResultDtoOfGetDocumentTypeForView {
    totalCount: number | undefined;
    items: GetDocumentTypeForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDocumentTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDocumentTypeForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDocumentTypeForView {
        let result = new PagedResultDtoOfGetDocumentTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDocumentTypeForView {
    totalCount: number | undefined;
    items: GetDocumentTypeForView[] | undefined;
}

export class GetDocumentTypeForView implements IGetDocumentTypeForView {
    documentType: DocumentTypeDto | undefined;

    constructor(data?: IGetDocumentTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"] ? DocumentTypeDto.fromJS(data["documentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentTypeForView {
        let result = new GetDocumentTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDocumentTypeForView {
    documentType: DocumentTypeDto | undefined;
}

export class DocumentTypeDto implements IDocumentTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    id: number | undefined;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDocumentTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfDocumentTypeDto implements IListResultDtoOfDocumentTypeDto {
    items: DocumentTypeDto[] | undefined;

    constructor(data?: IListResultDtoOfDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DocumentTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDocumentTypeDto {
        let result = new ListResultDtoOfDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDocumentTypeDto {
    items: DocumentTypeDto[] | undefined;
}

export class GetDocumentTypeForEditOutput implements IGetDocumentTypeForEditOutput {
    documentType: CreateOrEditDocumentTypeDto | undefined;

    constructor(data?: IGetDocumentTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"] ? CreateOrEditDocumentTypeDto.fromJS(data["documentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentTypeForEditOutput {
        let result = new GetDocumentTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDocumentTypeForEditOutput {
    documentType: CreateOrEditDocumentTypeDto | undefined;
}

export class CreateOrEditDocumentTypeDto implements ICreateOrEditDocumentTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDocumentTypeDto {
        let result = new CreateOrEditDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditDocumentTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class EditionListDto implements IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition: EditionEditDto | undefined;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto | undefined;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto | undefined;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string] : any; } | undefined;
    validator: IValueValidator | undefined;
    itemSource: LocalizableComboboxItemSourceDto | undefined;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string] : any; } | undefined;
    validator: IValueValidator | undefined;
    itemSource: LocalizableComboboxItemSourceDto | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name: string | undefined;
    readonly attributes: { [key: string] : any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).name = data["name"];
            if (data["attributes"]) {
                (<any>this).attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes[key] = data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data; 
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string] : any; } | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition: EditionEditDto = new EditionEditDto();
    featureValues: NameValueDto[] = [];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class PagedResultDtoOfEnterpriseDto implements IPagedResultDtoOfEnterpriseDto {
    totalCount: number | undefined;
    items: EnterpriseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEnterpriseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EnterpriseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEnterpriseDto {
        let result = new PagedResultDtoOfEnterpriseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEnterpriseDto {
    totalCount: number | undefined;
    items: EnterpriseDto[] | undefined;
}

export class EnterpriseDto implements IEnterpriseDto {
    cnpj: string | undefined;
    companyName: string | undefined;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    category: string | undefined;
    correspondenceManager: string | undefined;
    type: EnterpriseDtoType | undefined;
    statusIntegracao: EnterpriseDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    isActive: boolean | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    addresses: EnterpriseAddressDto[] | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IEnterpriseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnpj = data["cnpj"];
            this.companyName = data["companyName"];
            this.tradingName = data["tradingName"];
            this.enterpriseEmail = data["enterpriseEmail"];
            this.category = data["category"];
            this.correspondenceManager = data["correspondenceManager"];
            this.type = data["type"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.situationId = data["situationId"];
            this.situation = data["situation"] ? SituationDto.fromJS(data["situation"]) : <any>undefined;
            this.isActive = data["isActive"];
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(EnterprisePhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(EnterpriseAddressDto.fromJS(item));
            }
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EnterpriseDto {
        let result = new EnterpriseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnpj"] = this.cnpj;
        data["companyName"] = this.companyName;
        data["tradingName"] = this.tradingName;
        data["enterpriseEmail"] = this.enterpriseEmail;
        data["category"] = this.category;
        data["correspondenceManager"] = this.correspondenceManager;
        data["type"] = this.type;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["situationId"] = this.situationId;
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEnterpriseDto {
    cnpj: string | undefined;
    companyName: string | undefined;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    category: string | undefined;
    correspondenceManager: string | undefined;
    type: EnterpriseDtoType | undefined;
    statusIntegracao: EnterpriseDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    isActive: boolean | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    addresses: EnterpriseAddressDto[] | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class SituationDto implements ISituationDto {
    description: string | undefined;
    type: SituationDtoType | undefined;
    id: number | undefined;

    constructor(data?: ISituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SituationDto {
        let result = new SituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISituationDto {
    description: string | undefined;
    type: SituationDtoType | undefined;
    id: number | undefined;
}

export class EnterpriseAddressDto implements IEnterpriseAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: EnterpriseAddressDtoType;
    id: number | undefined;

    constructor(data?: IEnterpriseAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EnterpriseAddressDto {
        let result = new EnterpriseAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEnterpriseAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: EnterpriseAddressDtoType;
    id: number | undefined;
}

export class ListResultDtoOfEnterpriseListDto implements IListResultDtoOfEnterpriseListDto {
    items: EnterpriseListDto[] | undefined;

    constructor(data?: IListResultDtoOfEnterpriseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EnterpriseListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEnterpriseListDto {
        let result = new ListResultDtoOfEnterpriseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEnterpriseListDto {
    items: EnterpriseListDto[] | undefined;
}

export class GetEnterpriseForEditOutput implements IGetEnterpriseForEditOutput {
    enterprise: UpdateEnterpriseInput | undefined;

    constructor(data?: IGetEnterpriseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.enterprise = data["enterprise"] ? UpdateEnterpriseInput.fromJS(data["enterprise"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEnterpriseForEditOutput {
        let result = new GetEnterpriseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEnterpriseForEditOutput {
    enterprise: UpdateEnterpriseInput | undefined;
}

export class UpdateEnterpriseInput implements IUpdateEnterpriseInput {
    cnpj: string | undefined;
    companyName: string;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    category: string | undefined;
    correspondenceManager: string | undefined;
    type: UpdateEnterpriseInputType;
    statusIntegracao: UpdateEnterpriseInputStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    contacts: ContactEditDto[] | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    addresses: EnterpriseAddressDto[] | undefined;
    id: number | undefined;
    displayName: string;

    constructor(data?: IUpdateEnterpriseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnpj = data["cnpj"];
            this.companyName = data["companyName"];
            this.tradingName = data["tradingName"];
            this.enterpriseEmail = data["enterpriseEmail"];
            this.category = data["category"];
            this.correspondenceManager = data["correspondenceManager"];
            this.type = data["type"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.situationId = data["situationId"];
            this.situation = data["situation"] ? SituationDto.fromJS(data["situation"]) : <any>undefined;
            if (data["contacts"] && data["contacts"].constructor === Array) {
                this.contacts = [];
                for (let item of data["contacts"])
                    this.contacts.push(ContactEditDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(EnterprisePhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(EnterpriseAddressDto.fromJS(item));
            }
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateEnterpriseInput {
        let result = new UpdateEnterpriseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnpj"] = this.cnpj;
        data["companyName"] = this.companyName;
        data["tradingName"] = this.tradingName;
        data["enterpriseEmail"] = this.enterpriseEmail;
        data["category"] = this.category;
        data["correspondenceManager"] = this.correspondenceManager;
        data["type"] = this.type;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["situationId"] = this.situationId;
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        if (this.contacts && this.contacts.constructor === Array) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateEnterpriseInput {
    cnpj: string | undefined;
    companyName: string;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    category: string | undefined;
    correspondenceManager: string | undefined;
    type: UpdateEnterpriseInputType;
    statusIntegracao: UpdateEnterpriseInputStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    contacts: ContactEditDto[] | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    addresses: EnterpriseAddressDto[] | undefined;
    id: number | undefined;
    displayName: string;
}

export class ContactEditDto implements IContactEditDto {
    jobPosition: JobPositionEditDto = new JobPositionEditDto();
    name: string;
    nickname: string | undefined;
    department: string;
    email: string;
    biennium: string | undefined;
    phones: ContactPhoneDto[] = [];
    id: number | undefined;

    constructor(data?: IContactEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.jobPosition = data["jobPosition"] ? JobPositionEditDto.fromJS(data["jobPosition"]) : new JobPositionEditDto();
            this.name = data["name"];
            this.nickname = data["nickname"];
            this.department = data["department"];
            this.email = data["email"];
            this.biennium = data["biennium"];
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(ContactPhoneDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactEditDto {
        let result = new ContactEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nickname"] = this.nickname;
        data["department"] = this.department;
        data["email"] = this.email;
        data["biennium"] = this.biennium;
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactEditDto {
    jobPosition: JobPositionEditDto;
    name: string;
    nickname: string | undefined;
    department: string;
    email: string;
    biennium: string | undefined;
    phones: ContactPhoneDto[];
    id: number | undefined;
}

export class ContactPhoneDto implements IContactPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: ContactPhoneDtoType;
    id: number | undefined;

    constructor(data?: IContactPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactPhoneDto {
        let result = new ContactPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: ContactPhoneDtoType;
    id: number | undefined;
}

export class CreateEnterpriseInput implements ICreateEnterpriseInput {
    cnpj: string | undefined;
    companyName: string;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    category: string | undefined;
    correspondenceManager: string | undefined;
    type: CreateEnterpriseInputType;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    contacts: ContactEditDto[] | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    addresses: EnterpriseAddressDto[] | undefined;
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateEnterpriseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnpj = data["cnpj"];
            this.companyName = data["companyName"];
            this.tradingName = data["tradingName"];
            this.enterpriseEmail = data["enterpriseEmail"];
            this.category = data["category"];
            this.correspondenceManager = data["correspondenceManager"];
            this.type = data["type"];
            this.situationId = data["situationId"];
            this.situation = data["situation"] ? SituationDto.fromJS(data["situation"]) : <any>undefined;
            if (data["contacts"] && data["contacts"].constructor === Array) {
                this.contacts = [];
                for (let item of data["contacts"])
                    this.contacts.push(ContactEditDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(EnterprisePhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(EnterpriseAddressDto.fromJS(item));
            }
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateEnterpriseInput {
        let result = new CreateEnterpriseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnpj"] = this.cnpj;
        data["companyName"] = this.companyName;
        data["tradingName"] = this.tradingName;
        data["enterpriseEmail"] = this.enterpriseEmail;
        data["category"] = this.category;
        data["correspondenceManager"] = this.correspondenceManager;
        data["type"] = this.type;
        data["situationId"] = this.situationId;
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        if (this.contacts && this.contacts.constructor === Array) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateEnterpriseInput {
    cnpj: string | undefined;
    companyName: string;
    tradingName: string | undefined;
    enterpriseEmail: string | undefined;
    category: string | undefined;
    correspondenceManager: string | undefined;
    type: CreateEnterpriseInputType;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    contacts: ContactEditDto[] | undefined;
    phones: EnterprisePhoneDto[] | undefined;
    addresses: EnterpriseAddressDto[] | undefined;
    parentId: number | undefined;
    displayName: string;
}

export class PagedResultDtoOfGetEvaluatorForViewDto implements IPagedResultDtoOfGetEvaluatorForViewDto {
    totalCount: number | undefined;
    items: GetEvaluatorForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEvaluatorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEvaluatorForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEvaluatorForViewDto {
        let result = new PagedResultDtoOfGetEvaluatorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEvaluatorForViewDto {
    totalCount: number | undefined;
    items: GetEvaluatorForViewDto[] | undefined;
}

export class GetEvaluatorForViewDto implements IGetEvaluatorForViewDto {
    evaluator: EvaluatorDto | undefined;
    userName: string | undefined;
    specialityDescription: string | undefined;
    institutionWorkName: string | undefined;
    eventWorkEvent: string | undefined;
    totalEvaluated: number | undefined;
    totalNotEvaluated: number | undefined;
    invitationWorkStatus: GetEvaluatorForViewDtoInvitationWorkStatus | undefined;

    constructor(data?: IGetEvaluatorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluator = data["evaluator"] ? EvaluatorDto.fromJS(data["evaluator"]) : <any>undefined;
            this.userName = data["userName"];
            this.specialityDescription = data["specialityDescription"];
            this.institutionWorkName = data["institutionWorkName"];
            this.eventWorkEvent = data["eventWorkEvent"];
            this.totalEvaluated = data["totalEvaluated"];
            this.totalNotEvaluated = data["totalNotEvaluated"];
            this.invitationWorkStatus = data["invitationWorkStatus"];
        }
    }

    static fromJS(data: any): GetEvaluatorForViewDto {
        let result = new GetEvaluatorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluator"] = this.evaluator ? this.evaluator.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["specialityDescription"] = this.specialityDescription;
        data["institutionWorkName"] = this.institutionWorkName;
        data["eventWorkEvent"] = this.eventWorkEvent;
        data["totalEvaluated"] = this.totalEvaluated;
        data["totalNotEvaluated"] = this.totalNotEvaluated;
        data["invitationWorkStatus"] = this.invitationWorkStatus;
        return data; 
    }
}

export interface IGetEvaluatorForViewDto {
    evaluator: EvaluatorDto | undefined;
    userName: string | undefined;
    specialityDescription: string | undefined;
    institutionWorkName: string | undefined;
    eventWorkEvent: string | undefined;
    totalEvaluated: number | undefined;
    totalNotEvaluated: number | undefined;
    invitationWorkStatus: GetEvaluatorForViewDtoInvitationWorkStatus | undefined;
}

export class GetEvaluatorForEditOutput implements IGetEvaluatorForEditOutput {
    evaluator: CreateOrEditEvaluatorDto | undefined;

    constructor(data?: IGetEvaluatorForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluator = data["evaluator"] ? CreateOrEditEvaluatorDto.fromJS(data["evaluator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEvaluatorForEditOutput {
        let result = new GetEvaluatorForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluator"] = this.evaluator ? this.evaluator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEvaluatorForEditOutput {
    evaluator: CreateOrEditEvaluatorDto | undefined;
}

export class CreateOrEditEvaluatorDto implements ICreateOrEditEvaluatorDto {
    userId: number | undefined;
    specialityId: number | undefined;
    institutionWorkId: number | undefined;
    eventWorkId: number | undefined;
    user: UserSelectListDto | undefined;
    institutionWork: InstitutionWorkDto | undefined;
    speciality: SpecialityDto | undefined;
    subspecialities: EvaluatorSubspecialityDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditEvaluatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.specialityId = data["specialityId"];
            this.institutionWorkId = data["institutionWorkId"];
            this.eventWorkId = data["eventWorkId"];
            this.user = data["user"] ? UserSelectListDto.fromJS(data["user"]) : <any>undefined;
            this.institutionWork = data["institutionWork"] ? InstitutionWorkDto.fromJS(data["institutionWork"]) : <any>undefined;
            this.speciality = data["speciality"] ? SpecialityDto.fromJS(data["speciality"]) : <any>undefined;
            if (data["subspecialities"] && data["subspecialities"].constructor === Array) {
                this.subspecialities = [];
                for (let item of data["subspecialities"])
                    this.subspecialities.push(EvaluatorSubspecialityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEvaluatorDto {
        let result = new CreateOrEditEvaluatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["specialityId"] = this.specialityId;
        data["institutionWorkId"] = this.institutionWorkId;
        data["eventWorkId"] = this.eventWorkId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["institutionWork"] = this.institutionWork ? this.institutionWork.toJSON() : <any>undefined;
        data["speciality"] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        if (this.subspecialities && this.subspecialities.constructor === Array) {
            data["subspecialities"] = [];
            for (let item of this.subspecialities)
                data["subspecialities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEvaluatorDto {
    userId: number | undefined;
    specialityId: number | undefined;
    institutionWorkId: number | undefined;
    eventWorkId: number | undefined;
    user: UserSelectListDto | undefined;
    institutionWork: InstitutionWorkDto | undefined;
    speciality: SpecialityDto | undefined;
    subspecialities: EvaluatorSubspecialityDto[] | undefined;
    id: number | undefined;
}

export class InstitutionWorkDto implements IInstitutionWorkDto {
    name: string | undefined;
    countryName: string | undefined;
    stateName: string | undefined;
    stateAbbreviation: string | undefined;
    city: string | undefined;
    status: InstitutionWorkDtoStatus | undefined;
    id: number | undefined;

    constructor(data?: IInstitutionWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.countryName = data["countryName"];
            this.stateName = data["stateName"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.city = data["city"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InstitutionWorkDto {
        let result = new InstitutionWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryName"] = this.countryName;
        data["stateName"] = this.stateName;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["city"] = this.city;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInstitutionWorkDto {
    name: string | undefined;
    countryName: string | undefined;
    stateName: string | undefined;
    stateAbbreviation: string | undefined;
    city: string | undefined;
    status: InstitutionWorkDtoStatus | undefined;
    id: number | undefined;
}

export class SpecialityDto implements ISpecialityDto {
    description: string | undefined;
    isActive: boolean | undefined;
    totalSubspecialities: number | undefined;
    subspecialities: SubspecialityDto[] | undefined;
    id: number | undefined;

    constructor(data?: ISpecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.totalSubspecialities = data["totalSubspecialities"];
            if (data["subspecialities"] && data["subspecialities"].constructor === Array) {
                this.subspecialities = [];
                for (let item of data["subspecialities"])
                    this.subspecialities.push(SubspecialityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SpecialityDto {
        let result = new SpecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["totalSubspecialities"] = this.totalSubspecialities;
        if (this.subspecialities && this.subspecialities.constructor === Array) {
            data["subspecialities"] = [];
            for (let item of this.subspecialities)
                data["subspecialities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ISpecialityDto {
    description: string | undefined;
    isActive: boolean | undefined;
    totalSubspecialities: number | undefined;
    subspecialities: SubspecialityDto[] | undefined;
    id: number | undefined;
}

export class EvaluatorSubspecialityDto implements IEvaluatorSubspecialityDto {
    id: number | undefined;
    evaluatorId: number | undefined;
    subspecialityId: number | undefined;
    subspeciality: SubspecialityDto | undefined;

    constructor(data?: IEvaluatorSubspecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.evaluatorId = data["evaluatorId"];
            this.subspecialityId = data["subspecialityId"];
            this.subspeciality = data["subspeciality"] ? SubspecialityDto.fromJS(data["subspeciality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EvaluatorSubspecialityDto {
        let result = new EvaluatorSubspecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["evaluatorId"] = this.evaluatorId;
        data["subspecialityId"] = this.subspecialityId;
        data["subspeciality"] = this.subspeciality ? this.subspeciality.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEvaluatorSubspecialityDto {
    id: number | undefined;
    evaluatorId: number | undefined;
    subspecialityId: number | undefined;
    subspeciality: SubspecialityDto | undefined;
}

export class SubspecialityDto implements ISubspecialityDto {
    description: string | undefined;
    isActive: boolean | undefined;
    specialityId: number | undefined;
    id: number | undefined;

    constructor(data?: ISubspecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.specialityId = data["specialityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubspecialityDto {
        let result = new SubspecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["specialityId"] = this.specialityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubspecialityDto {
    description: string | undefined;
    isActive: boolean | undefined;
    specialityId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfUserSelectListDto implements IListResultDtoOfUserSelectListDto {
    items: UserSelectListDto[] | undefined;

    constructor(data?: IListResultDtoOfUserSelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserSelectListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserSelectListDto {
        let result = new ListResultDtoOfUserSelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserSelectListDto {
    items: UserSelectListDto[] | undefined;
}

export class GetEvaluatorInput implements IGetEvaluatorInput {
    userId: number | undefined;
    eventWorkId: number | undefined;

    constructor(data?: IGetEvaluatorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.eventWorkId = data["eventWorkId"];
        }
    }

    static fromJS(data: any): GetEvaluatorInput {
        let result = new GetEvaluatorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["eventWorkId"] = this.eventWorkId;
        return data; 
    }
}

export interface IGetEvaluatorInput {
    userId: number | undefined;
    eventWorkId: number | undefined;
}

export class PagedResultDtoOfGetAllEventsOutput implements IPagedResultDtoOfGetAllEventsOutput {
    totalCount: number | undefined;
    items: GetAllEventsOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllEventsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllEventsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllEventsOutput {
        let result = new PagedResultDtoOfGetAllEventsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllEventsOutput {
    totalCount: number | undefined;
    items: GetAllEventsOutput[] | undefined;
}

export class GetAllEventsOutput implements IGetAllEventsOutput {
    event: EventDto | undefined;
    isDeletable: boolean | undefined;
    hasPendingTransfers: boolean | undefined;

    constructor(data?: IGetAllEventsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : <any>undefined;
            this.isDeletable = data["isDeletable"];
            this.hasPendingTransfers = data["hasPendingTransfers"];
        }
    }

    static fromJS(data: any): GetAllEventsOutput {
        let result = new GetAllEventsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["isDeletable"] = this.isDeletable;
        data["hasPendingTransfers"] = this.hasPendingTransfers;
        return data; 
    }
}

export interface IGetAllEventsOutput {
    event: EventDto | undefined;
    isDeletable: boolean | undefined;
    hasPendingTransfers: boolean | undefined;
}

export class EventDto implements IEventDto {
    name: string;
    shortName: string;
    description: string | undefined;
    descriptions: LanguageTextDto[] | undefined;
    note: string | undefined;
    eventImageId: string | undefined;
    programmingImageId: string | undefined;
    isPublished: boolean | undefined;
    numberOfPlaces: number | undefined;
    daysToUnsubscribe: number | undefined;
    daysToTransferARegistration: number | undefined;
    daysToTransferARegistrationForAnotherUser: number | undefined;
    cancellationAndTransferPolicyText: string | undefined;
    relatedEventId: number | undefined;
    requireRelatedEventInscription: boolean | undefined;
    displayAsFirstOnSite: boolean | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    inGoogleCalendar: boolean | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: string | undefined;
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    codigoMaterial: string | undefined;
    statusIntegracao: EventDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    eventPlaceId: number | undefined;
    place: EventPlaceDto | undefined;
    eventTypeId: number | undefined;
    type: EventTypeDto | undefined;
    contract: ContractDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    paymentMethods: EventPaymentMethodPermissionDto[] | undefined;
    registrations: RegistrationDto[] | undefined;
    id: number | undefined;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            if (data["descriptions"] && data["descriptions"].constructor === Array) {
                this.descriptions = [];
                for (let item of data["descriptions"])
                    this.descriptions.push(LanguageTextDto.fromJS(item));
            }
            this.note = data["note"];
            this.eventImageId = data["eventImageId"];
            this.programmingImageId = data["programmingImageId"];
            this.isPublished = data["isPublished"];
            this.numberOfPlaces = data["numberOfPlaces"];
            this.daysToUnsubscribe = data["daysToUnsubscribe"];
            this.daysToTransferARegistration = data["daysToTransferARegistration"];
            this.daysToTransferARegistrationForAnotherUser = data["daysToTransferARegistrationForAnotherUser"];
            this.cancellationAndTransferPolicyText = data["cancellationAndTransferPolicyText"];
            this.relatedEventId = data["relatedEventId"];
            this.requireRelatedEventInscription = data["requireRelatedEventInscription"];
            this.displayAsFirstOnSite = data["displayAsFirstOnSite"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.time = data["time"];
            this.inGoogleCalendar = data["inGoogleCalendar"];
            this.allowGoogleCalendar = data["allowGoogleCalendar"];
            this.allowYahooCalendar = data["allowYahooCalendar"];
            this.allowICalCalendar = data["allowICalCalendar"];
            this.beginInscriptionDate = data["beginInscriptionDate"] ? moment(data["beginInscriptionDate"].toString()) : <any>undefined;
            this.endInscriptionDate = data["endInscriptionDate"] ? moment(data["endInscriptionDate"].toString()) : <any>undefined;
            this.codigoMaterial = data["codigoMaterial"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.eventPlaceId = data["eventPlaceId"];
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            this.eventTypeId = data["eventTypeId"];
            this.type = data["type"] ? EventTypeDto.fromJS(data["type"]) : <any>undefined;
            this.contract = data["contract"] ? ContractDto.fromJS(data["contract"]) : <any>undefined;
            this.certificateConfig = data["certificateConfig"] ? CertificateConfigDto.fromJS(data["certificateConfig"]) : <any>undefined;
            if (data["categoryDeadlines"] && data["categoryDeadlines"].constructor === Array) {
                this.categoryDeadlines = [];
                for (let item of data["categoryDeadlines"])
                    this.categoryDeadlines.push(EventCategoryDeadlineDto.fromJS(item));
            }
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(EventPaymentMethodPermissionDto.fromJS(item));
            }
            if (data["registrations"] && data["registrations"].constructor === Array) {
                this.registrations = [];
                for (let item of data["registrations"])
                    this.registrations.push(RegistrationDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventDto {
        let result = new EventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (this.descriptions && this.descriptions.constructor === Array) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        data["note"] = this.note;
        data["eventImageId"] = this.eventImageId;
        data["programmingImageId"] = this.programmingImageId;
        data["isPublished"] = this.isPublished;
        data["numberOfPlaces"] = this.numberOfPlaces;
        data["daysToUnsubscribe"] = this.daysToUnsubscribe;
        data["daysToTransferARegistration"] = this.daysToTransferARegistration;
        data["daysToTransferARegistrationForAnotherUser"] = this.daysToTransferARegistrationForAnotherUser;
        data["cancellationAndTransferPolicyText"] = this.cancellationAndTransferPolicyText;
        data["relatedEventId"] = this.relatedEventId;
        data["requireRelatedEventInscription"] = this.requireRelatedEventInscription;
        data["displayAsFirstOnSite"] = this.displayAsFirstOnSite;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["inGoogleCalendar"] = this.inGoogleCalendar;
        data["allowGoogleCalendar"] = this.allowGoogleCalendar;
        data["allowYahooCalendar"] = this.allowYahooCalendar;
        data["allowICalCalendar"] = this.allowICalCalendar;
        data["beginInscriptionDate"] = this.beginInscriptionDate ? this.beginInscriptionDate.toISOString() : <any>undefined;
        data["endInscriptionDate"] = this.endInscriptionDate ? this.endInscriptionDate.toISOString() : <any>undefined;
        data["codigoMaterial"] = this.codigoMaterial;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["eventPlaceId"] = this.eventPlaceId;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["eventTypeId"] = this.eventTypeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["certificateConfig"] = this.certificateConfig ? this.certificateConfig.toJSON() : <any>undefined;
        if (this.categoryDeadlines && this.categoryDeadlines.constructor === Array) {
            data["categoryDeadlines"] = [];
            for (let item of this.categoryDeadlines)
                data["categoryDeadlines"].push(item.toJSON());
        }
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        if (this.registrations && this.registrations.constructor === Array) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventDto {
    name: string;
    shortName: string;
    description: string | undefined;
    descriptions: LanguageTextDto[] | undefined;
    note: string | undefined;
    eventImageId: string | undefined;
    programmingImageId: string | undefined;
    isPublished: boolean | undefined;
    numberOfPlaces: number | undefined;
    daysToUnsubscribe: number | undefined;
    daysToTransferARegistration: number | undefined;
    daysToTransferARegistrationForAnotherUser: number | undefined;
    cancellationAndTransferPolicyText: string | undefined;
    relatedEventId: number | undefined;
    requireRelatedEventInscription: boolean | undefined;
    displayAsFirstOnSite: boolean | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    inGoogleCalendar: boolean | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: string | undefined;
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    codigoMaterial: string | undefined;
    statusIntegracao: EventDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    eventPlaceId: number | undefined;
    place: EventPlaceDto | undefined;
    eventTypeId: number | undefined;
    type: EventTypeDto | undefined;
    contract: ContractDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    paymentMethods: EventPaymentMethodPermissionDto[] | undefined;
    registrations: RegistrationDto[] | undefined;
    id: number | undefined;
}

export class LanguageTextDto implements ILanguageTextDto {
    tenantId: number | undefined;
    languageName: string;
    source: string | undefined;
    key: string | undefined;
    value: string | undefined;
    id: number | undefined;

    constructor(data?: ILanguageTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.languageName = data["languageName"];
            this.source = data["source"];
            this.key = data["key"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LanguageTextDto {
        let result = new LanguageTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["languageName"] = this.languageName;
        data["source"] = this.source;
        data["key"] = this.key;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILanguageTextDto {
    tenantId: number | undefined;
    languageName: string;
    source: string | undefined;
    key: string | undefined;
    value: string | undefined;
    id: number | undefined;
}

export class EventTypeDto implements IEventTypeDto {
    description: string;
    order: number | undefined;
    id: number | undefined;

    constructor(data?: IEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventTypeDto {
        let result = new EventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventTypeDto {
    description: string;
    order: number | undefined;
    id: number | undefined;
}

export class ContractDto implements IContractDto {
    daysToUnsubscribe: number | undefined;
    daysToTransferARegistration: number | undefined;
    daysToTransferARegistrationForAnotherUser: number | undefined;
    daysToPayment: number | undefined;
    cancellationAndTransferPolicyText: string | undefined;
    cancellationAndTransferPolicyTexts: CreateOrEditLanguageTextDto[] | undefined;
    creditCardPaymentDiscountPercentage: number | undefined;
    cancellationDiscountPercentage: number | undefined;
    id: number | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.daysToUnsubscribe = data["daysToUnsubscribe"];
            this.daysToTransferARegistration = data["daysToTransferARegistration"];
            this.daysToTransferARegistrationForAnotherUser = data["daysToTransferARegistrationForAnotherUser"];
            this.daysToPayment = data["daysToPayment"];
            this.cancellationAndTransferPolicyText = data["cancellationAndTransferPolicyText"];
            if (data["cancellationAndTransferPolicyTexts"] && data["cancellationAndTransferPolicyTexts"].constructor === Array) {
                this.cancellationAndTransferPolicyTexts = [];
                for (let item of data["cancellationAndTransferPolicyTexts"])
                    this.cancellationAndTransferPolicyTexts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            this.creditCardPaymentDiscountPercentage = data["creditCardPaymentDiscountPercentage"];
            this.cancellationDiscountPercentage = data["cancellationDiscountPercentage"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContractDto {
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daysToUnsubscribe"] = this.daysToUnsubscribe;
        data["daysToTransferARegistration"] = this.daysToTransferARegistration;
        data["daysToTransferARegistrationForAnotherUser"] = this.daysToTransferARegistrationForAnotherUser;
        data["daysToPayment"] = this.daysToPayment;
        data["cancellationAndTransferPolicyText"] = this.cancellationAndTransferPolicyText;
        if (this.cancellationAndTransferPolicyTexts && this.cancellationAndTransferPolicyTexts.constructor === Array) {
            data["cancellationAndTransferPolicyTexts"] = [];
            for (let item of this.cancellationAndTransferPolicyTexts)
                data["cancellationAndTransferPolicyTexts"].push(item.toJSON());
        }
        data["creditCardPaymentDiscountPercentage"] = this.creditCardPaymentDiscountPercentage;
        data["cancellationDiscountPercentage"] = this.cancellationDiscountPercentage;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContractDto {
    daysToUnsubscribe: number | undefined;
    daysToTransferARegistration: number | undefined;
    daysToTransferARegistrationForAnotherUser: number | undefined;
    daysToPayment: number | undefined;
    cancellationAndTransferPolicyText: string | undefined;
    cancellationAndTransferPolicyTexts: CreateOrEditLanguageTextDto[] | undefined;
    creditCardPaymentDiscountPercentage: number | undefined;
    cancellationDiscountPercentage: number | undefined;
    id: number | undefined;
}

export class EventPaymentMethodPermissionDto implements IEventPaymentMethodPermissionDto {
    eventId: number | undefined;
    isAllowed: boolean | undefined;
    fee: number | undefined;
    percentDiscount: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethodPermissionType: string | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    id: number | undefined;

    constructor(data?: IEventPaymentMethodPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            this.isAllowed = data["isAllowed"];
            this.fee = data["fee"];
            this.percentDiscount = data["percentDiscount"];
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethodPermissionType = data["paymentMethodPermissionType"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventPaymentMethodPermissionDto {
        let result = new EventPaymentMethodPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["isAllowed"] = this.isAllowed;
        data["fee"] = this.fee;
        data["percentDiscount"] = this.percentDiscount;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethodPermissionType"] = this.paymentMethodPermissionType;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventPaymentMethodPermissionDto {
    eventId: number | undefined;
    isAllowed: boolean | undefined;
    fee: number | undefined;
    percentDiscount: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethodPermissionType: string | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    id: number | undefined;
}

export class EventForRegistrationPagedResultDto implements IEventForRegistrationPagedResultDto {
    eventTypes: string[] | undefined;
    totalCount: number | undefined;
    items: GetEventForRegistrationOutput[] | undefined;

    constructor(data?: IEventForRegistrationPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["eventTypes"] && data["eventTypes"].constructor === Array) {
                this.eventTypes = [];
                for (let item of data["eventTypes"])
                    this.eventTypes.push(item);
            }
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEventForRegistrationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventForRegistrationPagedResultDto {
        let result = new EventForRegistrationPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.eventTypes && this.eventTypes.constructor === Array) {
            data["eventTypes"] = [];
            for (let item of this.eventTypes)
                data["eventTypes"].push(item);
        }
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEventForRegistrationPagedResultDto {
    eventTypes: string[] | undefined;
    totalCount: number | undefined;
    items: GetEventForRegistrationOutput[] | undefined;
}

export class GetEventForRegistrationOutput implements IGetEventForRegistrationOutput {
    event: EventToSignUpDto | undefined;
    categoryDeadline: EventCategoryDeadlineDto | undefined;

    constructor(data?: IGetEventForRegistrationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.event = data["event"] ? EventToSignUpDto.fromJS(data["event"]) : <any>undefined;
            this.categoryDeadline = data["categoryDeadline"] ? EventCategoryDeadlineDto.fromJS(data["categoryDeadline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventForRegistrationOutput {
        let result = new GetEventForRegistrationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["categoryDeadline"] = this.categoryDeadline ? this.categoryDeadline.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEventForRegistrationOutput {
    event: EventToSignUpDto | undefined;
    categoryDeadline: EventCategoryDeadlineDto | undefined;
}

export class EventToSignUpDto implements IEventToSignUpDto {
    name: string | undefined;
    shortName: string | undefined;
    description: string | undefined;
    descriptions: LanguageTextDto[] | undefined;
    note: string | undefined;
    eventImageId: string | undefined;
    eventImage: string | undefined;
    programmingImageId: string | undefined;
    programmingImage: string | undefined;
    numberOfPlaces: number | undefined;
    contract: ContractDto | undefined;
    readonly numberOfPlacesAvailable: number | undefined;
    relatedEventId: number | undefined;
    relatedEvent: EventListDto | undefined;
    requireRelatedEventInscription: boolean | undefined;
    displayAsFirstOnSite: boolean | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    readonly openRegistrations: boolean | undefined;
    readonly onLocal: boolean | undefined;
    userHasApprovedRegistration: boolean | undefined;
    eventPlaceId: number | undefined;
    place: EventPlaceDto | undefined;
    eventTypeId: number | undefined;
    type: EventTypeDto | undefined;
    allCategoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    paymentMethods: EventPaymentMethodPermissionDto[] | undefined;
    registrations: EventRegistrationListDto[] | undefined;
    id: number | undefined;

    constructor(data?: IEventToSignUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            if (data["descriptions"] && data["descriptions"].constructor === Array) {
                this.descriptions = [];
                for (let item of data["descriptions"])
                    this.descriptions.push(LanguageTextDto.fromJS(item));
            }
            this.note = data["note"];
            this.eventImageId = data["eventImageId"];
            this.eventImage = data["eventImage"];
            this.programmingImageId = data["programmingImageId"];
            this.programmingImage = data["programmingImage"];
            this.numberOfPlaces = data["numberOfPlaces"];
            this.contract = data["contract"] ? ContractDto.fromJS(data["contract"]) : <any>undefined;
            (<any>this).numberOfPlacesAvailable = data["numberOfPlacesAvailable"];
            this.relatedEventId = data["relatedEventId"];
            this.relatedEvent = data["relatedEvent"] ? EventListDto.fromJS(data["relatedEvent"]) : <any>undefined;
            this.requireRelatedEventInscription = data["requireRelatedEventInscription"];
            this.displayAsFirstOnSite = data["displayAsFirstOnSite"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.time = data["time"];
            this.beginInscriptionDate = data["beginInscriptionDate"] ? moment(data["beginInscriptionDate"].toString()) : <any>undefined;
            this.endInscriptionDate = data["endInscriptionDate"] ? moment(data["endInscriptionDate"].toString()) : <any>undefined;
            (<any>this).openRegistrations = data["openRegistrations"];
            (<any>this).onLocal = data["onLocal"];
            this.userHasApprovedRegistration = data["userHasApprovedRegistration"];
            this.eventPlaceId = data["eventPlaceId"];
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            this.eventTypeId = data["eventTypeId"];
            this.type = data["type"] ? EventTypeDto.fromJS(data["type"]) : <any>undefined;
            if (data["allCategoryDeadlines"] && data["allCategoryDeadlines"].constructor === Array) {
                this.allCategoryDeadlines = [];
                for (let item of data["allCategoryDeadlines"])
                    this.allCategoryDeadlines.push(EventCategoryDeadlineDto.fromJS(item));
            }
            if (data["categoryDeadlines"] && data["categoryDeadlines"].constructor === Array) {
                this.categoryDeadlines = [];
                for (let item of data["categoryDeadlines"])
                    this.categoryDeadlines.push(EventCategoryDeadlineDto.fromJS(item));
            }
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(EventPaymentMethodPermissionDto.fromJS(item));
            }
            if (data["registrations"] && data["registrations"].constructor === Array) {
                this.registrations = [];
                for (let item of data["registrations"])
                    this.registrations.push(EventRegistrationListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventToSignUpDto {
        let result = new EventToSignUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (this.descriptions && this.descriptions.constructor === Array) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        data["note"] = this.note;
        data["eventImageId"] = this.eventImageId;
        data["eventImage"] = this.eventImage;
        data["programmingImageId"] = this.programmingImageId;
        data["programmingImage"] = this.programmingImage;
        data["numberOfPlaces"] = this.numberOfPlaces;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["numberOfPlacesAvailable"] = this.numberOfPlacesAvailable;
        data["relatedEventId"] = this.relatedEventId;
        data["relatedEvent"] = this.relatedEvent ? this.relatedEvent.toJSON() : <any>undefined;
        data["requireRelatedEventInscription"] = this.requireRelatedEventInscription;
        data["displayAsFirstOnSite"] = this.displayAsFirstOnSite;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["beginInscriptionDate"] = this.beginInscriptionDate ? this.beginInscriptionDate.toISOString() : <any>undefined;
        data["endInscriptionDate"] = this.endInscriptionDate ? this.endInscriptionDate.toISOString() : <any>undefined;
        data["openRegistrations"] = this.openRegistrations;
        data["onLocal"] = this.onLocal;
        data["userHasApprovedRegistration"] = this.userHasApprovedRegistration;
        data["eventPlaceId"] = this.eventPlaceId;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["eventTypeId"] = this.eventTypeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        if (this.allCategoryDeadlines && this.allCategoryDeadlines.constructor === Array) {
            data["allCategoryDeadlines"] = [];
            for (let item of this.allCategoryDeadlines)
                data["allCategoryDeadlines"].push(item.toJSON());
        }
        if (this.categoryDeadlines && this.categoryDeadlines.constructor === Array) {
            data["categoryDeadlines"] = [];
            for (let item of this.categoryDeadlines)
                data["categoryDeadlines"].push(item.toJSON());
        }
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        if (this.registrations && this.registrations.constructor === Array) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventToSignUpDto {
    name: string | undefined;
    shortName: string | undefined;
    description: string | undefined;
    descriptions: LanguageTextDto[] | undefined;
    note: string | undefined;
    eventImageId: string | undefined;
    eventImage: string | undefined;
    programmingImageId: string | undefined;
    programmingImage: string | undefined;
    numberOfPlaces: number | undefined;
    contract: ContractDto | undefined;
    numberOfPlacesAvailable: number | undefined;
    relatedEventId: number | undefined;
    relatedEvent: EventListDto | undefined;
    requireRelatedEventInscription: boolean | undefined;
    displayAsFirstOnSite: boolean | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    openRegistrations: boolean | undefined;
    onLocal: boolean | undefined;
    userHasApprovedRegistration: boolean | undefined;
    eventPlaceId: number | undefined;
    place: EventPlaceDto | undefined;
    eventTypeId: number | undefined;
    type: EventTypeDto | undefined;
    allCategoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    paymentMethods: EventPaymentMethodPermissionDto[] | undefined;
    registrations: EventRegistrationListDto[] | undefined;
    id: number | undefined;
}

export class EventRegistrationListDto implements IEventRegistrationListDto {
    nameForCredential: string | undefined;
    situation: EventRegistrationListDtoSituation | undefined;
    status: EventRegistrationListDtoStatus | undefined;
    id: number | undefined;

    constructor(data?: IEventRegistrationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameForCredential = data["nameForCredential"];
            this.situation = data["situation"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventRegistrationListDto {
        let result = new EventRegistrationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameForCredential"] = this.nameForCredential;
        data["situation"] = this.situation;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventRegistrationListDto {
    nameForCredential: string | undefined;
    situation: EventRegistrationListDtoSituation | undefined;
    status: EventRegistrationListDtoStatus | undefined;
    id: number | undefined;
}

export class ListResultDtoOfEventListDto implements IListResultDtoOfEventListDto {
    items: EventListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventListDto {
        let result = new ListResultDtoOfEventListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventListDto {
    items: EventListDto[] | undefined;
}

export class ListResultDtoOfEventCategoryDeadlineDto implements IListResultDtoOfEventCategoryDeadlineDto {
    items: EventCategoryDeadlineDto[] | undefined;

    constructor(data?: IListResultDtoOfEventCategoryDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventCategoryDeadlineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventCategoryDeadlineDto {
        let result = new ListResultDtoOfEventCategoryDeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventCategoryDeadlineDto {
    items: EventCategoryDeadlineDto[] | undefined;
}

export class GetEventForEditOutput implements IGetEventForEditOutput {
    event: CreateOrEditEventDto | undefined;

    constructor(data?: IGetEventForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.event = data["event"] ? CreateOrEditEventDto.fromJS(data["event"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventForEditOutput {
        let result = new GetEventForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEventForEditOutput {
    event: CreateOrEditEventDto | undefined;
}

export class CreateOrEditEventDto implements ICreateOrEditEventDto {
    name: string;
    shortName: string;
    description: string | undefined;
    descriptions: CreateOrEditLanguageTextDto[] | undefined;
    eventImageId: string | undefined;
    eventImage: string | undefined;
    eventImageInput: UpdateEventImageInput | undefined;
    programmingImageId: string | undefined;
    programmingImage: string | undefined;
    programmingImageInput: UpdateEventImageInput | undefined;
    isPublished: boolean | undefined;
    numberOfPlaces: number | undefined;
    relatedEventId: number | undefined;
    previousRelatedEventId: number | undefined;
    relatedEvent: EventListDto | undefined;
    requireRelatedEventInscription: boolean | undefined;
    displayAsFirstOnSite: boolean | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: boolean | undefined;
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    codigoMaterial: string | undefined;
    codigoGrupo: string | undefined;
    codigoSubGrupo: string | undefined;
    codigoContaFinanceira: string | undefined;
    codigoContaGerencial: string | undefined;
    statusIntegracao: CreateOrEditEventDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    eventPlaceId: number | undefined;
    place: EventPlaceDto | undefined;
    contract: ContractDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    eventTypeId: number | undefined;
    type: EventTypeDto | undefined;
    paymentMethods: EventPaymentMethodPermissionDto[] | undefined;
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    emailConfigs: EmailConfigDto[] | undefined;
    note: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            if (data["descriptions"] && data["descriptions"].constructor === Array) {
                this.descriptions = [];
                for (let item of data["descriptions"])
                    this.descriptions.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            this.eventImageId = data["eventImageId"];
            this.eventImage = data["eventImage"];
            this.eventImageInput = data["eventImageInput"] ? UpdateEventImageInput.fromJS(data["eventImageInput"]) : <any>undefined;
            this.programmingImageId = data["programmingImageId"];
            this.programmingImage = data["programmingImage"];
            this.programmingImageInput = data["programmingImageInput"] ? UpdateEventImageInput.fromJS(data["programmingImageInput"]) : <any>undefined;
            this.isPublished = data["isPublished"];
            this.numberOfPlaces = data["numberOfPlaces"];
            this.relatedEventId = data["relatedEventId"];
            this.previousRelatedEventId = data["previousRelatedEventId"];
            this.relatedEvent = data["relatedEvent"] ? EventListDto.fromJS(data["relatedEvent"]) : <any>undefined;
            this.requireRelatedEventInscription = data["requireRelatedEventInscription"];
            this.displayAsFirstOnSite = data["displayAsFirstOnSite"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.time = data["time"];
            this.allowGoogleCalendar = data["allowGoogleCalendar"];
            this.allowYahooCalendar = data["allowYahooCalendar"];
            this.allowICalCalendar = data["allowICalCalendar"];
            this.beginInscriptionDate = data["beginInscriptionDate"] ? moment(data["beginInscriptionDate"].toString()) : <any>undefined;
            this.endInscriptionDate = data["endInscriptionDate"] ? moment(data["endInscriptionDate"].toString()) : <any>undefined;
            this.codigoMaterial = data["codigoMaterial"];
            this.codigoGrupo = data["codigoGrupo"];
            this.codigoSubGrupo = data["codigoSubGrupo"];
            this.codigoContaFinanceira = data["codigoContaFinanceira"];
            this.codigoContaGerencial = data["codigoContaGerencial"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.eventPlaceId = data["eventPlaceId"];
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            this.contract = data["contract"] ? ContractDto.fromJS(data["contract"]) : <any>undefined;
            this.certificateConfig = data["certificateConfig"] ? CertificateConfigDto.fromJS(data["certificateConfig"]) : <any>undefined;
            this.eventTypeId = data["eventTypeId"];
            this.type = data["type"] ? EventTypeDto.fromJS(data["type"]) : <any>undefined;
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(EventPaymentMethodPermissionDto.fromJS(item));
            }
            if (data["categoryDeadlines"] && data["categoryDeadlines"].constructor === Array) {
                this.categoryDeadlines = [];
                for (let item of data["categoryDeadlines"])
                    this.categoryDeadlines.push(EventCategoryDeadlineDto.fromJS(item));
            }
            if (data["emailConfigs"] && data["emailConfigs"].constructor === Array) {
                this.emailConfigs = [];
                for (let item of data["emailConfigs"])
                    this.emailConfigs.push(EmailConfigDto.fromJS(item));
            }
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventDto {
        let result = new CreateOrEditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (this.descriptions && this.descriptions.constructor === Array) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        data["eventImageId"] = this.eventImageId;
        data["eventImage"] = this.eventImage;
        data["eventImageInput"] = this.eventImageInput ? this.eventImageInput.toJSON() : <any>undefined;
        data["programmingImageId"] = this.programmingImageId;
        data["programmingImage"] = this.programmingImage;
        data["programmingImageInput"] = this.programmingImageInput ? this.programmingImageInput.toJSON() : <any>undefined;
        data["isPublished"] = this.isPublished;
        data["numberOfPlaces"] = this.numberOfPlaces;
        data["relatedEventId"] = this.relatedEventId;
        data["previousRelatedEventId"] = this.previousRelatedEventId;
        data["relatedEvent"] = this.relatedEvent ? this.relatedEvent.toJSON() : <any>undefined;
        data["requireRelatedEventInscription"] = this.requireRelatedEventInscription;
        data["displayAsFirstOnSite"] = this.displayAsFirstOnSite;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["allowGoogleCalendar"] = this.allowGoogleCalendar;
        data["allowYahooCalendar"] = this.allowYahooCalendar;
        data["allowICalCalendar"] = this.allowICalCalendar;
        data["beginInscriptionDate"] = this.beginInscriptionDate ? this.beginInscriptionDate.toISOString() : <any>undefined;
        data["endInscriptionDate"] = this.endInscriptionDate ? this.endInscriptionDate.toISOString() : <any>undefined;
        data["codigoMaterial"] = this.codigoMaterial;
        data["codigoGrupo"] = this.codigoGrupo;
        data["codigoSubGrupo"] = this.codigoSubGrupo;
        data["codigoContaFinanceira"] = this.codigoContaFinanceira;
        data["codigoContaGerencial"] = this.codigoContaGerencial;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["eventPlaceId"] = this.eventPlaceId;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["certificateConfig"] = this.certificateConfig ? this.certificateConfig.toJSON() : <any>undefined;
        data["eventTypeId"] = this.eventTypeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        if (this.categoryDeadlines && this.categoryDeadlines.constructor === Array) {
            data["categoryDeadlines"] = [];
            for (let item of this.categoryDeadlines)
                data["categoryDeadlines"].push(item.toJSON());
        }
        if (this.emailConfigs && this.emailConfigs.constructor === Array) {
            data["emailConfigs"] = [];
            for (let item of this.emailConfigs)
                data["emailConfigs"].push(item.toJSON());
        }
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventDto {
    name: string;
    shortName: string;
    description: string | undefined;
    descriptions: CreateOrEditLanguageTextDto[] | undefined;
    eventImageId: string | undefined;
    eventImage: string | undefined;
    eventImageInput: UpdateEventImageInput | undefined;
    programmingImageId: string | undefined;
    programmingImage: string | undefined;
    programmingImageInput: UpdateEventImageInput | undefined;
    isPublished: boolean | undefined;
    numberOfPlaces: number | undefined;
    relatedEventId: number | undefined;
    previousRelatedEventId: number | undefined;
    relatedEvent: EventListDto | undefined;
    requireRelatedEventInscription: boolean | undefined;
    displayAsFirstOnSite: boolean | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    time: string | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: boolean | undefined;
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    codigoMaterial: string | undefined;
    codigoGrupo: string | undefined;
    codigoSubGrupo: string | undefined;
    codigoContaFinanceira: string | undefined;
    codigoContaGerencial: string | undefined;
    statusIntegracao: CreateOrEditEventDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    eventPlaceId: number | undefined;
    place: EventPlaceDto | undefined;
    contract: ContractDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    eventTypeId: number | undefined;
    type: EventTypeDto | undefined;
    paymentMethods: EventPaymentMethodPermissionDto[] | undefined;
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    emailConfigs: EmailConfigDto[] | undefined;
    note: string | undefined;
    id: number | undefined;
}

export class UpdateEventImageInput implements IUpdateEventImageInput {
    eventId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateEventImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateEventImageInput {
        let result = new UpdateEventImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateEventImageInput {
    eventId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class GetEventImageOutput implements IGetEventImageOutput {
    eventImage: string | undefined;

    constructor(data?: IGetEventImageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventImage = data["eventImage"];
        }
    }

    static fromJS(data: any): GetEventImageOutput {
        let result = new GetEventImageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventImage"] = this.eventImage;
        return data; 
    }
}

export interface IGetEventImageOutput {
    eventImage: string | undefined;
}

export class GetPendingTransfersForEditOutput implements IGetPendingTransfersForEditOutput {
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    registrationsToTransfer: RegistrationToTransferDto[] | undefined;

    constructor(data?: IGetPendingTransfersForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categoryDeadlines"] && data["categoryDeadlines"].constructor === Array) {
                this.categoryDeadlines = [];
                for (let item of data["categoryDeadlines"])
                    this.categoryDeadlines.push(EventCategoryDeadlineDto.fromJS(item));
            }
            if (data["registrationsToTransfer"] && data["registrationsToTransfer"].constructor === Array) {
                this.registrationsToTransfer = [];
                for (let item of data["registrationsToTransfer"])
                    this.registrationsToTransfer.push(RegistrationToTransferDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPendingTransfersForEditOutput {
        let result = new GetPendingTransfersForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categoryDeadlines && this.categoryDeadlines.constructor === Array) {
            data["categoryDeadlines"] = [];
            for (let item of this.categoryDeadlines)
                data["categoryDeadlines"].push(item.toJSON());
        }
        if (this.registrationsToTransfer && this.registrationsToTransfer.constructor === Array) {
            data["registrationsToTransfer"] = [];
            for (let item of this.registrationsToTransfer)
                data["registrationsToTransfer"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPendingTransfersForEditOutput {
    categoryDeadlines: EventCategoryDeadlineDto[] | undefined;
    registrationsToTransfer: RegistrationToTransferDto[] | undefined;
}

export class RegistrationToTransferDto implements IRegistrationToTransferDto {
    newCategoryDeadLineId: number | undefined;
    categoryId: number | undefined;
    hasPresence: boolean | undefined;
    situation: RegistrationToTransferDtoSituation | undefined;
    coupon: CouponDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    motiveDisapprove: string | undefined;
    newNotes: NoteEditDto[] | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: RegistrationToTransferDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: RegistrationToTransferDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IRegistrationToTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newCategoryDeadLineId = data["newCategoryDeadLineId"];
            this.categoryId = data["categoryId"];
            this.hasPresence = data["hasPresence"];
            this.situation = data["situation"];
            this.coupon = data["coupon"] ? CouponDto.fromJS(data["coupon"]) : <any>undefined;
            this.categoryDeadLineId = data["categoryDeadLineId"];
            this.categoryDeadLine = data["categoryDeadLine"] ? EventCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.motiveDisapprove = data["motiveDisapprove"];
            if (data["newNotes"] && data["newNotes"].constructor === Array) {
                this.newNotes = [];
                for (let item of data["newNotes"])
                    this.newNotes.push(NoteEditDto.fromJS(item));
            }
            this.orderId = data["orderId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationToTransferDto {
        let result = new RegistrationToTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newCategoryDeadLineId"] = this.newCategoryDeadLineId;
        data["categoryId"] = this.categoryId;
        data["hasPresence"] = this.hasPresence;
        data["situation"] = this.situation;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["motiveDisapprove"] = this.motiveDisapprove;
        if (this.newNotes && this.newNotes.constructor === Array) {
            data["newNotes"] = [];
            for (let item of this.newNotes)
                data["newNotes"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationToTransferDto {
    newCategoryDeadLineId: number | undefined;
    categoryId: number | undefined;
    hasPresence: boolean | undefined;
    situation: RegistrationToTransferDtoSituation | undefined;
    coupon: CouponDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    motiveDisapprove: string | undefined;
    newNotes: NoteEditDto[] | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: RegistrationToTransferDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: RegistrationToTransferDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class TransferRegistrationsDto implements ITransferRegistrationsDto {
    eventId: number | undefined;
    publish: boolean | undefined;
    registrationsToTransfer: RegistrationToTransferDto[] | undefined;

    constructor(data?: ITransferRegistrationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            this.publish = data["publish"];
            if (data["registrationsToTransfer"] && data["registrationsToTransfer"].constructor === Array) {
                this.registrationsToTransfer = [];
                for (let item of data["registrationsToTransfer"])
                    this.registrationsToTransfer.push(RegistrationToTransferDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferRegistrationsDto {
        let result = new TransferRegistrationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["publish"] = this.publish;
        if (this.registrationsToTransfer && this.registrationsToTransfer.constructor === Array) {
            data["registrationsToTransfer"] = [];
            for (let item of this.registrationsToTransfer)
                data["registrationsToTransfer"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransferRegistrationsDto {
    eventId: number | undefined;
    publish: boolean | undefined;
    registrationsToTransfer: RegistrationToTransferDto[] | undefined;
}

export class PublishEventInput implements IPublishEventInput {
    eventId: number | undefined;

    constructor(data?: IPublishEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
        }
    }

    static fromJS(data: any): PublishEventInput {
        let result = new PublishEventInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        return data; 
    }
}

export interface IPublishEventInput {
    eventId: number | undefined;
}

export class EventsScheduleDto implements IEventsScheduleDto {
    scheduleHtml: string | undefined;
    showToPublic: boolean | undefined;
    showToMembers: boolean | undefined;
    calendarId: string | undefined;
    calendarManagerEmail: string | undefined;
    id: number | undefined;

    constructor(data?: IEventsScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scheduleHtml = data["scheduleHtml"];
            this.showToPublic = data["showToPublic"];
            this.showToMembers = data["showToMembers"];
            this.calendarId = data["calendarId"];
            this.calendarManagerEmail = data["calendarManagerEmail"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventsScheduleDto {
        let result = new EventsScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleHtml"] = this.scheduleHtml;
        data["showToPublic"] = this.showToPublic;
        data["showToMembers"] = this.showToMembers;
        data["calendarId"] = this.calendarId;
        data["calendarManagerEmail"] = this.calendarManagerEmail;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventsScheduleDto {
    scheduleHtml: string | undefined;
    showToPublic: boolean | undefined;
    showToMembers: boolean | undefined;
    calendarId: string | undefined;
    calendarManagerEmail: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetAllEventTypesOutput implements IPagedResultDtoOfGetAllEventTypesOutput {
    totalCount: number | undefined;
    items: GetAllEventTypesOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllEventTypesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllEventTypesOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllEventTypesOutput {
        let result = new PagedResultDtoOfGetAllEventTypesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllEventTypesOutput {
    totalCount: number | undefined;
    items: GetAllEventTypesOutput[] | undefined;
}

export class GetAllEventTypesOutput implements IGetAllEventTypesOutput {
    eventType: EventTypeDto | undefined;

    constructor(data?: IGetAllEventTypesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventType = data["eventType"] ? EventTypeDto.fromJS(data["eventType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllEventTypesOutput {
        let result = new GetAllEventTypesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType ? this.eventType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAllEventTypesOutput {
    eventType: EventTypeDto | undefined;
}

export class GetEventTypeForEditOutput implements IGetEventTypeForEditOutput {
    eventType: CreateOrEditEventTypeDto | undefined;

    constructor(data?: IGetEventTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventType = data["eventType"] ? CreateOrEditEventTypeDto.fromJS(data["eventType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventTypeForEditOutput {
        let result = new GetEventTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType ? this.eventType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEventTypeForEditOutput {
    eventType: CreateOrEditEventTypeDto | undefined;
}

export class CreateOrEditEventTypeDto implements ICreateOrEditEventTypeDto {
    description: string;
    order: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventTypeDto {
        let result = new CreateOrEditEventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventTypeDto {
    description: string;
    order: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfEventTypeListDto implements IListResultDtoOfEventTypeListDto {
    items: EventTypeListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventTypeListDto {
        let result = new ListResultDtoOfEventTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventTypeListDto {
    items: EventTypeListDto[] | undefined;
}

export class EventTypeListDto implements IEventTypeListDto {
    description: string;
    id: number | undefined;

    constructor(data?: IEventTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventTypeListDto {
        let result = new EventTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventTypeListDto {
    description: string;
    id: number | undefined;
}

export class PagedResultDtoOfGetEventWorkForViewDto implements IPagedResultDtoOfGetEventWorkForViewDto {
    totalCount: number | undefined;
    items: GetEventWorkForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEventWorkForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventWorkForViewDto {
        let result = new PagedResultDtoOfGetEventWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEventWorkForViewDto {
    totalCount: number | undefined;
    items: GetEventWorkForViewDto[] | undefined;
}

export class GetEventWorkForViewDto implements IGetEventWorkForViewDto {
    eventWork: EventWorkDto | undefined;
    eventName: string | undefined;
    isOpen: boolean | undefined;

    constructor(data?: IGetEventWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventWork = data["eventWork"] ? EventWorkDto.fromJS(data["eventWork"]) : <any>undefined;
            this.eventName = data["eventName"];
            this.isOpen = data["isOpen"];
        }
    }

    static fromJS(data: any): GetEventWorkForViewDto {
        let result = new GetEventWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventWork"] = this.eventWork ? this.eventWork.toJSON() : <any>undefined;
        data["eventName"] = this.eventName;
        data["isOpen"] = this.isOpen;
        return data; 
    }
}

export interface IGetEventWorkForViewDto {
    eventWork: EventWorkDto | undefined;
    eventName: string | undefined;
    isOpen: boolean | undefined;
}

export class EventWorkDto implements IEventWorkDto {
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    commissionResponseDate: moment.Moment | undefined;
    automaticDraw: boolean | undefined;
    term: string | undefined;
    maxWorksByPresenter: number | undefined;
    eventId: number | undefined;
    modelFile: EventWorkModelFileDto | undefined;
    eventWorkEmailConfig: EventWorkEmailConfigDto | undefined;
    files: EventWorkFileDto[] | undefined;
    id: number | undefined;

    constructor(data?: IEventWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginInscriptionDate = data["beginInscriptionDate"] ? moment(data["beginInscriptionDate"].toString()) : <any>undefined;
            this.endInscriptionDate = data["endInscriptionDate"] ? moment(data["endInscriptionDate"].toString()) : <any>undefined;
            this.commissionResponseDate = data["commissionResponseDate"] ? moment(data["commissionResponseDate"].toString()) : <any>undefined;
            this.automaticDraw = data["automaticDraw"];
            this.term = data["term"];
            this.maxWorksByPresenter = data["maxWorksByPresenter"];
            this.eventId = data["eventId"];
            this.modelFile = data["modelFile"] ? EventWorkModelFileDto.fromJS(data["modelFile"]) : <any>undefined;
            this.eventWorkEmailConfig = data["eventWorkEmailConfig"] ? EventWorkEmailConfigDto.fromJS(data["eventWorkEmailConfig"]) : <any>undefined;
            if (data["files"] && data["files"].constructor === Array) {
                this.files = [];
                for (let item of data["files"])
                    this.files.push(EventWorkFileDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventWorkDto {
        let result = new EventWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginInscriptionDate"] = this.beginInscriptionDate ? this.beginInscriptionDate.toISOString() : <any>undefined;
        data["endInscriptionDate"] = this.endInscriptionDate ? this.endInscriptionDate.toISOString() : <any>undefined;
        data["commissionResponseDate"] = this.commissionResponseDate ? this.commissionResponseDate.toISOString() : <any>undefined;
        data["automaticDraw"] = this.automaticDraw;
        data["term"] = this.term;
        data["maxWorksByPresenter"] = this.maxWorksByPresenter;
        data["eventId"] = this.eventId;
        data["modelFile"] = this.modelFile ? this.modelFile.toJSON() : <any>undefined;
        data["eventWorkEmailConfig"] = this.eventWorkEmailConfig ? this.eventWorkEmailConfig.toJSON() : <any>undefined;
        if (this.files && this.files.constructor === Array) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventWorkDto {
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    commissionResponseDate: moment.Moment | undefined;
    automaticDraw: boolean | undefined;
    term: string | undefined;
    maxWorksByPresenter: number | undefined;
    eventId: number | undefined;
    modelFile: EventWorkModelFileDto | undefined;
    eventWorkEmailConfig: EventWorkEmailConfigDto | undefined;
    files: EventWorkFileDto[] | undefined;
    id: number | undefined;
}

export class EventWorkModelFileDto implements IEventWorkModelFileDto {
    documentId: string | undefined;
    fileExtension: string | undefined;
    fileName: string | undefined;
    input: UpdateModelFileInput | undefined;
    id: number | undefined;

    constructor(data?: IEventWorkModelFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentId = data["documentId"];
            this.fileExtension = data["fileExtension"];
            this.fileName = data["fileName"];
            this.input = data["input"] ? UpdateModelFileInput.fromJS(data["input"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventWorkModelFileDto {
        let result = new EventWorkModelFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fileExtension"] = this.fileExtension;
        data["fileName"] = this.fileName;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventWorkModelFileDto {
    documentId: string | undefined;
    fileExtension: string | undefined;
    fileName: string | undefined;
    input: UpdateModelFileInput | undefined;
    id: number | undefined;
}

export class EventWorkEmailConfigDto implements IEventWorkEmailConfigDto {
    copyMail: string | undefined;
    workSent: string | undefined;
    workInRevision: string | undefined;
    workApprovedEPoster: string | undefined;
    workApprovedPresenter: string | undefined;
    workDisapproved: string | undefined;
    evaluatorEmail: string | undefined;
    workSentTexts: CreateOrEditLanguageTextDto[] | undefined;
    workInRevisionTexts: CreateOrEditLanguageTextDto[] | undefined;
    workApprovedEPosterTexts: CreateOrEditLanguageTextDto[] | undefined;
    workApprovedPresenterTexts: CreateOrEditLanguageTextDto[] | undefined;
    workDisapprovedTexts: CreateOrEditLanguageTextDto[] | undefined;
    evaluatorEmailTexts: CreateOrEditLanguageTextDto[] | undefined;
    id: number | undefined;

    constructor(data?: IEventWorkEmailConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.copyMail = data["copyMail"];
            this.workSent = data["workSent"];
            this.workInRevision = data["workInRevision"];
            this.workApprovedEPoster = data["workApprovedEPoster"];
            this.workApprovedPresenter = data["workApprovedPresenter"];
            this.workDisapproved = data["workDisapproved"];
            this.evaluatorEmail = data["evaluatorEmail"];
            if (data["workSentTexts"] && data["workSentTexts"].constructor === Array) {
                this.workSentTexts = [];
                for (let item of data["workSentTexts"])
                    this.workSentTexts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            if (data["workInRevisionTexts"] && data["workInRevisionTexts"].constructor === Array) {
                this.workInRevisionTexts = [];
                for (let item of data["workInRevisionTexts"])
                    this.workInRevisionTexts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            if (data["workApprovedEPosterTexts"] && data["workApprovedEPosterTexts"].constructor === Array) {
                this.workApprovedEPosterTexts = [];
                for (let item of data["workApprovedEPosterTexts"])
                    this.workApprovedEPosterTexts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            if (data["workApprovedPresenterTexts"] && data["workApprovedPresenterTexts"].constructor === Array) {
                this.workApprovedPresenterTexts = [];
                for (let item of data["workApprovedPresenterTexts"])
                    this.workApprovedPresenterTexts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            if (data["workDisapprovedTexts"] && data["workDisapprovedTexts"].constructor === Array) {
                this.workDisapprovedTexts = [];
                for (let item of data["workDisapprovedTexts"])
                    this.workDisapprovedTexts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            if (data["evaluatorEmailTexts"] && data["evaluatorEmailTexts"].constructor === Array) {
                this.evaluatorEmailTexts = [];
                for (let item of data["evaluatorEmailTexts"])
                    this.evaluatorEmailTexts.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventWorkEmailConfigDto {
        let result = new EventWorkEmailConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copyMail"] = this.copyMail;
        data["workSent"] = this.workSent;
        data["workInRevision"] = this.workInRevision;
        data["workApprovedEPoster"] = this.workApprovedEPoster;
        data["workApprovedPresenter"] = this.workApprovedPresenter;
        data["workDisapproved"] = this.workDisapproved;
        data["evaluatorEmail"] = this.evaluatorEmail;
        if (this.workSentTexts && this.workSentTexts.constructor === Array) {
            data["workSentTexts"] = [];
            for (let item of this.workSentTexts)
                data["workSentTexts"].push(item.toJSON());
        }
        if (this.workInRevisionTexts && this.workInRevisionTexts.constructor === Array) {
            data["workInRevisionTexts"] = [];
            for (let item of this.workInRevisionTexts)
                data["workInRevisionTexts"].push(item.toJSON());
        }
        if (this.workApprovedEPosterTexts && this.workApprovedEPosterTexts.constructor === Array) {
            data["workApprovedEPosterTexts"] = [];
            for (let item of this.workApprovedEPosterTexts)
                data["workApprovedEPosterTexts"].push(item.toJSON());
        }
        if (this.workApprovedPresenterTexts && this.workApprovedPresenterTexts.constructor === Array) {
            data["workApprovedPresenterTexts"] = [];
            for (let item of this.workApprovedPresenterTexts)
                data["workApprovedPresenterTexts"].push(item.toJSON());
        }
        if (this.workDisapprovedTexts && this.workDisapprovedTexts.constructor === Array) {
            data["workDisapprovedTexts"] = [];
            for (let item of this.workDisapprovedTexts)
                data["workDisapprovedTexts"].push(item.toJSON());
        }
        if (this.evaluatorEmailTexts && this.evaluatorEmailTexts.constructor === Array) {
            data["evaluatorEmailTexts"] = [];
            for (let item of this.evaluatorEmailTexts)
                data["evaluatorEmailTexts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventWorkEmailConfigDto {
    copyMail: string | undefined;
    workSent: string | undefined;
    workInRevision: string | undefined;
    workApprovedEPoster: string | undefined;
    workApprovedPresenter: string | undefined;
    workDisapproved: string | undefined;
    evaluatorEmail: string | undefined;
    workSentTexts: CreateOrEditLanguageTextDto[] | undefined;
    workInRevisionTexts: CreateOrEditLanguageTextDto[] | undefined;
    workApprovedEPosterTexts: CreateOrEditLanguageTextDto[] | undefined;
    workApprovedPresenterTexts: CreateOrEditLanguageTextDto[] | undefined;
    workDisapprovedTexts: CreateOrEditLanguageTextDto[] | undefined;
    evaluatorEmailTexts: CreateOrEditLanguageTextDto[] | undefined;
    id: number | undefined;
}

export class EventWorkFileDto implements IEventWorkFileDto {
    description: string;
    file: string;
    eventWorkId: number | undefined;
    id: number | undefined;

    constructor(data?: IEventWorkFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.file = data["file"];
            this.eventWorkId = data["eventWorkId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventWorkFileDto {
        let result = new EventWorkFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["file"] = this.file;
        data["eventWorkId"] = this.eventWorkId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventWorkFileDto {
    description: string;
    file: string;
    eventWorkId: number | undefined;
    id: number | undefined;
}

export class UpdateModelFileInput implements IUpdateModelFileInput {
    fileId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateModelFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateModelFileInput {
        let result = new UpdateModelFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateModelFileInput {
    fileId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class CreateOrUpdateEventWorkInput implements ICreateOrUpdateEventWorkInput {
    eventWork: CreateOrEditEventWorkDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    eventName: string | undefined;

    constructor(data?: ICreateOrUpdateEventWorkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventWork = data["eventWork"] ? CreateOrEditEventWorkDto.fromJS(data["eventWork"]) : <any>undefined;
            this.certificateConfig = data["certificateConfig"] ? CertificateConfigDto.fromJS(data["certificateConfig"]) : <any>undefined;
            this.eventName = data["eventName"];
        }
    }

    static fromJS(data: any): CreateOrUpdateEventWorkInput {
        let result = new CreateOrUpdateEventWorkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventWork"] = this.eventWork ? this.eventWork.toJSON() : <any>undefined;
        data["certificateConfig"] = this.certificateConfig ? this.certificateConfig.toJSON() : <any>undefined;
        data["eventName"] = this.eventName;
        return data; 
    }
}

export interface ICreateOrUpdateEventWorkInput {
    eventWork: CreateOrEditEventWorkDto | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    eventName: string | undefined;
}

export class CreateOrEditEventWorkDto implements ICreateOrEditEventWorkDto {
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    commissionResponseDate: moment.Moment | undefined;
    automaticDraw: boolean | undefined;
    term: string | undefined;
    maxWorksByPresenter: number | undefined;
    eventId: number | undefined;
    event: EventDto | undefined;
    modelFile: EventWorkModelFileDto | undefined;
    eventWorkEmailConfig: EventWorkEmailConfigDto | undefined;
    terms: CreateOrEditLanguageTextDto[] | undefined;
    files: EventWorkFileDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditEventWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginInscriptionDate = data["beginInscriptionDate"] ? moment(data["beginInscriptionDate"].toString()) : <any>undefined;
            this.endInscriptionDate = data["endInscriptionDate"] ? moment(data["endInscriptionDate"].toString()) : <any>undefined;
            this.commissionResponseDate = data["commissionResponseDate"] ? moment(data["commissionResponseDate"].toString()) : <any>undefined;
            this.automaticDraw = data["automaticDraw"];
            this.term = data["term"];
            this.maxWorksByPresenter = data["maxWorksByPresenter"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : <any>undefined;
            this.modelFile = data["modelFile"] ? EventWorkModelFileDto.fromJS(data["modelFile"]) : <any>undefined;
            this.eventWorkEmailConfig = data["eventWorkEmailConfig"] ? EventWorkEmailConfigDto.fromJS(data["eventWorkEmailConfig"]) : <any>undefined;
            if (data["terms"] && data["terms"].constructor === Array) {
                this.terms = [];
                for (let item of data["terms"])
                    this.terms.push(CreateOrEditLanguageTextDto.fromJS(item));
            }
            if (data["files"] && data["files"].constructor === Array) {
                this.files = [];
                for (let item of data["files"])
                    this.files.push(EventWorkFileDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventWorkDto {
        let result = new CreateOrEditEventWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginInscriptionDate"] = this.beginInscriptionDate ? this.beginInscriptionDate.toISOString() : <any>undefined;
        data["endInscriptionDate"] = this.endInscriptionDate ? this.endInscriptionDate.toISOString() : <any>undefined;
        data["commissionResponseDate"] = this.commissionResponseDate ? this.commissionResponseDate.toISOString() : <any>undefined;
        data["automaticDraw"] = this.automaticDraw;
        data["term"] = this.term;
        data["maxWorksByPresenter"] = this.maxWorksByPresenter;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["modelFile"] = this.modelFile ? this.modelFile.toJSON() : <any>undefined;
        data["eventWorkEmailConfig"] = this.eventWorkEmailConfig ? this.eventWorkEmailConfig.toJSON() : <any>undefined;
        if (this.terms && this.terms.constructor === Array) {
            data["terms"] = [];
            for (let item of this.terms)
                data["terms"].push(item.toJSON());
        }
        if (this.files && this.files.constructor === Array) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventWorkDto {
    beginInscriptionDate: moment.Moment | undefined;
    endInscriptionDate: moment.Moment | undefined;
    commissionResponseDate: moment.Moment | undefined;
    automaticDraw: boolean | undefined;
    term: string | undefined;
    maxWorksByPresenter: number | undefined;
    eventId: number | undefined;
    event: EventDto | undefined;
    modelFile: EventWorkModelFileDto | undefined;
    eventWorkEmailConfig: EventWorkEmailConfigDto | undefined;
    terms: CreateOrEditLanguageTextDto[] | undefined;
    files: EventWorkFileDto[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfEventWorkListDto implements IListResultDtoOfEventWorkListDto {
    items: EventWorkListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventWorkListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventWorkListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventWorkListDto {
        let result = new ListResultDtoOfEventWorkListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventWorkListDto {
    items: EventWorkListDto[] | undefined;
}

export class EventWorkListDto implements IEventWorkListDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IEventWorkListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): EventWorkListDto {
        let result = new EventWorkListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IEventWorkListDto {
    id: number | undefined;
    name: string | undefined;
}

export class PagedResultDtoOfGetFinancialSettingsForViewDto implements IPagedResultDtoOfGetFinancialSettingsForViewDto {
    totalCount: number | undefined;
    items: GetFinancialSettingsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFinancialSettingsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetFinancialSettingsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFinancialSettingsForViewDto {
        let result = new PagedResultDtoOfGetFinancialSettingsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFinancialSettingsForViewDto {
    totalCount: number | undefined;
    items: GetFinancialSettingsForViewDto[] | undefined;
}

export class GetFinancialSettingsForViewDto implements IGetFinancialSettingsForViewDto {
    financialSettings: FinancialSettingsDto | undefined;

    constructor(data?: IGetFinancialSettingsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.financialSettings = data["financialSettings"] ? FinancialSettingsDto.fromJS(data["financialSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFinancialSettingsForViewDto {
        let result = new GetFinancialSettingsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialSettings"] = this.financialSettings ? this.financialSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFinancialSettingsForViewDto {
    financialSettings: FinancialSettingsDto | undefined;
}

export class FinancialSettingsDto implements IFinancialSettingsDto {
    description: string | undefined;
    ticketEmailConfigs: TicketEmailConfigDto[] | undefined;
    id: number | undefined;

    constructor(data?: IFinancialSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            if (data["ticketEmailConfigs"] && data["ticketEmailConfigs"].constructor === Array) {
                this.ticketEmailConfigs = [];
                for (let item of data["ticketEmailConfigs"])
                    this.ticketEmailConfigs.push(TicketEmailConfigDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FinancialSettingsDto {
        let result = new FinancialSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (this.ticketEmailConfigs && this.ticketEmailConfigs.constructor === Array) {
            data["ticketEmailConfigs"] = [];
            for (let item of this.ticketEmailConfigs)
                data["ticketEmailConfigs"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IFinancialSettingsDto {
    description: string | undefined;
    ticketEmailConfigs: TicketEmailConfigDto[] | undefined;
    id: number | undefined;
}

export class TicketEmailConfigDto implements ITicketEmailConfigDto {
    readonly paymentChargeType: string | undefined;
    text: string | undefined;
    id: number | undefined;

    constructor(data?: ITicketEmailConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).paymentChargeType = data["paymentChargeType"];
            this.text = data["text"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TicketEmailConfigDto {
        let result = new TicketEmailConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentChargeType"] = this.paymentChargeType;
        data["text"] = this.text;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITicketEmailConfigDto {
    paymentChargeType: string | undefined;
    text: string | undefined;
    id: number | undefined;
}

export class GetFinancialSettingsForEditOutput implements IGetFinancialSettingsForEditOutput {
    financialSettings: CreateOrEditFinancialSettingsDto | undefined;

    constructor(data?: IGetFinancialSettingsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.financialSettings = data["financialSettings"] ? CreateOrEditFinancialSettingsDto.fromJS(data["financialSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFinancialSettingsForEditOutput {
        let result = new GetFinancialSettingsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialSettings"] = this.financialSettings ? this.financialSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFinancialSettingsForEditOutput {
    financialSettings: CreateOrEditFinancialSettingsDto | undefined;
}

export class CreateOrEditFinancialSettingsDto implements ICreateOrEditFinancialSettingsDto {
    description: string | undefined;
    ticketEmailConfigs: CreateOrEditTicketEmailConfigDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditFinancialSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            if (data["ticketEmailConfigs"] && data["ticketEmailConfigs"].constructor === Array) {
                this.ticketEmailConfigs = [];
                for (let item of data["ticketEmailConfigs"])
                    this.ticketEmailConfigs.push(CreateOrEditTicketEmailConfigDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFinancialSettingsDto {
        let result = new CreateOrEditFinancialSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (this.ticketEmailConfigs && this.ticketEmailConfigs.constructor === Array) {
            data["ticketEmailConfigs"] = [];
            for (let item of this.ticketEmailConfigs)
                data["ticketEmailConfigs"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFinancialSettingsDto {
    description: string | undefined;
    ticketEmailConfigs: CreateOrEditTicketEmailConfigDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditTicketEmailConfigDto implements ICreateOrEditTicketEmailConfigDto {
    readonly paymentChargeType: string | undefined;
    text: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditTicketEmailConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).paymentChargeType = data["paymentChargeType"];
            this.text = data["text"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTicketEmailConfigDto {
        let result = new CreateOrEditTicketEmailConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentChargeType"] = this.paymentChargeType;
        data["text"] = this.text;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTicketEmailConfigDto {
    paymentChargeType: string | undefined;
    text: string | undefined;
    id: number | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId: number | undefined;
    tenantId: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId: number | undefined;
    tenantId: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IBlockUserInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId: number | undefined;
    tenantId: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IUnblockUserInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId: number | undefined;
    tenantId: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class PagedResultDtoOfGetGuestForViewDto implements IPagedResultDtoOfGetGuestForViewDto {
    totalCount: number | undefined;
    items: GetGuestForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGuestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGuestForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGuestForViewDto {
        let result = new PagedResultDtoOfGetGuestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetGuestForViewDto {
    totalCount: number | undefined;
    items: GetGuestForViewDto[] | undefined;
}

export class GetGuestForViewDto implements IGetGuestForViewDto {
    guest: GuestDto | undefined;
    numberOfParticipatons: number | undefined;
    userImage: string | undefined;
    invitationStatus: GetGuestForViewDtoInvitationStatus | undefined;
    hasRegistration: boolean | undefined;

    constructor(data?: IGetGuestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guest = data["guest"] ? GuestDto.fromJS(data["guest"]) : <any>undefined;
            this.numberOfParticipatons = data["numberOfParticipatons"];
            this.userImage = data["userImage"];
            this.invitationStatus = data["invitationStatus"];
            this.hasRegistration = data["hasRegistration"];
        }
    }

    static fromJS(data: any): GetGuestForViewDto {
        let result = new GetGuestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["numberOfParticipatons"] = this.numberOfParticipatons;
        data["userImage"] = this.userImage;
        data["invitationStatus"] = this.invitationStatus;
        data["hasRegistration"] = this.hasRegistration;
        return data; 
    }
}

export interface IGetGuestForViewDto {
    guest: GuestDto | undefined;
    numberOfParticipatons: number | undefined;
    userImage: string | undefined;
    invitationStatus: GetGuestForViewDtoInvitationStatus | undefined;
    hasRegistration: boolean | undefined;
}

export class GetGuestForEditOutput implements IGetGuestForEditOutput {
    guest: CreateOrEditGuestDto | undefined;
    userImage: string | undefined;

    constructor(data?: IGetGuestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guest = data["guest"] ? CreateOrEditGuestDto.fromJS(data["guest"]) : <any>undefined;
            this.userImage = data["userImage"];
        }
    }

    static fromJS(data: any): GetGuestForEditOutput {
        let result = new GetGuestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["userImage"] = this.userImage;
        return data; 
    }
}

export interface IGetGuestForEditOutput {
    guest: CreateOrEditGuestDto | undefined;
    userImage: string | undefined;
}

export class GuestScheduleDto implements IGuestScheduleDto {
    guest: GuestListDto | undefined;
    calendarActivities: GetCalendarActivityForViewDto[] | undefined;

    constructor(data?: IGuestScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guest = data["guest"] ? GuestListDto.fromJS(data["guest"]) : <any>undefined;
            if (data["calendarActivities"] && data["calendarActivities"].constructor === Array) {
                this.calendarActivities = [];
                for (let item of data["calendarActivities"])
                    this.calendarActivities.push(GetCalendarActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuestScheduleDto {
        let result = new GuestScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        if (this.calendarActivities && this.calendarActivities.constructor === Array) {
            data["calendarActivities"] = [];
            for (let item of this.calendarActivities)
                data["calendarActivities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGuestScheduleDto {
    guest: GuestListDto | undefined;
    calendarActivities: GetCalendarActivityForViewDto[] | undefined;
}

export class HostDashboardData implements IHostDashboardData {
    newTenantsCount: number | undefined;
    newSubscriptionAmount: number | undefined;
    dashboardPlaceholder1: number | undefined;
    dashboardPlaceholder2: number | undefined;
    incomeStatistics: IncomeStastistic[] | undefined;
    editionStatistics: TenantEdition[] | undefined;
    expiringTenants: ExpiringTenant[] | undefined;
    recentTenants: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount: number | undefined;
    maxRecentTenantsShownCount: number | undefined;
    subscriptionEndAlertDayCount: number | undefined;
    recentTenantsDayCount: number | undefined;
    subscriptionEndDateStart: moment.Moment | undefined;
    subscriptionEndDateEnd: moment.Moment | undefined;
    tenantCreationStartDate: moment.Moment | undefined;

    constructor(data?: IHostDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
            if (data["expiringTenants"] && data["expiringTenants"].constructor === Array) {
                this.expiringTenants = [];
                for (let item of data["expiringTenants"])
                    this.expiringTenants.push(ExpiringTenant.fromJS(item));
            }
            if (data["recentTenants"] && data["recentTenants"].constructor === Array) {
                this.recentTenants = [];
                for (let item of data["recentTenants"])
                    this.recentTenants.push(RecentTenant.fromJS(item));
            }
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : <any>undefined;
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HostDashboardData {
        let result = new HostDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        if (this.expiringTenants && this.expiringTenants.constructor === Array) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        if (this.recentTenants && this.recentTenants.constructor === Array) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHostDashboardData {
    newTenantsCount: number | undefined;
    newSubscriptionAmount: number | undefined;
    dashboardPlaceholder1: number | undefined;
    dashboardPlaceholder2: number | undefined;
    incomeStatistics: IncomeStastistic[] | undefined;
    editionStatistics: TenantEdition[] | undefined;
    expiringTenants: ExpiringTenant[] | undefined;
    recentTenants: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount: number | undefined;
    maxRecentTenantsShownCount: number | undefined;
    subscriptionEndAlertDayCount: number | undefined;
    recentTenantsDayCount: number | undefined;
    subscriptionEndDateStart: moment.Moment | undefined;
    subscriptionEndDateEnd: moment.Moment | undefined;
    tenantCreationStartDate: moment.Moment | undefined;
}

export class IncomeStastistic implements IIncomeStastistic {
    label: string | undefined;
    date: moment.Moment | undefined;
    amount: number | undefined;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: moment.Moment | undefined;
    amount: number | undefined;
}

export class TenantEdition implements ITenantEdition {
    label: string | undefined;
    value: number | undefined;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number | undefined;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number | undefined;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data; 
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number | undefined;
}

export class RecentTenant implements IRecentTenant {
    id: number | undefined;
    name: string | undefined;
    creationTime: moment.Moment | undefined;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRecentTenant {
    id: number | undefined;
    name: string | undefined;
    creationTime: moment.Moment | undefined;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class MemberDashboardData implements IMemberDashboardData {
    receivables: ReceivableListDto[] | undefined;
    certificates: GetCertificateInput[] | undefined;
    pendingDocumentation: boolean | undefined;
    currentAnnuityPaid: boolean | undefined;
    nextEvents: EventToSignUpDto[] | undefined;
    pendinInvitations: InvitationDto[] | undefined;
    pendinInvitationWork: InvitationWorkDto | undefined;
    maxRecentEventsShownCount: number | undefined;

    constructor(data?: IMemberDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["receivables"] && data["receivables"].constructor === Array) {
                this.receivables = [];
                for (let item of data["receivables"])
                    this.receivables.push(ReceivableListDto.fromJS(item));
            }
            if (data["certificates"] && data["certificates"].constructor === Array) {
                this.certificates = [];
                for (let item of data["certificates"])
                    this.certificates.push(GetCertificateInput.fromJS(item));
            }
            this.pendingDocumentation = data["pendingDocumentation"];
            this.currentAnnuityPaid = data["currentAnnuityPaid"];
            if (data["nextEvents"] && data["nextEvents"].constructor === Array) {
                this.nextEvents = [];
                for (let item of data["nextEvents"])
                    this.nextEvents.push(EventToSignUpDto.fromJS(item));
            }
            if (data["pendinInvitations"] && data["pendinInvitations"].constructor === Array) {
                this.pendinInvitations = [];
                for (let item of data["pendinInvitations"])
                    this.pendinInvitations.push(InvitationDto.fromJS(item));
            }
            this.pendinInvitationWork = data["pendinInvitationWork"] ? InvitationWorkDto.fromJS(data["pendinInvitationWork"]) : <any>undefined;
            this.maxRecentEventsShownCount = data["maxRecentEventsShownCount"];
        }
    }

    static fromJS(data: any): MemberDashboardData {
        let result = new MemberDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.receivables && this.receivables.constructor === Array) {
            data["receivables"] = [];
            for (let item of this.receivables)
                data["receivables"].push(item.toJSON());
        }
        if (this.certificates && this.certificates.constructor === Array) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        data["pendingDocumentation"] = this.pendingDocumentation;
        data["currentAnnuityPaid"] = this.currentAnnuityPaid;
        if (this.nextEvents && this.nextEvents.constructor === Array) {
            data["nextEvents"] = [];
            for (let item of this.nextEvents)
                data["nextEvents"].push(item.toJSON());
        }
        if (this.pendinInvitations && this.pendinInvitations.constructor === Array) {
            data["pendinInvitations"] = [];
            for (let item of this.pendinInvitations)
                data["pendinInvitations"].push(item.toJSON());
        }
        data["pendinInvitationWork"] = this.pendinInvitationWork ? this.pendinInvitationWork.toJSON() : <any>undefined;
        data["maxRecentEventsShownCount"] = this.maxRecentEventsShownCount;
        return data; 
    }
}

export interface IMemberDashboardData {
    receivables: ReceivableListDto[] | undefined;
    certificates: GetCertificateInput[] | undefined;
    pendingDocumentation: boolean | undefined;
    currentAnnuityPaid: boolean | undefined;
    nextEvents: EventToSignUpDto[] | undefined;
    pendinInvitations: InvitationDto[] | undefined;
    pendinInvitationWork: InvitationWorkDto | undefined;
    maxRecentEventsShownCount: number | undefined;
}

export class ReceivableListDto implements IReceivableListDto {
    userId: number | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: ReceivableListDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IReceivableListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReceivableListDto {
        let result = new ReceivableListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReceivableListDto {
    userId: number | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: ReceivableListDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetCertificateInput implements IGetCertificateInput {
    event: string | undefined;
    registrationId: number | undefined;
    isCNA: boolean | undefined;
    activityId: number | undefined;
    module: string | undefined;
    topic: string | undefined;
    role: string | undefined;
    type: GetCertificateInputType | undefined;
    surveyId: number | undefined;
    answeredSurvey: boolean | undefined;
    workId: number | undefined;

    constructor(data?: IGetCertificateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.event = data["event"];
            this.registrationId = data["registrationId"];
            this.isCNA = data["isCNA"];
            this.activityId = data["activityId"];
            this.module = data["module"];
            this.topic = data["topic"];
            this.role = data["role"];
            this.type = data["type"];
            this.surveyId = data["surveyId"];
            this.answeredSurvey = data["answeredSurvey"];
            this.workId = data["workId"];
        }
    }

    static fromJS(data: any): GetCertificateInput {
        let result = new GetCertificateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["registrationId"] = this.registrationId;
        data["isCNA"] = this.isCNA;
        data["activityId"] = this.activityId;
        data["module"] = this.module;
        data["topic"] = this.topic;
        data["role"] = this.role;
        data["type"] = this.type;
        data["surveyId"] = this.surveyId;
        data["answeredSurvey"] = this.answeredSurvey;
        data["workId"] = this.workId;
        return data; 
    }
}

export interface IGetCertificateInput {
    event: string | undefined;
    registrationId: number | undefined;
    isCNA: boolean | undefined;
    activityId: number | undefined;
    module: string | undefined;
    topic: string | undefined;
    role: string | undefined;
    type: GetCertificateInputType | undefined;
    surveyId: number | undefined;
    answeredSurvey: boolean | undefined;
    workId: number | undefined;
}

export class InvitationDto implements IInvitationDto {
    guestId: number | undefined;
    guest: GuestDto | undefined;
    subject: string | undefined;
    message: string | undefined;
    email: string | undefined;
    sendDate: moment.Moment | undefined;
    responseDeadline: moment.Moment | undefined;
    status: InvitationDtoStatus | undefined;
    config: InvitationConfigDto | undefined;
    responseId: number | undefined;
    response: InvitationResponseListDto | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.guest = data["guest"] ? GuestDto.fromJS(data["guest"]) : <any>undefined;
            this.subject = data["subject"];
            this.message = data["message"];
            this.email = data["email"];
            this.sendDate = data["sendDate"] ? moment(data["sendDate"].toString()) : <any>undefined;
            this.responseDeadline = data["responseDeadline"] ? moment(data["responseDeadline"].toString()) : <any>undefined;
            this.status = data["status"];
            this.config = data["config"] ? InvitationConfigDto.fromJS(data["config"]) : <any>undefined;
            this.responseId = data["responseId"];
            this.response = data["response"] ? InvitationResponseListDto.fromJS(data["response"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InvitationDto {
        let result = new InvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["email"] = this.email;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["responseDeadline"] = this.responseDeadline ? this.responseDeadline.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        data["responseId"] = this.responseId;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInvitationDto {
    guestId: number | undefined;
    guest: GuestDto | undefined;
    subject: string | undefined;
    message: string | undefined;
    email: string | undefined;
    sendDate: moment.Moment | undefined;
    responseDeadline: moment.Moment | undefined;
    status: InvitationDtoStatus | undefined;
    config: InvitationConfigDto | undefined;
    responseId: number | undefined;
    response: InvitationResponseListDto | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class InvitationWorkDto implements IInvitationWorkDto {
    status: InvitationWorkDtoStatus | undefined;
    subject: string | undefined;
    email: string | undefined;
    sendDate: moment.Moment | undefined;
    evaluatorId: number | undefined;
    responseId: number | undefined;
    response: InvitationWorkResponseDto | undefined;
    id: number | undefined;

    constructor(data?: IInvitationWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.subject = data["subject"];
            this.email = data["email"];
            this.sendDate = data["sendDate"] ? moment(data["sendDate"].toString()) : <any>undefined;
            this.evaluatorId = data["evaluatorId"];
            this.responseId = data["responseId"];
            this.response = data["response"] ? InvitationWorkResponseDto.fromJS(data["response"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InvitationWorkDto {
        let result = new InvitationWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["subject"] = this.subject;
        data["email"] = this.email;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["evaluatorId"] = this.evaluatorId;
        data["responseId"] = this.responseId;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInvitationWorkDto {
    status: InvitationWorkDtoStatus | undefined;
    subject: string | undefined;
    email: string | undefined;
    sendDate: moment.Moment | undefined;
    evaluatorId: number | undefined;
    responseId: number | undefined;
    response: InvitationWorkResponseDto | undefined;
    id: number | undefined;
}

export class InvitationConfigDto implements IInvitationConfigDto {
    tenantId: number | undefined;
    templateImageId: string | undefined;
    templateExtension: string | undefined;
    guideImageId: string | undefined;
    guideExtension: string | undefined;
    programmingId: number | undefined;
    message: string | undefined;
    copyrightTerm: string | undefined;
    deadlineToConfirmParticipation: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IInvitationConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.templateImageId = data["templateImageId"];
            this.templateExtension = data["templateExtension"];
            this.guideImageId = data["guideImageId"];
            this.guideExtension = data["guideExtension"];
            this.programmingId = data["programmingId"];
            this.message = data["message"];
            this.copyrightTerm = data["copyrightTerm"];
            this.deadlineToConfirmParticipation = data["deadlineToConfirmParticipation"] ? moment(data["deadlineToConfirmParticipation"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InvitationConfigDto {
        let result = new InvitationConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["templateImageId"] = this.templateImageId;
        data["templateExtension"] = this.templateExtension;
        data["guideImageId"] = this.guideImageId;
        data["guideExtension"] = this.guideExtension;
        data["programmingId"] = this.programmingId;
        data["message"] = this.message;
        data["copyrightTerm"] = this.copyrightTerm;
        data["deadlineToConfirmParticipation"] = this.deadlineToConfirmParticipation ? this.deadlineToConfirmParticipation.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInvitationConfigDto {
    tenantId: number | undefined;
    templateImageId: string | undefined;
    templateExtension: string | undefined;
    guideImageId: string | undefined;
    guideExtension: string | undefined;
    programmingId: number | undefined;
    message: string | undefined;
    copyrightTerm: string | undefined;
    deadlineToConfirmParticipation: moment.Moment | undefined;
    id: number | undefined;
}

export class InvitationWorkResponseDto implements IInvitationWorkResponseDto {
    disapprovalReason: string | undefined;
    approved: InvitationWorkResponseDtoApproved | undefined;
    invitationWorkId: number | undefined;
    id: number | undefined;

    constructor(data?: IInvitationWorkResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disapprovalReason = data["disapprovalReason"];
            this.approved = data["approved"];
            this.invitationWorkId = data["invitationWorkId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InvitationWorkResponseDto {
        let result = new InvitationWorkResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disapprovalReason"] = this.disapprovalReason;
        data["approved"] = this.approved;
        data["invitationWorkId"] = this.invitationWorkId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInvitationWorkResponseDto {
    disapprovalReason: string | undefined;
    approved: InvitationWorkResponseDtoApproved | undefined;
    invitationWorkId: number | undefined;
    id: number | undefined;
}

export class EventDashboardData implements IEventDashboardData {
    registrationsTotalCount: number | undefined;
    paidRegistrationsCount: number | undefined;
    registrationCountwaitingForApproval: number | undefined;
    usedCounponsCount: number | undefined;
    notUsedCounponsCount: number | undefined;
    maxRecentEventsShownCount: number | undefined;
    registrationsByCategory: RegistrationCategoryDto[] | undefined;
    nextEvents: EventToSignUpDto[] | undefined;

    constructor(data?: IEventDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrationsTotalCount = data["registrationsTotalCount"];
            this.paidRegistrationsCount = data["paidRegistrationsCount"];
            this.registrationCountwaitingForApproval = data["registrationCountwaitingForApproval"];
            this.usedCounponsCount = data["usedCounponsCount"];
            this.notUsedCounponsCount = data["notUsedCounponsCount"];
            this.maxRecentEventsShownCount = data["maxRecentEventsShownCount"];
            if (data["registrationsByCategory"] && data["registrationsByCategory"].constructor === Array) {
                this.registrationsByCategory = [];
                for (let item of data["registrationsByCategory"])
                    this.registrationsByCategory.push(RegistrationCategoryDto.fromJS(item));
            }
            if (data["nextEvents"] && data["nextEvents"].constructor === Array) {
                this.nextEvents = [];
                for (let item of data["nextEvents"])
                    this.nextEvents.push(EventToSignUpDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventDashboardData {
        let result = new EventDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationsTotalCount"] = this.registrationsTotalCount;
        data["paidRegistrationsCount"] = this.paidRegistrationsCount;
        data["registrationCountwaitingForApproval"] = this.registrationCountwaitingForApproval;
        data["usedCounponsCount"] = this.usedCounponsCount;
        data["notUsedCounponsCount"] = this.notUsedCounponsCount;
        data["maxRecentEventsShownCount"] = this.maxRecentEventsShownCount;
        if (this.registrationsByCategory && this.registrationsByCategory.constructor === Array) {
            data["registrationsByCategory"] = [];
            for (let item of this.registrationsByCategory)
                data["registrationsByCategory"].push(item.toJSON());
        }
        if (this.nextEvents && this.nextEvents.constructor === Array) {
            data["nextEvents"] = [];
            for (let item of this.nextEvents)
                data["nextEvents"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEventDashboardData {
    registrationsTotalCount: number | undefined;
    paidRegistrationsCount: number | undefined;
    registrationCountwaitingForApproval: number | undefined;
    usedCounponsCount: number | undefined;
    notUsedCounponsCount: number | undefined;
    maxRecentEventsShownCount: number | undefined;
    registrationsByCategory: RegistrationCategoryDto[] | undefined;
    nextEvents: EventToSignUpDto[] | undefined;
}

export class RegistrationCategoryDto implements IRegistrationCategoryDto {
    category: string | undefined;
    registrationsCount: number | undefined;

    constructor(data?: IRegistrationCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.registrationsCount = data["registrationsCount"];
        }
    }

    static fromJS(data: any): RegistrationCategoryDto {
        let result = new RegistrationCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["registrationsCount"] = this.registrationsCount;
        return data; 
    }
}

export interface IRegistrationCategoryDto {
    category: string | undefined;
    registrationsCount: number | undefined;
}

export class CientificDashboardData implements ICientificDashboardData {
    activitiesTotalCount: number | undefined;
    calendarActivitiesTotalCount: number | undefined;
    guestsTotalCount: number | undefined;
    invitationsTotalCount: number | undefined;
    invitationsByStatus: InvitationStatusDto[] | undefined;
    guests: GuestListDto[] | undefined;
    newGuestsDayCount: number | undefined;
    newGuests: GuestListDto[] | undefined;

    constructor(data?: ICientificDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activitiesTotalCount = data["activitiesTotalCount"];
            this.calendarActivitiesTotalCount = data["calendarActivitiesTotalCount"];
            this.guestsTotalCount = data["guestsTotalCount"];
            this.invitationsTotalCount = data["invitationsTotalCount"];
            if (data["invitationsByStatus"] && data["invitationsByStatus"].constructor === Array) {
                this.invitationsByStatus = [];
                for (let item of data["invitationsByStatus"])
                    this.invitationsByStatus.push(InvitationStatusDto.fromJS(item));
            }
            if (data["guests"] && data["guests"].constructor === Array) {
                this.guests = [];
                for (let item of data["guests"])
                    this.guests.push(GuestListDto.fromJS(item));
            }
            this.newGuestsDayCount = data["newGuestsDayCount"];
            if (data["newGuests"] && data["newGuests"].constructor === Array) {
                this.newGuests = [];
                for (let item of data["newGuests"])
                    this.newGuests.push(GuestListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CientificDashboardData {
        let result = new CientificDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activitiesTotalCount"] = this.activitiesTotalCount;
        data["calendarActivitiesTotalCount"] = this.calendarActivitiesTotalCount;
        data["guestsTotalCount"] = this.guestsTotalCount;
        data["invitationsTotalCount"] = this.invitationsTotalCount;
        if (this.invitationsByStatus && this.invitationsByStatus.constructor === Array) {
            data["invitationsByStatus"] = [];
            for (let item of this.invitationsByStatus)
                data["invitationsByStatus"].push(item.toJSON());
        }
        if (this.guests && this.guests.constructor === Array) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item.toJSON());
        }
        data["newGuestsDayCount"] = this.newGuestsDayCount;
        if (this.newGuests && this.newGuests.constructor === Array) {
            data["newGuests"] = [];
            for (let item of this.newGuests)
                data["newGuests"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICientificDashboardData {
    activitiesTotalCount: number | undefined;
    calendarActivitiesTotalCount: number | undefined;
    guestsTotalCount: number | undefined;
    invitationsTotalCount: number | undefined;
    invitationsByStatus: InvitationStatusDto[] | undefined;
    guests: GuestListDto[] | undefined;
    newGuestsDayCount: number | undefined;
    newGuests: GuestListDto[] | undefined;
}

export class InvitationStatusDto implements IInvitationStatusDto {
    status: string | undefined;
    invitationCount: number | undefined;

    constructor(data?: IInvitationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.invitationCount = data["invitationCount"];
        }
    }

    static fromJS(data: any): InvitationStatusDto {
        let result = new InvitationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["invitationCount"] = this.invitationCount;
        return data; 
    }
}

export interface IInvitationStatusDto {
    status: string | undefined;
    invitationCount: number | undefined;
}

export class AnnuityDashboardData implements IAnnuityDashboardData {
    paidMemberAnnuitiesCount: number | undefined;
    unpaidMemberAnnuitiesCount: number | undefined;
    readmissionCount: number | undefined;
    pendingDocAnnuities: MemberAnnuityDto[] | undefined;
    annuitiesByCategory: AnnuityCategoryDto[] | undefined;

    constructor(data?: IAnnuityDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paidMemberAnnuitiesCount = data["paidMemberAnnuitiesCount"];
            this.unpaidMemberAnnuitiesCount = data["unpaidMemberAnnuitiesCount"];
            this.readmissionCount = data["readmissionCount"];
            if (data["pendingDocAnnuities"] && data["pendingDocAnnuities"].constructor === Array) {
                this.pendingDocAnnuities = [];
                for (let item of data["pendingDocAnnuities"])
                    this.pendingDocAnnuities.push(MemberAnnuityDto.fromJS(item));
            }
            if (data["annuitiesByCategory"] && data["annuitiesByCategory"].constructor === Array) {
                this.annuitiesByCategory = [];
                for (let item of data["annuitiesByCategory"])
                    this.annuitiesByCategory.push(AnnuityCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnnuityDashboardData {
        let result = new AnnuityDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidMemberAnnuitiesCount"] = this.paidMemberAnnuitiesCount;
        data["unpaidMemberAnnuitiesCount"] = this.unpaidMemberAnnuitiesCount;
        data["readmissionCount"] = this.readmissionCount;
        if (this.pendingDocAnnuities && this.pendingDocAnnuities.constructor === Array) {
            data["pendingDocAnnuities"] = [];
            for (let item of this.pendingDocAnnuities)
                data["pendingDocAnnuities"].push(item.toJSON());
        }
        if (this.annuitiesByCategory && this.annuitiesByCategory.constructor === Array) {
            data["annuitiesByCategory"] = [];
            for (let item of this.annuitiesByCategory)
                data["annuitiesByCategory"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAnnuityDashboardData {
    paidMemberAnnuitiesCount: number | undefined;
    unpaidMemberAnnuitiesCount: number | undefined;
    readmissionCount: number | undefined;
    pendingDocAnnuities: MemberAnnuityDto[] | undefined;
    annuitiesByCategory: AnnuityCategoryDto[] | undefined;
}

export class MemberAnnuityDto implements IMemberAnnuityDto {
    annuityId: number;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    documentationId: number | undefined;
    documentation: DocumentationDto | undefined;
    paidSBA: boolean | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: MemberAnnuityDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: MemberAnnuityDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IMemberAnnuityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityEditDto.fromJS(data["annuity"]) : <any>undefined;
            this.memberId = data["memberId"];
            this.categoryDeadLineId = data["categoryDeadLineId"];
            this.categoryDeadLine = data["categoryDeadLine"] ? AnnuityCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.documentationId = data["documentationId"];
            this.documentation = data["documentation"] ? DocumentationDto.fromJS(data["documentation"]) : <any>undefined;
            this.paidSBA = data["paidSBA"];
            this.orderId = data["orderId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberAnnuityDto {
        let result = new MemberAnnuityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["memberId"] = this.memberId;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["documentationId"] = this.documentationId;
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        data["paidSBA"] = this.paidSBA;
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberAnnuityDto {
    annuityId: number;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    documentationId: number | undefined;
    documentation: DocumentationDto | undefined;
    paidSBA: boolean | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: MemberAnnuityDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: MemberAnnuityDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class AnnuityCategoryDto implements IAnnuityCategoryDto {
    category: string | undefined;
    annuityCount: number | undefined;

    constructor(data?: IAnnuityCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.annuityCount = data["annuityCount"];
        }
    }

    static fromJS(data: any): AnnuityCategoryDto {
        let result = new AnnuityCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["annuityCount"] = this.annuityCount;
        return data; 
    }
}

export interface IAnnuityCategoryDto {
    category: string | undefined;
    annuityCount: number | undefined;
}

export class FinancialDashboardData implements IFinancialDashboardData {
    receivablesAmount: number | undefined;
    payablesAmount: number | undefined;
    realizedReceivablesAmount: number | undefined;
    realizedPayablesAmount: number | undefined;
    nextPayables: PayableDto[] | undefined;
    cashFlowStatistics: CashFlowStatisic[] | undefined;
    maxRecentPayablesShownCount: number | undefined;

    constructor(data?: IFinancialDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receivablesAmount = data["receivablesAmount"];
            this.payablesAmount = data["payablesAmount"];
            this.realizedReceivablesAmount = data["realizedReceivablesAmount"];
            this.realizedPayablesAmount = data["realizedPayablesAmount"];
            if (data["nextPayables"] && data["nextPayables"].constructor === Array) {
                this.nextPayables = [];
                for (let item of data["nextPayables"])
                    this.nextPayables.push(PayableDto.fromJS(item));
            }
            if (data["cashFlowStatistics"] && data["cashFlowStatistics"].constructor === Array) {
                this.cashFlowStatistics = [];
                for (let item of data["cashFlowStatistics"])
                    this.cashFlowStatistics.push(CashFlowStatisic.fromJS(item));
            }
            this.maxRecentPayablesShownCount = data["maxRecentPayablesShownCount"];
        }
    }

    static fromJS(data: any): FinancialDashboardData {
        let result = new FinancialDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivablesAmount"] = this.receivablesAmount;
        data["payablesAmount"] = this.payablesAmount;
        data["realizedReceivablesAmount"] = this.realizedReceivablesAmount;
        data["realizedPayablesAmount"] = this.realizedPayablesAmount;
        if (this.nextPayables && this.nextPayables.constructor === Array) {
            data["nextPayables"] = [];
            for (let item of this.nextPayables)
                data["nextPayables"].push(item.toJSON());
        }
        if (this.cashFlowStatistics && this.cashFlowStatistics.constructor === Array) {
            data["cashFlowStatistics"] = [];
            for (let item of this.cashFlowStatistics)
                data["cashFlowStatistics"].push(item.toJSON());
        }
        data["maxRecentPayablesShownCount"] = this.maxRecentPayablesShownCount;
        return data; 
    }
}

export interface IFinancialDashboardData {
    receivablesAmount: number | undefined;
    payablesAmount: number | undefined;
    realizedReceivablesAmount: number | undefined;
    realizedPayablesAmount: number | undefined;
    nextPayables: PayableDto[] | undefined;
    cashFlowStatistics: CashFlowStatisic[] | undefined;
    maxRecentPayablesShownCount: number | undefined;
}

export class PayableDto implements IPayableDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    customer: string | undefined;
    reference: string | undefined;
    receivableId: number | undefined;
    receivable: ReceivableListDto | undefined;
    type: PayableDtoType | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: PayableDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IPayableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.customer = data["customer"];
            this.reference = data["reference"];
            this.receivableId = data["receivableId"];
            this.receivable = data["receivable"] ? ReceivableListDto.fromJS(data["receivable"]) : <any>undefined;
            this.type = data["type"];
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PayableDto {
        let result = new PayableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["customer"] = this.customer;
        data["reference"] = this.reference;
        data["receivableId"] = this.receivableId;
        data["receivable"] = this.receivable ? this.receivable.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPayableDto {
    userId: number | undefined;
    user: UserListDto | undefined;
    customer: string | undefined;
    reference: string | undefined;
    receivableId: number | undefined;
    receivable: ReceivableListDto | undefined;
    type: PayableDtoType | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: PayableDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CashFlowStatisic implements ICashFlowStatisic {
    label: string | undefined;
    date: moment.Moment | undefined;
    receivableAmount: number | undefined;
    payablebleAmount: number | undefined;
    balance: number | undefined;

    constructor(data?: ICashFlowStatisic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.receivableAmount = data["receivableAmount"];
            this.payablebleAmount = data["payablebleAmount"];
            this.balance = data["balance"];
        }
    }

    static fromJS(data: any): CashFlowStatisic {
        let result = new CashFlowStatisic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["receivableAmount"] = this.receivableAmount;
        data["payablebleAmount"] = this.payablebleAmount;
        data["balance"] = this.balance;
        return data; 
    }
}

export interface ICashFlowStatisic {
    label: string | undefined;
    date: moment.Moment | undefined;
    receivableAmount: number | undefined;
    payablebleAmount: number | undefined;
    balance: number | undefined;
}

export class GetICashFlowStatisticsDataOutput implements IGetICashFlowStatisticsDataOutput {
    cashFlowStatistics: CashFlowStatisic[] | undefined;

    constructor(data?: IGetICashFlowStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["cashFlowStatistics"] && data["cashFlowStatistics"].constructor === Array) {
                this.cashFlowStatistics = [];
                for (let item of data["cashFlowStatistics"])
                    this.cashFlowStatistics.push(CashFlowStatisic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetICashFlowStatisticsDataOutput {
        let result = new GetICashFlowStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.cashFlowStatistics && this.cashFlowStatistics.constructor === Array) {
            data["cashFlowStatistics"] = [];
            for (let item of this.cashFlowStatistics)
                data["cashFlowStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetICashFlowStatisticsDataOutput {
    cashFlowStatistics: CashFlowStatisic[] | undefined;
}

export class EventWorkDashboardData implements IEventWorkDashboardData {
    evaluatedWorksTotalCount: number | undefined;
    notEvaluatedWorksTotalCount: number | undefined;
    sentEPosterWorksTotalCount: number | undefined;
    notSentEPosterWorksTotalCount: number | undefined;
    worksWithEvaluatorsTotalCount: number | undefined;
    worksWithoutEvaluatorsTotalCount: number | undefined;
    worksByStatus: WorkStatusDto[] | undefined;

    constructor(data?: IEventWorkDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluatedWorksTotalCount = data["evaluatedWorksTotalCount"];
            this.notEvaluatedWorksTotalCount = data["notEvaluatedWorksTotalCount"];
            this.sentEPosterWorksTotalCount = data["sentEPosterWorksTotalCount"];
            this.notSentEPosterWorksTotalCount = data["notSentEPosterWorksTotalCount"];
            this.worksWithEvaluatorsTotalCount = data["worksWithEvaluatorsTotalCount"];
            this.worksWithoutEvaluatorsTotalCount = data["worksWithoutEvaluatorsTotalCount"];
            if (data["worksByStatus"] && data["worksByStatus"].constructor === Array) {
                this.worksByStatus = [];
                for (let item of data["worksByStatus"])
                    this.worksByStatus.push(WorkStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventWorkDashboardData {
        let result = new EventWorkDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluatedWorksTotalCount"] = this.evaluatedWorksTotalCount;
        data["notEvaluatedWorksTotalCount"] = this.notEvaluatedWorksTotalCount;
        data["sentEPosterWorksTotalCount"] = this.sentEPosterWorksTotalCount;
        data["notSentEPosterWorksTotalCount"] = this.notSentEPosterWorksTotalCount;
        data["worksWithEvaluatorsTotalCount"] = this.worksWithEvaluatorsTotalCount;
        data["worksWithoutEvaluatorsTotalCount"] = this.worksWithoutEvaluatorsTotalCount;
        if (this.worksByStatus && this.worksByStatus.constructor === Array) {
            data["worksByStatus"] = [];
            for (let item of this.worksByStatus)
                data["worksByStatus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEventWorkDashboardData {
    evaluatedWorksTotalCount: number | undefined;
    notEvaluatedWorksTotalCount: number | undefined;
    sentEPosterWorksTotalCount: number | undefined;
    notSentEPosterWorksTotalCount: number | undefined;
    worksWithEvaluatorsTotalCount: number | undefined;
    worksWithoutEvaluatorsTotalCount: number | undefined;
    worksByStatus: WorkStatusDto[] | undefined;
}

export class WorkStatusDto implements IWorkStatusDto {
    status: string | undefined;
    worksCount: number | undefined;

    constructor(data?: IWorkStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.worksCount = data["worksCount"];
        }
    }

    static fromJS(data: any): WorkStatusDto {
        let result = new WorkStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["worksCount"] = this.worksCount;
        return data; 
    }
}

export interface IWorkStatusDto {
    status: string | undefined;
    worksCount: number | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general: GeneralSettingsEditDto = new GeneralSettingsEditDto();
    userManagement: HostUserManagementSettingsEditDto = new HostUserManagementSettingsEditDto();
    email: EmailSettingsEditDto = new EmailSettingsEditDto();
    tenantManagement: TenantManagementSettingsEditDto = new TenantManagementSettingsEditDto();
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: HostBillingSettingsEditDto | undefined;
    cigam: CigamSettingsDto | undefined;
    serpro: SerproSettingsDto | undefined;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
            this.cigam = data["cigam"] ? CigamSettingsDto.fromJS(data["cigam"]) : <any>undefined;
            this.serpro = data["serpro"] ? SerproSettingsDto.fromJS(data["serpro"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["cigam"] = this.cigam ? this.cigam.toJSON() : <any>undefined;
        data["serpro"] = this.serpro ? this.serpro.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto | undefined;
    cigam: CigamSettingsDto | undefined;
    serpro: SerproSettingsDto | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data; 
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    smsVerificationEnabled: boolean | undefined;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        return data; 
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    smsVerificationEnabled: boolean | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number | undefined;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean | undefined;
    smtpUseDefaultCredentials: boolean | undefined;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data; 
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number | undefined;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean | undefined;
    smtpUseDefaultCredentials: boolean | undefined;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredTenantActiveByDefault: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;
    defaultEditionId: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data; 
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredTenantActiveByDefault: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;
    defaultEditionId: number | undefined;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean | undefined;
    passwordComplexity: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity: PasswordComplexitySetting | undefined;
    userLockOut: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin: TwoFactorLoginSettingsEditDto | undefined;
    secretSharedKey: string | undefined;
    portalAdminChangePasswordUrl: string | undefined;
    portalMemberChangePasswordUrl: string | undefined;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : <any>undefined;
            this.secretSharedKey = data["secretSharedKey"];
            this.portalAdminChangePasswordUrl = data["portalAdminChangePasswordUrl"];
            this.portalMemberChangePasswordUrl = data["portalMemberChangePasswordUrl"];
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        data["secretSharedKey"] = this.secretSharedKey;
        data["portalAdminChangePasswordUrl"] = this.portalAdminChangePasswordUrl;
        data["portalMemberChangePasswordUrl"] = this.portalMemberChangePasswordUrl;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean | undefined;
    passwordComplexity: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity: PasswordComplexitySetting | undefined;
    userLockOut: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin: TwoFactorLoginSettingsEditDto | undefined;
    secretSharedKey: string | undefined;
    portalAdminChangePasswordUrl: string | undefined;
    portalMemberChangePasswordUrl: string | undefined;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data; 
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class CigamSettingsDto implements ICigamSettingsDto {
    memberIsActive: boolean | undefined;
    annuityIsActive: boolean | undefined;
    eventIsActive: boolean | undefined;
    financialIsActive: boolean | undefined;
    isEnabled: boolean | undefined;

    constructor(data?: ICigamSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberIsActive = data["memberIsActive"];
            this.annuityIsActive = data["annuityIsActive"];
            this.eventIsActive = data["eventIsActive"];
            this.financialIsActive = data["financialIsActive"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): CigamSettingsDto {
        let result = new CigamSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberIsActive"] = this.memberIsActive;
        data["annuityIsActive"] = this.annuityIsActive;
        data["eventIsActive"] = this.eventIsActive;
        data["financialIsActive"] = this.financialIsActive;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface ICigamSettingsDto {
    memberIsActive: boolean | undefined;
    annuityIsActive: boolean | undefined;
    eventIsActive: boolean | undefined;
    financialIsActive: boolean | undefined;
    isEnabled: boolean | undefined;
}

export class SerproSettingsDto implements ISerproSettingsDto {
    consumerKey: string | undefined;
    consumerSecret: string;
    description: string | undefined;
    urlRequestCpf: string;
    urlToken: string;
    isActive: boolean | undefined;
    isEnabled: boolean | undefined;

    constructor(data?: ISerproSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerKey = data["consumerKey"];
            this.consumerSecret = data["consumerSecret"];
            this.description = data["description"];
            this.urlRequestCpf = data["urlRequestCpf"];
            this.urlToken = data["urlToken"];
            this.isActive = data["isActive"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): SerproSettingsDto {
        let result = new SerproSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        data["description"] = this.description;
        data["urlRequestCpf"] = this.urlRequestCpf;
        data["urlToken"] = this.urlToken;
        data["isActive"] = this.isActive;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface ISerproSettingsDto {
    consumerKey: string | undefined;
    consumerSecret: string;
    description: string | undefined;
    urlRequestCpf: string;
    urlToken: string;
    isActive: boolean | undefined;
    isEnabled: boolean | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit: boolean | undefined;
    requireLowercase: boolean | undefined;
    requireNonAlphanumeric: boolean | undefined;
    requireUppercase: boolean | undefined;
    requiredLength: number | undefined;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data; 
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean | undefined;
    requireLowercase: boolean | undefined;
    requireNonAlphanumeric: boolean | undefined;
    requireUppercase: boolean | undefined;
    requiredLength: number | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout: number | undefined;
    defaultAccountLockoutSeconds: number | undefined;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data; 
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout: number | undefined;
    defaultAccountLockoutSeconds: number | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean | undefined;
    isEnabled: boolean | undefined;
    isEmailProviderEnabled: boolean | undefined;
    isSmsProviderEnabled: boolean | undefined;
    isRememberBrowserEnabled: boolean | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean | undefined;
    isEnabled: boolean | undefined;
    isEmailProviderEnabled: boolean | undefined;
    isSmsProviderEnabled: boolean | undefined;
    isRememberBrowserEnabled: boolean | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class InstallDto implements IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto | undefined;
    billInfo: HostBillingSettingsEditDto | undefined;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : <any>undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto | undefined;
    billInfo: HostBillingSettingsEditDto | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (let item of data["languages"])
                    this.languages.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class NameValue implements INameValue {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist: boolean | undefined;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data; 
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean | undefined;
}

export class PagedResultDtoOfInstitutionDto implements IPagedResultDtoOfInstitutionDto {
    totalCount: number | undefined;
    items: InstitutionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(InstitutionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInstitutionDto {
        let result = new PagedResultDtoOfInstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfInstitutionDto {
    totalCount: number | undefined;
    items: InstitutionDto[] | undefined;
}

export class InstitutionDto implements IInstitutionDto {
    name: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InstitutionDto {
        let result = new InstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInstitutionDto {
    name: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfInstitutionListDto implements IListResultDtoOfInstitutionListDto {
    items: InstitutionListDto[] | undefined;

    constructor(data?: IListResultDtoOfInstitutionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(InstitutionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInstitutionListDto {
        let result = new ListResultDtoOfInstitutionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfInstitutionListDto {
    items: InstitutionListDto[] | undefined;
}

export class InstitutionListDto implements IInstitutionListDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IInstitutionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): InstitutionListDto {
        let result = new InstitutionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IInstitutionListDto {
    id: number | undefined;
    name: string | undefined;
}

export class CreateOrEditInstitutionDto implements ICreateOrEditInstitutionDto {
    name: string;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInstitutionDto {
        let result = new CreateOrEditInstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditInstitutionDto {
    name: string;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetInstitutionWorkForViewDto implements IPagedResultDtoOfGetInstitutionWorkForViewDto {
    totalCount: number | undefined;
    items: GetInstitutionWorkForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInstitutionWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetInstitutionWorkForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInstitutionWorkForViewDto {
        let result = new PagedResultDtoOfGetInstitutionWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetInstitutionWorkForViewDto {
    totalCount: number | undefined;
    items: GetInstitutionWorkForViewDto[] | undefined;
}

export class GetInstitutionWorkForViewDto implements IGetInstitutionWorkForViewDto {
    institutionWork: InstitutionWorkDto | undefined;

    constructor(data?: IGetInstitutionWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.institutionWork = data["institutionWork"] ? InstitutionWorkDto.fromJS(data["institutionWork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInstitutionWorkForViewDto {
        let result = new GetInstitutionWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["institutionWork"] = this.institutionWork ? this.institutionWork.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetInstitutionWorkForViewDto {
    institutionWork: InstitutionWorkDto | undefined;
}

export class GetInstitutionWorkForEditOutput implements IGetInstitutionWorkForEditOutput {
    institutionWork: CreateOrEditInstitutionWorkDto | undefined;

    constructor(data?: IGetInstitutionWorkForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.institutionWork = data["institutionWork"] ? CreateOrEditInstitutionWorkDto.fromJS(data["institutionWork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInstitutionWorkForEditOutput {
        let result = new GetInstitutionWorkForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["institutionWork"] = this.institutionWork ? this.institutionWork.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetInstitutionWorkForEditOutput {
    institutionWork: CreateOrEditInstitutionWorkDto | undefined;
}

export class CreateOrEditInstitutionWorkDto implements ICreateOrEditInstitutionWorkDto {
    name: string;
    countryName: string;
    stateName: string;
    stateAbbreviation: string | undefined;
    city: string;
    status: CreateOrEditInstitutionWorkDtoStatus | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditInstitutionWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.countryName = data["countryName"];
            this.stateName = data["stateName"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.city = data["city"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInstitutionWorkDto {
        let result = new CreateOrEditInstitutionWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryName"] = this.countryName;
        data["stateName"] = this.stateName;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["city"] = this.city;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditInstitutionWorkDto {
    name: string;
    countryName: string;
    stateName: string;
    stateAbbreviation: string | undefined;
    city: string;
    status: CreateOrEditInstitutionWorkDtoStatus | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetInvitationForViewDto implements IPagedResultDtoOfGetInvitationForViewDto {
    totalCount: number | undefined;
    items: GetInvitationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInvitationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetInvitationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInvitationForViewDto {
        let result = new PagedResultDtoOfGetInvitationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetInvitationForViewDto {
    totalCount: number | undefined;
    items: GetInvitationForViewDto[] | undefined;
}

export class GetInvitationForViewDto implements IGetInvitationForViewDto {
    invitation: InvitationDto | undefined;
    creatorUser: UserSelectListDto | undefined;
    hasInvitationRefused: boolean | undefined;

    constructor(data?: IGetInvitationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invitation = data["invitation"] ? InvitationDto.fromJS(data["invitation"]) : <any>undefined;
            this.creatorUser = data["creatorUser"] ? UserSelectListDto.fromJS(data["creatorUser"]) : <any>undefined;
            this.hasInvitationRefused = data["hasInvitationRefused"];
        }
    }

    static fromJS(data: any): GetInvitationForViewDto {
        let result = new GetInvitationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitation"] = this.invitation ? this.invitation.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["hasInvitationRefused"] = this.hasInvitationRefused;
        return data; 
    }
}

export interface IGetInvitationForViewDto {
    invitation: InvitationDto | undefined;
    creatorUser: UserSelectListDto | undefined;
    hasInvitationRefused: boolean | undefined;
}

export class GetInvitationForEditOutput implements IGetInvitationForEditOutput {
    invitation: CreateOrEditInvitationDto | undefined;

    constructor(data?: IGetInvitationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invitation = data["invitation"] ? CreateOrEditInvitationDto.fromJS(data["invitation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvitationForEditOutput {
        let result = new GetInvitationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitation"] = this.invitation ? this.invitation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetInvitationForEditOutput {
    invitation: CreateOrEditInvitationDto | undefined;
}

export class CreateOrEditInvitationDto implements ICreateOrEditInvitationDto {
    guestId: number | undefined;
    guest: GuestListDto | undefined;
    invitationConfigId: number | undefined;
    subject: string | undefined;
    message: string | undefined;
    email: string | undefined;
    sendDate: moment.Moment | undefined;
    responseDeadline: moment.Moment | undefined;
    status: CreateOrEditInvitationDtoStatus | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.guest = data["guest"] ? GuestListDto.fromJS(data["guest"]) : <any>undefined;
            this.invitationConfigId = data["invitationConfigId"];
            this.subject = data["subject"];
            this.message = data["message"];
            this.email = data["email"];
            this.sendDate = data["sendDate"] ? moment(data["sendDate"].toString()) : <any>undefined;
            this.responseDeadline = data["responseDeadline"] ? moment(data["responseDeadline"].toString()) : <any>undefined;
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInvitationDto {
        let result = new CreateOrEditInvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["invitationConfigId"] = this.invitationConfigId;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["email"] = this.email;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["responseDeadline"] = this.responseDeadline ? this.responseDeadline.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditInvitationDto {
    guestId: number | undefined;
    guest: GuestListDto | undefined;
    invitationConfigId: number | undefined;
    subject: string | undefined;
    message: string | undefined;
    email: string | undefined;
    sendDate: moment.Moment | undefined;
    responseDeadline: moment.Moment | undefined;
    status: CreateOrEditInvitationDtoStatus | undefined;
    id: number | undefined;
}

export class CreateInvitationsInput implements ICreateInvitationsInput {
    guestsIds: number[] | undefined;
    send: boolean | undefined;
    programmingId: number | undefined;

    constructor(data?: ICreateInvitationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["guestsIds"] && data["guestsIds"].constructor === Array) {
                this.guestsIds = [];
                for (let item of data["guestsIds"])
                    this.guestsIds.push(item);
            }
            this.send = data["send"];
            this.programmingId = data["programmingId"];
        }
    }

    static fromJS(data: any): CreateInvitationsInput {
        let result = new CreateInvitationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.guestsIds && this.guestsIds.constructor === Array) {
            data["guestsIds"] = [];
            for (let item of this.guestsIds)
                data["guestsIds"].push(item);
        }
        data["send"] = this.send;
        data["programmingId"] = this.programmingId;
        return data; 
    }
}

export interface ICreateInvitationsInput {
    guestsIds: number[] | undefined;
    send: boolean | undefined;
    programmingId: number | undefined;
}

export class SendInvitationsInput implements ISendInvitationsInput {
    invitationsIds: number[] | undefined;

    constructor(data?: ISendInvitationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["invitationsIds"] && data["invitationsIds"].constructor === Array) {
                this.invitationsIds = [];
                for (let item of data["invitationsIds"])
                    this.invitationsIds.push(item);
            }
        }
    }

    static fromJS(data: any): SendInvitationsInput {
        let result = new SendInvitationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.invitationsIds && this.invitationsIds.constructor === Array) {
            data["invitationsIds"] = [];
            for (let item of this.invitationsIds)
                data["invitationsIds"].push(item);
        }
        return data; 
    }
}

export interface ISendInvitationsInput {
    invitationsIds: number[] | undefined;
}

export class GetInvitationResponseForEditOutput implements IGetInvitationResponseForEditOutput {
    response: CreateOrEditInvitationResponseDto | undefined;
    templateImageId: string | undefined;
    templateExtension: string | undefined;
    audioVisualGuideImageId: string | undefined;
    guideExtension: string | undefined;

    constructor(data?: IGetInvitationResponseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.response = data["response"] ? CreateOrEditInvitationResponseDto.fromJS(data["response"]) : <any>undefined;
            this.templateImageId = data["templateImageId"];
            this.templateExtension = data["templateExtension"];
            this.audioVisualGuideImageId = data["audioVisualGuideImageId"];
            this.guideExtension = data["guideExtension"];
        }
    }

    static fromJS(data: any): GetInvitationResponseForEditOutput {
        let result = new GetInvitationResponseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["templateImageId"] = this.templateImageId;
        data["templateExtension"] = this.templateExtension;
        data["audioVisualGuideImageId"] = this.audioVisualGuideImageId;
        data["guideExtension"] = this.guideExtension;
        return data; 
    }
}

export interface IGetInvitationResponseForEditOutput {
    response: CreateOrEditInvitationResponseDto | undefined;
    templateImageId: string | undefined;
    templateExtension: string | undefined;
    audioVisualGuideImageId: string | undefined;
    guideExtension: string | undefined;
}

export class CreateOrEditInvitationResponseDto implements ICreateOrEditInvitationResponseDto {
    startHostingPeriod: moment.Moment | undefined;
    endHostingPeriod: moment.Moment | undefined;
    copyrightDisapprovalReason: string | undefined;
    userImageId: string | undefined;
    userImage: string | undefined;
    userImageInput: UpdateUserImageInput | undefined;
    invitationId: number | undefined;
    guest: UpdateGuestDto | undefined;
    invitationActivities: InvitationActivityDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditInvitationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startHostingPeriod = data["startHostingPeriod"] ? moment(data["startHostingPeriod"].toString()) : <any>undefined;
            this.endHostingPeriod = data["endHostingPeriod"] ? moment(data["endHostingPeriod"].toString()) : <any>undefined;
            this.copyrightDisapprovalReason = data["copyrightDisapprovalReason"];
            this.userImageId = data["userImageId"];
            this.userImage = data["userImage"];
            this.userImageInput = data["userImageInput"] ? UpdateUserImageInput.fromJS(data["userImageInput"]) : <any>undefined;
            this.invitationId = data["invitationId"];
            this.guest = data["guest"] ? UpdateGuestDto.fromJS(data["guest"]) : <any>undefined;
            if (data["invitationActivities"] && data["invitationActivities"].constructor === Array) {
                this.invitationActivities = [];
                for (let item of data["invitationActivities"])
                    this.invitationActivities.push(InvitationActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInvitationResponseDto {
        let result = new CreateOrEditInvitationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startHostingPeriod"] = this.startHostingPeriod ? this.startHostingPeriod.toISOString() : <any>undefined;
        data["endHostingPeriod"] = this.endHostingPeriod ? this.endHostingPeriod.toISOString() : <any>undefined;
        data["copyrightDisapprovalReason"] = this.copyrightDisapprovalReason;
        data["userImageId"] = this.userImageId;
        data["userImage"] = this.userImage;
        data["userImageInput"] = this.userImageInput ? this.userImageInput.toJSON() : <any>undefined;
        data["invitationId"] = this.invitationId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        if (this.invitationActivities && this.invitationActivities.constructor === Array) {
            data["invitationActivities"] = [];
            for (let item of this.invitationActivities)
                data["invitationActivities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditInvitationResponseDto {
    startHostingPeriod: moment.Moment | undefined;
    endHostingPeriod: moment.Moment | undefined;
    copyrightDisapprovalReason: string | undefined;
    userImageId: string | undefined;
    userImage: string | undefined;
    userImageInput: UpdateUserImageInput | undefined;
    invitationId: number | undefined;
    guest: UpdateGuestDto | undefined;
    invitationActivities: InvitationActivityDto[] | undefined;
    id: number | undefined;
}

export class UpdateUserImageInput implements IUpdateUserImageInput {
    userId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateUserImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateUserImageInput {
        let result = new UpdateUserImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateUserImageInput {
    userId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class UpdateGuestDto implements IUpdateGuestDto {
    userId: number;
    name: string | undefined;
    nameForCredential: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    rg: string | undefined;
    lattes: string | undefined;
    scheduleSubmitted: boolean | undefined;
    phone: GuestPhoneDto | undefined;
    address: GuestAddressDto | undefined;
    emails: GuestEmailDto[] | undefined;
    id: number | undefined;

    constructor(data?: IUpdateGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.crm = data["crm"];
            this.crmUf = data["crmUf"];
            this.rg = data["rg"];
            this.lattes = data["lattes"];
            this.scheduleSubmitted = data["scheduleSubmitted"];
            this.phone = data["phone"] ? GuestPhoneDto.fromJS(data["phone"]) : <any>undefined;
            this.address = data["address"] ? GuestAddressDto.fromJS(data["address"]) : <any>undefined;
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(GuestEmailDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateGuestDto {
        let result = new UpdateGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["crm"] = this.crm;
        data["crmUf"] = this.crmUf;
        data["rg"] = this.rg;
        data["lattes"] = this.lattes;
        data["scheduleSubmitted"] = this.scheduleSubmitted;
        data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateGuestDto {
    userId: number;
    name: string | undefined;
    nameForCredential: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    rg: string | undefined;
    lattes: string | undefined;
    scheduleSubmitted: boolean | undefined;
    phone: GuestPhoneDto | undefined;
    address: GuestAddressDto | undefined;
    emails: GuestEmailDto[] | undefined;
    id: number | undefined;
}

export class GetInvitationConfigForEditOutput implements IGetInvitationConfigForEditOutput {
    config: CreateOrEditInvitationConfigDto | undefined;

    constructor(data?: IGetInvitationConfigForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.config = data["config"] ? CreateOrEditInvitationConfigDto.fromJS(data["config"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvitationConfigForEditOutput {
        let result = new GetInvitationConfigForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetInvitationConfigForEditOutput {
    config: CreateOrEditInvitationConfigDto | undefined;
}

export class CreateOrEditInvitationConfigDto implements ICreateOrEditInvitationConfigDto {
    templateImageId: string | undefined;
    guideImageId: string | undefined;
    templateImage: string | undefined;
    templateExtension: string | undefined;
    guideImage: string | undefined;
    guideExtension: string | undefined;
    templateImageInput: UpdateTemplateImageInput | undefined;
    guideImageInput: UpdateGuideImageInput | undefined;
    programmingId: number | undefined;
    message: string | undefined;
    copyrightTerm: string | undefined;
    deadlineToConfirmParticipation: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditInvitationConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateImageId = data["templateImageId"];
            this.guideImageId = data["guideImageId"];
            this.templateImage = data["templateImage"];
            this.templateExtension = data["templateExtension"];
            this.guideImage = data["guideImage"];
            this.guideExtension = data["guideExtension"];
            this.templateImageInput = data["templateImageInput"] ? UpdateTemplateImageInput.fromJS(data["templateImageInput"]) : <any>undefined;
            this.guideImageInput = data["guideImageInput"] ? UpdateGuideImageInput.fromJS(data["guideImageInput"]) : <any>undefined;
            this.programmingId = data["programmingId"];
            this.message = data["message"];
            this.copyrightTerm = data["copyrightTerm"];
            this.deadlineToConfirmParticipation = data["deadlineToConfirmParticipation"] ? moment(data["deadlineToConfirmParticipation"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInvitationConfigDto {
        let result = new CreateOrEditInvitationConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateImageId"] = this.templateImageId;
        data["guideImageId"] = this.guideImageId;
        data["templateImage"] = this.templateImage;
        data["templateExtension"] = this.templateExtension;
        data["guideImage"] = this.guideImage;
        data["guideExtension"] = this.guideExtension;
        data["templateImageInput"] = this.templateImageInput ? this.templateImageInput.toJSON() : <any>undefined;
        data["guideImageInput"] = this.guideImageInput ? this.guideImageInput.toJSON() : <any>undefined;
        data["programmingId"] = this.programmingId;
        data["message"] = this.message;
        data["copyrightTerm"] = this.copyrightTerm;
        data["deadlineToConfirmParticipation"] = this.deadlineToConfirmParticipation ? this.deadlineToConfirmParticipation.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditInvitationConfigDto {
    templateImageId: string | undefined;
    guideImageId: string | undefined;
    templateImage: string | undefined;
    templateExtension: string | undefined;
    guideImage: string | undefined;
    guideExtension: string | undefined;
    templateImageInput: UpdateTemplateImageInput | undefined;
    guideImageInput: UpdateGuideImageInput | undefined;
    programmingId: number | undefined;
    message: string | undefined;
    copyrightTerm: string | undefined;
    deadlineToConfirmParticipation: moment.Moment | undefined;
    id: number | undefined;
}

export class UpdateTemplateImageInput implements IUpdateTemplateImageInput {
    invitationConfigId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateTemplateImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invitationConfigId = data["invitationConfigId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateTemplateImageInput {
        let result = new UpdateTemplateImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationConfigId"] = this.invitationConfigId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateTemplateImageInput {
    invitationConfigId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class UpdateGuideImageInput implements IUpdateGuideImageInput {
    invitationConfigId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateGuideImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invitationConfigId = data["invitationConfigId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateGuideImageInput {
        let result = new UpdateGuideImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationConfigId"] = this.invitationConfigId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateGuideImageInput {
    invitationConfigId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class PagedResultDtoOfGetInvitationWorkForViewDto implements IPagedResultDtoOfGetInvitationWorkForViewDto {
    totalCount: number | undefined;
    items: GetInvitationWorkForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInvitationWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetInvitationWorkForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInvitationWorkForViewDto {
        let result = new PagedResultDtoOfGetInvitationWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetInvitationWorkForViewDto {
    totalCount: number | undefined;
    items: GetInvitationWorkForViewDto[] | undefined;
}

export class GetInvitationWorkForViewDto implements IGetInvitationWorkForViewDto {
    invitationWork: InvitationWorkDto | undefined;
    evaluatorUserId: string | undefined;
    evaluatorUserName: string | undefined;
    approvedInvite: boolean | undefined;

    constructor(data?: IGetInvitationWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invitationWork = data["invitationWork"] ? InvitationWorkDto.fromJS(data["invitationWork"]) : <any>undefined;
            this.evaluatorUserId = data["evaluatorUserId"];
            this.evaluatorUserName = data["evaluatorUserName"];
            this.approvedInvite = data["approvedInvite"];
        }
    }

    static fromJS(data: any): GetInvitationWorkForViewDto {
        let result = new GetInvitationWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationWork"] = this.invitationWork ? this.invitationWork.toJSON() : <any>undefined;
        data["evaluatorUserId"] = this.evaluatorUserId;
        data["evaluatorUserName"] = this.evaluatorUserName;
        data["approvedInvite"] = this.approvedInvite;
        return data; 
    }
}

export interface IGetInvitationWorkForViewDto {
    invitationWork: InvitationWorkDto | undefined;
    evaluatorUserId: string | undefined;
    evaluatorUserName: string | undefined;
    approvedInvite: boolean | undefined;
}

export class GetInvitationWorkForEditOutput implements IGetInvitationWorkForEditOutput {
    invitationWork: CreateOrEditInvitationWorkDto | undefined;
    evaluator: CreateOrEditEvaluatorDto | undefined;
    evaluatorUserId: string | undefined;
    evaluatorUserName: string | undefined;
    eventName: string | undefined;
    canResponse: boolean | undefined;

    constructor(data?: IGetInvitationWorkForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invitationWork = data["invitationWork"] ? CreateOrEditInvitationWorkDto.fromJS(data["invitationWork"]) : <any>undefined;
            this.evaluator = data["evaluator"] ? CreateOrEditEvaluatorDto.fromJS(data["evaluator"]) : <any>undefined;
            this.evaluatorUserId = data["evaluatorUserId"];
            this.evaluatorUserName = data["evaluatorUserName"];
            this.eventName = data["eventName"];
            this.canResponse = data["canResponse"];
        }
    }

    static fromJS(data: any): GetInvitationWorkForEditOutput {
        let result = new GetInvitationWorkForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationWork"] = this.invitationWork ? this.invitationWork.toJSON() : <any>undefined;
        data["evaluator"] = this.evaluator ? this.evaluator.toJSON() : <any>undefined;
        data["evaluatorUserId"] = this.evaluatorUserId;
        data["evaluatorUserName"] = this.evaluatorUserName;
        data["eventName"] = this.eventName;
        data["canResponse"] = this.canResponse;
        return data; 
    }
}

export interface IGetInvitationWorkForEditOutput {
    invitationWork: CreateOrEditInvitationWorkDto | undefined;
    evaluator: CreateOrEditEvaluatorDto | undefined;
    evaluatorUserId: string | undefined;
    evaluatorUserName: string | undefined;
    eventName: string | undefined;
    canResponse: boolean | undefined;
}

export class CreateOrEditInvitationWorkDto implements ICreateOrEditInvitationWorkDto {
    status: CreateOrEditInvitationWorkDtoStatus | undefined;
    subject: string;
    message: string;
    email: string;
    sendDate: moment.Moment | undefined;
    evaluatorId: number | undefined;
    response: InvitationWorkResponseDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditInvitationWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.subject = data["subject"];
            this.message = data["message"];
            this.email = data["email"];
            this.sendDate = data["sendDate"] ? moment(data["sendDate"].toString()) : <any>undefined;
            this.evaluatorId = data["evaluatorId"];
            this.response = data["response"] ? InvitationWorkResponseDto.fromJS(data["response"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInvitationWorkDto {
        let result = new CreateOrEditInvitationWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["email"] = this.email;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["evaluatorId"] = this.evaluatorId;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditInvitationWorkDto {
    status: CreateOrEditInvitationWorkDtoStatus | undefined;
    subject: string;
    message: string;
    email: string;
    sendDate: moment.Moment | undefined;
    evaluatorId: number | undefined;
    response: InvitationWorkResponseDto | undefined;
    id: number | undefined;
}

export class SendInvitationWorksInput implements ISendInvitationWorksInput {
    invitationWorksIds: number[] | undefined;

    constructor(data?: ISendInvitationWorksInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["invitationWorksIds"] && data["invitationWorksIds"].constructor === Array) {
                this.invitationWorksIds = [];
                for (let item of data["invitationWorksIds"])
                    this.invitationWorksIds.push(item);
            }
        }
    }

    static fromJS(data: any): SendInvitationWorksInput {
        let result = new SendInvitationWorksInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.invitationWorksIds && this.invitationWorksIds.constructor === Array) {
            data["invitationWorksIds"] = [];
            for (let item of this.invitationWorksIds)
                data["invitationWorksIds"].push(item);
        }
        return data; 
    }
}

export interface ISendInvitationWorksInput {
    invitationWorksIds: number[] | undefined;
}

export class CreateInvitationWorksInput implements ICreateInvitationWorksInput {
    evaluatorsIds: number[] | undefined;
    send: boolean | undefined;

    constructor(data?: ICreateInvitationWorksInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["evaluatorsIds"] && data["evaluatorsIds"].constructor === Array) {
                this.evaluatorsIds = [];
                for (let item of data["evaluatorsIds"])
                    this.evaluatorsIds.push(item);
            }
            this.send = data["send"];
        }
    }

    static fromJS(data: any): CreateInvitationWorksInput {
        let result = new CreateInvitationWorksInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.evaluatorsIds && this.evaluatorsIds.constructor === Array) {
            data["evaluatorsIds"] = [];
            for (let item of this.evaluatorsIds)
                data["evaluatorsIds"].push(item);
        }
        data["send"] = this.send;
        return data; 
    }
}

export interface ICreateInvitationWorksInput {
    evaluatorsIds: number[] | undefined;
    send: boolean | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    amount: number | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment | undefined;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (data["tenantAddress"] && data["tenantAddress"].constructor === Array) {
                this.tenantAddress = [];
                for (let item of data["tenantAddress"])
                    this.tenantAddress.push(item);
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (data["hostAddress"] && data["hostAddress"].constructor === Array) {
                this.hostAddress = [];
                for (let item of data["hostAddress"])
                    this.hostAddress.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (this.tenantAddress && this.tenantAddress.constructor === Array) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (this.hostAddress && this.hostAddress.constructor === Array) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data; 
    }
}

export interface IInvoiceDto {
    amount: number | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment | undefined;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId: number | undefined;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data; 
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number | undefined;
}

export class GetItauTicketDto implements IGetItauTicketDto {
    orderId: number | undefined;
    html: string | undefined;

    constructor(data?: IGetItauTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderId = data["orderId"];
            this.html = data["html"];
        }
    }

    static fromJS(data: any): GetItauTicketDto {
        let result = new GetItauTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["html"] = this.html;
        return data; 
    }
}

export interface IGetItauTicketDto {
    orderId: number | undefined;
    html: string | undefined;
}

export class PagedResultDtoOfJobPositionDto implements IPagedResultDtoOfJobPositionDto {
    totalCount: number | undefined;
    items: JobPositionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfJobPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(JobPositionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfJobPositionDto {
        let result = new PagedResultDtoOfJobPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfJobPositionDto {
    totalCount: number | undefined;
    items: JobPositionDto[] | undefined;
}

export class JobPositionDto implements IJobPositionDto {
    name: string;
    approveRegistration: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IJobPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.approveRegistration = data["approveRegistration"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): JobPositionDto {
        let result = new JobPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["approveRegistration"] = this.approveRegistration;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IJobPositionDto {
    name: string;
    approveRegistration: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfJobPositionListDto implements IListResultDtoOfJobPositionListDto {
    items: JobPositionListDto[] | undefined;

    constructor(data?: IListResultDtoOfJobPositionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(JobPositionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfJobPositionListDto {
        let result = new ListResultDtoOfJobPositionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfJobPositionListDto {
    items: JobPositionListDto[] | undefined;
}

export class ListResultDtoOfJobPositionDetailListDto implements IListResultDtoOfJobPositionDetailListDto {
    items: JobPositionDetailListDto[] | undefined;

    constructor(data?: IListResultDtoOfJobPositionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(JobPositionDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfJobPositionDetailListDto {
        let result = new ListResultDtoOfJobPositionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfJobPositionDetailListDto {
    items: JobPositionDetailListDto[] | undefined;
}

export class JobPositionDetailListDto implements IJobPositionDetailListDto {
    description: string | undefined;
    id: number | undefined;

    constructor(data?: IJobPositionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): JobPositionDetailListDto {
        let result = new JobPositionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IJobPositionDetailListDto {
    description: string | undefined;
    id: number | undefined;
}

export class GetJobPositionForEditOutput implements IGetJobPositionForEditOutput {
    jobPosition: CreateOrEditJobPosition | undefined;

    constructor(data?: IGetJobPositionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.jobPosition = data["jobPosition"] ? CreateOrEditJobPosition.fromJS(data["jobPosition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJobPositionForEditOutput {
        let result = new GetJobPositionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobPosition"] = this.jobPosition ? this.jobPosition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetJobPositionForEditOutput {
    jobPosition: CreateOrEditJobPosition | undefined;
}

export class CreateOrEditJobPosition implements ICreateOrEditJobPosition {
    id: number | undefined;
    name: string;
    approveRegistration: boolean | undefined;

    constructor(data?: ICreateOrEditJobPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.approveRegistration = data["approveRegistration"];
        }
    }

    static fromJS(data: any): CreateOrEditJobPosition {
        let result = new CreateOrEditJobPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["approveRegistration"] = this.approveRegistration;
        return data; 
    }
}

export interface ICreateOrEditJobPosition {
    id: number | undefined;
    name: string;
    approveRegistration: boolean | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto | undefined;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : <any>undefined;
            if (data["languageNames"] && data["languageNames"].constructor === Array) {
                this.languageNames = [];
                for (let item of data["languageNames"])
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (data["flags"] && data["flags"].constructor === Array) {
                this.flags = [];
                for (let item of data["flags"])
                    this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (this.languageNames && this.languageNames.constructor === Array) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (this.flags && this.flags.constructor === Array) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto | undefined;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean | undefined;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto = new ApplicationLanguageEditDto();

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount: number | undefined;
    items: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number | undefined;
    items: LanguageTextListDto[] | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data; 
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class PagedResultDtoOfGetMemberAnnuityForView implements IPagedResultDtoOfGetMemberAnnuityForView {
    totalCount: number | undefined;
    items: GetMemberAnnuityForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMemberAnnuityForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMemberAnnuityForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMemberAnnuityForView {
        let result = new PagedResultDtoOfGetMemberAnnuityForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMemberAnnuityForView {
    totalCount: number | undefined;
    items: GetMemberAnnuityForView[] | undefined;
}

export class GetMemberAnnuityForView implements IGetMemberAnnuityForView {
    memberAnnuity: MemberAnnuityDto | undefined;
    memberCategory: string | undefined;

    constructor(data?: IGetMemberAnnuityForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberAnnuity = data["memberAnnuity"] ? MemberAnnuityDto.fromJS(data["memberAnnuity"]) : <any>undefined;
            this.memberCategory = data["memberCategory"];
        }
    }

    static fromJS(data: any): GetMemberAnnuityForView {
        let result = new GetMemberAnnuityForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberAnnuity"] = this.memberAnnuity ? this.memberAnnuity.toJSON() : <any>undefined;
        data["memberCategory"] = this.memberCategory;
        return data; 
    }
}

export interface IGetMemberAnnuityForView {
    memberAnnuity: MemberAnnuityDto | undefined;
    memberCategory: string | undefined;
}

export class ListResultDtoOfMemberAnnuityListDto implements IListResultDtoOfMemberAnnuityListDto {
    items: MemberAnnuityListDto[] | undefined;

    constructor(data?: IListResultDtoOfMemberAnnuityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MemberAnnuityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMemberAnnuityListDto {
        let result = new ListResultDtoOfMemberAnnuityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMemberAnnuityListDto {
    items: MemberAnnuityListDto[] | undefined;
}

export class MemberAnnuityListDto implements IMemberAnnuityListDto {
    id: number | undefined;
    annuityId: number | undefined;
    orderId: number | undefined;
    creationTime: moment.Moment | undefined;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    user: MemberAnnuityUserDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    documentationId: number | undefined;
    documentation: DocumentationDto | undefined;
    pendingDocumentation: boolean | undefined;
    paidSBA: boolean | undefined;
    status: MemberAnnuityListDtoStatus | undefined;
    netAmount: number | undefined;
    memberCategory: string | undefined;
    paymentDate: moment.Moment | undefined;

    constructor(data?: IMemberAnnuityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.annuityId = data["annuityId"];
            this.orderId = data["orderId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.annuity = data["annuity"] ? AnnuityEditDto.fromJS(data["annuity"]) : <any>undefined;
            this.memberId = data["memberId"];
            this.user = data["user"] ? MemberAnnuityUserDto.fromJS(data["user"]) : <any>undefined;
            this.categoryDeadLineId = data["categoryDeadLineId"];
            this.categoryDeadLine = data["categoryDeadLine"] ? AnnuityCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.documentationId = data["documentationId"];
            this.documentation = data["documentation"] ? DocumentationDto.fromJS(data["documentation"]) : <any>undefined;
            this.pendingDocumentation = data["pendingDocumentation"];
            this.paidSBA = data["paidSBA"];
            this.status = data["status"];
            this.netAmount = data["netAmount"];
            this.memberCategory = data["memberCategory"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MemberAnnuityListDto {
        let result = new MemberAnnuityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["annuityId"] = this.annuityId;
        data["orderId"] = this.orderId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["memberId"] = this.memberId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["documentationId"] = this.documentationId;
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        data["pendingDocumentation"] = this.pendingDocumentation;
        data["paidSBA"] = this.paidSBA;
        data["status"] = this.status;
        data["netAmount"] = this.netAmount;
        data["memberCategory"] = this.memberCategory;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMemberAnnuityListDto {
    id: number | undefined;
    annuityId: number | undefined;
    orderId: number | undefined;
    creationTime: moment.Moment | undefined;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    user: MemberAnnuityUserDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    documentationId: number | undefined;
    documentation: DocumentationDto | undefined;
    pendingDocumentation: boolean | undefined;
    paidSBA: boolean | undefined;
    status: MemberAnnuityListDtoStatus | undefined;
    netAmount: number | undefined;
    memberCategory: string | undefined;
    paymentDate: moment.Moment | undefined;
}

export class MemberAnnuityUserDto implements IMemberAnnuityUserDto {
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;

    constructor(data?: IMemberAnnuityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberAnnuityUserDto {
        let result = new MemberAnnuityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberAnnuityUserDto {
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;
}

export class UserPhoneDto implements IUserPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: UserPhoneDtoType;
    id: number | undefined;

    constructor(data?: IUserPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserPhoneDto {
        let result = new UserPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: UserPhoneDtoType;
    id: number | undefined;
}

export class GetMemberAnnuityForEditOutput implements IGetMemberAnnuityForEditOutput {
    memberAnnuity: CreateOrEditMemberAnnuityDto | undefined;

    constructor(data?: IGetMemberAnnuityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberAnnuity = data["memberAnnuity"] ? CreateOrEditMemberAnnuityDto.fromJS(data["memberAnnuity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMemberAnnuityForEditOutput {
        let result = new GetMemberAnnuityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberAnnuity"] = this.memberAnnuity ? this.memberAnnuity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetMemberAnnuityForEditOutput {
    memberAnnuity: CreateOrEditMemberAnnuityDto | undefined;
}

export class CreateOrEditMemberAnnuityDto implements ICreateOrEditMemberAnnuityDto {
    onLocal: boolean | undefined;
    justSave: boolean | undefined;
    annuity: MemberAnnuityDto | undefined;
    user: MemberAnnuityUserEditDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;
    sitefClientVoucher: string | undefined;
    sitefStoreVoucher: string | undefined;
    sitefTransactionData: string | undefined;

    constructor(data?: ICreateOrEditMemberAnnuityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.onLocal = data["onLocal"];
            this.justSave = data["justSave"];
            this.annuity = data["annuity"] ? MemberAnnuityDto.fromJS(data["annuity"]) : <any>undefined;
            this.user = data["user"] ? MemberAnnuityUserEditDto.fromJS(data["user"]) : <any>undefined;
            this.creditCardPayment = data["creditCardPayment"] ? CreditCardPaymentDto.fromJS(data["creditCardPayment"]) : <any>undefined;
            this.debitCardPayment = data["debitCardPayment"] ? DebitCardPaymentDto.fromJS(data["debitCardPayment"]) : <any>undefined;
            this.ticketPayment = data["ticketPayment"] ? TicketPaymentDto.fromJS(data["ticketPayment"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.sitefClientVoucher = data["sitefClientVoucher"];
            this.sitefStoreVoucher = data["sitefStoreVoucher"];
            this.sitefTransactionData = data["sitefTransactionData"];
        }
    }

    static fromJS(data: any): CreateOrEditMemberAnnuityDto {
        let result = new CreateOrEditMemberAnnuityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onLocal"] = this.onLocal;
        data["justSave"] = this.justSave;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>undefined;
        data["debitCardPayment"] = this.debitCardPayment ? this.debitCardPayment.toJSON() : <any>undefined;
        data["ticketPayment"] = this.ticketPayment ? this.ticketPayment.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["sitefClientVoucher"] = this.sitefClientVoucher;
        data["sitefStoreVoucher"] = this.sitefStoreVoucher;
        data["sitefTransactionData"] = this.sitefTransactionData;
        return data; 
    }
}

export interface ICreateOrEditMemberAnnuityDto {
    onLocal: boolean | undefined;
    justSave: boolean | undefined;
    annuity: MemberAnnuityDto | undefined;
    user: MemberAnnuityUserEditDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;
    sitefClientVoucher: string | undefined;
    sitefStoreVoucher: string | undefined;
    sitefTransactionData: string | undefined;
}

export class MemberAnnuityUserEditDto implements IMemberAnnuityUserEditDto {
    member: MemberAnnuityUserMemberEditDto | undefined;
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;

    constructor(data?: IMemberAnnuityUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.member = data["member"] ? MemberAnnuityUserMemberEditDto.fromJS(data["member"]) : <any>undefined;
            this.userName = data["userName"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberAnnuityUserEditDto {
        let result = new MemberAnnuityUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberAnnuityUserEditDto {
    member: MemberAnnuityUserMemberEditDto | undefined;
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;
}

export class CreditCardPaymentDto implements ICreditCardPaymentDto {
    cpf: string;
    creditCardBrand: string;
    holderName: string;
    cardNumber: string;
    cardExpirationDate: moment.Moment;
    securityCode: string;
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    readonly bankRate: number | undefined;
    readonly totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    cardBrand: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreditCardPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cpf = data["cpf"];
            this.creditCardBrand = data["creditCardBrand"];
            this.holderName = data["holderName"];
            this.cardNumber = data["cardNumber"];
            this.cardExpirationDate = data["cardExpirationDate"] ? moment(data["cardExpirationDate"].toString()) : <any>undefined;
            this.securityCode = data["securityCode"];
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.totalPaid = data["totalPaid"];
            this.netAmount = data["netAmount"];
            this.appliedDiscount = data["appliedDiscount"];
            (<any>this).bankRate = data["bankRate"];
            (<any>this).totalNetAmountReceived = data["totalNetAmountReceived"];
            this.note = data["note"];
            this.receivableId = data["receivableId"];
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.cardBrand = data["cardBrand"];
            this.numberOfInstallments = data["numberOfInstallments"];
            if (data["installments"] && data["installments"].constructor === Array) {
                this.installments = [];
                for (let item of data["installments"])
                    this.installments.push(InstallmentDto.fromJS(item));
            }
            if (data["transactions"] && data["transactions"].constructor === Array) {
                this.transactions = [];
                for (let item of data["transactions"])
                    this.transactions.push(TransactionRespondeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreditCardPaymentDto {
        let result = new CreditCardPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["creditCardBrand"] = this.creditCardBrand;
        data["holderName"] = this.holderName;
        data["cardNumber"] = this.cardNumber;
        data["cardExpirationDate"] = this.cardExpirationDate ? this.cardExpirationDate.toISOString() : <any>undefined;
        data["securityCode"] = this.securityCode;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["totalPaid"] = this.totalPaid;
        data["netAmount"] = this.netAmount;
        data["appliedDiscount"] = this.appliedDiscount;
        data["bankRate"] = this.bankRate;
        data["totalNetAmountReceived"] = this.totalNetAmountReceived;
        data["note"] = this.note;
        data["receivableId"] = this.receivableId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["cardBrand"] = this.cardBrand;
        data["numberOfInstallments"] = this.numberOfInstallments;
        if (this.installments && this.installments.constructor === Array) {
            data["installments"] = [];
            for (let item of this.installments)
                data["installments"].push(item.toJSON());
        }
        if (this.transactions && this.transactions.constructor === Array) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreditCardPaymentDto {
    cpf: string;
    creditCardBrand: string;
    holderName: string;
    cardNumber: string;
    cardExpirationDate: moment.Moment;
    securityCode: string;
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    bankRate: number | undefined;
    totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    cardBrand: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;
}

export class DebitCardPaymentDto implements IDebitCardPaymentDto {
    cpf: string;
    cardBrand: string;
    holderName: string;
    cardNumber: string;
    cardExpirationDate: moment.Moment;
    securityCode: string;
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    readonly bankRate: number | undefined;
    readonly totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;

    constructor(data?: IDebitCardPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cpf = data["cpf"];
            this.cardBrand = data["cardBrand"];
            this.holderName = data["holderName"];
            this.cardNumber = data["cardNumber"];
            this.cardExpirationDate = data["cardExpirationDate"] ? moment(data["cardExpirationDate"].toString()) : <any>undefined;
            this.securityCode = data["securityCode"];
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.totalPaid = data["totalPaid"];
            this.netAmount = data["netAmount"];
            this.appliedDiscount = data["appliedDiscount"];
            (<any>this).bankRate = data["bankRate"];
            (<any>this).totalNetAmountReceived = data["totalNetAmountReceived"];
            this.note = data["note"];
            this.receivableId = data["receivableId"];
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.numberOfInstallments = data["numberOfInstallments"];
            if (data["installments"] && data["installments"].constructor === Array) {
                this.installments = [];
                for (let item of data["installments"])
                    this.installments.push(InstallmentDto.fromJS(item));
            }
            if (data["transactions"] && data["transactions"].constructor === Array) {
                this.transactions = [];
                for (let item of data["transactions"])
                    this.transactions.push(TransactionRespondeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DebitCardPaymentDto {
        let result = new DebitCardPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["cardBrand"] = this.cardBrand;
        data["holderName"] = this.holderName;
        data["cardNumber"] = this.cardNumber;
        data["cardExpirationDate"] = this.cardExpirationDate ? this.cardExpirationDate.toISOString() : <any>undefined;
        data["securityCode"] = this.securityCode;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["totalPaid"] = this.totalPaid;
        data["netAmount"] = this.netAmount;
        data["appliedDiscount"] = this.appliedDiscount;
        data["bankRate"] = this.bankRate;
        data["totalNetAmountReceived"] = this.totalNetAmountReceived;
        data["note"] = this.note;
        data["receivableId"] = this.receivableId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["numberOfInstallments"] = this.numberOfInstallments;
        if (this.installments && this.installments.constructor === Array) {
            data["installments"] = [];
            for (let item of this.installments)
                data["installments"].push(item.toJSON());
        }
        if (this.transactions && this.transactions.constructor === Array) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IDebitCardPaymentDto {
    cpf: string;
    cardBrand: string;
    holderName: string;
    cardNumber: string;
    cardExpirationDate: moment.Moment;
    securityCode: string;
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    bankRate: number | undefined;
    totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;
}

export class TicketPaymentDto implements ITicketPaymentDto {
    expirationDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    readonly bankRate: number | undefined;
    readonly totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    cardBrand: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;

    constructor(data?: ITicketPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.totalPaid = data["totalPaid"];
            this.netAmount = data["netAmount"];
            this.appliedDiscount = data["appliedDiscount"];
            (<any>this).bankRate = data["bankRate"];
            (<any>this).totalNetAmountReceived = data["totalNetAmountReceived"];
            this.note = data["note"];
            this.receivableId = data["receivableId"];
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.cardBrand = data["cardBrand"];
            this.numberOfInstallments = data["numberOfInstallments"];
            if (data["installments"] && data["installments"].constructor === Array) {
                this.installments = [];
                for (let item of data["installments"])
                    this.installments.push(InstallmentDto.fromJS(item));
            }
            if (data["transactions"] && data["transactions"].constructor === Array) {
                this.transactions = [];
                for (let item of data["transactions"])
                    this.transactions.push(TransactionRespondeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TicketPaymentDto {
        let result = new TicketPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["totalPaid"] = this.totalPaid;
        data["netAmount"] = this.netAmount;
        data["appliedDiscount"] = this.appliedDiscount;
        data["bankRate"] = this.bankRate;
        data["totalNetAmountReceived"] = this.totalNetAmountReceived;
        data["note"] = this.note;
        data["receivableId"] = this.receivableId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["cardBrand"] = this.cardBrand;
        data["numberOfInstallments"] = this.numberOfInstallments;
        if (this.installments && this.installments.constructor === Array) {
            data["installments"] = [];
            for (let item of this.installments)
                data["installments"].push(item.toJSON());
        }
        if (this.transactions && this.transactions.constructor === Array) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITicketPaymentDto {
    expirationDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    totalPaid: number | undefined;
    netAmount: number | undefined;
    appliedDiscount: number | undefined;
    bankRate: number | undefined;
    totalNetAmountReceived: number | undefined;
    note: string | undefined;
    receivableId: number | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    paymentType: string | undefined;
    cardBrand: string | undefined;
    numberOfInstallments: number | undefined;
    installments: InstallmentDto[] | undefined;
    transactions: TransactionRespondeDto[] | undefined;
    id: number | undefined;
}

export class MemberAnnuityUserMemberEditDto implements IMemberAnnuityUserMemberEditDto {
    categories: MemberCategoryEditDto[] | undefined;

    constructor(data?: IMemberAnnuityUserMemberEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(MemberCategoryEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberAnnuityUserMemberEditDto {
        let result = new MemberAnnuityUserMemberEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberAnnuityUserMemberEditDto {
    categories: MemberCategoryEditDto[] | undefined;
}

export class CreateOrEditMemberAnnuityOutput implements ICreateOrEditMemberAnnuityOutput {
    memberAnnuityId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    link: string | undefined;
    barcode: string | undefined;

    constructor(data?: ICreateOrEditMemberAnnuityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberAnnuityId = data["memberAnnuityId"];
            this.success = data["success"];
            this.message = data["message"];
            this.html = data["html"];
            this.url = data["url"];
            this.link = data["link"];
            this.barcode = data["barcode"];
        }
    }

    static fromJS(data: any): CreateOrEditMemberAnnuityOutput {
        let result = new CreateOrEditMemberAnnuityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberAnnuityId"] = this.memberAnnuityId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["html"] = this.html;
        data["url"] = this.url;
        data["link"] = this.link;
        data["barcode"] = this.barcode;
        return data; 
    }
}

export interface ICreateOrEditMemberAnnuityOutput {
    memberAnnuityId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    link: string | undefined;
    barcode: string | undefined;
}

export class UpdateMemberAnnuityValuesInput implements IUpdateMemberAnnuityValuesInput {
    userName: string | undefined;
    annuity: MemberAnnuityDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;

    constructor(data?: IUpdateMemberAnnuityValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.annuity = data["annuity"] ? MemberAnnuityDto.fromJS(data["annuity"]) : <any>undefined;
            this.creditCardPayment = data["creditCardPayment"] ? CreditCardPaymentDto.fromJS(data["creditCardPayment"]) : <any>undefined;
            this.debitCardPayment = data["debitCardPayment"] ? DebitCardPaymentDto.fromJS(data["debitCardPayment"]) : <any>undefined;
            this.ticketPayment = data["ticketPayment"] ? TicketPaymentDto.fromJS(data["ticketPayment"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMemberAnnuityValuesInput {
        let result = new UpdateMemberAnnuityValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>undefined;
        data["debitCardPayment"] = this.debitCardPayment ? this.debitCardPayment.toJSON() : <any>undefined;
        data["ticketPayment"] = this.ticketPayment ? this.ticketPayment.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateMemberAnnuityValuesInput {
    userName: string | undefined;
    annuity: MemberAnnuityDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id: number | undefined;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt64 {
    id: number | undefined;
}

export class DisaproveDocDto implements IDisaproveDocDto {
    note: string;
    id: number | undefined;

    constructor(data?: IDisaproveDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DisaproveDocDto {
        let result = new DisaproveDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDisaproveDocDto {
    note: string;
    id: number | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount: number | undefined;
    totalCount: number | undefined;
    items: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number | undefined;
    totalCount: number | undefined;
    items: UserNotification[] | undefined;
}

export class UserNotification implements IUserNotification {
    tenantId: number | undefined;
    userId: number | undefined;
    state: UserNotificationState | undefined;
    notification: TenantNotification | undefined;
    id: string | undefined;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number | undefined;
    state: UserNotificationState | undefined;
    notification: TenantNotification | undefined;
    id: string | undefined;
}

export class TenantNotification implements ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData | undefined;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: TenantNotificationSeverity | undefined;
    creationTime: moment.Moment | undefined;
    id: string | undefined;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : <any>undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            if (data["entityId"]) {
                this.entityId = {};
                for (let key in data["entityId"]) {
                    if (data["entityId"].hasOwnProperty(key))
                        this.entityId[key] = data["entityId"][key];
                }
            }
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        if (this.entityId) {
            data["entityId"] = {};
            for (let key in this.entityId) {
                if (this.entityId.hasOwnProperty(key))
                    data["entityId"][key] = this.entityId[key];
            }
        }
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData | undefined;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: TenantNotificationSeverity | undefined;
    creationTime: moment.Moment | undefined;
    id: string | undefined;
}

export class NotificationData implements INotificationData {
    readonly type: string | undefined;
    properties: { [key: string] : any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (let key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string] : any; } | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id: string | undefined;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfGuid {
    id: string | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications: boolean | undefined;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean | undefined;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean | undefined;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean | undefined;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications: boolean | undefined;
    notifications: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean | undefined;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean | undefined;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean | undefined;
}

export class PagedResultDtoOfGetOrderForView implements IPagedResultDtoOfGetOrderForView {
    totalCount: number | undefined;
    items: GetOrderForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrderForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOrderForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrderForView {
        let result = new PagedResultDtoOfGetOrderForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetOrderForView {
    totalCount: number | undefined;
    items: GetOrderForView[] | undefined;
}

export class GetOrderForView implements IGetOrderForView {
    order: OrderDto | undefined;

    constructor(data?: IGetOrderForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"] ? OrderDto.fromJS(data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderForView {
        let result = new GetOrderForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetOrderForView {
    order: OrderDto | undefined;
}

export class OrderDto implements IOrderDto {
    memberAnnuities: MemberAnnuityOrderItemDto[] | undefined;
    registrations: RegistrationOrderItemDto[] | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: OrderDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: OrderDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["memberAnnuities"] && data["memberAnnuities"].constructor === Array) {
                this.memberAnnuities = [];
                for (let item of data["memberAnnuities"])
                    this.memberAnnuities.push(MemberAnnuityOrderItemDto.fromJS(item));
            }
            if (data["registrations"] && data["registrations"].constructor === Array) {
                this.registrations = [];
                for (let item of data["registrations"])
                    this.registrations.push(RegistrationOrderItemDto.fromJS(item));
            }
            this.orderId = data["orderId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderDto {
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.memberAnnuities && this.memberAnnuities.constructor === Array) {
            data["memberAnnuities"] = [];
            for (let item of this.memberAnnuities)
                data["memberAnnuities"].push(item.toJSON());
        }
        if (this.registrations && this.registrations.constructor === Array) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrderDto {
    memberAnnuities: MemberAnnuityOrderItemDto[] | undefined;
    registrations: RegistrationOrderItemDto[] | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: OrderDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: OrderDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class MemberAnnuityOrderItemDto implements IMemberAnnuityOrderItemDto {
    annuityId: number;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: MemberAnnuityOrderItemDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: MemberAnnuityOrderItemDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IMemberAnnuityOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityEditDto.fromJS(data["annuity"]) : <any>undefined;
            this.memberId = data["memberId"];
            this.categoryDeadLineId = data["categoryDeadLineId"];
            this.categoryDeadLine = data["categoryDeadLine"] ? AnnuityCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.orderId = data["orderId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberAnnuityOrderItemDto {
        let result = new MemberAnnuityOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["memberId"] = this.memberId;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberAnnuityOrderItemDto {
    annuityId: number;
    annuity: AnnuityEditDto | undefined;
    memberId: number | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: AnnuityCategoryDeadlineDto | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: MemberAnnuityOrderItemDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: MemberAnnuityOrderItemDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RegistrationOrderItemDto implements IRegistrationOrderItemDto {
    categoryId: number | undefined;
    hasPresence: boolean | undefined;
    coupon: CouponDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    note: string | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: RegistrationOrderItemDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: RegistrationOrderItemDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IRegistrationOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.hasPresence = data["hasPresence"];
            this.coupon = data["coupon"] ? CouponDto.fromJS(data["coupon"]) : <any>undefined;
            this.categoryDeadLineId = data["categoryDeadLineId"];
            this.categoryDeadLine = data["categoryDeadLine"] ? EventCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.note = data["note"];
            this.orderId = data["orderId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationOrderItemDto {
        let result = new RegistrationOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["hasPresence"] = this.hasPresence;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["note"] = this.note;
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationOrderItemDto {
    categoryId: number | undefined;
    hasPresence: boolean | undefined;
    coupon: CouponDto | undefined;
    categoryDeadLineId: number | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    note: string | undefined;
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: RegistrationOrderItemDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: RegistrationOrderItemDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetOrderForEditOutput implements IGetOrderForEditOutput {
    order: CreateOrEditOrderDto | undefined;

    constructor(data?: IGetOrderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"] ? CreateOrEditOrderDto.fromJS(data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderForEditOutput {
        let result = new GetOrderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetOrderForEditOutput {
    order: CreateOrEditOrderDto | undefined;
}

export class CreateOrEditOrderDto implements ICreateOrEditOrderDto {
    order: OrderDto | undefined;
    user: OrderUserEditDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;
    onLocal: boolean | undefined;
    justSave: boolean | undefined;
    autoApprove: boolean | undefined;
    sitefClientVoucher: string | undefined;
    sitefStoreVoucher: string | undefined;
    sitefTransactionData: string | undefined;

    constructor(data?: ICreateOrEditOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"] ? OrderDto.fromJS(data["order"]) : <any>undefined;
            this.user = data["user"] ? OrderUserEditDto.fromJS(data["user"]) : <any>undefined;
            this.creditCardPayment = data["creditCardPayment"] ? CreditCardPaymentDto.fromJS(data["creditCardPayment"]) : <any>undefined;
            this.debitCardPayment = data["debitCardPayment"] ? DebitCardPaymentDto.fromJS(data["debitCardPayment"]) : <any>undefined;
            this.ticketPayment = data["ticketPayment"] ? TicketPaymentDto.fromJS(data["ticketPayment"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.onLocal = data["onLocal"];
            this.justSave = data["justSave"];
            this.autoApprove = data["autoApprove"];
            this.sitefClientVoucher = data["sitefClientVoucher"];
            this.sitefStoreVoucher = data["sitefStoreVoucher"];
            this.sitefTransactionData = data["sitefTransactionData"];
        }
    }

    static fromJS(data: any): CreateOrEditOrderDto {
        let result = new CreateOrEditOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>undefined;
        data["debitCardPayment"] = this.debitCardPayment ? this.debitCardPayment.toJSON() : <any>undefined;
        data["ticketPayment"] = this.ticketPayment ? this.ticketPayment.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["onLocal"] = this.onLocal;
        data["justSave"] = this.justSave;
        data["autoApprove"] = this.autoApprove;
        data["sitefClientVoucher"] = this.sitefClientVoucher;
        data["sitefStoreVoucher"] = this.sitefStoreVoucher;
        data["sitefTransactionData"] = this.sitefTransactionData;
        return data; 
    }
}

export interface ICreateOrEditOrderDto {
    order: OrderDto | undefined;
    user: OrderUserEditDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;
    onLocal: boolean | undefined;
    justSave: boolean | undefined;
    autoApprove: boolean | undefined;
    sitefClientVoucher: string | undefined;
    sitefStoreVoucher: string | undefined;
    sitefTransactionData: string | undefined;
}

export class OrderUserEditDto implements IOrderUserEditDto {
    member: MemberAnnuityUserMemberEditDto | undefined;
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;

    constructor(data?: IOrderUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.member = data["member"] ? MemberAnnuityUserMemberEditDto.fromJS(data["member"]) : <any>undefined;
            this.userName = data["userName"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderUserEditDto {
        let result = new OrderUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrderUserEditDto {
    member: MemberAnnuityUserMemberEditDto | undefined;
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;
}

export class CreateOrEditOrderOutput implements ICreateOrEditOrderOutput {
    orderId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    items: ReceivableDto[] | undefined;
    barcode: string | undefined;
    link: string | undefined;

    constructor(data?: ICreateOrEditOrderOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderId = data["orderId"];
            this.success = data["success"];
            this.message = data["message"];
            this.html = data["html"];
            this.url = data["url"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReceivableDto.fromJS(item));
            }
            this.barcode = data["barcode"];
            this.link = data["link"];
        }
    }

    static fromJS(data: any): CreateOrEditOrderOutput {
        let result = new CreateOrEditOrderOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["html"] = this.html;
        data["url"] = this.url;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["barcode"] = this.barcode;
        data["link"] = this.link;
        return data; 
    }
}

export interface ICreateOrEditOrderOutput {
    orderId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    items: ReceivableDto[] | undefined;
    barcode: string | undefined;
    link: string | undefined;
}

export class ReceivableDto implements IReceivableDto {
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: ReceivableDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: ReceivableDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IReceivableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderId = data["orderId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.enterpriseId = data["enterpriseId"];
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                this.devolutions = [];
                for (let item of data["devolutions"])
                    this.devolutions.push(PayableListDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.description = data["description"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.synced = data["synced"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["costCenters"] && data["costCenters"].constructor === Array) {
                this.costCenters = [];
                for (let item of data["costCenters"])
                    this.costCenters.push(PaymentChargeCostCentersDto.fromJS(item));
            }
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReceivableDto {
        let result = new ReceivableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["enterpriseId"] = this.enterpriseId;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["description"] = this.description;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["synced"] = this.synced;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.costCenters && this.costCenters.constructor === Array) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReceivableDto {
    orderId: number | undefined;
    userId: number | undefined;
    user: UserListDto | undefined;
    enterpriseId: number | undefined;
    enterprise: EnterpriseListDto | undefined;
    statusIntegracao: ReceivableDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    payments: PaymentDto[] | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    description: string | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    annuityId: number | undefined;
    annuity: AnnuityListDto | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    status: ReceivableDtoStatus | undefined;
    synced: boolean | undefined;
    notes: NoteDto[] | undefined;
    costCenters: PaymentChargeCostCentersDto[] | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number | undefined;
    items: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number | undefined;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment | undefined;
    id: number | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id: number | undefined;
    displayName: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number | undefined;
    displayName: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id: number | undefined;
    newParentId: number | undefined;
    moveItemsToo: boolean | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
            this.moveItemsToo = data["moveItemsToo"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        data["moveItemsToo"] = this.moveItemsToo;
        return data; 
    }
}

export interface IMoveOrganizationUnitInput {
    id: number | undefined;
    newParentId: number | undefined;
    moveItemsToo: boolean | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number | undefined;
    addToParents: boolean | undefined;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["userIds"] && data["userIds"].constructor === Array) {
                this.userIds = [];
                for (let item of data["userIds"])
                    this.userIds.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
            this.addToParents = data["addToParents"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.userIds && this.userIds.constructor === Array) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        data["addToParents"] = this.addToParents;
        return data; 
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number | undefined;
    addToParents: boolean | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId: number | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition: EditionSelectDto | undefined;
    additionalPrice: number | undefined;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data; 
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto | undefined;
    additionalPrice: number | undefined;
}

export class EditionSelectDto implements IEditionSelectDto {
    id: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean | undefined;
    additionalData: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEditionSelectDto {
    id: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean | undefined;
    additionalData: AdditionalData | undefined;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId: number | undefined;
    editionPaymentType: CreatePaymentDtoEditionPaymentType | undefined;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType | undefined;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        return data; 
    }
}

export interface ICreatePaymentDto {
    editionId: number | undefined;
    editionPaymentType: CreatePaymentDtoEditionPaymentType | undefined;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType | undefined;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType | undefined;
}

export class ExecutePaymentDto implements IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway | undefined;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType | undefined;
    editionId: number | undefined;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType | undefined;
    additionalData: { [key: string] : string; } | undefined;

    constructor(data?: IExecutePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.editionPaymentType = data["editionPaymentType"];
            this.editionId = data["editionId"];
            this.paymentPeriodType = data["paymentPeriodType"];
            if (data["additionalData"]) {
                this.additionalData = {};
                for (let key in data["additionalData"]) {
                    if (data["additionalData"].hasOwnProperty(key))
                        this.additionalData[key] = data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecutePaymentDto {
        let result = new ExecutePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["editionPaymentType"] = this.editionPaymentType;
        data["editionId"] = this.editionId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    data["additionalData"][key] = this.additionalData[key];
            }
        }
        return data; 
    }
}

export interface IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway | undefined;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType | undefined;
    editionId: number | undefined;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType | undefined;
    additionalData: { [key: string] : string; } | undefined;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number | undefined;
    items: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number | undefined;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number | undefined;
    editionId: number | undefined;
    dayCount: number | undefined;
    paymentPeriodType: string | undefined;
    paymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number | undefined;
    invoiceNo: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number | undefined;
    editionId: number | undefined;
    dayCount: number | undefined;
    paymentPeriodType: string | undefined;
    paymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number | undefined;
    invoiceNo: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetReceivableForView implements IPagedResultDtoOfGetReceivableForView {
    totalCount: number | undefined;
    items: GetReceivableForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReceivableForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReceivableForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReceivableForView {
        let result = new PagedResultDtoOfGetReceivableForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetReceivableForView {
    totalCount: number | undefined;
    items: GetReceivableForView[] | undefined;
}

export class GetReceivableForView implements IGetReceivableForView {
    receivable: ReceivableDto | undefined;
    installmentsValue: number | undefined;
    receiptDate: moment.Moment | undefined;
    balance: number | undefined;

    constructor(data?: IGetReceivableForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receivable = data["receivable"] ? ReceivableDto.fromJS(data["receivable"]) : <any>undefined;
            this.installmentsValue = data["installmentsValue"];
            this.receiptDate = data["receiptDate"] ? moment(data["receiptDate"].toString()) : <any>undefined;
            this.balance = data["balance"];
        }
    }

    static fromJS(data: any): GetReceivableForView {
        let result = new GetReceivableForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivable"] = this.receivable ? this.receivable.toJSON() : <any>undefined;
        data["installmentsValue"] = this.installmentsValue;
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : <any>undefined;
        data["balance"] = this.balance;
        return data; 
    }
}

export interface IGetReceivableForView {
    receivable: ReceivableDto | undefined;
    installmentsValue: number | undefined;
    receiptDate: moment.Moment | undefined;
    balance: number | undefined;
}

export class ListResultDtoOfReceivableListDto implements IListResultDtoOfReceivableListDto {
    items: ReceivableListDto[] | undefined;

    constructor(data?: IListResultDtoOfReceivableListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReceivableListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfReceivableListDto {
        let result = new ListResultDtoOfReceivableListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfReceivableListDto {
    items: ReceivableListDto[] | undefined;
}

export class GetReceveibleForEditOutput implements IGetReceveibleForEditOutput {
    receivable: CreateOrEditReceivableDto | undefined;
    items: ReceivableDto[] | undefined;
    synced: boolean | undefined;

    constructor(data?: IGetReceveibleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receivable = data["receivable"] ? CreateOrEditReceivableDto.fromJS(data["receivable"]) : <any>undefined;
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReceivableDto.fromJS(item));
            }
            this.synced = data["synced"];
        }
    }

    static fromJS(data: any): GetReceveibleForEditOutput {
        let result = new GetReceveibleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivable"] = this.receivable ? this.receivable.toJSON() : <any>undefined;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["synced"] = this.synced;
        return data; 
    }
}

export interface IGetReceveibleForEditOutput {
    receivable: CreateOrEditReceivableDto | undefined;
    items: ReceivableDto[] | undefined;
    synced: boolean | undefined;
}

export class CreateOrEditReceivableDto implements ICreateOrEditReceivableDto {
    userId: number | undefined;
    codigoMaterial: string | undefined;
    historyCode: string | undefined;
    codigoContaFinanceira: string | undefined;
    codigoContaGerencial: string | undefined;
    codigoContrato: string | undefined;
    statusIntegracao: CreateOrEditReceivableDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    user: UserReceivableDto | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    payments: PaymentDto[] | undefined;
    readonly devolutions: PayableListDto[] | undefined;
    description: string | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    annuityId: number | undefined;
    enterpriseId: number | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    annuity: AnnuityListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    event: EventListDto | undefined;
    enterprise: EnterpriseListDto | undefined;
    status: CreateOrEditReceivableDtoStatus | undefined;
    notes: NoteEditDto[] | undefined;
    costCenter: CostCenterListDto | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditReceivableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.codigoMaterial = data["codigoMaterial"];
            this.historyCode = data["historyCode"];
            this.codigoContaFinanceira = data["codigoContaFinanceira"];
            this.codigoContaGerencial = data["codigoContaGerencial"];
            this.codigoContrato = data["codigoContrato"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.user = data["user"] ? UserReceivableDto.fromJS(data["user"]) : <any>undefined;
            if (data["paymentMethodPermissions"] && data["paymentMethodPermissions"].constructor === Array) {
                this.paymentMethodPermissions = [];
                for (let item of data["paymentMethodPermissions"])
                    this.paymentMethodPermissions.push(ReceivablePaymentMethodPermissionDto.fromJS(item));
            }
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            if (data["devolutions"] && data["devolutions"].constructor === Array) {
                (<any>this).devolutions = [];
                for (let item of data["devolutions"])
                    (<any>this).devolutions.push(PayableListDto.fromJS(item));
            }
            this.description = data["description"];
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.annuityId = data["annuityId"];
            this.enterpriseId = data["enterpriseId"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.status = data["status"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteEditDto.fromJS(item));
            }
            this.costCenter = data["costCenter"] ? CostCenterListDto.fromJS(data["costCenter"]) : <any>undefined;
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReceivableDto {
        let result = new CreateOrEditReceivableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["codigoMaterial"] = this.codigoMaterial;
        data["historyCode"] = this.historyCode;
        data["codigoContaFinanceira"] = this.codigoContaFinanceira;
        data["codigoContaGerencial"] = this.codigoContaGerencial;
        data["codigoContrato"] = this.codigoContrato;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.paymentMethodPermissions && this.paymentMethodPermissions.constructor === Array) {
            data["paymentMethodPermissions"] = [];
            for (let item of this.paymentMethodPermissions)
                data["paymentMethodPermissions"].push(item.toJSON());
        }
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.devolutions && this.devolutions.constructor === Array) {
            data["devolutions"] = [];
            for (let item of this.devolutions)
                data["devolutions"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["annuityId"] = this.annuityId;
        data["enterpriseId"] = this.enterpriseId;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["status"] = this.status;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditReceivableDto {
    userId: number | undefined;
    codigoMaterial: string | undefined;
    historyCode: string | undefined;
    codigoContaFinanceira: string | undefined;
    codigoContaGerencial: string | undefined;
    codigoContrato: string | undefined;
    statusIntegracao: CreateOrEditReceivableDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    user: UserReceivableDto | undefined;
    paymentMethodPermissions: ReceivablePaymentMethodPermissionDto[] | undefined;
    payments: PaymentDto[] | undefined;
    devolutions: PayableListDto[] | undefined;
    description: string | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    annuityId: number | undefined;
    enterpriseId: number | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    annuity: AnnuityListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    event: EventListDto | undefined;
    enterprise: EnterpriseListDto | undefined;
    status: CreateOrEditReceivableDtoStatus | undefined;
    notes: NoteEditDto[] | undefined;
    costCenter: CostCenterListDto | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    id: number | undefined;
}

export class UserReceivableDto implements IUserReceivableDto {
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;

    constructor(data?: IUserReceivableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserReceivableDto {
        let result = new UserReceivableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserReceivableDto {
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
    id: number | undefined;
}

export class GetInstallmentsDto implements IGetInstallmentsDto {
    fee: number | undefined;
    paymentDate: moment.Moment | undefined;
    installments: InstallmentDto[] | undefined;

    constructor(data?: IGetInstallmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fee = data["fee"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            if (data["installments"] && data["installments"].constructor === Array) {
                this.installments = [];
                for (let item of data["installments"])
                    this.installments.push(InstallmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInstallmentsDto {
        let result = new GetInstallmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fee"] = this.fee;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        if (this.installments && this.installments.constructor === Array) {
            data["installments"] = [];
            for (let item of this.installments)
                data["installments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetInstallmentsDto {
    fee: number | undefined;
    paymentDate: moment.Moment | undefined;
    installments: InstallmentDto[] | undefined;
}

export class UpdateInstallmentDto implements IUpdateInstallmentDto {
    receivablesIds: number[] | undefined;
    createDate: moment.Moment | undefined;
    fee: number | undefined;
    applyDateConfig: boolean | undefined;
    installments: InstallmentDto[] | undefined;

    constructor(data?: IUpdateInstallmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["receivablesIds"] && data["receivablesIds"].constructor === Array) {
                this.receivablesIds = [];
                for (let item of data["receivablesIds"])
                    this.receivablesIds.push(item);
            }
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.fee = data["fee"];
            this.applyDateConfig = data["applyDateConfig"];
            if (data["installments"] && data["installments"].constructor === Array) {
                this.installments = [];
                for (let item of data["installments"])
                    this.installments.push(InstallmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInstallmentDto {
        let result = new UpdateInstallmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.receivablesIds && this.receivablesIds.constructor === Array) {
            data["receivablesIds"] = [];
            for (let item of this.receivablesIds)
                data["receivablesIds"].push(item);
        }
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["fee"] = this.fee;
        data["applyDateConfig"] = this.applyDateConfig;
        if (this.installments && this.installments.constructor === Array) {
            data["installments"] = [];
            for (let item of this.installments)
                data["installments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateInstallmentDto {
    receivablesIds: number[] | undefined;
    createDate: moment.Moment | undefined;
    fee: number | undefined;
    applyDateConfig: boolean | undefined;
    installments: InstallmentDto[] | undefined;
}

export class SyncInstallmentsDto implements ISyncInstallmentsDto {
    createDateRange: DateRangeDto | undefined;
    receivablesIds: number[] | undefined;

    constructor(data?: ISyncInstallmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDateRange = data["createDateRange"] ? DateRangeDto.fromJS(data["createDateRange"]) : <any>undefined;
            if (data["receivablesIds"] && data["receivablesIds"].constructor === Array) {
                this.receivablesIds = [];
                for (let item of data["receivablesIds"])
                    this.receivablesIds.push(item);
            }
        }
    }

    static fromJS(data: any): SyncInstallmentsDto {
        let result = new SyncInstallmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDateRange"] = this.createDateRange ? this.createDateRange.toJSON() : <any>undefined;
        if (this.receivablesIds && this.receivablesIds.constructor === Array) {
            data["receivablesIds"] = [];
            for (let item of this.receivablesIds)
                data["receivablesIds"].push(item);
        }
        return data; 
    }
}

export interface ISyncInstallmentsDto {
    createDateRange: DateRangeDto | undefined;
    receivablesIds: number[] | undefined;
}

export class PaymentResponse implements IPaymentResponse {
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    link: string | undefined;
    data: string | undefined;
    url: string | undefined;
    barcode: string | undefined;

    constructor(data?: IPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.message = data["message"];
            this.html = data["html"];
            this.link = data["link"];
            this.data = data["data"];
            this.url = data["url"];
            this.barcode = data["barcode"];
        }
    }

    static fromJS(data: any): PaymentResponse {
        let result = new PaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["html"] = this.html;
        data["link"] = this.link;
        data["data"] = this.data;
        data["url"] = this.url;
        data["barcode"] = this.barcode;
        return data; 
    }
}

export interface IPaymentResponse {
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    link: string | undefined;
    data: string | undefined;
    url: string | undefined;
    barcode: string | undefined;
}

export class SendTicketsInput implements ISendTicketsInput {
    receivablesIds: number[] | undefined;

    constructor(data?: ISendTicketsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["receivablesIds"] && data["receivablesIds"].constructor === Array) {
                this.receivablesIds = [];
                for (let item of data["receivablesIds"])
                    this.receivablesIds.push(item);
            }
        }
    }

    static fromJS(data: any): SendTicketsInput {
        let result = new SendTicketsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.receivablesIds && this.receivablesIds.constructor === Array) {
            data["receivablesIds"] = [];
            for (let item of this.receivablesIds)
                data["receivablesIds"].push(item);
        }
        return data; 
    }
}

export interface ISendTicketsInput {
    receivablesIds: number[] | undefined;
}

export class AddPaymentOutput implements IAddPaymentOutput {
    receivableId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    link: string | undefined;
    barcode: string | undefined;

    constructor(data?: IAddPaymentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receivableId = data["receivableId"];
            this.success = data["success"];
            this.message = data["message"];
            this.html = data["html"];
            this.url = data["url"];
            this.link = data["link"];
            this.barcode = data["barcode"];
        }
    }

    static fromJS(data: any): AddPaymentOutput {
        let result = new AddPaymentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivableId"] = this.receivableId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["html"] = this.html;
        data["url"] = this.url;
        data["link"] = this.link;
        data["barcode"] = this.barcode;
        return data; 
    }
}

export interface IAddPaymentOutput {
    receivableId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    link: string | undefined;
    barcode: string | undefined;
}

export class AddPaymentInput implements IAddPaymentInput {
    receivable: CreateOrEditReceivableDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;

    constructor(data?: IAddPaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receivable = data["receivable"] ? CreateOrEditReceivableDto.fromJS(data["receivable"]) : <any>undefined;
            this.creditCardPayment = data["creditCardPayment"] ? CreditCardPaymentDto.fromJS(data["creditCardPayment"]) : <any>undefined;
            this.debitCardPayment = data["debitCardPayment"] ? DebitCardPaymentDto.fromJS(data["debitCardPayment"]) : <any>undefined;
            this.ticketPayment = data["ticketPayment"] ? TicketPaymentDto.fromJS(data["ticketPayment"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPaymentInput {
        let result = new AddPaymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivable"] = this.receivable ? this.receivable.toJSON() : <any>undefined;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>undefined;
        data["debitCardPayment"] = this.debitCardPayment ? this.debitCardPayment.toJSON() : <any>undefined;
        data["ticketPayment"] = this.ticketPayment ? this.ticketPayment.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPaymentInput {
    receivable: CreateOrEditReceivableDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    payment: PaymentDto | undefined;
}

export class PagedResultDtoOfGetPayableForView implements IPagedResultDtoOfGetPayableForView {
    totalCount: number | undefined;
    items: GetPayableForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPayableForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPayableForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPayableForView {
        let result = new PagedResultDtoOfGetPayableForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPayableForView {
    totalCount: number | undefined;
    items: GetPayableForView[] | undefined;
}

export class GetPayableForView implements IGetPayableForView {
    payable: PayableDto | undefined;

    constructor(data?: IGetPayableForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payable = data["payable"] ? PayableDto.fromJS(data["payable"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPayableForView {
        let result = new GetPayableForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payable"] = this.payable ? this.payable.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPayableForView {
    payable: PayableDto | undefined;
}

export class GetPayableForEditOutput implements IGetPayableForEditOutput {
    payable: CreateOrEditPayableDto | undefined;

    constructor(data?: IGetPayableForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payable = data["payable"] ? CreateOrEditPayableDto.fromJS(data["payable"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPayableForEditOutput {
        let result = new GetPayableForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payable"] = this.payable ? this.payable.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPayableForEditOutput {
    payable: CreateOrEditPayableDto | undefined;
}

export class CreateOrEditPayableDto implements ICreateOrEditPayableDto {
    userId: number | undefined;
    user: UserPayableDto | undefined;
    customer: string | undefined;
    reference: string | undefined;
    receivableId: number | undefined;
    receivable: ReceivableListDto | undefined;
    type: CreateOrEditPayableDtoType | undefined;
    description: string | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    annuityId: number | undefined;
    enterpriseId: number | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    annuity: AnnuityListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    event: EventListDto | undefined;
    enterprise: EnterpriseListDto | undefined;
    status: CreateOrEditPayableDtoStatus | undefined;
    notes: NoteEditDto[] | undefined;
    costCenter: CostCenterListDto | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditPayableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.user = data["user"] ? UserPayableDto.fromJS(data["user"]) : <any>undefined;
            this.customer = data["customer"];
            this.reference = data["reference"];
            this.receivableId = data["receivableId"];
            this.receivable = data["receivable"] ? ReceivableListDto.fromJS(data["receivable"]) : <any>undefined;
            this.type = data["type"];
            this.description = data["description"];
            this.amount = data["amount"];
            this.discount = data["discount"];
            this.increase = data["increase"];
            this.netAmount = data["netAmount"];
            this.paymentChargeType = data["paymentChargeType"];
            this.eventId = data["eventId"];
            this.annuityId = data["annuityId"];
            this.enterpriseId = data["enterpriseId"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.annuity = data["annuity"] ? AnnuityListDto.fromJS(data["annuity"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.enterprise = data["enterprise"] ? EnterpriseListDto.fromJS(data["enterprise"]) : <any>undefined;
            this.status = data["status"];
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteEditDto.fromJS(item));
            }
            this.costCenter = data["costCenter"] ? CostCenterListDto.fromJS(data["costCenter"]) : <any>undefined;
            if (data["transactionHistories"] && data["transactionHistories"].constructor === Array) {
                this.transactionHistories = [];
                for (let item of data["transactionHistories"])
                    this.transactionHistories.push(TransactionHistoryDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPayableDto {
        let result = new CreateOrEditPayableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["customer"] = this.customer;
        data["reference"] = this.reference;
        data["receivableId"] = this.receivableId;
        data["receivable"] = this.receivable ? this.receivable.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        data["increase"] = this.increase;
        data["netAmount"] = this.netAmount;
        data["paymentChargeType"] = this.paymentChargeType;
        data["eventId"] = this.eventId;
        data["annuityId"] = this.annuityId;
        data["enterpriseId"] = this.enterpriseId;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["enterprise"] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
        data["status"] = this.status;
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        if (this.transactionHistories && this.transactionHistories.constructor === Array) {
            data["transactionHistories"] = [];
            for (let item of this.transactionHistories)
                data["transactionHistories"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPayableDto {
    userId: number | undefined;
    user: UserPayableDto | undefined;
    customer: string | undefined;
    reference: string | undefined;
    receivableId: number | undefined;
    receivable: ReceivableListDto | undefined;
    type: CreateOrEditPayableDtoType | undefined;
    description: string | undefined;
    amount: number | undefined;
    discount: number | undefined;
    increase: number | undefined;
    netAmount: number | undefined;
    paymentChargeType: string | undefined;
    eventId: number | undefined;
    annuityId: number | undefined;
    enterpriseId: number | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    annuity: AnnuityListDto | undefined;
    paymentDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    cancelDate: moment.Moment | undefined;
    event: EventListDto | undefined;
    enterprise: EnterpriseListDto | undefined;
    status: CreateOrEditPayableDtoStatus | undefined;
    notes: NoteEditDto[] | undefined;
    costCenter: CostCenterListDto | undefined;
    transactionHistories: TransactionHistoryDto[] | undefined;
    id: number | undefined;
}

export class UserPayableDto implements IUserPayableDto {
    userName: string | undefined;
    name: string | undefined;
    nameForCredential: string | undefined;
    emailAddress: string | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;

    constructor(data?: IUserPayableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserPayableDto {
        let result = new UserPayableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserPayableDto {
    userName: string | undefined;
    name: string | undefined;
    nameForCredential: string | undefined;
    emailAddress: string | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto | undefined;
}

export class PagedResultDtoOfGetPaymentMethodForView implements IPagedResultDtoOfGetPaymentMethodForView {
    totalCount: number | undefined;
    items: GetPaymentMethodForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPaymentMethodForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPaymentMethodForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPaymentMethodForView {
        let result = new PagedResultDtoOfGetPaymentMethodForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPaymentMethodForView {
    totalCount: number | undefined;
    items: GetPaymentMethodForView[] | undefined;
}

export class GetPaymentMethodForView implements IGetPaymentMethodForView {
    paymentMethod: PaymentMethodDto | undefined;

    constructor(data?: IGetPaymentMethodForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodDto.fromJS(data["paymentMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentMethodForView {
        let result = new GetPaymentMethodForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPaymentMethodForView {
    paymentMethod: PaymentMethodDto | undefined;
}

export class PaymentMethodDto implements IPaymentMethodDto {
    description: string | undefined;
    environmentType: PaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    bankAccountId: number | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    id: number | undefined;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.bankAccountId = data["bankAccountId"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodDto {
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["bankAccountId"] = this.bankAccountId;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethodDto {
    description: string | undefined;
    environmentType: PaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    bankAccountId: number | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    id: number | undefined;
}

export class ListResultDtoOfPaymentMethodEditDto implements IListResultDtoOfPaymentMethodEditDto {
    items: PaymentMethodEditDto[] | undefined;

    constructor(data?: IListResultDtoOfPaymentMethodEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PaymentMethodEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPaymentMethodEditDto {
        let result = new ListResultDtoOfPaymentMethodEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPaymentMethodEditDto {
    items: PaymentMethodEditDto[] | undefined;
}

export class GetPaymentMethodForEditOutput implements IGetPaymentMethodForEditOutput {
    paymentMethod: CreateOrEditPaymentMethodDto | undefined;

    constructor(data?: IGetPaymentMethodForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentMethod = data["paymentMethod"] ? CreateOrEditPaymentMethodDto.fromJS(data["paymentMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentMethodForEditOutput {
        let result = new GetPaymentMethodForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPaymentMethodForEditOutput {
    paymentMethod: CreateOrEditPaymentMethodDto | undefined;
}

export class CreateOrEditPaymentMethodDto implements ICreateOrEditPaymentMethodDto {
    ticketPaymentMethod: TicketPaymentMethodDto | undefined;
    creditCardPaymentMethod: CreditCardPaymentMethodDto | undefined;
    debitCardPaymentMethod: DebitCardPaymentMethodDto | undefined;
    depositPaymentMethod: DepositPaymentMethodDto | undefined;
    moneyPaymentMethod: MoneyPaymentMethodDto | undefined;
    checkPaymentMethod: CheckPaymentMethodDto | undefined;
    bankTransferPaymentMethod: BankTransferPaymentMethodDto | undefined;
    couponPaymentMethod: CouponPaymentMethodDto | undefined;

    constructor(data?: ICreateOrEditPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ticketPaymentMethod = data["ticketPaymentMethod"] ? TicketPaymentMethodDto.fromJS(data["ticketPaymentMethod"]) : <any>undefined;
            this.creditCardPaymentMethod = data["creditCardPaymentMethod"] ? CreditCardPaymentMethodDto.fromJS(data["creditCardPaymentMethod"]) : <any>undefined;
            this.debitCardPaymentMethod = data["debitCardPaymentMethod"] ? DebitCardPaymentMethodDto.fromJS(data["debitCardPaymentMethod"]) : <any>undefined;
            this.depositPaymentMethod = data["depositPaymentMethod"] ? DepositPaymentMethodDto.fromJS(data["depositPaymentMethod"]) : <any>undefined;
            this.moneyPaymentMethod = data["moneyPaymentMethod"] ? MoneyPaymentMethodDto.fromJS(data["moneyPaymentMethod"]) : <any>undefined;
            this.checkPaymentMethod = data["checkPaymentMethod"] ? CheckPaymentMethodDto.fromJS(data["checkPaymentMethod"]) : <any>undefined;
            this.bankTransferPaymentMethod = data["bankTransferPaymentMethod"] ? BankTransferPaymentMethodDto.fromJS(data["bankTransferPaymentMethod"]) : <any>undefined;
            this.couponPaymentMethod = data["couponPaymentMethod"] ? CouponPaymentMethodDto.fromJS(data["couponPaymentMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditPaymentMethodDto {
        let result = new CreateOrEditPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketPaymentMethod"] = this.ticketPaymentMethod ? this.ticketPaymentMethod.toJSON() : <any>undefined;
        data["creditCardPaymentMethod"] = this.creditCardPaymentMethod ? this.creditCardPaymentMethod.toJSON() : <any>undefined;
        data["debitCardPaymentMethod"] = this.debitCardPaymentMethod ? this.debitCardPaymentMethod.toJSON() : <any>undefined;
        data["depositPaymentMethod"] = this.depositPaymentMethod ? this.depositPaymentMethod.toJSON() : <any>undefined;
        data["moneyPaymentMethod"] = this.moneyPaymentMethod ? this.moneyPaymentMethod.toJSON() : <any>undefined;
        data["checkPaymentMethod"] = this.checkPaymentMethod ? this.checkPaymentMethod.toJSON() : <any>undefined;
        data["bankTransferPaymentMethod"] = this.bankTransferPaymentMethod ? this.bankTransferPaymentMethod.toJSON() : <any>undefined;
        data["couponPaymentMethod"] = this.couponPaymentMethod ? this.couponPaymentMethod.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditPaymentMethodDto {
    ticketPaymentMethod: TicketPaymentMethodDto | undefined;
    creditCardPaymentMethod: CreditCardPaymentMethodDto | undefined;
    debitCardPaymentMethod: DebitCardPaymentMethodDto | undefined;
    depositPaymentMethod: DepositPaymentMethodDto | undefined;
    moneyPaymentMethod: MoneyPaymentMethodDto | undefined;
    checkPaymentMethod: CheckPaymentMethodDto | undefined;
    bankTransferPaymentMethod: BankTransferPaymentMethodDto | undefined;
    couponPaymentMethod: CouponPaymentMethodDto | undefined;
}

export class TicketPaymentMethodDto implements ITicketPaymentMethodDto {
    wallet: string | undefined;
    isRegisteredCharge: boolean | undefined;
    processCode: string | undefined;
    encryptedKey: string | undefined;
    daysUntilTicketExpiration: number | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    urlToken: string | undefined;
    urlApiBoleto: string | undefined;
    urlConsultaBoleto: string | undefined;
    certificatePfxPath: string | undefined;
    certificatePfxPassoword: string | undefined;
    certificatePfxInput: CertificateFileItauInput | undefined;
    description: string | undefined;
    environmentType: TicketPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;

    constructor(data?: ITicketPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.wallet = data["wallet"];
            this.isRegisteredCharge = data["isRegisteredCharge"];
            this.processCode = data["processCode"];
            this.encryptedKey = data["encryptedKey"];
            this.daysUntilTicketExpiration = data["daysUntilTicketExpiration"];
            this.clientId = data["clientId"];
            this.clientSecret = data["clientSecret"];
            this.urlToken = data["urlToken"];
            this.urlApiBoleto = data["urlApiBoleto"];
            this.urlConsultaBoleto = data["urlConsultaBoleto"];
            this.certificatePfxPath = data["certificatePfxPath"];
            this.certificatePfxPassoword = data["certificatePfxPassoword"];
            this.certificatePfxInput = data["certificatePfxInput"] ? CertificateFileItauInput.fromJS(data["certificatePfxInput"]) : <any>undefined;
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(CardBrandDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TicketPaymentMethodDto {
        let result = new TicketPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wallet"] = this.wallet;
        data["isRegisteredCharge"] = this.isRegisteredCharge;
        data["processCode"] = this.processCode;
        data["encryptedKey"] = this.encryptedKey;
        data["daysUntilTicketExpiration"] = this.daysUntilTicketExpiration;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["urlToken"] = this.urlToken;
        data["urlApiBoleto"] = this.urlApiBoleto;
        data["urlConsultaBoleto"] = this.urlConsultaBoleto;
        data["certificatePfxPath"] = this.certificatePfxPath;
        data["certificatePfxPassoword"] = this.certificatePfxPassoword;
        data["certificatePfxInput"] = this.certificatePfxInput ? this.certificatePfxInput.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITicketPaymentMethodDto {
    wallet: string | undefined;
    isRegisteredCharge: boolean | undefined;
    processCode: string | undefined;
    encryptedKey: string | undefined;
    daysUntilTicketExpiration: number | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    urlToken: string | undefined;
    urlApiBoleto: string | undefined;
    urlConsultaBoleto: string | undefined;
    certificatePfxPath: string | undefined;
    certificatePfxPassoword: string | undefined;
    certificatePfxInput: CertificateFileItauInput | undefined;
    description: string | undefined;
    environmentType: TicketPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;
}

export class CreditCardPaymentMethodDto implements ICreditCardPaymentMethodDto {
    affiliation: number | undefined;
    accessKey: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    urlProcessing: string | undefined;
    tokenUrl: string | undefined;
    baseUrl: string | undefined;
    transactionUrl: string | undefined;
    cardBrands: PaymentMethodCardBrandDto[] | undefined;
    description: string | undefined;
    environmentType: CreditCardPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    id: number | undefined;

    constructor(data?: ICreditCardPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.affiliation = data["affiliation"];
            this.accessKey = data["accessKey"];
            this.clientId = data["clientId"];
            this.clientSecret = data["clientSecret"];
            this.urlProcessing = data["urlProcessing"];
            this.tokenUrl = data["tokenUrl"];
            this.baseUrl = data["baseUrl"];
            this.transactionUrl = data["transactionUrl"];
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(PaymentMethodCardBrandDto.fromJS(item));
            }
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreditCardPaymentMethodDto {
        let result = new CreditCardPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["affiliation"] = this.affiliation;
        data["accessKey"] = this.accessKey;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["urlProcessing"] = this.urlProcessing;
        data["tokenUrl"] = this.tokenUrl;
        data["baseUrl"] = this.baseUrl;
        data["transactionUrl"] = this.transactionUrl;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreditCardPaymentMethodDto {
    affiliation: number | undefined;
    accessKey: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    urlProcessing: string | undefined;
    tokenUrl: string | undefined;
    baseUrl: string | undefined;
    transactionUrl: string | undefined;
    cardBrands: PaymentMethodCardBrandDto[] | undefined;
    description: string | undefined;
    environmentType: CreditCardPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    id: number | undefined;
}

export class DebitCardPaymentMethodDto implements IDebitCardPaymentMethodDto {
    affiliation: number | undefined;
    accessKey: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    urlProcessing: string | undefined;
    tokenUrl: string | undefined;
    baseUrl: string | undefined;
    transactionUrl: string | undefined;
    cardBrands: PaymentMethodCardBrandDto[] | undefined;
    description: string | undefined;
    environmentType: DebitCardPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    id: number | undefined;

    constructor(data?: IDebitCardPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.affiliation = data["affiliation"];
            this.accessKey = data["accessKey"];
            this.clientId = data["clientId"];
            this.clientSecret = data["clientSecret"];
            this.urlProcessing = data["urlProcessing"];
            this.tokenUrl = data["tokenUrl"];
            this.baseUrl = data["baseUrl"];
            this.transactionUrl = data["transactionUrl"];
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(PaymentMethodCardBrandDto.fromJS(item));
            }
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DebitCardPaymentMethodDto {
        let result = new DebitCardPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["affiliation"] = this.affiliation;
        data["accessKey"] = this.accessKey;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["urlProcessing"] = this.urlProcessing;
        data["tokenUrl"] = this.tokenUrl;
        data["baseUrl"] = this.baseUrl;
        data["transactionUrl"] = this.transactionUrl;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDebitCardPaymentMethodDto {
    affiliation: number | undefined;
    accessKey: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    urlProcessing: string | undefined;
    tokenUrl: string | undefined;
    baseUrl: string | undefined;
    transactionUrl: string | undefined;
    cardBrands: PaymentMethodCardBrandDto[] | undefined;
    description: string | undefined;
    environmentType: DebitCardPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    id: number | undefined;
}

export class DepositPaymentMethodDto implements IDepositPaymentMethodDto {
    description: string | undefined;
    environmentType: DepositPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;

    constructor(data?: IDepositPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(CardBrandDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DepositPaymentMethodDto {
        let result = new DepositPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IDepositPaymentMethodDto {
    description: string | undefined;
    environmentType: DepositPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;
}

export class MoneyPaymentMethodDto implements IMoneyPaymentMethodDto {
    description: string | undefined;
    environmentType: MoneyPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;

    constructor(data?: IMoneyPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(CardBrandDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MoneyPaymentMethodDto {
        let result = new MoneyPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IMoneyPaymentMethodDto {
    description: string | undefined;
    environmentType: MoneyPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;
}

export class CheckPaymentMethodDto implements ICheckPaymentMethodDto {
    description: string | undefined;
    environmentType: CheckPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICheckPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(CardBrandDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CheckPaymentMethodDto {
        let result = new CheckPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICheckPaymentMethodDto {
    description: string | undefined;
    environmentType: CheckPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;
}

export class BankTransferPaymentMethodDto implements IBankTransferPaymentMethodDto {
    description: string | undefined;
    environmentType: BankTransferPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;

    constructor(data?: IBankTransferPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(CardBrandDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BankTransferPaymentMethodDto {
        let result = new BankTransferPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IBankTransferPaymentMethodDto {
    description: string | undefined;
    environmentType: BankTransferPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;
}

export class CouponPaymentMethodDto implements ICouponPaymentMethodDto {
    description: string | undefined;
    environmentType: CouponPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICouponPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.environmentType = data["environmentType"];
            this.maxFee = data["maxFee"];
            this.isActive = data["isActive"];
            this.paymentMethodType = data["paymentMethodType"];
            this.isDefaultToReceivable = data["isDefaultToReceivable"];
            this.bankAccountId = data["bankAccountId"];
            this.bankAccount = data["bankAccount"] ? BankAccountListDto.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["cardBrands"] && data["cardBrands"].constructor === Array) {
                this.cardBrands = [];
                for (let item of data["cardBrands"])
                    this.cardBrands.push(CardBrandDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponPaymentMethodDto {
        let result = new CouponPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isActive"] = this.isActive;
        data["paymentMethodType"] = this.paymentMethodType;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.cardBrands && this.cardBrands.constructor === Array) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponPaymentMethodDto {
    description: string | undefined;
    environmentType: CouponPaymentMethodDtoEnvironmentType | undefined;
    maxFee: number | undefined;
    isActive: boolean | undefined;
    paymentMethodType: string | undefined;
    isDefaultToReceivable: boolean | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccountListDto | undefined;
    cardBrands: CardBrandDto[] | undefined;
    id: number | undefined;
}

export class CertificateFileItauInput implements ICertificateFileItauInput {
    itauConfigId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: ICertificateFileItauInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itauConfigId = data["itauConfigId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): CertificateFileItauInput {
        let result = new CertificateFileItauInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itauConfigId"] = this.itauConfigId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface ICertificateFileItauInput {
    itauConfigId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class PaymentMethodCardBrandDto implements IPaymentMethodCardBrandDto {
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    cardBrandId: number | undefined;
    cardBrand: CardBrandDto | undefined;
    fees: CardFeeDto[] | undefined;
    id: number | undefined;

    constructor(data?: IPaymentMethodCardBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethodEditDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.cardBrandId = data["cardBrandId"];
            this.cardBrand = data["cardBrand"] ? CardBrandDto.fromJS(data["cardBrand"]) : <any>undefined;
            if (data["fees"] && data["fees"].constructor === Array) {
                this.fees = [];
                for (let item of data["fees"])
                    this.fees.push(CardFeeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodCardBrandDto {
        let result = new PaymentMethodCardBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["cardBrandId"] = this.cardBrandId;
        data["cardBrand"] = this.cardBrand ? this.cardBrand.toJSON() : <any>undefined;
        if (this.fees && this.fees.constructor === Array) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethodCardBrandDto {
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethodEditDto | undefined;
    cardBrandId: number | undefined;
    cardBrand: CardBrandDto | undefined;
    fees: CardFeeDto[] | undefined;
    id: number | undefined;
}

export class CardFeeDto implements ICardFeeDto {
    installments: number | undefined;
    percentage: number | undefined;
    paymentMethodCardBrandId: number | undefined;
    id: number | undefined;

    constructor(data?: ICardFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.installments = data["installments"];
            this.percentage = data["percentage"];
            this.paymentMethodCardBrandId = data["paymentMethodCardBrandId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CardFeeDto {
        let result = new CardFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installments"] = this.installments;
        data["percentage"] = this.percentage;
        data["paymentMethodCardBrandId"] = this.paymentMethodCardBrandId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICardFeeDto {
    installments: number | undefined;
    percentage: number | undefined;
    paymentMethodCardBrandId: number | undefined;
    id: number | undefined;
}

export class PaymentMethodPermission implements IPaymentMethodPermission {
    readonly isAllowed: boolean | undefined;
    readonly fee: number | undefined;
    readonly percentDiscount: number | undefined;
    readonly paymentMethodPermissionType: string | undefined;
    readonly paymentMethodId: number | undefined;
    paymentMethod: PaymentMethod | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IPaymentMethodPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).isAllowed = data["isAllowed"];
            (<any>this).fee = data["fee"];
            (<any>this).percentDiscount = data["percentDiscount"];
            (<any>this).paymentMethodPermissionType = data["paymentMethodPermissionType"];
            (<any>this).paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? PaymentMethod.fromJS(data["paymentMethod"]) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodPermission {
        let result = new PaymentMethodPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAllowed"] = this.isAllowed;
        data["fee"] = this.fee;
        data["percentDiscount"] = this.percentDiscount;
        data["paymentMethodPermissionType"] = this.paymentMethodPermissionType;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethodPermission {
    isAllowed: boolean | undefined;
    fee: number | undefined;
    percentDiscount: number | undefined;
    paymentMethodPermissionType: string | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: PaymentMethod | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PaymentMethod implements IPaymentMethod {
    tenantId: number | undefined;
    isActive: boolean | undefined;
    readonly description: string;
    readonly environmentType: PaymentMethodEnvironmentType | undefined;
    readonly maxFee: number | undefined;
    readonly isDefaultToReceivable: boolean | undefined;
    paymentMethodType: string | undefined;
    bankAccountId: number | undefined;
    readonly bankAccount: BankAccount | undefined;
    permissions: PaymentMethodPermission[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.isActive = data["isActive"];
            (<any>this).description = data["description"];
            (<any>this).environmentType = data["environmentType"];
            (<any>this).maxFee = data["maxFee"];
            (<any>this).isDefaultToReceivable = data["isDefaultToReceivable"];
            this.paymentMethodType = data["paymentMethodType"];
            this.bankAccountId = data["bankAccountId"];
            (<any>this).bankAccount = data["bankAccount"] ? BankAccount.fromJS(data["bankAccount"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(PaymentMethodPermission.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethod {
        let result = new PaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["environmentType"] = this.environmentType;
        data["maxFee"] = this.maxFee;
        data["isDefaultToReceivable"] = this.isDefaultToReceivable;
        data["paymentMethodType"] = this.paymentMethodType;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethod {
    tenantId: number | undefined;
    isActive: boolean | undefined;
    description: string;
    environmentType: PaymentMethodEnvironmentType | undefined;
    maxFee: number | undefined;
    isDefaultToReceivable: boolean | undefined;
    paymentMethodType: string | undefined;
    bankAccountId: number | undefined;
    bankAccount: BankAccount | undefined;
    permissions: PaymentMethodPermission[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class BankAccount implements IBankAccount {
    tenantId: number | undefined;
    description: string | undefined;
    bankCode: string | undefined;
    agency: string | undefined;
    agencyDigit: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    holderName: string | undefined;
    cnpj: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IBankAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.description = data["description"];
            this.bankCode = data["bankCode"];
            this.agency = data["agency"];
            this.agencyDigit = data["agencyDigit"];
            this.checkingAccount = data["checkingAccount"];
            this.checkingAccountDigit = data["checkingAccountDigit"];
            this.holderName = data["holderName"];
            this.cnpj = data["cnpj"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BankAccount {
        let result = new BankAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["bankCode"] = this.bankCode;
        data["agency"] = this.agency;
        data["agencyDigit"] = this.agencyDigit;
        data["checkingAccount"] = this.checkingAccount;
        data["checkingAccountDigit"] = this.checkingAccountDigit;
        data["holderName"] = this.holderName;
        data["cnpj"] = this.cnpj;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBankAccount {
    tenantId: number | undefined;
    description: string | undefined;
    bankCode: string | undefined;
    agency: string | undefined;
    agencyDigit: string | undefined;
    checkingAccount: string | undefined;
    checkingAccountDigit: string | undefined;
    holderName: string | undefined;
    cnpj: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level: number | undefined;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number | undefined;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean | undefined;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean | undefined;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data; 
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data; 
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureInput {
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting | undefined;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting | undefined;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class PagedResultDtoOfGetProgrammingForView implements IPagedResultDtoOfGetProgrammingForView {
    totalCount: number | undefined;
    items: GetProgrammingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProgrammingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProgrammingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProgrammingForView {
        let result = new PagedResultDtoOfGetProgrammingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetProgrammingForView {
    totalCount: number | undefined;
    items: GetProgrammingForView[] | undefined;
}

export class GetProgrammingForView implements IGetProgrammingForView {
    programming: ProgrammingDto | undefined;

    constructor(data?: IGetProgrammingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programming = data["programming"] ? ProgrammingDto.fromJS(data["programming"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgrammingForView {
        let result = new GetProgrammingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programming"] = this.programming ? this.programming.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetProgrammingForView {
    programming: ProgrammingDto | undefined;
}

export class ProgrammingDto implements IProgrammingDto {
    digitalMidiaLink: string | undefined;
    eventId: number;
    event: EventDto | undefined;
    calendarId: number | undefined;
    calendar: CalendarDto | undefined;
    days: EventDayDto[] | undefined;
    rooms: EventRoomDto[] | undefined;
    id: number | undefined;

    constructor(data?: IProgrammingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.digitalMidiaLink = data["digitalMidiaLink"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : <any>undefined;
            this.calendarId = data["calendarId"];
            this.calendar = data["calendar"] ? CalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (data["days"] && data["days"].constructor === Array) {
                this.days = [];
                for (let item of data["days"])
                    this.days.push(EventDayDto.fromJS(item));
            }
            if (data["rooms"] && data["rooms"].constructor === Array) {
                this.rooms = [];
                for (let item of data["rooms"])
                    this.rooms.push(EventRoomDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProgrammingDto {
        let result = new ProgrammingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["digitalMidiaLink"] = this.digitalMidiaLink;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["calendarId"] = this.calendarId;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (this.days && this.days.constructor === Array) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (this.rooms && this.rooms.constructor === Array) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IProgrammingDto {
    digitalMidiaLink: string | undefined;
    eventId: number;
    event: EventDto | undefined;
    calendarId: number | undefined;
    calendar: CalendarDto | undefined;
    days: EventDayDto[] | undefined;
    rooms: EventRoomDto[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfProgrammingListDto implements IListResultDtoOfProgrammingListDto {
    items: ProgrammingListDto[] | undefined;

    constructor(data?: IListResultDtoOfProgrammingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProgrammingListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProgrammingListDto {
        let result = new ListResultDtoOfProgrammingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProgrammingListDto {
    items: ProgrammingListDto[] | undefined;
}

export class GetProgrammingForEditOutput implements IGetProgrammingForEditOutput {
    programming: CreateOrEditProgrammingDto | undefined;

    constructor(data?: IGetProgrammingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programming = data["programming"] ? CreateOrEditProgrammingDto.fromJS(data["programming"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgrammingForEditOutput {
        let result = new GetProgrammingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programming"] = this.programming ? this.programming.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetProgrammingForEditOutput {
    programming: CreateOrEditProgrammingDto | undefined;
}

export class CreateOrEditProgrammingDto implements ICreateOrEditProgrammingDto {
    digitalMidiaLink: string | undefined;
    eventId: number;
    event: EventDto | undefined;
    calendarId: number | undefined;
    calendar: CalendarDto | undefined;
    days: EventDayDto[] | undefined;
    rooms: EventRoomDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditProgrammingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.digitalMidiaLink = data["digitalMidiaLink"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : <any>undefined;
            this.calendarId = data["calendarId"];
            this.calendar = data["calendar"] ? CalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (data["days"] && data["days"].constructor === Array) {
                this.days = [];
                for (let item of data["days"])
                    this.days.push(EventDayDto.fromJS(item));
            }
            if (data["rooms"] && data["rooms"].constructor === Array) {
                this.rooms = [];
                for (let item of data["rooms"])
                    this.rooms.push(EventRoomDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProgrammingDto {
        let result = new CreateOrEditProgrammingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["digitalMidiaLink"] = this.digitalMidiaLink;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["calendarId"] = this.calendarId;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (this.days && this.days.constructor === Array) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (this.rooms && this.rooms.constructor === Array) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditProgrammingDto {
    digitalMidiaLink: string | undefined;
    eventId: number;
    event: EventDto | undefined;
    calendarId: number | undefined;
    calendar: CalendarDto | undefined;
    days: EventDayDto[] | undefined;
    rooms: EventRoomDto[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetProtocolForView implements IPagedResultDtoOfGetProtocolForView {
    totalCount: number | undefined;
    items: GetProtocolForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProtocolForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProtocolForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProtocolForView {
        let result = new PagedResultDtoOfGetProtocolForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetProtocolForView {
    totalCount: number | undefined;
    items: GetProtocolForView[] | undefined;
}

export class GetProtocolForView implements IGetProtocolForView {
    protocol: ProtocolDto | undefined;

    constructor(data?: IGetProtocolForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.protocol = data["protocol"] ? ProtocolDto.fromJS(data["protocol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProtocolForView {
        let result = new GetProtocolForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protocol"] = this.protocol ? this.protocol.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetProtocolForView {
    protocol: ProtocolDto | undefined;
}

export class ProtocolDto implements IProtocolDto {
    tenantId: number | undefined;
    subject: string | undefined;
    readonly number: number | undefined;
    readonly year: number | undefined;
    responsable: string | undefined;
    collaborator: UserProtocolDto | undefined;
    collaboratorId: number | undefined;
    documentType: DocumentTypeDto | undefined;
    documentTypeId: number | undefined;
    entryDate: moment.Moment | undefined;
    departureDate: moment.Moment | undefined;
    protocolType: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: IProtocolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.subject = data["subject"];
            (<any>this).number = data["number"];
            (<any>this).year = data["year"];
            this.responsable = data["responsable"];
            this.collaborator = data["collaborator"] ? UserProtocolDto.fromJS(data["collaborator"]) : <any>undefined;
            this.collaboratorId = data["collaboratorId"];
            this.documentType = data["documentType"] ? DocumentTypeDto.fromJS(data["documentType"]) : <any>undefined;
            this.documentTypeId = data["documentTypeId"];
            this.entryDate = data["entryDate"] ? moment(data["entryDate"].toString()) : <any>undefined;
            this.departureDate = data["departureDate"] ? moment(data["departureDate"].toString()) : <any>undefined;
            this.protocolType = data["protocolType"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProtocolDto {
        let result = new ProtocolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["subject"] = this.subject;
        data["number"] = this.number;
        data["year"] = this.year;
        data["responsable"] = this.responsable;
        data["collaborator"] = this.collaborator ? this.collaborator.toJSON() : <any>undefined;
        data["collaboratorId"] = this.collaboratorId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["documentTypeId"] = this.documentTypeId;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["protocolType"] = this.protocolType;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProtocolDto {
    tenantId: number | undefined;
    subject: string | undefined;
    number: number | undefined;
    year: number | undefined;
    responsable: string | undefined;
    collaborator: UserProtocolDto | undefined;
    collaboratorId: number | undefined;
    documentType: DocumentTypeDto | undefined;
    documentTypeId: number | undefined;
    entryDate: moment.Moment | undefined;
    departureDate: moment.Moment | undefined;
    protocolType: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class UserProtocolDto implements IUserProtocolDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IUserProtocolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): UserProtocolDto {
        let result = new UserProtocolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUserProtocolDto {
    id: number | undefined;
    name: string | undefined;
}

export class GetProtocolForEditOutput implements IGetProtocolForEditOutput {
    protocol: CreateOrEditProtocolDto | undefined;

    constructor(data?: IGetProtocolForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.protocol = data["protocol"] ? CreateOrEditProtocolDto.fromJS(data["protocol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProtocolForEditOutput {
        let result = new GetProtocolForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protocol"] = this.protocol ? this.protocol.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetProtocolForEditOutput {
    protocol: CreateOrEditProtocolDto | undefined;
}

export class CreateOrEditProtocolDto implements ICreateOrEditProtocolDto {
    tenantId: number | undefined;
    entryProtocol: EntryProtocolEditDto | undefined;
    dropOffProtocol: DropOffProtocolEditDto | undefined;

    constructor(data?: ICreateOrEditProtocolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.entryProtocol = data["entryProtocol"] ? EntryProtocolEditDto.fromJS(data["entryProtocol"]) : <any>undefined;
            this.dropOffProtocol = data["dropOffProtocol"] ? DropOffProtocolEditDto.fromJS(data["dropOffProtocol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditProtocolDto {
        let result = new CreateOrEditProtocolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["entryProtocol"] = this.entryProtocol ? this.entryProtocol.toJSON() : <any>undefined;
        data["dropOffProtocol"] = this.dropOffProtocol ? this.dropOffProtocol.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditProtocolDto {
    tenantId: number | undefined;
    entryProtocol: EntryProtocolEditDto | undefined;
    dropOffProtocol: DropOffProtocolEditDto | undefined;
}

export class EntryProtocolEditDto implements IEntryProtocolEditDto {
    companyName: string | undefined;
    entryDate: moment.Moment | undefined;
    toRule: boolean | undefined;
    subject: string | undefined;
    number: number | undefined;
    year: number | undefined;
    responsable: string | undefined;
    collaborator: UserProtocolDto | undefined;
    collaboratorId: number | undefined;
    documentType: DocumentTypeDto | undefined;
    documentTypeId: number | undefined;
    protocolType: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: IEntryProtocolEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyName = data["companyName"];
            this.entryDate = data["entryDate"] ? moment(data["entryDate"].toString()) : <any>undefined;
            this.toRule = data["toRule"];
            this.subject = data["subject"];
            this.number = data["number"];
            this.year = data["year"];
            this.responsable = data["responsable"];
            this.collaborator = data["collaborator"] ? UserProtocolDto.fromJS(data["collaborator"]) : <any>undefined;
            this.collaboratorId = data["collaboratorId"];
            this.documentType = data["documentType"] ? DocumentTypeDto.fromJS(data["documentType"]) : <any>undefined;
            this.documentTypeId = data["documentTypeId"];
            this.protocolType = data["protocolType"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntryProtocolEditDto {
        let result = new EntryProtocolEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["toRule"] = this.toRule;
        data["subject"] = this.subject;
        data["number"] = this.number;
        data["year"] = this.year;
        data["responsable"] = this.responsable;
        data["collaborator"] = this.collaborator ? this.collaborator.toJSON() : <any>undefined;
        data["collaboratorId"] = this.collaboratorId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["documentTypeId"] = this.documentTypeId;
        data["protocolType"] = this.protocolType;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntryProtocolEditDto {
    companyName: string | undefined;
    entryDate: moment.Moment | undefined;
    toRule: boolean | undefined;
    subject: string | undefined;
    number: number | undefined;
    year: number | undefined;
    responsable: string | undefined;
    collaborator: UserProtocolDto | undefined;
    collaboratorId: number | undefined;
    documentType: DocumentTypeDto | undefined;
    documentTypeId: number | undefined;
    protocolType: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class DropOffProtocolEditDto implements IDropOffProtocolEditDto {
    departureDate: moment.Moment | undefined;
    to: string | undefined;
    path: string | undefined;
    subject: string | undefined;
    number: number | undefined;
    year: number | undefined;
    responsable: string | undefined;
    collaborator: UserProtocolDto | undefined;
    collaboratorId: number | undefined;
    documentType: DocumentTypeDto | undefined;
    documentTypeId: number | undefined;
    protocolType: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: IDropOffProtocolEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.departureDate = data["departureDate"] ? moment(data["departureDate"].toString()) : <any>undefined;
            this.to = data["to"];
            this.path = data["path"];
            this.subject = data["subject"];
            this.number = data["number"];
            this.year = data["year"];
            this.responsable = data["responsable"];
            this.collaborator = data["collaborator"] ? UserProtocolDto.fromJS(data["collaborator"]) : <any>undefined;
            this.collaboratorId = data["collaboratorId"];
            this.documentType = data["documentType"] ? DocumentTypeDto.fromJS(data["documentType"]) : <any>undefined;
            this.documentTypeId = data["documentTypeId"];
            this.protocolType = data["protocolType"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DropOffProtocolEditDto {
        let result = new DropOffProtocolEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["to"] = this.to;
        data["path"] = this.path;
        data["subject"] = this.subject;
        data["number"] = this.number;
        data["year"] = this.year;
        data["responsable"] = this.responsable;
        data["collaborator"] = this.collaborator ? this.collaborator.toJSON() : <any>undefined;
        data["collaboratorId"] = this.collaboratorId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["documentTypeId"] = this.documentTypeId;
        data["protocolType"] = this.protocolType;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDropOffProtocolEditDto {
    departureDate: moment.Moment | undefined;
    to: string | undefined;
    path: string | undefined;
    subject: string | undefined;
    number: number | undefined;
    year: number | undefined;
    responsable: string | undefined;
    collaborator: UserProtocolDto | undefined;
    collaboratorId: number | undefined;
    documentType: DocumentTypeDto | undefined;
    documentTypeId: number | undefined;
    protocolType: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class ListResultDtoOfRegionalDto implements IListResultDtoOfRegionalDto {
    items: RegionalDto[] | undefined;

    constructor(data?: IListResultDtoOfRegionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RegionalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRegionalDto {
        let result = new ListResultDtoOfRegionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRegionalDto {
    items: RegionalDto[] | undefined;
}

export class RegionalDto implements IRegionalDto {
    email: string | undefined;
    currentBiennium: string | undefined;
    responsableId: number | undefined;
    isDefault: boolean | undefined;
    responsable: UserResponsableDto | undefined;
    phones: RegionalPhoneDto[] | undefined;
    addresses: RegionalAddressDto[] | undefined;
    cities: RegionalCityDto[] | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IRegionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.currentBiennium = data["currentBiennium"];
            this.responsableId = data["responsableId"];
            this.isDefault = data["isDefault"];
            this.responsable = data["responsable"] ? UserResponsableDto.fromJS(data["responsable"]) : <any>undefined;
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(RegionalPhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(RegionalAddressDto.fromJS(item));
            }
            if (data["cities"] && data["cities"].constructor === Array) {
                this.cities = [];
                for (let item of data["cities"])
                    this.cities.push(RegionalCityDto.fromJS(item));
            }
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionalDto {
        let result = new RegionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["currentBiennium"] = this.currentBiennium;
        data["responsableId"] = this.responsableId;
        data["isDefault"] = this.isDefault;
        data["responsable"] = this.responsable ? this.responsable.toJSON() : <any>undefined;
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (this.cities && this.cities.constructor === Array) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegionalDto {
    email: string | undefined;
    currentBiennium: string | undefined;
    responsableId: number | undefined;
    isDefault: boolean | undefined;
    responsable: UserResponsableDto | undefined;
    phones: RegionalPhoneDto[] | undefined;
    addresses: RegionalAddressDto[] | undefined;
    cities: RegionalCityDto[] | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class UserResponsableDto implements IUserResponsableDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IUserResponsableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): UserResponsableDto {
        let result = new UserResponsableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUserResponsableDto {
    id: number | undefined;
    name: string | undefined;
}

export class RegionalPhoneDto implements IRegionalPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: RegionalPhoneDtoType;
    id: number | undefined;

    constructor(data?: IRegionalPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionalPhoneDto {
        let result = new RegionalPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegionalPhoneDto {
    ddi: string;
    ddd: string;
    number: string;
    type: RegionalPhoneDtoType;
    id: number | undefined;
}

export class RegionalAddressDto implements IRegionalAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: RegionalAddressDtoType;
    id: number | undefined;

    constructor(data?: IRegionalAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionalAddressDto {
        let result = new RegionalAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegionalAddressDto {
    logradour: string;
    number: string;
    complement: string | undefined;
    district: string;
    zipCode: string;
    city: string;
    stateAbbreviation: string;
    stateName: string;
    countryName: string;
    isMailing: boolean | undefined;
    type: RegionalAddressDtoType;
    id: number | undefined;
}

export class RegionalCityDto implements IRegionalCityDto {
    regionalId: number | undefined;
    countryStateShortName: string | undefined;
    city: string | undefined;

    constructor(data?: IRegionalCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regionalId = data["regionalId"];
            this.countryStateShortName = data["countryStateShortName"];
            this.city = data["city"];
        }
    }

    static fromJS(data: any): RegionalCityDto {
        let result = new RegionalCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionalId"] = this.regionalId;
        data["countryStateShortName"] = this.countryStateShortName;
        data["city"] = this.city;
        return data; 
    }
}

export interface IRegionalCityDto {
    regionalId: number | undefined;
    countryStateShortName: string | undefined;
    city: string | undefined;
}

export class CreateRegionalInput implements ICreateRegionalInput {
    email: string | undefined;
    currentBiennium: string | undefined;
    responsableId: number | undefined;
    isDefault: boolean | undefined;
    phones: RegionalPhoneDto[] | undefined;
    addresses: RegionalAddressDto[] | undefined;
    cities: RegionalCityDto[] | undefined;
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateRegionalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.currentBiennium = data["currentBiennium"];
            this.responsableId = data["responsableId"];
            this.isDefault = data["isDefault"];
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(RegionalPhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(RegionalAddressDto.fromJS(item));
            }
            if (data["cities"] && data["cities"].constructor === Array) {
                this.cities = [];
                for (let item of data["cities"])
                    this.cities.push(RegionalCityDto.fromJS(item));
            }
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateRegionalInput {
        let result = new CreateRegionalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["currentBiennium"] = this.currentBiennium;
        data["responsableId"] = this.responsableId;
        data["isDefault"] = this.isDefault;
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (this.cities && this.cities.constructor === Array) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateRegionalInput {
    email: string | undefined;
    currentBiennium: string | undefined;
    responsableId: number | undefined;
    isDefault: boolean | undefined;
    phones: RegionalPhoneDto[] | undefined;
    addresses: RegionalAddressDto[] | undefined;
    cities: RegionalCityDto[] | undefined;
    parentId: number | undefined;
    displayName: string;
}

export class UpdateRegionalInput implements IUpdateRegionalInput {
    email: string | undefined;
    currentBiennium: string | undefined;
    responsableId: number | undefined;
    isDefault: boolean | undefined;
    phones: RegionalPhoneDto[] | undefined;
    addresses: RegionalAddressDto[] | undefined;
    cities: RegionalCityDto[] | undefined;
    id: number | undefined;
    displayName: string;

    constructor(data?: IUpdateRegionalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.currentBiennium = data["currentBiennium"];
            this.responsableId = data["responsableId"];
            this.isDefault = data["isDefault"];
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(RegionalPhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(RegionalAddressDto.fromJS(item));
            }
            if (data["cities"] && data["cities"].constructor === Array) {
                this.cities = [];
                for (let item of data["cities"])
                    this.cities.push(RegionalCityDto.fromJS(item));
            }
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateRegionalInput {
        let result = new UpdateRegionalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["currentBiennium"] = this.currentBiennium;
        data["responsableId"] = this.responsableId;
        data["isDefault"] = this.isDefault;
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (this.cities && this.cities.constructor === Array) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateRegionalInput {
    email: string | undefined;
    currentBiennium: string | undefined;
    responsableId: number | undefined;
    isDefault: boolean | undefined;
    phones: RegionalPhoneDto[] | undefined;
    addresses: RegionalAddressDto[] | undefined;
    cities: RegionalCityDto[] | undefined;
    id: number | undefined;
    displayName: string;
}

export class PagedResultDtoOfGetRegistrationForView implements IPagedResultDtoOfGetRegistrationForView {
    totalCount: number | undefined;
    items: GetRegistrationForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRegistrationForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRegistrationForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRegistrationForView {
        let result = new PagedResultDtoOfGetRegistrationForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetRegistrationForView {
    totalCount: number | undefined;
    items: GetRegistrationForView[] | undefined;
}

export class GetRegistrationForView implements IGetRegistrationForView {
    registration: RegistrationDto | undefined;
    numberOfInstallments: number | undefined;

    constructor(data?: IGetRegistrationForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registration = data["registration"] ? RegistrationDto.fromJS(data["registration"]) : <any>undefined;
            this.numberOfInstallments = data["numberOfInstallments"];
        }
    }

    static fromJS(data: any): GetRegistrationForView {
        let result = new GetRegistrationForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["numberOfInstallments"] = this.numberOfInstallments;
        return data; 
    }
}

export interface IGetRegistrationForView {
    registration: RegistrationDto | undefined;
    numberOfInstallments: number | undefined;
}

export class GetRegistrationForEditOutput implements IGetRegistrationForEditOutput {
    registration: CreateOrEditRegistrationDto | undefined;

    constructor(data?: IGetRegistrationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registration = data["registration"] ? CreateOrEditRegistrationDto.fromJS(data["registration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRegistrationForEditOutput {
        let result = new GetRegistrationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetRegistrationForEditOutput {
    registration: CreateOrEditRegistrationDto | undefined;
}

export class CreateOrEditRegistrationDto implements ICreateOrEditRegistrationDto {
    eventId: number | undefined;
    event: EventListDto | undefined;
    userId: number | undefined;
    user: RegistrationUserDto | undefined;
    categoryDeadlineId: number;
    coupon: ValidateCouponOutput | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: EventPaymentMethodPermissionDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    note: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? RegistrationUserDto.fromJS(data["user"]) : <any>undefined;
            this.categoryDeadlineId = data["categoryDeadlineId"];
            this.coupon = data["coupon"] ? ValidateCouponOutput.fromJS(data["coupon"]) : <any>undefined;
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? EventPaymentMethodPermissionDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.creditCardPayment = data["creditCardPayment"] ? CreditCardPaymentDto.fromJS(data["creditCardPayment"]) : <any>undefined;
            this.debitCardPayment = data["debitCardPayment"] ? DebitCardPaymentDto.fromJS(data["debitCardPayment"]) : <any>undefined;
            this.ticketPayment = data["ticketPayment"] ? TicketPaymentDto.fromJS(data["ticketPayment"]) : <any>undefined;
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationDto {
        let result = new CreateOrEditRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["categoryDeadlineId"] = this.categoryDeadlineId;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>undefined;
        data["debitCardPayment"] = this.debitCardPayment ? this.debitCardPayment.toJSON() : <any>undefined;
        data["ticketPayment"] = this.ticketPayment ? this.ticketPayment.toJSON() : <any>undefined;
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRegistrationDto {
    eventId: number | undefined;
    event: EventListDto | undefined;
    userId: number | undefined;
    user: RegistrationUserDto | undefined;
    categoryDeadlineId: number;
    coupon: ValidateCouponOutput | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: EventPaymentMethodPermissionDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    note: string | undefined;
    id: number | undefined;
}

export class RegistrationUserDto implements IRegistrationUserDto {
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] = [];
    phones: UserPhoneDto[] = [];
    address: UserAddressDto = new UserAddressDto();
    hasRegistration: boolean | undefined;
    hasPaidRegistration: boolean | undefined;
    paidAnnuity: boolean | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    itsReadmissionAnnuity: boolean | undefined;
    relatedEventRegistration: boolean | undefined;
    hasCredential: boolean | undefined;
    registrations: UserRegistrationListDto[] | undefined;
    registrationCategory: string | undefined;
    id: number | undefined;

    constructor(data?: IRegistrationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : new UserAddressDto();
            this.hasRegistration = data["hasRegistration"];
            this.hasPaidRegistration = data["hasPaidRegistration"];
            this.paidAnnuity = data["paidAnnuity"];
            this.categoryId = data["categoryId"];
            this.categoryName = data["categoryName"];
            this.itsReadmissionAnnuity = data["itsReadmissionAnnuity"];
            this.relatedEventRegistration = data["relatedEventRegistration"];
            this.hasCredential = data["hasCredential"];
            if (data["registrations"] && data["registrations"].constructor === Array) {
                this.registrations = [];
                for (let item of data["registrations"])
                    this.registrations.push(UserRegistrationListDto.fromJS(item));
            }
            this.registrationCategory = data["registrationCategory"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationUserDto {
        let result = new RegistrationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["hasRegistration"] = this.hasRegistration;
        data["hasPaidRegistration"] = this.hasPaidRegistration;
        data["paidAnnuity"] = this.paidAnnuity;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["itsReadmissionAnnuity"] = this.itsReadmissionAnnuity;
        data["relatedEventRegistration"] = this.relatedEventRegistration;
        data["hasCredential"] = this.hasCredential;
        if (this.registrations && this.registrations.constructor === Array) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        data["registrationCategory"] = this.registrationCategory;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationUserDto {
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[];
    phones: UserPhoneDto[];
    address: UserAddressDto;
    hasRegistration: boolean | undefined;
    hasPaidRegistration: boolean | undefined;
    paidAnnuity: boolean | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    itsReadmissionAnnuity: boolean | undefined;
    relatedEventRegistration: boolean | undefined;
    hasCredential: boolean | undefined;
    registrations: UserRegistrationListDto[] | undefined;
    registrationCategory: string | undefined;
    id: number | undefined;
}

export class UserRegistrationListDto implements IUserRegistrationListDto {
    hasPresence: boolean | undefined;
    eventId: number | undefined;
    orderId: number | undefined;
    surveyId: number | undefined;
    answeredSurvey: boolean | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: boolean | undefined;
    inGoogleCalendar: boolean | undefined;
    event: RegistrationEventDto | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    status: UserRegistrationListDtoStatus | undefined;
    netAmount: number | undefined;
    situation: UserRegistrationListDtoSituation | undefined;
    certificates: GetCertificateInput[] | undefined;
    surveyAnswerSkiped: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserRegistrationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hasPresence = data["hasPresence"];
            this.eventId = data["eventId"];
            this.orderId = data["orderId"];
            this.surveyId = data["surveyId"];
            this.answeredSurvey = data["answeredSurvey"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.description = data["description"];
            this.allowGoogleCalendar = data["allowGoogleCalendar"];
            this.allowYahooCalendar = data["allowYahooCalendar"];
            this.allowICalCalendar = data["allowICalCalendar"];
            this.inGoogleCalendar = data["inGoogleCalendar"];
            this.event = data["event"] ? RegistrationEventDto.fromJS(data["event"]) : <any>undefined;
            this.categoryDeadLine = data["categoryDeadLine"] ? EventCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.status = data["status"];
            this.netAmount = data["netAmount"];
            this.situation = data["situation"];
            if (data["certificates"] && data["certificates"].constructor === Array) {
                this.certificates = [];
                for (let item of data["certificates"])
                    this.certificates.push(GetCertificateInput.fromJS(item));
            }
            this.surveyAnswerSkiped = data["surveyAnswerSkiped"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserRegistrationListDto {
        let result = new UserRegistrationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPresence"] = this.hasPresence;
        data["eventId"] = this.eventId;
        data["orderId"] = this.orderId;
        data["surveyId"] = this.surveyId;
        data["answeredSurvey"] = this.answeredSurvey;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["description"] = this.description;
        data["allowGoogleCalendar"] = this.allowGoogleCalendar;
        data["allowYahooCalendar"] = this.allowYahooCalendar;
        data["allowICalCalendar"] = this.allowICalCalendar;
        data["inGoogleCalendar"] = this.inGoogleCalendar;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["netAmount"] = this.netAmount;
        data["situation"] = this.situation;
        if (this.certificates && this.certificates.constructor === Array) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        data["surveyAnswerSkiped"] = this.surveyAnswerSkiped;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserRegistrationListDto {
    hasPresence: boolean | undefined;
    eventId: number | undefined;
    orderId: number | undefined;
    surveyId: number | undefined;
    answeredSurvey: boolean | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: boolean | undefined;
    inGoogleCalendar: boolean | undefined;
    event: RegistrationEventDto | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    status: UserRegistrationListDtoStatus | undefined;
    netAmount: number | undefined;
    situation: UserRegistrationListDtoSituation | undefined;
    certificates: GetCertificateInput[] | undefined;
    surveyAnswerSkiped: boolean | undefined;
    id: number | undefined;
}

export class RegistrationEventDto implements IRegistrationEventDto {
    name: string;
    eventImage: string | undefined;
    shortName: string;
    eventImageId: string | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    place: EventPlaceDto | undefined;
    time: string | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: boolean | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    certificateReleased: boolean | undefined;
    hasCnaCertificate: boolean | undefined;
    situation: RegistrationEventDtoSituation | undefined;

    constructor(data?: IRegistrationEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.eventImage = data["eventImage"];
            this.shortName = data["shortName"];
            this.eventImageId = data["eventImageId"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            this.time = data["time"];
            this.allowGoogleCalendar = data["allowGoogleCalendar"];
            this.allowYahooCalendar = data["allowYahooCalendar"];
            this.allowICalCalendar = data["allowICalCalendar"];
            this.certificateConfig = data["certificateConfig"] ? CertificateConfigDto.fromJS(data["certificateConfig"]) : <any>undefined;
            this.certificateReleased = data["certificateReleased"];
            this.hasCnaCertificate = data["hasCnaCertificate"];
            this.situation = data["situation"];
        }
    }

    static fromJS(data: any): RegistrationEventDto {
        let result = new RegistrationEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["eventImage"] = this.eventImage;
        data["shortName"] = this.shortName;
        data["eventImageId"] = this.eventImageId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["time"] = this.time;
        data["allowGoogleCalendar"] = this.allowGoogleCalendar;
        data["allowYahooCalendar"] = this.allowYahooCalendar;
        data["allowICalCalendar"] = this.allowICalCalendar;
        data["certificateConfig"] = this.certificateConfig ? this.certificateConfig.toJSON() : <any>undefined;
        data["certificateReleased"] = this.certificateReleased;
        data["hasCnaCertificate"] = this.hasCnaCertificate;
        data["situation"] = this.situation;
        return data; 
    }
}

export interface IRegistrationEventDto {
    name: string;
    eventImage: string | undefined;
    shortName: string;
    eventImageId: string | undefined;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    place: EventPlaceDto | undefined;
    time: string | undefined;
    allowGoogleCalendar: boolean | undefined;
    allowYahooCalendar: boolean | undefined;
    allowICalCalendar: boolean | undefined;
    certificateConfig: CertificateConfigDto | undefined;
    certificateReleased: boolean | undefined;
    hasCnaCertificate: boolean | undefined;
    situation: RegistrationEventDtoSituation | undefined;
}

export class CreateOrEditRegistrationByAdminDto implements ICreateOrEditRegistrationByAdminDto {
    onLocal: boolean | undefined;
    justSave: boolean | undefined;
    autoApprove: boolean | undefined;
    sitefClientVoucher: string | undefined;
    sitefStoreVoucher: string | undefined;
    sitefTransactionData: string | undefined;
    user: RegistrationUserEditDto | undefined;
    payments: PaymentDto[] | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    userId: number | undefined;
    categoryDeadlineId: number;
    coupon: ValidateCouponOutput | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: EventPaymentMethodPermissionDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    note: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditRegistrationByAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.onLocal = data["onLocal"];
            this.justSave = data["justSave"];
            this.autoApprove = data["autoApprove"];
            this.sitefClientVoucher = data["sitefClientVoucher"];
            this.sitefStoreVoucher = data["sitefStoreVoucher"];
            this.sitefTransactionData = data["sitefTransactionData"];
            this.user = data["user"] ? RegistrationUserEditDto.fromJS(data["user"]) : <any>undefined;
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.userId = data["userId"];
            this.categoryDeadlineId = data["categoryDeadlineId"];
            this.coupon = data["coupon"] ? ValidateCouponOutput.fromJS(data["coupon"]) : <any>undefined;
            this.paymentMethodId = data["paymentMethodId"];
            this.paymentMethod = data["paymentMethod"] ? EventPaymentMethodPermissionDto.fromJS(data["paymentMethod"]) : <any>undefined;
            this.creditCardPayment = data["creditCardPayment"] ? CreditCardPaymentDto.fromJS(data["creditCardPayment"]) : <any>undefined;
            this.debitCardPayment = data["debitCardPayment"] ? DebitCardPaymentDto.fromJS(data["debitCardPayment"]) : <any>undefined;
            this.ticketPayment = data["ticketPayment"] ? TicketPaymentDto.fromJS(data["ticketPayment"]) : <any>undefined;
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationByAdminDto {
        let result = new CreateOrEditRegistrationByAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onLocal"] = this.onLocal;
        data["justSave"] = this.justSave;
        data["autoApprove"] = this.autoApprove;
        data["sitefClientVoucher"] = this.sitefClientVoucher;
        data["sitefStoreVoucher"] = this.sitefStoreVoucher;
        data["sitefTransactionData"] = this.sitefTransactionData;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["categoryDeadlineId"] = this.categoryDeadlineId;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>undefined;
        data["debitCardPayment"] = this.debitCardPayment ? this.debitCardPayment.toJSON() : <any>undefined;
        data["ticketPayment"] = this.ticketPayment ? this.ticketPayment.toJSON() : <any>undefined;
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRegistrationByAdminDto {
    onLocal: boolean | undefined;
    justSave: boolean | undefined;
    autoApprove: boolean | undefined;
    sitefClientVoucher: string | undefined;
    sitefStoreVoucher: string | undefined;
    sitefTransactionData: string | undefined;
    user: RegistrationUserEditDto | undefined;
    payments: PaymentDto[] | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    userId: number | undefined;
    categoryDeadlineId: number;
    coupon: ValidateCouponOutput | undefined;
    paymentMethodId: number | undefined;
    paymentMethod: EventPaymentMethodPermissionDto | undefined;
    creditCardPayment: CreditCardPaymentDto | undefined;
    debitCardPayment: DebitCardPaymentDto | undefined;
    ticketPayment: TicketPaymentDto | undefined;
    note: string | undefined;
    id: number | undefined;
}

export class RegistrationUserEditDto implements IRegistrationUserEditDto {
    member: RegistrationUserMemberEditDto | undefined;
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[] = [];
    phones: UserPhoneDto[] = [];
    address: UserAddressDto = new UserAddressDto();
    hasRegistration: boolean | undefined;
    hasPaidRegistration: boolean | undefined;
    paidAnnuity: boolean | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    itsReadmissionAnnuity: boolean | undefined;
    relatedEventRegistration: boolean | undefined;
    hasCredential: boolean | undefined;
    registrations: UserRegistrationListDto[] | undefined;
    registrationCategory: string | undefined;
    id: number | undefined;

    constructor(data?: IRegistrationUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.member = data["member"] ? RegistrationUserMemberEditDto.fromJS(data["member"]) : <any>undefined;
            this.userName = data["userName"];
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : new UserAddressDto();
            this.hasRegistration = data["hasRegistration"];
            this.hasPaidRegistration = data["hasPaidRegistration"];
            this.paidAnnuity = data["paidAnnuity"];
            this.categoryId = data["categoryId"];
            this.categoryName = data["categoryName"];
            this.itsReadmissionAnnuity = data["itsReadmissionAnnuity"];
            this.relatedEventRegistration = data["relatedEventRegistration"];
            this.hasCredential = data["hasCredential"];
            if (data["registrations"] && data["registrations"].constructor === Array) {
                this.registrations = [];
                for (let item of data["registrations"])
                    this.registrations.push(UserRegistrationListDto.fromJS(item));
            }
            this.registrationCategory = data["registrationCategory"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationUserEditDto {
        let result = new RegistrationUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["hasRegistration"] = this.hasRegistration;
        data["hasPaidRegistration"] = this.hasPaidRegistration;
        data["paidAnnuity"] = this.paidAnnuity;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["itsReadmissionAnnuity"] = this.itsReadmissionAnnuity;
        data["relatedEventRegistration"] = this.relatedEventRegistration;
        data["hasCredential"] = this.hasCredential;
        if (this.registrations && this.registrations.constructor === Array) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        data["registrationCategory"] = this.registrationCategory;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationUserEditDto {
    member: RegistrationUserMemberEditDto | undefined;
    userName: string;
    name: string;
    nameForCredential: string | undefined;
    emailAddress: string;
    emails: UserEmailDto[];
    phones: UserPhoneDto[];
    address: UserAddressDto;
    hasRegistration: boolean | undefined;
    hasPaidRegistration: boolean | undefined;
    paidAnnuity: boolean | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    itsReadmissionAnnuity: boolean | undefined;
    relatedEventRegistration: boolean | undefined;
    hasCredential: boolean | undefined;
    registrations: UserRegistrationListDto[] | undefined;
    registrationCategory: string | undefined;
    id: number | undefined;
}

export class RegistrationUserMemberEditDto implements IRegistrationUserMemberEditDto {
    categories: MemberCategoryEditDto[] | undefined;

    constructor(data?: IRegistrationUserMemberEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(MemberCategoryEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegistrationUserMemberEditDto {
        let result = new RegistrationUserMemberEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRegistrationUserMemberEditDto {
    categories: MemberCategoryEditDto[] | undefined;
}

export class CreateOrEditRegistrationOutput implements ICreateOrEditRegistrationOutput {
    registrationId: number | undefined;
    eventId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    link: string | undefined;
    barcode: string | undefined;
    items: ReceivableDto[] | undefined;

    constructor(data?: ICreateOrEditRegistrationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrationId = data["registrationId"];
            this.eventId = data["eventId"];
            this.success = data["success"];
            this.message = data["message"];
            this.html = data["html"];
            this.url = data["url"];
            this.link = data["link"];
            this.barcode = data["barcode"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReceivableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationOutput {
        let result = new CreateOrEditRegistrationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["eventId"] = this.eventId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["html"] = this.html;
        data["url"] = this.url;
        data["link"] = this.link;
        data["barcode"] = this.barcode;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditRegistrationOutput {
    registrationId: number | undefined;
    eventId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    html: string | undefined;
    url: string | undefined;
    link: string | undefined;
    barcode: string | undefined;
    items: ReceivableDto[] | undefined;
}

export class UserEditDto implements IUserEditDto {
    id: number | undefined;
    name: string;
    userName: string;
    nameForCredential: string | undefined;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    pendingUpdate: boolean | undefined;
    userJson: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    member: UserMemberEditDto | undefined;
    jobPositions: UserJobPositionEditDto[] | undefined;
    emails: UserEmailDto[] = [];
    phones: UserPhoneDto[] = [];
    addresses: UserAddressDto[] = [];
    notes: NoteEditDto[] | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    isTwoFactorEnabled: boolean | undefined;
    isLockoutEnabled: boolean | undefined;
    receiveActivityNotifications: boolean | undefined;
    statusCpf: UserEditDtoStatusCpf | undefined;
    situationCpf: UserEditDtoSituationCpf | undefined;
    idRegistro: number | undefined;
    idIntegracao: number | undefined;
    idCorrelato: number | undefined;
    statusIntegracao: UserEditDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.nameForCredential = data["nameForCredential"];
            this.situationId = data["situationId"];
            this.situation = data["situation"] ? SituationDto.fromJS(data["situation"]) : <any>undefined;
            this.pendingUpdate = data["pendingUpdate"];
            this.userJson = data["userJson"];
            this.nameValidSerpro = data["nameValidSerpro"];
            this.confirmedName = data["confirmedName"];
            this.member = data["member"] ? UserMemberEditDto.fromJS(data["member"]) : <any>undefined;
            if (data["jobPositions"] && data["jobPositions"].constructor === Array) {
                this.jobPositions = [];
                for (let item of data["jobPositions"])
                    this.jobPositions.push(UserJobPositionEditDto.fromJS(item));
            }
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(UserAddressDto.fromJS(item));
            }
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteEditDto.fromJS(item));
            }
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.receiveActivityNotifications = data["receiveActivityNotifications"];
            this.statusCpf = data["statusCpf"];
            this.situationCpf = data["situationCpf"];
            this.idRegistro = data["idRegistro"];
            this.idIntegracao = data["idIntegracao"];
            this.idCorrelato = data["idCorrelato"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
        }
    }

    static fromJS(data: any): UserEditDto {
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["nameForCredential"] = this.nameForCredential;
        data["situationId"] = this.situationId;
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        data["pendingUpdate"] = this.pendingUpdate;
        data["userJson"] = this.userJson;
        data["nameValidSerpro"] = this.nameValidSerpro;
        data["confirmedName"] = this.confirmedName;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        if (this.jobPositions && this.jobPositions.constructor === Array) {
            data["jobPositions"] = [];
            for (let item of this.jobPositions)
                data["jobPositions"].push(item.toJSON());
        }
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["receiveActivityNotifications"] = this.receiveActivityNotifications;
        data["statusCpf"] = this.statusCpf;
        data["situationCpf"] = this.situationCpf;
        data["idRegistro"] = this.idRegistro;
        data["idIntegracao"] = this.idIntegracao;
        data["idCorrelato"] = this.idCorrelato;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        return data; 
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    userName: string;
    nameForCredential: string | undefined;
    situationId: number | undefined;
    situation: SituationDto | undefined;
    pendingUpdate: boolean | undefined;
    userJson: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    member: UserMemberEditDto | undefined;
    jobPositions: UserJobPositionEditDto[] | undefined;
    emails: UserEmailDto[];
    phones: UserPhoneDto[];
    addresses: UserAddressDto[];
    notes: NoteEditDto[] | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    isTwoFactorEnabled: boolean | undefined;
    isLockoutEnabled: boolean | undefined;
    receiveActivityNotifications: boolean | undefined;
    statusCpf: UserEditDtoStatusCpf | undefined;
    situationCpf: UserEditDtoSituationCpf | undefined;
    idRegistro: number | undefined;
    idIntegracao: number | undefined;
    idCorrelato: number | undefined;
    statusIntegracao: UserEditDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
}

export class UpdatePaymentInput implements IUpdatePaymentInput {
    payment: PaymentDto | undefined;
    coupon: ValidateCouponOutput | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    paymentMethodPermissionId: number | undefined;

    constructor(data?: IUpdatePaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.coupon = data["coupon"] ? ValidateCouponOutput.fromJS(data["coupon"]) : <any>undefined;
            this.categoryDeadLine = data["categoryDeadLine"] ? EventCategoryDeadlineDto.fromJS(data["categoryDeadLine"]) : <any>undefined;
            this.paymentMethodPermissionId = data["paymentMethodPermissionId"];
        }
    }

    static fromJS(data: any): UpdatePaymentInput {
        let result = new UpdatePaymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["categoryDeadLine"] = this.categoryDeadLine ? this.categoryDeadLine.toJSON() : <any>undefined;
        data["paymentMethodPermissionId"] = this.paymentMethodPermissionId;
        return data; 
    }
}

export interface IUpdatePaymentInput {
    payment: PaymentDto | undefined;
    coupon: ValidateCouponOutput | undefined;
    categoryDeadLine: EventCategoryDeadlineDto | undefined;
    paymentMethodPermissionId: number | undefined;
}

export class UpdateNotesDto implements IUpdateNotesDto {
    id: number | undefined;
    newNotes: NoteEditDto[] | undefined;

    constructor(data?: IUpdateNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["newNotes"] && data["newNotes"].constructor === Array) {
                this.newNotes = [];
                for (let item of data["newNotes"])
                    this.newNotes.push(NoteEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotesDto {
        let result = new UpdateNotesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.newNotes && this.newNotes.constructor === Array) {
            data["newNotes"] = [];
            for (let item of this.newNotes)
                data["newNotes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotesDto {
    id: number | undefined;
    newNotes: NoteEditDto[] | undefined;
}

export class DisapproveRegistrationInput implements IDisapproveRegistrationInput {
    registrationId: number | undefined;
    note: string;

    constructor(data?: IDisapproveRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrationId = data["registrationId"];
            this.note = data["note"];
        }
    }

    static fromJS(data: any): DisapproveRegistrationInput {
        let result = new DisapproveRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["note"] = this.note;
        return data; 
    }
}

export interface IDisapproveRegistrationInput {
    registrationId: number | undefined;
    note: string;
}

export class CancelRegistrationInput implements ICancelRegistrationInput {
    registrationId: number | undefined;
    situation: CancelRegistrationInputSituation | undefined;

    constructor(data?: ICancelRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrationId = data["registrationId"];
            this.situation = data["situation"];
        }
    }

    static fromJS(data: any): CancelRegistrationInput {
        let result = new CancelRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["situation"] = this.situation;
        return data; 
    }
}

export interface ICancelRegistrationInput {
    registrationId: number | undefined;
    situation: CancelRegistrationInputSituation | undefined;
}

export class TransferRegistrationAnotherEventDto implements ITransferRegistrationAnotherEventDto {
    registrationId: number;
    eventId: number;
    categoryDeadLineId: number;

    constructor(data?: ITransferRegistrationAnotherEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrationId = data["registrationId"];
            this.eventId = data["eventId"];
            this.categoryDeadLineId = data["categoryDeadLineId"];
        }
    }

    static fromJS(data: any): TransferRegistrationAnotherEventDto {
        let result = new TransferRegistrationAnotherEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["eventId"] = this.eventId;
        data["categoryDeadLineId"] = this.categoryDeadLineId;
        return data; 
    }
}

export interface ITransferRegistrationAnotherEventDto {
    registrationId: number;
    eventId: number;
    categoryDeadLineId: number;
}

export class TransferRegistrationDto implements ITransferRegistrationDto {
    registrationId: number | undefined;
    userId: number | undefined;

    constructor(data?: ITransferRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrationId = data["registrationId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): TransferRegistrationDto {
        let result = new TransferRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface ITransferRegistrationDto {
    registrationId: number | undefined;
    userId: number | undefined;
}

export class UploadPresenceToRegistrationsDto implements IUploadPresenceToRegistrationsDto {
    eventId: number;
    fileName: string;

    constructor(data?: IUploadPresenceToRegistrationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): UploadPresenceToRegistrationsDto {
        let result = new UploadPresenceToRegistrationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IUploadPresenceToRegistrationsDto {
    eventId: number;
    fileName: string;
}

export class ListResultDtoOfUserRegistrationListDto implements IListResultDtoOfUserRegistrationListDto {
    items: UserRegistrationListDto[] | undefined;

    constructor(data?: IListResultDtoOfUserRegistrationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserRegistrationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserRegistrationListDto {
        let result = new ListResultDtoOfUserRegistrationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserRegistrationListDto {
    items: UserRegistrationListDto[] | undefined;
}

export class GetExtractOutput implements IGetExtractOutput {
    totalReceivable: number | undefined;
    totalPayable: number | undefined;
    beginBalance: number | undefined;
    balance: number | undefined;
    paymentCharges: PagedResultDtoOfExtractPaymentChargeDto | undefined;

    constructor(data?: IGetExtractOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalReceivable = data["totalReceivable"];
            this.totalPayable = data["totalPayable"];
            this.beginBalance = data["beginBalance"];
            this.balance = data["balance"];
            this.paymentCharges = data["paymentCharges"] ? PagedResultDtoOfExtractPaymentChargeDto.fromJS(data["paymentCharges"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExtractOutput {
        let result = new GetExtractOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalReceivable"] = this.totalReceivable;
        data["totalPayable"] = this.totalPayable;
        data["beginBalance"] = this.beginBalance;
        data["balance"] = this.balance;
        data["paymentCharges"] = this.paymentCharges ? this.paymentCharges.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetExtractOutput {
    totalReceivable: number | undefined;
    totalPayable: number | undefined;
    beginBalance: number | undefined;
    balance: number | undefined;
    paymentCharges: PagedResultDtoOfExtractPaymentChargeDto | undefined;
}

export class PagedResultDtoOfExtractPaymentChargeDto implements IPagedResultDtoOfExtractPaymentChargeDto {
    totalCount: number | undefined;
    items: ExtractPaymentChargeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfExtractPaymentChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ExtractPaymentChargeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfExtractPaymentChargeDto {
        let result = new PagedResultDtoOfExtractPaymentChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfExtractPaymentChargeDto {
    totalCount: number | undefined;
    items: ExtractPaymentChargeDto[] | undefined;
}

export class ExtractPaymentChargeDto implements IExtractPaymentChargeDto {
    id: number | undefined;
    creationTime: moment.Moment | undefined;
    paymentDate: moment.Moment | undefined;
    description: string | undefined;
    customer: string | undefined;
    paymentChargeType: string | undefined;
    amount: number | undefined;
    costCenter: CostCenterListDto | undefined;
    balance: number | undefined;
    paymentId: number | undefined;
    paymentType: string | undefined;

    constructor(data?: IExtractPaymentChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.customer = data["customer"];
            this.paymentChargeType = data["paymentChargeType"];
            this.amount = data["amount"];
            this.costCenter = data["costCenter"] ? CostCenterListDto.fromJS(data["costCenter"]) : <any>undefined;
            this.balance = data["balance"];
            this.paymentId = data["paymentId"];
            this.paymentType = data["paymentType"];
        }
    }

    static fromJS(data: any): ExtractPaymentChargeDto {
        let result = new ExtractPaymentChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["customer"] = this.customer;
        data["paymentChargeType"] = this.paymentChargeType;
        data["amount"] = this.amount;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        data["balance"] = this.balance;
        data["paymentId"] = this.paymentId;
        data["paymentType"] = this.paymentType;
        return data; 
    }
}

export interface IExtractPaymentChargeDto {
    id: number | undefined;
    creationTime: moment.Moment | undefined;
    paymentDate: moment.Moment | undefined;
    description: string | undefined;
    customer: string | undefined;
    paymentChargeType: string | undefined;
    amount: number | undefined;
    costCenter: CostCenterListDto | undefined;
    balance: number | undefined;
    paymentId: number | undefined;
    paymentType: string | undefined;
}

export class GetCashFlowOutput implements IGetCashFlowOutput {
    prediction: PredictionDto | undefined;
    realized: RealizedDto | undefined;

    constructor(data?: IGetCashFlowOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prediction = data["prediction"] ? PredictionDto.fromJS(data["prediction"]) : <any>undefined;
            this.realized = data["realized"] ? RealizedDto.fromJS(data["realized"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCashFlowOutput {
        let result = new GetCashFlowOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prediction"] = this.prediction ? this.prediction.toJSON() : <any>undefined;
        data["realized"] = this.realized ? this.realized.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCashFlowOutput {
    prediction: PredictionDto | undefined;
    realized: RealizedDto | undefined;
}

export class PredictionDto implements IPredictionDto {
    items: PredictionItemDto[] | undefined;
    totalInputs: number | undefined;
    totalAccumulatedInputs: number | undefined;
    totalOutputs: number | undefined;
    totalBalance: number | undefined;
    beginBalance: number | undefined;

    constructor(data?: IPredictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PredictionItemDto.fromJS(item));
            }
            this.totalInputs = data["totalInputs"];
            this.totalAccumulatedInputs = data["totalAccumulatedInputs"];
            this.totalOutputs = data["totalOutputs"];
            this.totalBalance = data["totalBalance"];
            this.beginBalance = data["beginBalance"];
        }
    }

    static fromJS(data: any): PredictionDto {
        let result = new PredictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalInputs"] = this.totalInputs;
        data["totalAccumulatedInputs"] = this.totalAccumulatedInputs;
        data["totalOutputs"] = this.totalOutputs;
        data["totalBalance"] = this.totalBalance;
        data["beginBalance"] = this.beginBalance;
        return data; 
    }
}

export interface IPredictionDto {
    items: PredictionItemDto[] | undefined;
    totalInputs: number | undefined;
    totalAccumulatedInputs: number | undefined;
    totalOutputs: number | undefined;
    totalBalance: number | undefined;
    beginBalance: number | undefined;
}

export class RealizedDto implements IRealizedDto {
    items: RealizedItemDto[] | undefined;
    totalInputs: number | undefined;
    totalOutputs: number | undefined;
    totalBalance: number | undefined;
    beginBalance: number | undefined;
    totalBankCheckToCompensate: number | undefined;

    constructor(data?: IRealizedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RealizedItemDto.fromJS(item));
            }
            this.totalInputs = data["totalInputs"];
            this.totalOutputs = data["totalOutputs"];
            this.totalBalance = data["totalBalance"];
            this.beginBalance = data["beginBalance"];
            this.totalBankCheckToCompensate = data["totalBankCheckToCompensate"];
        }
    }

    static fromJS(data: any): RealizedDto {
        let result = new RealizedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalInputs"] = this.totalInputs;
        data["totalOutputs"] = this.totalOutputs;
        data["totalBalance"] = this.totalBalance;
        data["beginBalance"] = this.beginBalance;
        data["totalBankCheckToCompensate"] = this.totalBankCheckToCompensate;
        return data; 
    }
}

export interface IRealizedDto {
    items: RealizedItemDto[] | undefined;
    totalInputs: number | undefined;
    totalOutputs: number | undefined;
    totalBalance: number | undefined;
    beginBalance: number | undefined;
    totalBankCheckToCompensate: number | undefined;
}

export class PredictionItemDto implements IPredictionItemDto {
    date: moment.Moment | undefined;
    inputs: number | undefined;
    accumulatedInputs: number | undefined;
    outputs: number | undefined;
    balance: number | undefined;

    constructor(data?: IPredictionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.inputs = data["inputs"];
            this.accumulatedInputs = data["accumulatedInputs"];
            this.outputs = data["outputs"];
            this.balance = data["balance"];
        }
    }

    static fromJS(data: any): PredictionItemDto {
        let result = new PredictionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["inputs"] = this.inputs;
        data["accumulatedInputs"] = this.accumulatedInputs;
        data["outputs"] = this.outputs;
        data["balance"] = this.balance;
        return data; 
    }
}

export interface IPredictionItemDto {
    date: moment.Moment | undefined;
    inputs: number | undefined;
    accumulatedInputs: number | undefined;
    outputs: number | undefined;
    balance: number | undefined;
}

export class RealizedItemDto implements IRealizedItemDto {
    date: moment.Moment | undefined;
    inputs: number | undefined;
    outputs: number | undefined;
    balance: number | undefined;

    constructor(data?: IRealizedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.inputs = data["inputs"];
            this.outputs = data["outputs"];
            this.balance = data["balance"];
        }
    }

    static fromJS(data: any): RealizedItemDto {
        let result = new RealizedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["inputs"] = this.inputs;
        data["outputs"] = this.outputs;
        data["balance"] = this.balance;
        return data; 
    }
}

export interface IRealizedItemDto {
    date: moment.Moment | undefined;
    inputs: number | undefined;
    outputs: number | undefined;
    balance: number | undefined;
}

export class GetSurveyTabulationOutput implements IGetSurveyTabulationOutput {
    id: number | undefined;
    totalRegistrations: number | undefined;
    totalAnswers: number | undefined;
    questions: QuestionTabulationOutput[] | undefined;

    constructor(data?: IGetSurveyTabulationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.totalRegistrations = data["totalRegistrations"];
            this.totalAnswers = data["totalAnswers"];
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(QuestionTabulationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyTabulationOutput {
        let result = new GetSurveyTabulationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalRegistrations"] = this.totalRegistrations;
        data["totalAnswers"] = this.totalAnswers;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSurveyTabulationOutput {
    id: number | undefined;
    totalRegistrations: number | undefined;
    totalAnswers: number | undefined;
    questions: QuestionTabulationOutput[] | undefined;
}

export class QuestionTabulationOutput implements IQuestionTabulationOutput {
    id: number | undefined;
    number: string | undefined;
    text: string | undefined;
    type: QuestionTabulationOutputType | undefined;
    numberOfAnswers: number | undefined;
    percentOfAnswers: number | undefined;
    parentId: number | undefined;
    options: OptionTabulationOutput[] | undefined;
    subQuestions: QuestionTabulationOutput[] | undefined;

    constructor(data?: IQuestionTabulationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.number = data["number"];
            this.text = data["text"];
            this.type = data["type"];
            this.numberOfAnswers = data["numberOfAnswers"];
            this.percentOfAnswers = data["percentOfAnswers"];
            this.parentId = data["parentId"];
            if (data["options"] && data["options"].constructor === Array) {
                this.options = [];
                for (let item of data["options"])
                    this.options.push(OptionTabulationOutput.fromJS(item));
            }
            if (data["subQuestions"] && data["subQuestions"].constructor === Array) {
                this.subQuestions = [];
                for (let item of data["subQuestions"])
                    this.subQuestions.push(QuestionTabulationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionTabulationOutput {
        let result = new QuestionTabulationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["text"] = this.text;
        data["type"] = this.type;
        data["numberOfAnswers"] = this.numberOfAnswers;
        data["percentOfAnswers"] = this.percentOfAnswers;
        data["parentId"] = this.parentId;
        if (this.options && this.options.constructor === Array) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (this.subQuestions && this.subQuestions.constructor === Array) {
            data["subQuestions"] = [];
            for (let item of this.subQuestions)
                data["subQuestions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQuestionTabulationOutput {
    id: number | undefined;
    number: string | undefined;
    text: string | undefined;
    type: QuestionTabulationOutputType | undefined;
    numberOfAnswers: number | undefined;
    percentOfAnswers: number | undefined;
    parentId: number | undefined;
    options: OptionTabulationOutput[] | undefined;
    subQuestions: QuestionTabulationOutput[] | undefined;
}

export class OptionTabulationOutput implements IOptionTabulationOutput {
    answerText: string | undefined;
    questionId: number | undefined;
    numberOfAnswers: number | undefined;
    percentOfAnswers: number | undefined;

    constructor(data?: IOptionTabulationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerText = data["answerText"];
            this.questionId = data["questionId"];
            this.numberOfAnswers = data["numberOfAnswers"];
            this.percentOfAnswers = data["percentOfAnswers"];
        }
    }

    static fromJS(data: any): OptionTabulationOutput {
        let result = new OptionTabulationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["questionId"] = this.questionId;
        data["numberOfAnswers"] = this.numberOfAnswers;
        data["percentOfAnswers"] = this.percentOfAnswers;
        return data; 
    }
}

export interface IOptionTabulationOutput {
    answerText: string | undefined;
    questionId: number | undefined;
    numberOfAnswers: number | undefined;
    percentOfAnswers: number | undefined;
}

export class PagedResultDtoOfQuestionCommentDto implements IPagedResultDtoOfQuestionCommentDto {
    totalCount: number | undefined;
    items: QuestionCommentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfQuestionCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(QuestionCommentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfQuestionCommentDto {
        let result = new PagedResultDtoOfQuestionCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfQuestionCommentDto {
    totalCount: number | undefined;
    items: QuestionCommentDto[] | undefined;
}

export class QuestionCommentDto implements IQuestionCommentDto {
    creationTime: moment.Moment | undefined;
    comment: string | undefined;

    constructor(data?: IQuestionCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.comment = data["comment"];
        }
    }

    static fromJS(data: any): QuestionCommentDto {
        let result = new QuestionCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data; 
    }
}

export interface IQuestionCommentDto {
    creationTime: moment.Moment | undefined;
    comment: string | undefined;
}

export class PagedResultDtoOfSurveyContactDto implements IPagedResultDtoOfSurveyContactDto {
    totalCount: number | undefined;
    items: SurveyContactDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSurveyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SurveyContactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSurveyContactDto {
        let result = new PagedResultDtoOfSurveyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSurveyContactDto {
    totalCount: number | undefined;
    items: SurveyContactDto[] | undefined;
}

export class SurveyContactDto implements ISurveyContactDto {
    name: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    creationTime: moment.Moment | undefined;
    questionAnswerId: number | undefined;
    id: number | undefined;

    constructor(data?: ISurveyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.cpf = data["cpf"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.questionAnswerId = data["questionAnswerId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyContactDto {
        let result = new SurveyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["questionAnswerId"] = this.questionAnswerId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyContactDto {
    name: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    creationTime: moment.Moment | undefined;
    questionAnswerId: number | undefined;
    id: number | undefined;
}

export class GetReceiptsOutput implements IGetReceiptsOutput {
    paymentCharges: PagedResultDtoOfReceiptsPaymentChargeDto | undefined;

    constructor(data?: IGetReceiptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentCharges = data["paymentCharges"] ? PagedResultDtoOfReceiptsPaymentChargeDto.fromJS(data["paymentCharges"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReceiptsOutput {
        let result = new GetReceiptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentCharges"] = this.paymentCharges ? this.paymentCharges.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetReceiptsOutput {
    paymentCharges: PagedResultDtoOfReceiptsPaymentChargeDto | undefined;
}

export class PagedResultDtoOfReceiptsPaymentChargeDto implements IPagedResultDtoOfReceiptsPaymentChargeDto {
    totalCount: number | undefined;
    items: ReceiptsPaymentChargeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReceiptsPaymentChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReceiptsPaymentChargeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReceiptsPaymentChargeDto {
        let result = new PagedResultDtoOfReceiptsPaymentChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfReceiptsPaymentChargeDto {
    totalCount: number | undefined;
    items: ReceiptsPaymentChargeDto[] | undefined;
}

export class ReceiptsPaymentChargeDto implements IReceiptsPaymentChargeDto {
    id: number | undefined;
    creationTime: moment.Moment | undefined;
    paymentDate: moment.Moment | undefined;
    description: string | undefined;
    customer: string | undefined;
    paymentChargeType: string | undefined;
    amount: number | undefined;
    costCenter: CostCenterListDto | undefined;
    balance: number | undefined;
    paymentId: number | undefined;
    paymentType: string | undefined;
    status: ReceiptsPaymentChargeDtoStatus | undefined;
    synced: boolean | undefined;

    constructor(data?: IReceiptsPaymentChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.customer = data["customer"];
            this.paymentChargeType = data["paymentChargeType"];
            this.amount = data["amount"];
            this.costCenter = data["costCenter"] ? CostCenterListDto.fromJS(data["costCenter"]) : <any>undefined;
            this.balance = data["balance"];
            this.paymentId = data["paymentId"];
            this.paymentType = data["paymentType"];
            this.status = data["status"];
            this.synced = data["synced"];
        }
    }

    static fromJS(data: any): ReceiptsPaymentChargeDto {
        let result = new ReceiptsPaymentChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["customer"] = this.customer;
        data["paymentChargeType"] = this.paymentChargeType;
        data["amount"] = this.amount;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        data["balance"] = this.balance;
        data["paymentId"] = this.paymentId;
        data["paymentType"] = this.paymentType;
        data["status"] = this.status;
        data["synced"] = this.synced;
        return data; 
    }
}

export interface IReceiptsPaymentChargeDto {
    id: number | undefined;
    creationTime: moment.Moment | undefined;
    paymentDate: moment.Moment | undefined;
    description: string | undefined;
    customer: string | undefined;
    paymentChargeType: string | undefined;
    amount: number | undefined;
    costCenter: CostCenterListDto | undefined;
    balance: number | undefined;
    paymentId: number | undefined;
    paymentType: string | undefined;
    status: ReceiptsPaymentChargeDtoStatus | undefined;
    synced: boolean | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    isMember: boolean | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.isMember = data["isMember"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["isMember"] = this.isMember;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    isMember: boolean | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean | undefined;
    isMember: boolean | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
            this.isMember = data["isMember"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["isMember"] = this.isMember;
        return data; 
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean | undefined;
    isMember: boolean | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role: RoleEditDto = new RoleEditDto();
    grantedPermissionNames: string[] = [];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
    application: ApplicationInfoDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
    application: ApplicationInfoDto | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    pendingUpdate: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.pendingUpdate = data["pendingUpdate"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["pendingUpdate"] = this.pendingUpdate;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    pendingUpdate: boolean | undefined;
    id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
    edition: EditionInfoDto | undefined;
    creationTime: moment.Moment | undefined;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType | undefined;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
    edition: EditionInfoDto | undefined;
    creationTime: moment.Moment | undefined;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType | undefined;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment | undefined;
    features: { [key: string] : boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            if (data["features"]) {
                this.features = {};
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment | undefined;
    features: { [key: string] : boolean; } | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean | undefined;
    isFree: boolean | undefined;
    id: number | undefined;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean | undefined;
    isFree: boolean | undefined;
    id: number | undefined;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data; 
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class PagedResultDtoOfGetSettingsForViewDto implements IPagedResultDtoOfGetSettingsForViewDto {
    totalCount: number | undefined;
    items: GetSettingsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSettingsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSettingsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSettingsForViewDto {
        let result = new PagedResultDtoOfGetSettingsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSettingsForViewDto {
    totalCount: number | undefined;
    items: GetSettingsForViewDto[] | undefined;
}

export class GetSettingsForViewDto implements IGetSettingsForViewDto {
    settings: SettingsDto | undefined;

    constructor(data?: IGetSettingsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settings = data["settings"] ? SettingsDto.fromJS(data["settings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSettingsForViewDto {
        let result = new GetSettingsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSettingsForViewDto {
    settings: SettingsDto | undefined;
}

export class SettingsDto implements ISettingsDto {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
    description: string | undefined;
    urlRequestCpf: string | undefined;
    urlToken: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ISettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerKey = data["consumerKey"];
            this.consumerSecret = data["consumerSecret"];
            this.description = data["description"];
            this.urlRequestCpf = data["urlRequestCpf"];
            this.urlToken = data["urlToken"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SettingsDto {
        let result = new SettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        data["description"] = this.description;
        data["urlRequestCpf"] = this.urlRequestCpf;
        data["urlToken"] = this.urlToken;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISettingsDto {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
    description: string | undefined;
    urlRequestCpf: string | undefined;
    urlToken: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetSettingsForEditOutput implements IGetSettingsForEditOutput {
    settings: CreateOrEditSettingsDto | undefined;

    constructor(data?: IGetSettingsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settings = data["settings"] ? CreateOrEditSettingsDto.fromJS(data["settings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSettingsForEditOutput {
        let result = new GetSettingsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSettingsForEditOutput {
    settings: CreateOrEditSettingsDto | undefined;
}

export class CreateOrEditSettingsDto implements ICreateOrEditSettingsDto {
    consumerKey: string;
    consumerSecret: string;
    description: string | undefined;
    urlRequestCpf: string;
    urlToken: string;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerKey = data["consumerKey"];
            this.consumerSecret = data["consumerSecret"];
            this.description = data["description"];
            this.urlRequestCpf = data["urlRequestCpf"];
            this.urlToken = data["urlToken"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSettingsDto {
        let result = new CreateOrEditSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        data["description"] = this.description;
        data["urlRequestCpf"] = this.urlRequestCpf;
        data["urlToken"] = this.urlToken;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSettingsDto {
    consumerKey: string;
    consumerSecret: string;
    description: string | undefined;
    urlRequestCpf: string;
    urlToken: string;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetAllSituationsOutput implements IPagedResultDtoOfGetAllSituationsOutput {
    totalCount: number | undefined;
    items: GetAllSituationsOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSituationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllSituationsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSituationsOutput {
        let result = new PagedResultDtoOfGetAllSituationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllSituationsOutput {
    totalCount: number | undefined;
    items: GetAllSituationsOutput[] | undefined;
}

export class GetAllSituationsOutput implements IGetAllSituationsOutput {
    situation: SituationDto | undefined;

    constructor(data?: IGetAllSituationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.situation = data["situation"] ? SituationDto.fromJS(data["situation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllSituationsOutput {
        let result = new GetAllSituationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAllSituationsOutput {
    situation: SituationDto | undefined;
}

export class ListResultDtoOfSituationListDto implements IListResultDtoOfSituationListDto {
    items: SituationListDto[] | undefined;

    constructor(data?: IListResultDtoOfSituationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SituationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSituationListDto {
        let result = new ListResultDtoOfSituationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSituationListDto {
    items: SituationListDto[] | undefined;
}

export class GetSituationForEditOutput implements IGetSituationForEditOutput {
    situation: CreateOrEditSituationDto | undefined;

    constructor(data?: IGetSituationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.situation = data["situation"] ? CreateOrEditSituationDto.fromJS(data["situation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSituationForEditOutput {
        let result = new GetSituationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSituationForEditOutput {
    situation: CreateOrEditSituationDto | undefined;
}

export class CreateOrEditSituationDto implements ICreateOrEditSituationDto {
    description: string;
    type: CreateOrEditSituationDtoType;
    canReceiveCorrespondence: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.type = data["type"];
            this.canReceiveCorrespondence = data["canReceiveCorrespondence"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSituationDto {
        let result = new CreateOrEditSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["canReceiveCorrespondence"] = this.canReceiveCorrespondence;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSituationDto {
    description: string;
    type: CreateOrEditSituationDtoType;
    canReceiveCorrespondence: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSpecialityForViewDto implements IPagedResultDtoOfGetSpecialityForViewDto {
    totalCount: number | undefined;
    items: GetSpecialityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSpecialityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSpecialityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSpecialityForViewDto {
        let result = new PagedResultDtoOfGetSpecialityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSpecialityForViewDto {
    totalCount: number | undefined;
    items: GetSpecialityForViewDto[] | undefined;
}

export class GetSpecialityForViewDto implements IGetSpecialityForViewDto {
    speciality: SpecialityDto | undefined;

    constructor(data?: IGetSpecialityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.speciality = data["speciality"] ? SpecialityDto.fromJS(data["speciality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSpecialityForViewDto {
        let result = new GetSpecialityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speciality"] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSpecialityForViewDto {
    speciality: SpecialityDto | undefined;
}

export class GetSpecialityForEditOutput implements IGetSpecialityForEditOutput {
    speciality: CreateOrEditSpecialityDto | undefined;

    constructor(data?: IGetSpecialityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.speciality = data["speciality"] ? CreateOrEditSpecialityDto.fromJS(data["speciality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSpecialityForEditOutput {
        let result = new GetSpecialityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speciality"] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSpecialityForEditOutput {
    speciality: CreateOrEditSpecialityDto | undefined;
}

export class CreateOrEditSpecialityDto implements ICreateOrEditSpecialityDto {
    description: string;
    isActive: boolean | undefined;
    subspecialities: SubspecialityDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSpecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            if (data["subspecialities"] && data["subspecialities"].constructor === Array) {
                this.subspecialities = [];
                for (let item of data["subspecialities"])
                    this.subspecialities.push(SubspecialityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSpecialityDto {
        let result = new CreateOrEditSpecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (this.subspecialities && this.subspecialities.constructor === Array) {
            data["subspecialities"] = [];
            for (let item of this.subspecialities)
                data["subspecialities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSpecialityDto {
    description: string;
    isActive: boolean | undefined;
    subspecialities: SubspecialityDto[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSubspecialityForViewDto implements IPagedResultDtoOfGetSubspecialityForViewDto {
    totalCount: number | undefined;
    items: GetSubspecialityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSubspecialityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSubspecialityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSubspecialityForViewDto {
        let result = new PagedResultDtoOfGetSubspecialityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSubspecialityForViewDto {
    totalCount: number | undefined;
    items: GetSubspecialityForViewDto[] | undefined;
}

export class GetSubspecialityForViewDto implements IGetSubspecialityForViewDto {
    subspeciality: SubspecialityDto | undefined;

    constructor(data?: IGetSubspecialityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subspeciality = data["subspeciality"] ? SubspecialityDto.fromJS(data["subspeciality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSubspecialityForViewDto {
        let result = new GetSubspecialityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subspeciality"] = this.subspeciality ? this.subspeciality.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSubspecialityForViewDto {
    subspeciality: SubspecialityDto | undefined;
}

export class CreateOrEditSubspecialityDto implements ICreateOrEditSubspecialityDto {
    description: string;
    isActive: boolean | undefined;
    specialityId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSubspecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.specialityId = data["specialityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSubspecialityDto {
        let result = new CreateOrEditSubspecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["specialityId"] = this.specialityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSubspecialityDto {
    description: string;
    isActive: boolean | undefined;
    specialityId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyForViewDto implements IPagedResultDtoOfGetSurveyForViewDto {
    totalCount: number | undefined;
    items: GetSurveyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyForViewDto {
        let result = new PagedResultDtoOfGetSurveyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSurveyForViewDto {
    totalCount: number | undefined;
    items: GetSurveyForViewDto[] | undefined;
}

export class GetSurveyForViewDto implements IGetSurveyForViewDto {
    survey: SurveyDto | undefined;

    constructor(data?: IGetSurveyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.survey = data["survey"] ? SurveyDto.fromJS(data["survey"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyForViewDto {
        let result = new GetSurveyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSurveyForViewDto {
    survey: SurveyDto | undefined;
}

export class SurveyDto implements ISurveyDto {
    bannerImage: string | undefined;
    title: string | undefined;
    description: string | undefined;
    bannerImageId: string | undefined;
    expirationDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    requireAnswer: boolean | undefined;
    category: SurveyDtoCategory | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    questions: QuestionDto[] | undefined;
    id: number | undefined;

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bannerImage = data["bannerImage"];
            this.title = data["title"];
            this.description = data["description"];
            this.bannerImageId = data["bannerImageId"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.requireAnswer = data["requireAnswer"];
            this.category = data["category"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(QuestionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyDto {
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bannerImage"] = this.bannerImage;
        data["title"] = this.title;
        data["description"] = this.description;
        data["bannerImageId"] = this.bannerImageId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["requireAnswer"] = this.requireAnswer;
        data["category"] = this.category;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyDto {
    bannerImage: string | undefined;
    title: string | undefined;
    description: string | undefined;
    bannerImageId: string | undefined;
    expirationDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    requireAnswer: boolean | undefined;
    category: SurveyDtoCategory | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    questions: QuestionDto[] | undefined;
    id: number | undefined;
}

export class QuestionDto implements IQuestionDto {
    number: string | undefined;
    text: string | undefined;
    scaleRating: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    type: QuestionDtoType | undefined;
    surveyId: number | undefined;
    parentId: number | undefined;
    options: OptionDto[] | undefined;
    subQuestions: QuestionDto[] | undefined;
    id: number | undefined;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.number = data["number"];
            this.text = data["text"];
            this.scaleRating = data["scaleRating"];
            this.specify = data["specify"];
            this.specifyLabelText = data["specifyLabelText"];
            this.type = data["type"];
            this.surveyId = data["surveyId"];
            this.parentId = data["parentId"];
            if (data["options"] && data["options"].constructor === Array) {
                this.options = [];
                for (let item of data["options"])
                    this.options.push(OptionDto.fromJS(item));
            }
            if (data["subQuestions"] && data["subQuestions"].constructor === Array) {
                this.subQuestions = [];
                for (let item of data["subQuestions"])
                    this.subQuestions.push(QuestionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QuestionDto {
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["text"] = this.text;
        data["scaleRating"] = this.scaleRating;
        data["specify"] = this.specify;
        data["specifyLabelText"] = this.specifyLabelText;
        data["type"] = this.type;
        data["surveyId"] = this.surveyId;
        data["parentId"] = this.parentId;
        if (this.options && this.options.constructor === Array) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (this.subQuestions && this.subQuestions.constructor === Array) {
            data["subQuestions"] = [];
            for (let item of this.subQuestions)
                data["subQuestions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IQuestionDto {
    number: string | undefined;
    text: string | undefined;
    scaleRating: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    type: QuestionDtoType | undefined;
    surveyId: number | undefined;
    parentId: number | undefined;
    options: OptionDto[] | undefined;
    subQuestions: QuestionDto[] | undefined;
    id: number | undefined;
}

export class OptionDto implements IOptionDto {
    answerText: string | undefined;
    scaleRating: number | undefined;
    questionId: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    id: number | undefined;

    constructor(data?: IOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerText = data["answerText"];
            this.scaleRating = data["scaleRating"];
            this.questionId = data["questionId"];
            this.specify = data["specify"];
            this.specifyLabelText = data["specifyLabelText"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OptionDto {
        let result = new OptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["scaleRating"] = this.scaleRating;
        data["questionId"] = this.questionId;
        data["specify"] = this.specify;
        data["specifyLabelText"] = this.specifyLabelText;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOptionDto {
    answerText: string | undefined;
    scaleRating: number | undefined;
    questionId: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    id: number | undefined;
}

export class GetSurveyForEditOutput implements IGetSurveyForEditOutput {
    survey: CreateOrEditSurveyDto | undefined;

    constructor(data?: IGetSurveyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.survey = data["survey"] ? CreateOrEditSurveyDto.fromJS(data["survey"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyForEditOutput {
        let result = new GetSurveyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSurveyForEditOutput {
    survey: CreateOrEditSurveyDto | undefined;
}

export class CreateOrEditSurveyDto implements ICreateOrEditSurveyDto {
    bannerImageId: string | undefined;
    bannerImage: string | undefined;
    bannerImageInput: BannerImageInput | undefined;
    title: string;
    description: string | undefined;
    expirationDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    requireAnswer: boolean | undefined;
    category: CreateOrEditSurveyDtoCategory | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    questions: CreateOrEditQuestionDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bannerImageId = data["bannerImageId"];
            this.bannerImage = data["bannerImage"];
            this.bannerImageInput = data["bannerImageInput"] ? BannerImageInput.fromJS(data["bannerImageInput"]) : <any>undefined;
            this.title = data["title"];
            this.description = data["description"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.requireAnswer = data["requireAnswer"];
            this.category = data["category"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(CreateOrEditQuestionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyDto {
        let result = new CreateOrEditSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bannerImageId"] = this.bannerImageId;
        data["bannerImage"] = this.bannerImage;
        data["bannerImageInput"] = this.bannerImageInput ? this.bannerImageInput.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["requireAnswer"] = this.requireAnswer;
        data["category"] = this.category;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSurveyDto {
    bannerImageId: string | undefined;
    bannerImage: string | undefined;
    bannerImageInput: BannerImageInput | undefined;
    title: string;
    description: string | undefined;
    expirationDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    requireAnswer: boolean | undefined;
    category: CreateOrEditSurveyDtoCategory | undefined;
    eventId: number | undefined;
    event: EventListDto | undefined;
    questions: CreateOrEditQuestionDto[] | undefined;
    id: number | undefined;
}

export class BannerImageInput implements IBannerImageInput {
    surveyId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IBannerImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): BannerImageInput {
        let result = new BannerImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IBannerImageInput {
    surveyId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class CreateOrEditQuestionDto implements ICreateOrEditQuestionDto {
    number: string | undefined;
    text: string | undefined;
    scaleRating: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    type: CreateOrEditQuestionDtoType | undefined;
    surveyId: number | undefined;
    parentId: number | undefined;
    options: CreateOrEditOptionDto[] | undefined;
    subQuestions: CreateOrEditQuestionDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.number = data["number"];
            this.text = data["text"];
            this.scaleRating = data["scaleRating"];
            this.specify = data["specify"];
            this.specifyLabelText = data["specifyLabelText"];
            this.type = data["type"];
            this.surveyId = data["surveyId"];
            this.parentId = data["parentId"];
            if (data["options"] && data["options"].constructor === Array) {
                this.options = [];
                for (let item of data["options"])
                    this.options.push(CreateOrEditOptionDto.fromJS(item));
            }
            if (data["subQuestions"] && data["subQuestions"].constructor === Array) {
                this.subQuestions = [];
                for (let item of data["subQuestions"])
                    this.subQuestions.push(CreateOrEditQuestionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestionDto {
        let result = new CreateOrEditQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["text"] = this.text;
        data["scaleRating"] = this.scaleRating;
        data["specify"] = this.specify;
        data["specifyLabelText"] = this.specifyLabelText;
        data["type"] = this.type;
        data["surveyId"] = this.surveyId;
        data["parentId"] = this.parentId;
        if (this.options && this.options.constructor === Array) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (this.subQuestions && this.subQuestions.constructor === Array) {
            data["subQuestions"] = [];
            for (let item of this.subQuestions)
                data["subQuestions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditQuestionDto {
    number: string | undefined;
    text: string | undefined;
    scaleRating: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    type: CreateOrEditQuestionDtoType | undefined;
    surveyId: number | undefined;
    parentId: number | undefined;
    options: CreateOrEditOptionDto[] | undefined;
    subQuestions: CreateOrEditQuestionDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditOptionDto implements ICreateOrEditOptionDto {
    answerText: string | undefined;
    scaleRating: number | undefined;
    questionId: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    contactInfo: CreateOrEditSurveyContactDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerText = data["answerText"];
            this.scaleRating = data["scaleRating"];
            this.questionId = data["questionId"];
            this.specify = data["specify"];
            this.specifyLabelText = data["specifyLabelText"];
            this.contactInfo = data["contactInfo"] ? CreateOrEditSurveyContactDto.fromJS(data["contactInfo"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOptionDto {
        let result = new CreateOrEditOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["scaleRating"] = this.scaleRating;
        data["questionId"] = this.questionId;
        data["specify"] = this.specify;
        data["specifyLabelText"] = this.specifyLabelText;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditOptionDto {
    answerText: string | undefined;
    scaleRating: number | undefined;
    questionId: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    contactInfo: CreateOrEditSurveyContactDto | undefined;
    id: number | undefined;
}

export class CreateOrEditSurveyContactDto implements ICreateOrEditSurveyContactDto {
    name: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    questionAnswerId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSurveyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.cpf = data["cpf"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.questionAnswerId = data["questionAnswerId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyContactDto {
        let result = new CreateOrEditSurveyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["questionAnswerId"] = this.questionAnswerId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSurveyContactDto {
    name: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    questionAnswerId: number | undefined;
    id: number | undefined;
}

export class CopySurveyInput implements ICopySurveyInput {
    surveyId: number | undefined;
    eventBaseId: number | undefined;
    eventId: number | undefined;

    constructor(data?: ICopySurveyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.eventBaseId = data["eventBaseId"];
            this.eventId = data["eventId"];
        }
    }

    static fromJS(data: any): CopySurveyInput {
        let result = new CopySurveyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["eventBaseId"] = this.eventBaseId;
        data["eventId"] = this.eventId;
        return data; 
    }
}

export interface ICopySurveyInput {
    surveyId: number | undefined;
    eventBaseId: number | undefined;
    eventId: number | undefined;
}

export class CreateOrEditSurveyAnswerDto implements ICreateOrEditSurveyAnswerDto {
    surveyId: number | undefined;
    userId: number | undefined;
    registrationId: number | undefined;
    answers: CreateOrEditQuestionAnswerDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.userId = data["userId"];
            this.registrationId = data["registrationId"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(CreateOrEditQuestionAnswerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyAnswerDto {
        let result = new CreateOrEditSurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["userId"] = this.userId;
        data["registrationId"] = this.registrationId;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSurveyAnswerDto {
    surveyId: number | undefined;
    userId: number | undefined;
    registrationId: number | undefined;
    answers: CreateOrEditQuestionAnswerDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditQuestionAnswerDto implements ICreateOrEditQuestionAnswerDto {
    questionId: number | undefined;
    optionId: number | undefined;
    textComment: string | undefined;
    contact: CreateOrEditSurveyContactDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionId = data["questionId"];
            this.optionId = data["optionId"];
            this.textComment = data["textComment"];
            this.contact = data["contact"] ? CreateOrEditSurveyContactDto.fromJS(data["contact"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestionAnswerDto {
        let result = new CreateOrEditQuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["optionId"] = this.optionId;
        data["textComment"] = this.textComment;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditQuestionAnswerDto {
    questionId: number | undefined;
    optionId: number | undefined;
    textComment: string | undefined;
    contact: CreateOrEditSurveyContactDto | undefined;
    id: number | undefined;
}

export class GetSurveyAnswerForViewDto implements IGetSurveyAnswerForViewDto {
    answer: SurveyAnswerDto | undefined;

    constructor(data?: IGetSurveyAnswerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answer = data["answer"] ? SurveyAnswerDto.fromJS(data["answer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyAnswerForViewDto {
        let result = new GetSurveyAnswerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSurveyAnswerForViewDto {
    answer: SurveyAnswerDto | undefined;
}

export class SurveyAnswerDto implements ISurveyAnswerDto {
    surveyId: number | undefined;
    survey: SurveyDto | undefined;
    userId: number | undefined;
    registrationId: number | undefined;
    answers: QuestionAnswerDto[] | undefined;
    id: number | undefined;

    constructor(data?: ISurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.survey = data["survey"] ? SurveyDto.fromJS(data["survey"]) : <any>undefined;
            this.userId = data["userId"];
            this.registrationId = data["registrationId"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(QuestionAnswerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyAnswerDto {
        let result = new SurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["registrationId"] = this.registrationId;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyAnswerDto {
    surveyId: number | undefined;
    survey: SurveyDto | undefined;
    userId: number | undefined;
    registrationId: number | undefined;
    answers: QuestionAnswerDto[] | undefined;
    id: number | undefined;
}

export class QuestionAnswerDto implements IQuestionAnswerDto {
    questionId: number | undefined;
    optionId: number | undefined;
    textComment: string | undefined;
    contact: SurveyContactDto | undefined;
    id: number | undefined;

    constructor(data?: IQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionId = data["questionId"];
            this.optionId = data["optionId"];
            this.textComment = data["textComment"];
            this.contact = data["contact"] ? SurveyContactDto.fromJS(data["contact"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QuestionAnswerDto {
        let result = new QuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["optionId"] = this.optionId;
        data["textComment"] = this.textComment;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IQuestionAnswerDto {
    questionId: number | undefined;
    optionId: number | undefined;
    textComment: string | undefined;
    contact: SurveyContactDto | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyWorkForViewDto implements IPagedResultDtoOfGetSurveyWorkForViewDto {
    totalCount: number | undefined;
    items: GetSurveyWorkForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyWorkForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyWorkForViewDto {
        let result = new PagedResultDtoOfGetSurveyWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSurveyWorkForViewDto {
    totalCount: number | undefined;
    items: GetSurveyWorkForViewDto[] | undefined;
}

export class GetSurveyWorkForViewDto implements IGetSurveyWorkForViewDto {
    surveyWork: SurveyWorkDto | undefined;
    eventName: string | undefined;

    constructor(data?: IGetSurveyWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyWork = data["surveyWork"] ? SurveyWorkDto.fromJS(data["surveyWork"]) : <any>undefined;
            this.eventName = data["eventName"];
        }
    }

    static fromJS(data: any): GetSurveyWorkForViewDto {
        let result = new GetSurveyWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyWork"] = this.surveyWork ? this.surveyWork.toJSON() : <any>undefined;
        data["eventName"] = this.eventName;
        return data; 
    }
}

export interface IGetSurveyWorkForViewDto {
    surveyWork: SurveyWorkDto | undefined;
    eventName: string | undefined;
}

export class SurveyWorkDto implements ISurveyWorkDto {
    category: SurveyWorkDtoCategory | undefined;
    eventWorkId: number | undefined;
    id: number | undefined;

    constructor(data?: ISurveyWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.eventWorkId = data["eventWorkId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyWorkDto {
        let result = new SurveyWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["eventWorkId"] = this.eventWorkId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyWorkDto {
    category: SurveyWorkDtoCategory | undefined;
    eventWorkId: number | undefined;
    id: number | undefined;
}

export class GetSurveyWorkForEditOutput implements IGetSurveyWorkForEditOutput {
    surveyWork: CreateOrEditSurveyWorkDto | undefined;

    constructor(data?: IGetSurveyWorkForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyWork = data["surveyWork"] ? CreateOrEditSurveyWorkDto.fromJS(data["surveyWork"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyWorkForEditOutput {
        let result = new GetSurveyWorkForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyWork"] = this.surveyWork ? this.surveyWork.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSurveyWorkForEditOutput {
    surveyWork: CreateOrEditSurveyWorkDto | undefined;
}

export class CreateOrEditSurveyWorkDto implements ICreateOrEditSurveyWorkDto {
    category: CreateOrEditSurveyWorkDtoCategory | undefined;
    eventWorkId: number | undefined;
    questionWorks: CreateOrEditQuestionWorkDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditSurveyWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.eventWorkId = data["eventWorkId"];
            if (data["questionWorks"] && data["questionWorks"].constructor === Array) {
                this.questionWorks = [];
                for (let item of data["questionWorks"])
                    this.questionWorks.push(CreateOrEditQuestionWorkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyWorkDto {
        let result = new CreateOrEditSurveyWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["eventWorkId"] = this.eventWorkId;
        if (this.questionWorks && this.questionWorks.constructor === Array) {
            data["questionWorks"] = [];
            for (let item of this.questionWorks)
                data["questionWorks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSurveyWorkDto {
    category: CreateOrEditSurveyWorkDtoCategory | undefined;
    eventWorkId: number | undefined;
    questionWorks: CreateOrEditQuestionWorkDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditQuestionWorkDto implements ICreateOrEditQuestionWorkDto {
    number: string | undefined;
    text: string | undefined;
    scaleRating: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    type: CreateOrEditQuestionWorkDtoType | undefined;
    surveyWorkId: number | undefined;
    answered: boolean | undefined;
    optionWorks: CreateOrEditOptionWorkDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditQuestionWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.number = data["number"];
            this.text = data["text"];
            this.scaleRating = data["scaleRating"];
            this.specify = data["specify"];
            this.specifyLabelText = data["specifyLabelText"];
            this.type = data["type"];
            this.surveyWorkId = data["surveyWorkId"];
            this.answered = data["answered"];
            if (data["optionWorks"] && data["optionWorks"].constructor === Array) {
                this.optionWorks = [];
                for (let item of data["optionWorks"])
                    this.optionWorks.push(CreateOrEditOptionWorkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestionWorkDto {
        let result = new CreateOrEditQuestionWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["text"] = this.text;
        data["scaleRating"] = this.scaleRating;
        data["specify"] = this.specify;
        data["specifyLabelText"] = this.specifyLabelText;
        data["type"] = this.type;
        data["surveyWorkId"] = this.surveyWorkId;
        data["answered"] = this.answered;
        if (this.optionWorks && this.optionWorks.constructor === Array) {
            data["optionWorks"] = [];
            for (let item of this.optionWorks)
                data["optionWorks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditQuestionWorkDto {
    number: string | undefined;
    text: string | undefined;
    scaleRating: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    type: CreateOrEditQuestionWorkDtoType | undefined;
    surveyWorkId: number | undefined;
    answered: boolean | undefined;
    optionWorks: CreateOrEditOptionWorkDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditOptionWorkDto implements ICreateOrEditOptionWorkDto {
    answerText: string | undefined;
    questionWorkId: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditOptionWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerText = data["answerText"];
            this.questionWorkId = data["questionWorkId"];
            this.specify = data["specify"];
            this.specifyLabelText = data["specifyLabelText"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOptionWorkDto {
        let result = new CreateOrEditOptionWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["questionWorkId"] = this.questionWorkId;
        data["specify"] = this.specify;
        data["specifyLabelText"] = this.specifyLabelText;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditOptionWorkDto {
    answerText: string | undefined;
    questionWorkId: number | undefined;
    specify: boolean | undefined;
    specifyLabelText: string | undefined;
    id: number | undefined;
}

export class WorkPresentationEvaluationDto implements IWorkPresentationEvaluationDto {
    grade: number | undefined;
    workId: number | undefined;
    evaluatorId: number | undefined;
    evaluator: EvaluatorDto | undefined;
    answers: CreateOrEditSurveyAnswerWorkDto[] | undefined;
    id: number | undefined;

    constructor(data?: IWorkPresentationEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.grade = data["grade"];
            this.workId = data["workId"];
            this.evaluatorId = data["evaluatorId"];
            this.evaluator = data["evaluator"] ? EvaluatorDto.fromJS(data["evaluator"]) : <any>undefined;
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(CreateOrEditSurveyAnswerWorkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WorkPresentationEvaluationDto {
        let result = new WorkPresentationEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grade"] = this.grade;
        data["workId"] = this.workId;
        data["evaluatorId"] = this.evaluatorId;
        data["evaluator"] = this.evaluator ? this.evaluator.toJSON() : <any>undefined;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkPresentationEvaluationDto {
    grade: number | undefined;
    workId: number | undefined;
    evaluatorId: number | undefined;
    evaluator: EvaluatorDto | undefined;
    answers: CreateOrEditSurveyAnswerWorkDto[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount: number | undefined;
    items: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number | undefined;
    items: TenantListDto[] | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean | undefined;
    id: number | undefined;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean | undefined;
    id: number | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    sendActivationEmail: boolean | undefined;
    editionId: number | undefined;
    isActive: boolean | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data; 
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    sendActivationEmail: boolean | undefined;
    editionId: number | undefined;
    isActive: boolean | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
    id: number | undefined;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
    id: number | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id: number | undefined;
    featureValues: NameValueDto[] = [];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number | undefined;
    featureValues: NameValueDto[];
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["memberActivities"] && data["memberActivities"].constructor === Array) {
                this.memberActivities = [];
                for (let item of data["memberActivities"])
                    this.memberActivities.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.memberActivities && this.memberActivities.constructor === Array) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class MemberActivity implements IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number | undefined;
    closed: number | undefined;
    rate: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data; 
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number | undefined;
    closed: number | undefined;
    rate: string | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit: number | undefined;
    newFeedbacks: number | undefined;
    newOrders: number | undefined;
    newUsers: number | undefined;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number | undefined;
    revenue: number | undefined;
    expenses: number | undefined;
    growth: number | undefined;
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (data["dailySales"] && data["dailySales"].constructor === Array) {
                this.dailySales = [];
                for (let item of data["dailySales"])
                    this.dailySales.push(item);
            }
            if (data["profitShares"] && data["profitShares"].constructor === Array) {
                this.profitShares = [];
                for (let item of data["profitShares"])
                    this.profitShares.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (this.dailySales && this.dailySales.constructor === Array) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (this.profitShares && this.profitShares.constructor === Array) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data; 
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number | undefined;
    newFeedbacks: number | undefined;
    newOrders: number | undefined;
    newUsers: number | undefined;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number | undefined;
    revenue: number | undefined;
    expenses: number | undefined;
    growth: number | undefined;
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class SalesSummaryData implements ISalesSummaryData {
    period: string | undefined;
    sales: number | undefined;
    profit: number | undefined;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data; 
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number | undefined;
    profit: number | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetWorldMapOutput implements IGetWorldMapOutput {
    countries: WorldMapCountry[] | undefined;

    constructor(data?: IGetWorldMapOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["countries"] && data["countries"].constructor === Array) {
                this.countries = [];
                for (let item of data["countries"])
                    this.countries.push(WorldMapCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorldMapOutput {
        let result = new GetWorldMapOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.countries && this.countries.constructor === Array) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetWorldMapOutput {
    countries: WorldMapCountry[] | undefined;
}

export class WorldMapCountry implements IWorldMapCountry {
    countryName: string | undefined;
    color: number | undefined;

    constructor(data?: IWorldMapCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryName = data["countryName"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): WorldMapCountry {
        let result = new WorldMapCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["color"] = this.color;
        return data; 
    }
}

export interface IWorldMapCountry {
    countryName: string | undefined;
    color: number | undefined;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data; 
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType | undefined;
    gateway: RegisterTenantInputGateway | undefined;
    editionId: number | undefined;
    paymentId: string | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.gateway = data["gateway"];
            this.editionId = data["editionId"];
            this.paymentId = data["paymentId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["gateway"] = this.gateway;
        data["editionId"] = this.editionId;
        data["paymentId"] = this.paymentId;
        return data; 
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType | undefined;
    gateway: RegisterTenantInputGateway | undefined;
    editionId: number | undefined;
    paymentId: string | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean | undefined;
    isActive: boolean | undefined;
    isEmailConfirmationRequired: boolean | undefined;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data; 
    }
}

export interface IRegisterTenantOutput {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean | undefined;
    isActive: boolean | undefined;
    isEmailConfirmationRequired: boolean | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    tenantEditionId: number | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["allFeatures"] && data["allFeatures"].constructor === Array) {
                this.allFeatures = [];
                for (let item of data["allFeatures"])
                    this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (data["editionsWithFeatures"] && data["editionsWithFeatures"].constructor === Array) {
                this.editionsWithFeatures = [];
                for (let item of data["editionsWithFeatures"])
                    this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.tenantEditionId = data["tenantEditionId"];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures && this.allFeatures.constructor === Array) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (this.editionsWithFeatures && this.editionsWithFeatures.constructor === Array) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data; 
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    tenantEditionId: number | undefined;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType | undefined;
    textHtmlColor: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : <any>undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data; 
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType | undefined;
    textHtmlColor: string | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition: EditionSelectDto | undefined;
    featureValues: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto | undefined;
    featureValues: NameValueDto[] | undefined;
}

export class IInputType implements IIInputType {
    readonly name: string | undefined;
    readonly attributes: { [key: string] : any; } | undefined;
    validator: IValueValidator | undefined;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).name = data["name"];
            if (data["attributes"]) {
                (<any>this).attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string] : any; } | undefined;
    validator: IValueValidator | undefined;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general: GeneralSettingsEditDto | undefined;
    userManagement: TenantUserManagementSettingsEditDto = new TenantUserManagementSettingsEditDto();
    email: EmailSettingsEditDto | undefined;
    ldap: LdapSettingsEditDto | undefined;
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: TenantBillingSettingsEditDto | undefined;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : <any>undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : <any>undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : <any>undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto | undefined;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto | undefined;
    ldap: LdapSettingsEditDto | undefined;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredUserActiveByDefault: boolean | undefined;
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        return data; 
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredUserActiveByDefault: boolean | undefined;
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled: boolean | undefined;
    isEnabled: boolean | undefined;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean | undefined;
    isEnabled: boolean | undefined;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data; 
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class PagedResultDtoOfGetTerminalSettingForViewDto implements IPagedResultDtoOfGetTerminalSettingForViewDto {
    totalCount: number | undefined;
    items: GetTerminalSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTerminalSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTerminalSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTerminalSettingForViewDto {
        let result = new PagedResultDtoOfGetTerminalSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTerminalSettingForViewDto {
    totalCount: number | undefined;
    items: GetTerminalSettingForViewDto[] | undefined;
}

export class GetTerminalSettingForViewDto implements IGetTerminalSettingForViewDto {
    terminalSetting: TerminalSettingDto | undefined;

    constructor(data?: IGetTerminalSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.terminalSetting = data["terminalSetting"] ? TerminalSettingDto.fromJS(data["terminalSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTerminalSettingForViewDto {
        let result = new GetTerminalSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalSetting"] = this.terminalSetting ? this.terminalSetting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetTerminalSettingForViewDto {
    terminalSetting: TerminalSettingDto | undefined;
}

export class TerminalSettingDto implements ITerminalSettingDto {
    name: string | undefined;
    configParams: string | undefined;
    initParams: string | undefined;
    ipSiTef: string | undefined;
    enterprise: string | undefined;
    operator: string | undefined;
    isActive: boolean | undefined;
    sessionTimeoutSeconds: number | undefined;
    sessionNoticeTimeoutSeconds: number | undefined;
    showRelatedEvents: boolean | undefined;
    allowRegistration: boolean | undefined;
    allowCurrentAnnuity: boolean | undefined;
    allowCredential: boolean | undefined;
    mainEventName: string | undefined;
    numberOfCredentialsCopy: number | undefined;
    showCredentialBarcode: boolean | undefined;
    fontSizeName: number | undefined;
    fontSizeCity: number | undefined;
    eventsList: EventListDto[] | undefined;
    id: number | undefined;

    constructor(data?: ITerminalSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.configParams = data["configParams"];
            this.initParams = data["initParams"];
            this.ipSiTef = data["ipSiTef"];
            this.enterprise = data["enterprise"];
            this.operator = data["operator"];
            this.isActive = data["isActive"];
            this.sessionTimeoutSeconds = data["sessionTimeoutSeconds"];
            this.sessionNoticeTimeoutSeconds = data["sessionNoticeTimeoutSeconds"];
            this.showRelatedEvents = data["showRelatedEvents"];
            this.allowRegistration = data["allowRegistration"];
            this.allowCurrentAnnuity = data["allowCurrentAnnuity"];
            this.allowCredential = data["allowCredential"];
            this.mainEventName = data["mainEventName"];
            this.numberOfCredentialsCopy = data["numberOfCredentialsCopy"];
            this.showCredentialBarcode = data["showCredentialBarcode"];
            this.fontSizeName = data["fontSizeName"];
            this.fontSizeCity = data["fontSizeCity"];
            if (data["eventsList"] && data["eventsList"].constructor === Array) {
                this.eventsList = [];
                for (let item of data["eventsList"])
                    this.eventsList.push(EventListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TerminalSettingDto {
        let result = new TerminalSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["configParams"] = this.configParams;
        data["initParams"] = this.initParams;
        data["ipSiTef"] = this.ipSiTef;
        data["enterprise"] = this.enterprise;
        data["operator"] = this.operator;
        data["isActive"] = this.isActive;
        data["sessionTimeoutSeconds"] = this.sessionTimeoutSeconds;
        data["sessionNoticeTimeoutSeconds"] = this.sessionNoticeTimeoutSeconds;
        data["showRelatedEvents"] = this.showRelatedEvents;
        data["allowRegistration"] = this.allowRegistration;
        data["allowCurrentAnnuity"] = this.allowCurrentAnnuity;
        data["allowCredential"] = this.allowCredential;
        data["mainEventName"] = this.mainEventName;
        data["numberOfCredentialsCopy"] = this.numberOfCredentialsCopy;
        data["showCredentialBarcode"] = this.showCredentialBarcode;
        data["fontSizeName"] = this.fontSizeName;
        data["fontSizeCity"] = this.fontSizeCity;
        if (this.eventsList && this.eventsList.constructor === Array) {
            data["eventsList"] = [];
            for (let item of this.eventsList)
                data["eventsList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITerminalSettingDto {
    name: string | undefined;
    configParams: string | undefined;
    initParams: string | undefined;
    ipSiTef: string | undefined;
    enterprise: string | undefined;
    operator: string | undefined;
    isActive: boolean | undefined;
    sessionTimeoutSeconds: number | undefined;
    sessionNoticeTimeoutSeconds: number | undefined;
    showRelatedEvents: boolean | undefined;
    allowRegistration: boolean | undefined;
    allowCurrentAnnuity: boolean | undefined;
    allowCredential: boolean | undefined;
    mainEventName: string | undefined;
    numberOfCredentialsCopy: number | undefined;
    showCredentialBarcode: boolean | undefined;
    fontSizeName: number | undefined;
    fontSizeCity: number | undefined;
    eventsList: EventListDto[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfTerminalSettingsListDto implements IListResultDtoOfTerminalSettingsListDto {
    items: TerminalSettingsListDto[] | undefined;

    constructor(data?: IListResultDtoOfTerminalSettingsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TerminalSettingsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTerminalSettingsListDto {
        let result = new ListResultDtoOfTerminalSettingsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTerminalSettingsListDto {
    items: TerminalSettingsListDto[] | undefined;
}

export class TerminalSettingsListDto implements ITerminalSettingsListDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ITerminalSettingsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TerminalSettingsListDto {
        let result = new TerminalSettingsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITerminalSettingsListDto {
    name: string | undefined;
    id: number | undefined;
}

export class GetTerminalSettingForEditOutput implements IGetTerminalSettingForEditOutput {
    terminalSetting: CreateOrEditTerminalSettingDto | undefined;

    constructor(data?: IGetTerminalSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.terminalSetting = data["terminalSetting"] ? CreateOrEditTerminalSettingDto.fromJS(data["terminalSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTerminalSettingForEditOutput {
        let result = new GetTerminalSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalSetting"] = this.terminalSetting ? this.terminalSetting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetTerminalSettingForEditOutput {
    terminalSetting: CreateOrEditTerminalSettingDto | undefined;
}

export class CreateOrEditTerminalSettingDto implements ICreateOrEditTerminalSettingDto {
    name: string | undefined;
    configParams: string | undefined;
    initParams: string | undefined;
    ipSiTef: string | undefined;
    enterprise: string | undefined;
    operator: string | undefined;
    isActive: boolean | undefined;
    sessionTimeoutSeconds: number | undefined;
    sessionNoticeTimeoutSeconds: number | undefined;
    showRelatedEvents: boolean | undefined;
    allowRegistration: boolean | undefined;
    allowCurrentAnnuity: boolean | undefined;
    allowCredential: boolean | undefined;
    mainEventName: string | undefined;
    numberOfCredentialsCopy: number | undefined;
    showCredentialBarcode: boolean | undefined;
    fontSizeName: number | undefined;
    fontSizeCity: number | undefined;
    eventId: number | undefined;
    eventsList: EventListDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditTerminalSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.configParams = data["configParams"];
            this.initParams = data["initParams"];
            this.ipSiTef = data["ipSiTef"];
            this.enterprise = data["enterprise"];
            this.operator = data["operator"];
            this.isActive = data["isActive"];
            this.sessionTimeoutSeconds = data["sessionTimeoutSeconds"];
            this.sessionNoticeTimeoutSeconds = data["sessionNoticeTimeoutSeconds"];
            this.showRelatedEvents = data["showRelatedEvents"];
            this.allowRegistration = data["allowRegistration"];
            this.allowCurrentAnnuity = data["allowCurrentAnnuity"];
            this.allowCredential = data["allowCredential"];
            this.mainEventName = data["mainEventName"];
            this.numberOfCredentialsCopy = data["numberOfCredentialsCopy"];
            this.showCredentialBarcode = data["showCredentialBarcode"];
            this.fontSizeName = data["fontSizeName"];
            this.fontSizeCity = data["fontSizeCity"];
            this.eventId = data["eventId"];
            if (data["eventsList"] && data["eventsList"].constructor === Array) {
                this.eventsList = [];
                for (let item of data["eventsList"])
                    this.eventsList.push(EventListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTerminalSettingDto {
        let result = new CreateOrEditTerminalSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["configParams"] = this.configParams;
        data["initParams"] = this.initParams;
        data["ipSiTef"] = this.ipSiTef;
        data["enterprise"] = this.enterprise;
        data["operator"] = this.operator;
        data["isActive"] = this.isActive;
        data["sessionTimeoutSeconds"] = this.sessionTimeoutSeconds;
        data["sessionNoticeTimeoutSeconds"] = this.sessionNoticeTimeoutSeconds;
        data["showRelatedEvents"] = this.showRelatedEvents;
        data["allowRegistration"] = this.allowRegistration;
        data["allowCurrentAnnuity"] = this.allowCurrentAnnuity;
        data["allowCredential"] = this.allowCredential;
        data["mainEventName"] = this.mainEventName;
        data["numberOfCredentialsCopy"] = this.numberOfCredentialsCopy;
        data["showCredentialBarcode"] = this.showCredentialBarcode;
        data["fontSizeName"] = this.fontSizeName;
        data["fontSizeCity"] = this.fontSizeCity;
        data["eventId"] = this.eventId;
        if (this.eventsList && this.eventsList.constructor === Array) {
            data["eventsList"] = [];
            for (let item of this.eventsList)
                data["eventsList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTerminalSettingDto {
    name: string | undefined;
    configParams: string | undefined;
    initParams: string | undefined;
    ipSiTef: string | undefined;
    enterprise: string | undefined;
    operator: string | undefined;
    isActive: boolean | undefined;
    sessionTimeoutSeconds: number | undefined;
    sessionNoticeTimeoutSeconds: number | undefined;
    showRelatedEvents: boolean | undefined;
    allowRegistration: boolean | undefined;
    allowCurrentAnnuity: boolean | undefined;
    allowCredential: boolean | undefined;
    mainEventName: string | undefined;
    numberOfCredentialsCopy: number | undefined;
    showCredentialBarcode: boolean | undefined;
    fontSizeName: number | undefined;
    fontSizeCity: number | undefined;
    eventId: number | undefined;
    eventsList: EventListDto[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetThematicAreaForViewDto implements IPagedResultDtoOfGetThematicAreaForViewDto {
    totalCount: number | undefined;
    items: GetThematicAreaForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetThematicAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetThematicAreaForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetThematicAreaForViewDto {
        let result = new PagedResultDtoOfGetThematicAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetThematicAreaForViewDto {
    totalCount: number | undefined;
    items: GetThematicAreaForViewDto[] | undefined;
}

export class GetThematicAreaForViewDto implements IGetThematicAreaForViewDto {
    thematicArea: ThematicAreaDto | undefined;

    constructor(data?: IGetThematicAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.thematicArea = data["thematicArea"] ? ThematicAreaDto.fromJS(data["thematicArea"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetThematicAreaForViewDto {
        let result = new GetThematicAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetThematicAreaForViewDto {
    thematicArea: ThematicAreaDto | undefined;
}

export class ThematicAreaDto implements IThematicAreaDto {
    programingId: number | undefined;
    description: string | undefined;
    responsibleId: number | undefined;
    responsible: UserSelectListDto | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: IThematicAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programingId = data["programingId"];
            this.description = data["description"];
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? UserSelectListDto.fromJS(data["responsible"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThematicAreaDto {
        let result = new ThematicAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programingId"] = this.programingId;
        data["description"] = this.description;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThematicAreaDto {
    programingId: number | undefined;
    description: string | undefined;
    responsibleId: number | undefined;
    responsible: UserSelectListDto | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class ListResultDtoOfThematicAreaListDto implements IListResultDtoOfThematicAreaListDto {
    items: ThematicAreaListDto[] | undefined;

    constructor(data?: IListResultDtoOfThematicAreaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ThematicAreaListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfThematicAreaListDto {
        let result = new ListResultDtoOfThematicAreaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfThematicAreaListDto {
    items: ThematicAreaListDto[] | undefined;
}

export class GetThematicAreaForEditOutput implements IGetThematicAreaForEditOutput {
    thematicArea: CreateOrEditThematicAreaDto | undefined;

    constructor(data?: IGetThematicAreaForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.thematicArea = data["thematicArea"] ? CreateOrEditThematicAreaDto.fromJS(data["thematicArea"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetThematicAreaForEditOutput {
        let result = new GetThematicAreaForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetThematicAreaForEditOutput {
    thematicArea: CreateOrEditThematicAreaDto | undefined;
}

export class CreateOrEditThematicAreaDto implements ICreateOrEditThematicAreaDto {
    programingId: number;
    description: string;
    responsibleId: number | undefined;
    responsible: UserSelectListDto | undefined;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditThematicAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programingId = data["programingId"];
            this.description = data["description"];
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? UserSelectListDto.fromJS(data["responsible"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditThematicAreaDto {
        let result = new CreateOrEditThematicAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programingId"] = this.programingId;
        data["description"] = this.description;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditThematicAreaDto {
    programingId: number;
    description: string;
    responsibleId: number | undefined;
    responsible: UserSelectListDto | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean | undefined;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    refererUrl: string | undefined;
    token: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.refererUrl = data["refererUrl"];
            this.token = data["token"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["refererUrl"] = this.refererUrl;
        data["token"] = this.token;
        return data; 
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean | undefined;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    refererUrl: string | undefined;
    token: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    shouldResetPassword: boolean | undefined;
    passwordResetCode: string | undefined;
    userId: number | undefined;
    requiresTwoFactorVerification: boolean | undefined;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    shouldResetPassword: boolean | undefined;
    passwordResetCode: string | undefined;
    userId: number | undefined;
    requiresTwoFactorVerification: boolean | undefined;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
}

export class ChangePasswordRedirectInfoModel implements IChangePasswordRedirectInfoModel {
    url: string | undefined;
    token: string | undefined;

    constructor(data?: IChangePasswordRedirectInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"];
            this.token = data["token"];
        }
    }

    static fromJS(data: any): ChangePasswordRedirectInfoModel {
        let result = new ChangePasswordRedirectInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["token"] = this.token;
        return data;
    }
}

export interface IChangePasswordRedirectInfoModel {
    url: string | undefined;
    token: string | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId: number | undefined;
    provider: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number | undefined;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
    returnUrl: string | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
    returnUrl: string | undefined;
}

export class UiCustomizationSettingsEditDto implements IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto | undefined;
    header: UiCustomizationHeaderSettingsEditDto | undefined;
    menu: UiCustomizationMenuSettingsEditDto | undefined;
    footer: UiCustomizationFooterSettingsEditDto | undefined;

    constructor(data?: IUiCustomizationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layout = data["layout"] ? UiCustomizationLayoutSettingsEditDto.fromJS(data["layout"]) : <any>undefined;
            this.header = data["header"] ? UiCustomizationHeaderSettingsEditDto.fromJS(data["header"]) : <any>undefined;
            this.menu = data["menu"] ? UiCustomizationMenuSettingsEditDto.fromJS(data["menu"]) : <any>undefined;
            this.footer = data["footer"] ? UiCustomizationFooterSettingsEditDto.fromJS(data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiCustomizationSettingsEditDto {
        let result = new UiCustomizationSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto | undefined;
    header: UiCustomizationHeaderSettingsEditDto | undefined;
    menu: UiCustomizationMenuSettingsEditDto | undefined;
    footer: UiCustomizationFooterSettingsEditDto | undefined;
}

export class UiCustomizationLayoutSettingsEditDto implements IUiCustomizationLayoutSettingsEditDto {
    layoutType: string | undefined;
    contentSkin: string | undefined;

    constructor(data?: IUiCustomizationLayoutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutType = data["layoutType"];
            this.contentSkin = data["contentSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationLayoutSettingsEditDto {
        let result = new UiCustomizationLayoutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["contentSkin"] = this.contentSkin;
        return data; 
    }
}

export interface IUiCustomizationLayoutSettingsEditDto {
    layoutType: string | undefined;
    contentSkin: string | undefined;
}

export class UiCustomizationHeaderSettingsEditDto implements IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean | undefined;
    desktopMinimizeMode: string | undefined;
    mobileFixedHeader: boolean | undefined;
    dropdownSkinDesktop: string | undefined;
    displaySubmenuArrowDesktop: boolean | undefined;
    dropdownSkin: string | undefined;

    constructor(data?: IUiCustomizationHeaderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.desktopMinimizeMode = data["desktopMinimizeMode"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.dropdownSkinDesktop = data["dropdownSkinDesktop"];
            this.displaySubmenuArrowDesktop = data["displaySubmenuArrowDesktop"];
            this.dropdownSkin = data["dropdownSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationHeaderSettingsEditDto {
        let result = new UiCustomizationHeaderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["desktopMinimizeMode"] = this.desktopMinimizeMode;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["dropdownSkinDesktop"] = this.dropdownSkinDesktop;
        data["displaySubmenuArrowDesktop"] = this.displaySubmenuArrowDesktop;
        data["dropdownSkin"] = this.dropdownSkin;
        return data; 
    }
}

export interface IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean | undefined;
    desktopMinimizeMode: string | undefined;
    mobileFixedHeader: boolean | undefined;
    dropdownSkinDesktop: string | undefined;
    displaySubmenuArrowDesktop: boolean | undefined;
    dropdownSkin: string | undefined;
}

export class UiCustomizationMenuSettingsEditDto implements IUiCustomizationMenuSettingsEditDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean | undefined;
    allowAsideMinimizing: boolean | undefined;
    defaultMinimizedAside: boolean | undefined;
    allowAsideHiding: boolean | undefined;
    defaultHiddenAside: boolean | undefined;
    submenuToggle: string | undefined;
    dropdownSubmenuSkin: string | undefined;
    dropdownSubmenuArrow: boolean | undefined;

    constructor(data?: IUiCustomizationMenuSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.allowAsideHiding = data["allowAsideHiding"];
            this.defaultHiddenAside = data["defaultHiddenAside"];
            this.submenuToggle = data["submenuToggle"];
            this.dropdownSubmenuSkin = data["dropdownSubmenuSkin"];
            this.dropdownSubmenuArrow = data["dropdownSubmenuArrow"];
        }
    }

    static fromJS(data: any): UiCustomizationMenuSettingsEditDto {
        let result = new UiCustomizationMenuSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        data["dropdownSubmenuSkin"] = this.dropdownSubmenuSkin;
        data["dropdownSubmenuArrow"] = this.dropdownSubmenuArrow;
        return data; 
    }
}

export interface IUiCustomizationMenuSettingsEditDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean | undefined;
    allowAsideMinimizing: boolean | undefined;
    defaultMinimizedAside: boolean | undefined;
    allowAsideHiding: boolean | undefined;
    defaultHiddenAside: boolean | undefined;
    submenuToggle: string | undefined;
    dropdownSubmenuSkin: string | undefined;
    dropdownSubmenuArrow: boolean | undefined;
}

export class UiCustomizationFooterSettingsEditDto implements IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean | undefined;

    constructor(data?: IUiCustomizationFooterSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    }

    static fromJS(data: any): UiCustomizationFooterSettingsEditDto {
        let result = new UiCustomizationFooterSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data; 
    }
}

export interface IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount: number | undefined;
    items: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number | undefined;
    items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserListForImportDto implements IPagedResultDtoOfUserListForImportDto {
    totalCount: number | undefined;
    items: UserListForImportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListForImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserListForImportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListForImportDto {
        let result = new PagedResultDtoOfUserListForImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListForImportDto {
    totalCount: number | undefined;
    items: UserListForImportDto[] | undefined;
}

export class UserListForImportDto implements IUserListForImportDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    nameForCredential: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean | undefined;
    pendingUpdate: boolean | undefined;
    situation: SituationListDto | undefined;
    roles: UserListRoleDto[] | undefined;
    emails: UserListEmailDto[] | undefined;
    phones: UserListPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    memberStatus: string | undefined;
    member: UserMemberEditForImportDto | undefined;
    regionalName: string | undefined;
    hasUserJson: boolean | undefined;
    memberBase: string | undefined;
    statusCpf: UserListForImportDtoStatusCpf | undefined;
    situationCpf: UserListForImportDtoSituationCpf | undefined;
    statusIntegracao: UserListForImportDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    associationDate: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IUserListForImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.nameForCredential = data["nameForCredential"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.pendingUpdate = data["pendingUpdate"];
            this.situation = data["situation"] ? SituationListDto.fromJS(data["situation"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserListRoleDto.fromJS(item));
            }
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserListEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserListPhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(UserAddressDto.fromJS(item));
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.memberStatus = data["memberStatus"];
            this.member = data["member"] ? UserMemberEditForImportDto.fromJS(data["member"]) : <any>undefined;
            this.regionalName = data["regionalName"];
            this.hasUserJson = data["hasUserJson"];
            this.memberBase = data["memberBase"];
            this.statusCpf = data["statusCpf"];
            this.situationCpf = data["situationCpf"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.nameValidSerpro = data["nameValidSerpro"];
            this.confirmedName = data["confirmedName"];
            this.associationDate = data["associationDate"] ? moment(data["associationDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListForImportDto {
        let result = new UserListForImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["nameForCredential"] = this.nameForCredential;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["pendingUpdate"] = this.pendingUpdate;
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["memberStatus"] = this.memberStatus;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["regionalName"] = this.regionalName;
        data["hasUserJson"] = this.hasUserJson;
        data["memberBase"] = this.memberBase;
        data["statusCpf"] = this.statusCpf;
        data["situationCpf"] = this.situationCpf;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["nameValidSerpro"] = this.nameValidSerpro;
        data["confirmedName"] = this.confirmedName;
        data["associationDate"] = this.associationDate ? this.associationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListForImportDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    nameForCredential: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean | undefined;
    pendingUpdate: boolean | undefined;
    situation: SituationListDto | undefined;
    roles: UserListRoleDto[] | undefined;
    emails: UserListEmailDto[] | undefined;
    phones: UserListPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    memberStatus: string | undefined;
    member: UserMemberEditForImportDto | undefined;
    regionalName: string | undefined;
    hasUserJson: boolean | undefined;
    memberBase: string | undefined;
    statusCpf: UserListForImportDtoStatusCpf | undefined;
    situationCpf: UserListForImportDtoSituationCpf | undefined;
    statusIntegracao: UserListForImportDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    associationDate: moment.Moment | undefined;
    id: number | undefined;
}

export class UserMemberEditForImportDto implements IUserMemberEditForImportDto {
    registrySBA: string | undefined;
    rg: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    speciality: string | undefined;
    correspondenceSituation: UserMemberEditForImportDtoCorrespondenceSituation | undefined;
    gender: UserMemberEditForImportDtoGender | undefined;
    bornDate: moment.Moment;
    nationalityName: string | undefined;
    graduation: MemberGraduationEditDto | undefined;
    memberStatusId: number | undefined;
    status: MemberStatusDto | undefined;
    baseId: number | undefined;
    base: BaseDto | undefined;
    isReadmited: boolean | undefined;
    isForeign: boolean | undefined;
    complementaryData: MemberComplementaryDataEditDto | undefined;
    annuities: MemberAnnuityEditDto[] | undefined;
    categories: MemberCategoryEditDto[] | undefined;

    constructor(data?: IUserMemberEditForImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registrySBA = data["registrySBA"];
            this.rg = data["rg"];
            this.crm = data["crm"];
            this.crmUf = data["crmUf"];
            this.speciality = data["speciality"];
            this.correspondenceSituation = data["correspondenceSituation"];
            this.gender = data["gender"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.nationalityName = data["nationalityName"];
            this.graduation = data["graduation"] ? MemberGraduationEditDto.fromJS(data["graduation"]) : <any>undefined;
            this.memberStatusId = data["memberStatusId"];
            this.status = data["status"] ? MemberStatusDto.fromJS(data["status"]) : <any>undefined;
            this.baseId = data["baseId"];
            this.base = data["base"] ? BaseDto.fromJS(data["base"]) : <any>undefined;
            this.isReadmited = data["isReadmited"];
            this.isForeign = data["isForeign"];
            this.complementaryData = data["complementaryData"] ? MemberComplementaryDataEditDto.fromJS(data["complementaryData"]) : <any>undefined;
            if (data["annuities"] && data["annuities"].constructor === Array) {
                this.annuities = [];
                for (let item of data["annuities"])
                    this.annuities.push(MemberAnnuityEditDto.fromJS(item));
            }
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(MemberCategoryEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMemberEditForImportDto {
        let result = new UserMemberEditForImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrySBA"] = this.registrySBA;
        data["rg"] = this.rg;
        data["crm"] = this.crm;
        data["crmUf"] = this.crmUf;
        data["speciality"] = this.speciality;
        data["correspondenceSituation"] = this.correspondenceSituation;
        data["gender"] = this.gender;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["nationalityName"] = this.nationalityName;
        data["graduation"] = this.graduation ? this.graduation.toJSON() : <any>undefined;
        data["memberStatusId"] = this.memberStatusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["baseId"] = this.baseId;
        data["base"] = this.base ? this.base.toJSON() : <any>undefined;
        data["isReadmited"] = this.isReadmited;
        data["isForeign"] = this.isForeign;
        data["complementaryData"] = this.complementaryData ? this.complementaryData.toJSON() : <any>undefined;
        if (this.annuities && this.annuities.constructor === Array) {
            data["annuities"] = [];
            for (let item of this.annuities)
                data["annuities"].push(item.toJSON());
        }
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserMemberEditForImportDto {
    registrySBA: string | undefined;
    rg: string | undefined;
    crm: string | undefined;
    crmUf: string | undefined;
    speciality: string | undefined;
    correspondenceSituation: UserMemberEditForImportDtoCorrespondenceSituation | undefined;
    gender: UserMemberEditForImportDtoGender | undefined;
    bornDate: moment.Moment;
    nationalityName: string | undefined;
    graduation: MemberGraduationEditDto | undefined;
    memberStatusId: number | undefined;
    status: MemberStatusDto | undefined;
    baseId: number | undefined;
    base: BaseDto | undefined;
    isReadmited: boolean | undefined;
    isForeign: boolean | undefined;
    complementaryData: MemberComplementaryDataEditDto | undefined;
    annuities: MemberAnnuityEditDto[] | undefined;
    categories: MemberCategoryEditDto[] | undefined;
}

export class GetUserForViewOutput implements IGetUserForViewOutput {
    profilePictureId: string | undefined;
    user: UserViewDto | undefined;
    roles: UserRoleDto[] | undefined;
    documentation: DocumentationEditDto | undefined;

    constructor(data?: IGetUserForViewOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserViewDto.fromJS(data["user"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
            this.documentation = data["documentation"] ? DocumentationEditDto.fromJS(data["documentation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserForViewOutput {
        let result = new GetUserForViewOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetUserForViewOutput {
    profilePictureId: string | undefined;
    user: UserViewDto | undefined;
    roles: UserRoleDto[] | undefined;
    documentation: DocumentationEditDto | undefined;
}

export class UserViewDto implements IUserViewDto {
    name: string | undefined;
    userName: string | undefined;
    nameForCredential: string | undefined;
    situation: SituationDto | undefined;
    member: UserMemberEditDto | undefined;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean | undefined;
    userJson: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    statusCpf: UserViewDtoStatusCpf | undefined;
    situationCpf: UserViewDtoSituationCpf | undefined;
    statusIntegracao: UserViewDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    id: number | undefined;

    constructor(data?: IUserViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.userName = data["userName"];
            this.nameForCredential = data["nameForCredential"];
            this.situation = data["situation"] ? SituationDto.fromJS(data["situation"]) : <any>undefined;
            this.member = data["member"] ? UserMemberEditDto.fromJS(data["member"]) : <any>undefined;
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [];
                for (let item of data["emails"])
                    this.emails.push(UserEmailDto.fromJS(item));
            }
            if (data["phones"] && data["phones"].constructor === Array) {
                this.phones = [];
                for (let item of data["phones"])
                    this.phones.push(UserPhoneDto.fromJS(item));
            }
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [];
                for (let item of data["addresses"])
                    this.addresses.push(UserAddressDto.fromJS(item));
            }
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isActive = data["isActive"];
            this.userJson = data["userJson"];
            this.nameValidSerpro = data["nameValidSerpro"];
            this.confirmedName = data["confirmedName"];
            this.statusCpf = data["statusCpf"];
            this.situationCpf = data["situationCpf"];
            this.statusIntegracao = data["statusIntegracao"];
            this.descricaoMensagem = data["descricaoMensagem"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserViewDto {
        let result = new UserViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["nameForCredential"] = this.nameForCredential;
        data["situation"] = this.situation ? this.situation.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (this.phones && this.phones.constructor === Array) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["userJson"] = this.userJson;
        data["nameValidSerpro"] = this.nameValidSerpro;
        data["confirmedName"] = this.confirmedName;
        data["statusCpf"] = this.statusCpf;
        data["situationCpf"] = this.situationCpf;
        data["statusIntegracao"] = this.statusIntegracao;
        data["descricaoMensagem"] = this.descricaoMensagem;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserViewDto {
    name: string | undefined;
    userName: string | undefined;
    nameForCredential: string | undefined;
    situation: SituationDto | undefined;
    member: UserMemberEditDto | undefined;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean | undefined;
    userJson: string | undefined;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    statusCpf: UserViewDtoStatusCpf | undefined;
    situationCpf: UserViewDtoSituationCpf | undefined;
    statusIntegracao: UserViewDtoStatusIntegracao | undefined;
    descricaoMensagem: string | undefined;
    id: number | undefined;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean | undefined;
    isMember: boolean | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
            this.isMember = data["isMember"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["isMember"] = this.isMember;
        return data; 
    }
}

export interface IUserRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean | undefined;
    isMember: boolean | undefined;
}

export class DocumentationEditDto implements IDocumentationEditDto {
    note: string | undefined;
    status: DocumentationEditDtoStatus | undefined;
    documents: DocumentEditDto[] | undefined;
    id: number | undefined;

    constructor(data?: IDocumentationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.note = data["note"];
            this.status = data["status"];
            if (data["documents"] && data["documents"].constructor === Array) {
                this.documents = [];
                for (let item of data["documents"])
                    this.documents.push(DocumentEditDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DocumentationEditDto {
        let result = new DocumentationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["status"] = this.status;
        if (this.documents && this.documents.constructor === Array) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IDocumentationEditDto {
    note: string | undefined;
    status: DocumentationEditDtoStatus | undefined;
    documents: DocumentEditDto[] | undefined;
    id: number | undefined;
}

export class NullableIdDtoOfInt64 implements INullableIdDtoOfInt64 {
    id: number | undefined;

    constructor(data?: INullableIdDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NullableIdDtoOfInt64 {
        let result = new NullableIdDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface INullableIdDtoOfInt64 {
    id: number | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId: string | undefined;
    documentation: DocumentationEditDto | undefined;
    user: UserEditDto | undefined;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.documentation = data["documentation"] ? DocumentationEditDto.fromJS(data["documentation"]) : <any>undefined;
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
            if (data["allOrganizationUnits"] && data["allOrganizationUnits"].constructor === Array) {
                this.allOrganizationUnits = [];
                for (let item of data["allOrganizationUnits"])
                    this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
            }
            if (data["memberedOrganizationUnits"] && data["memberedOrganizationUnits"].constructor === Array) {
                this.memberedOrganizationUnits = [];
                for (let item of data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.allOrganizationUnits && this.allOrganizationUnits.constructor === Array) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (this.memberedOrganizationUnits && this.memberedOrganizationUnits.constructor === Array) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data; 
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    documentation: DocumentationEditDto | undefined;
    user: UserEditDto | undefined;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user: UserEditDto = new UserEditDto();
    documentation: DocumentationEditDto | undefined;
    assignedRoleNames: string[] = [];
    sendActivationEmail: boolean | undefined;
    sendAdmissionEmail: boolean | undefined;
    setRandomPassword: boolean | undefined;
    organizationUnits: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            this.documentation = data["documentation"] ? DocumentationEditDto.fromJS(data["documentation"]) : <any>undefined;
            if (data["assignedRoleNames"] && data["assignedRoleNames"].constructor === Array) {
                this.assignedRoleNames = [];
                for (let item of data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.sendAdmissionEmail = data["sendAdmissionEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        if (this.assignedRoleNames && this.assignedRoleNames.constructor === Array) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["sendAdmissionEmail"] = this.sendAdmissionEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    documentation: DocumentationEditDto | undefined;
    assignedRoleNames: string[];
    sendActivationEmail: boolean | undefined;
    sendAdmissionEmail: boolean | undefined;
    setRandomPassword: boolean | undefined;
    organizationUnits: number[] | undefined;
}

export class RequestCadastralUpdateInput implements IRequestCadastralUpdateInput {
    all: boolean | undefined;
    ids: number[] | undefined;

    constructor(data?: IRequestCadastralUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.all = data["all"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
        }
    }

    static fromJS(data: any): RequestCadastralUpdateInput {
        let result = new RequestCadastralUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["all"] = this.all;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IRequestCadastralUpdateInput {
    all: boolean | undefined;
    ids: number[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id: number | undefined;
    grantedPermissionNames: string[] = [];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateUserPermissionsInput {
    id: number | undefined;
    grantedPermissionNames: string[];
}

export class CreateOrEditNoteDto implements ICreateOrEditNoteDto {
    description: string;
    userId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.userId = data["userId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNoteDto {
        let result = new CreateOrEditNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditNoteDto {
    description: string;
    userId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfMemberCategoryEditDto implements IListResultDtoOfMemberCategoryEditDto {
    items: MemberCategoryEditDto[] | undefined;

    constructor(data?: IListResultDtoOfMemberCategoryEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MemberCategoryEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMemberCategoryEditDto {
        let result = new ListResultDtoOfMemberCategoryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMemberCategoryEditDto {
    items: MemberCategoryEditDto[] | undefined;
}

export class CreateOrEditUserCategoryDto implements ICreateOrEditUserCategoryDto {
    beginDate: moment.Moment;
    endDate: moment.Moment | undefined;
    note: string | undefined;
    categoryId: number;
    category: CategoryEditDto | undefined;
    categoryLevelId: number | undefined;
    categoryLevel: CategoryLevelDto | undefined;
    userId: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditUserCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.note = data["note"];
            this.categoryId = data["categoryId"];
            this.category = data["category"] ? CategoryEditDto.fromJS(data["category"]) : <any>undefined;
            this.categoryLevelId = data["categoryLevelId"];
            this.categoryLevel = data["categoryLevel"] ? CategoryLevelDto.fromJS(data["categoryLevel"]) : <any>undefined;
            this.userId = data["userId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserCategoryDto {
        let result = new CreateOrEditUserCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["categoryLevelId"] = this.categoryLevelId;
        data["categoryLevel"] = this.categoryLevel ? this.categoryLevel.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditUserCategoryDto {
    beginDate: moment.Moment;
    endDate: moment.Moment | undefined;
    note: string | undefined;
    categoryId: number;
    category: CategoryEditDto | undefined;
    categoryLevelId: number | undefined;
    categoryLevel: CategoryLevelDto | undefined;
    userId: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ChangeUserCategoryDto implements IChangeUserCategoryDto {
    userCategoryId: number | undefined;
    userId: number | undefined;
    categoryId: number;
    note: string | undefined;
    endDate: moment.Moment;
    categoryLevelId: number | undefined;
    categoryLevel: CategoryLevelDto | undefined;

    constructor(data?: IChangeUserCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userCategoryId = data["userCategoryId"];
            this.userId = data["userId"];
            this.categoryId = data["categoryId"];
            this.note = data["note"];
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.categoryLevelId = data["categoryLevelId"];
            this.categoryLevel = data["categoryLevel"] ? CategoryLevelDto.fromJS(data["categoryLevel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeUserCategoryDto {
        let result = new ChangeUserCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCategoryId"] = this.userCategoryId;
        data["userId"] = this.userId;
        data["categoryId"] = this.categoryId;
        data["note"] = this.note;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["categoryLevelId"] = this.categoryLevelId;
        data["categoryLevel"] = this.categoryLevel ? this.categoryLevel.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IChangeUserCategoryDto {
    userCategoryId: number | undefined;
    userId: number | undefined;
    categoryId: number;
    note: string | undefined;
    endDate: moment.Moment;
    categoryLevelId: number | undefined;
    categoryLevel: CategoryLevelDto | undefined;
}

export class ListResultDtoOfMemberStatusDto implements IListResultDtoOfMemberStatusDto {
    items: MemberStatusDto[] | undefined;

    constructor(data?: IListResultDtoOfMemberStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MemberStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMemberStatusDto {
        let result = new ListResultDtoOfMemberStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMemberStatusDto {
    items: MemberStatusDto[] | undefined;
}

export class ListResultDtoOfBaseDto implements IListResultDtoOfBaseDto {
    items: BaseDto[] | undefined;

    constructor(data?: IListResultDtoOfBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(BaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfBaseDto {
        let result = new ListResultDtoOfBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfBaseDto {
    items: BaseDto[] | undefined;
}

export class UpdateMemberStatusInput implements IUpdateMemberStatusInput {
    userId: number | undefined;
    statusId: number | undefined;

    constructor(data?: IUpdateMemberStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.statusId = data["statusId"];
        }
    }

    static fromJS(data: any): UpdateMemberStatusInput {
        let result = new UpdateMemberStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["statusId"] = this.statusId;
        return data; 
    }
}

export interface IUpdateMemberStatusInput {
    userId: number | undefined;
    statusId: number | undefined;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount: number | undefined;
    items: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number | undefined;
    items: LinkedUserDto[] | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    id: number | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number | undefined;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number | undefined;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment | undefined;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["latestWebLogLines"] && data["latestWebLogLines"].constructor === Array) {
                this.latestWebLogLines = [];
                for (let item of data["latestWebLogLines"])
                    this.latestWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.latestWebLogLines && this.latestWebLogLines.constructor === Array) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data; 
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class PagedResultDtoOfGetWorkForViewDto implements IPagedResultDtoOfGetWorkForViewDto {
    totalCount: number | undefined;
    items: GetWorkForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetWorkForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWorkForViewDto {
        let result = new PagedResultDtoOfGetWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetWorkForViewDto {
    totalCount: number | undefined;
    items: GetWorkForViewDto[] | undefined;
}

export class GetWorkForViewDto implements IGetWorkForViewDto {
    specialityDescription: string | undefined;
    subspecialityDescription: string | undefined;
    eventDescription: string | undefined;
    hasWorkCertificate: boolean | undefined;
    institutionWorkDescription: string | undefined;
    evaluatorName: string | undefined;
    evaluatedResumo: boolean | undefined;
    notesResumo: string | undefined;
    publishWork: boolean | undefined;
    isAuthor: boolean | undefined;
    deleterUserName: string | undefined;
    viewFile: string | undefined;
    work: WorkDto | undefined;
    author: AuthorDto | undefined;
    presenter: AuthorDto | undefined;
    evaluator: EvaluatorDto | undefined;
    authors: AuthorDto[] | undefined;

    constructor(data?: IGetWorkForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.specialityDescription = data["specialityDescription"];
            this.subspecialityDescription = data["subspecialityDescription"];
            this.eventDescription = data["eventDescription"];
            this.hasWorkCertificate = data["hasWorkCertificate"];
            this.institutionWorkDescription = data["institutionWorkDescription"];
            this.evaluatorName = data["evaluatorName"];
            this.evaluatedResumo = data["evaluatedResumo"];
            this.notesResumo = data["notesResumo"];
            this.publishWork = data["publishWork"];
            this.isAuthor = data["isAuthor"];
            this.deleterUserName = data["deleterUserName"];
            this.viewFile = data["viewFile"];
            this.work = data["work"] ? WorkDto.fromJS(data["work"]) : <any>undefined;
            this.author = data["author"] ? AuthorDto.fromJS(data["author"]) : <any>undefined;
            this.presenter = data["presenter"] ? AuthorDto.fromJS(data["presenter"]) : <any>undefined;
            this.evaluator = data["evaluator"] ? EvaluatorDto.fromJS(data["evaluator"]) : <any>undefined;
            if (data["authors"] && data["authors"].constructor === Array) {
                this.authors = [];
                for (let item of data["authors"])
                    this.authors.push(AuthorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorkForViewDto {
        let result = new GetWorkForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialityDescription"] = this.specialityDescription;
        data["subspecialityDescription"] = this.subspecialityDescription;
        data["eventDescription"] = this.eventDescription;
        data["hasWorkCertificate"] = this.hasWorkCertificate;
        data["institutionWorkDescription"] = this.institutionWorkDescription;
        data["evaluatorName"] = this.evaluatorName;
        data["evaluatedResumo"] = this.evaluatedResumo;
        data["notesResumo"] = this.notesResumo;
        data["publishWork"] = this.publishWork;
        data["isAuthor"] = this.isAuthor;
        data["deleterUserName"] = this.deleterUserName;
        data["viewFile"] = this.viewFile;
        data["work"] = this.work ? this.work.toJSON() : <any>undefined;
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        data["presenter"] = this.presenter ? this.presenter.toJSON() : <any>undefined;
        data["evaluator"] = this.evaluator ? this.evaluator.toJSON() : <any>undefined;
        if (this.authors && this.authors.constructor === Array) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetWorkForViewDto {
    specialityDescription: string | undefined;
    subspecialityDescription: string | undefined;
    eventDescription: string | undefined;
    hasWorkCertificate: boolean | undefined;
    institutionWorkDescription: string | undefined;
    evaluatorName: string | undefined;
    evaluatedResumo: boolean | undefined;
    notesResumo: string | undefined;
    publishWork: boolean | undefined;
    isAuthor: boolean | undefined;
    deleterUserName: string | undefined;
    viewFile: string | undefined;
    work: WorkDto | undefined;
    author: AuthorDto | undefined;
    presenter: AuthorDto | undefined;
    evaluator: EvaluatorDto | undefined;
    authors: AuthorDto[] | undefined;
}

export class GetWorkForEditOutput implements IGetWorkForEditOutput {
    work: CreateOrEditWorkDto | undefined;
    deleterUser: UserSelectListDto | undefined;
    viewFile: string | undefined;
    isAuthor: boolean | undefined;

    constructor(data?: IGetWorkForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.work = data["work"] ? CreateOrEditWorkDto.fromJS(data["work"]) : <any>undefined;
            this.deleterUser = data["deleterUser"] ? UserSelectListDto.fromJS(data["deleterUser"]) : <any>undefined;
            this.viewFile = data["viewFile"];
            this.isAuthor = data["isAuthor"];
        }
    }

    static fromJS(data: any): GetWorkForEditOutput {
        let result = new GetWorkForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["work"] = this.work ? this.work.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["viewFile"] = this.viewFile;
        data["isAuthor"] = this.isAuthor;
        return data; 
    }
}

export interface IGetWorkForEditOutput {
    work: CreateOrEditWorkDto | undefined;
    deleterUser: UserSelectListDto | undefined;
    viewFile: string | undefined;
    isAuthor: boolean | undefined;
}

export class CreateOrEditWorkDto implements ICreateOrEditWorkDto {
    title: string;
    resume: string;
    motiveDeleted: string | undefined;
    figure: string | undefined;
    conflictOfInterests: string | undefined;
    sourceOfFunding: string | undefined;
    workFigureInput: UpdateWorkImageInput | undefined;
    deletionTime: moment.Moment | undefined;
    type: CreateOrEditWorkDtoType | undefined;
    status: CreateOrEditWorkDtoStatus | undefined;
    solicitedPresentationType: CreateOrEditWorkDtoSolicitedPresentationType | undefined;
    resumeGrade: number | undefined;
    presentationGrade: number | undefined;
    finalGrade: number | undefined;
    presentationEvaluationEnabled: boolean | undefined;
    institutionWorkId: number | undefined;
    specialityId: number | undefined;
    subspecialityId: number | undefined;
    eventWorkId: number | undefined;
    institutionWork: InstitutionWorkDto | undefined;
    authors: AuthorDto[] | undefined;
    approvals: CreateOrEditWorkApprovalDto[] | undefined;
    keyWords: KeyWordDto[] | undefined;
    references: ReferenceDto[] | undefined;
    resumeEvaluations: WorkResumeEvaluationDto[] | undefined;
    presentationEvaluations: WorkPresentationEvaluationDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.resume = data["resume"];
            this.motiveDeleted = data["motiveDeleted"];
            this.figure = data["figure"];
            this.conflictOfInterests = data["conflictOfInterests"];
            this.sourceOfFunding = data["sourceOfFunding"];
            this.workFigureInput = data["workFigureInput"] ? UpdateWorkImageInput.fromJS(data["workFigureInput"]) : <any>undefined;
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.type = data["type"];
            this.status = data["status"];
            this.solicitedPresentationType = data["solicitedPresentationType"];
            this.resumeGrade = data["resumeGrade"];
            this.presentationGrade = data["presentationGrade"];
            this.finalGrade = data["finalGrade"];
            this.presentationEvaluationEnabled = data["presentationEvaluationEnabled"];
            this.institutionWorkId = data["institutionWorkId"];
            this.specialityId = data["specialityId"];
            this.subspecialityId = data["subspecialityId"];
            this.eventWorkId = data["eventWorkId"];
            this.institutionWork = data["institutionWork"] ? InstitutionWorkDto.fromJS(data["institutionWork"]) : <any>undefined;
            if (data["authors"] && data["authors"].constructor === Array) {
                this.authors = [];
                for (let item of data["authors"])
                    this.authors.push(AuthorDto.fromJS(item));
            }
            if (data["approvals"] && data["approvals"].constructor === Array) {
                this.approvals = [];
                for (let item of data["approvals"])
                    this.approvals.push(CreateOrEditWorkApprovalDto.fromJS(item));
            }
            if (data["keyWords"] && data["keyWords"].constructor === Array) {
                this.keyWords = [];
                for (let item of data["keyWords"])
                    this.keyWords.push(KeyWordDto.fromJS(item));
            }
            if (data["references"] && data["references"].constructor === Array) {
                this.references = [];
                for (let item of data["references"])
                    this.references.push(ReferenceDto.fromJS(item));
            }
            if (data["resumeEvaluations"] && data["resumeEvaluations"].constructor === Array) {
                this.resumeEvaluations = [];
                for (let item of data["resumeEvaluations"])
                    this.resumeEvaluations.push(WorkResumeEvaluationDto.fromJS(item));
            }
            if (data["presentationEvaluations"] && data["presentationEvaluations"].constructor === Array) {
                this.presentationEvaluations = [];
                for (let item of data["presentationEvaluations"])
                    this.presentationEvaluations.push(WorkPresentationEvaluationDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditWorkDto {
        let result = new CreateOrEditWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["resume"] = this.resume;
        data["motiveDeleted"] = this.motiveDeleted;
        data["figure"] = this.figure;
        data["conflictOfInterests"] = this.conflictOfInterests;
        data["sourceOfFunding"] = this.sourceOfFunding;
        data["workFigureInput"] = this.workFigureInput ? this.workFigureInput.toJSON() : <any>undefined;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["status"] = this.status;
        data["solicitedPresentationType"] = this.solicitedPresentationType;
        data["resumeGrade"] = this.resumeGrade;
        data["presentationGrade"] = this.presentationGrade;
        data["finalGrade"] = this.finalGrade;
        data["presentationEvaluationEnabled"] = this.presentationEvaluationEnabled;
        data["institutionWorkId"] = this.institutionWorkId;
        data["specialityId"] = this.specialityId;
        data["subspecialityId"] = this.subspecialityId;
        data["eventWorkId"] = this.eventWorkId;
        data["institutionWork"] = this.institutionWork ? this.institutionWork.toJSON() : <any>undefined;
        if (this.authors && this.authors.constructor === Array) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        if (this.approvals && this.approvals.constructor === Array) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (this.keyWords && this.keyWords.constructor === Array) {
            data["keyWords"] = [];
            for (let item of this.keyWords)
                data["keyWords"].push(item.toJSON());
        }
        if (this.references && this.references.constructor === Array) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        if (this.resumeEvaluations && this.resumeEvaluations.constructor === Array) {
            data["resumeEvaluations"] = [];
            for (let item of this.resumeEvaluations)
                data["resumeEvaluations"].push(item.toJSON());
        }
        if (this.presentationEvaluations && this.presentationEvaluations.constructor === Array) {
            data["presentationEvaluations"] = [];
            for (let item of this.presentationEvaluations)
                data["presentationEvaluations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditWorkDto {
    title: string;
    resume: string;
    motiveDeleted: string | undefined;
    figure: string | undefined;
    conflictOfInterests: string | undefined;
    sourceOfFunding: string | undefined;
    workFigureInput: UpdateWorkImageInput | undefined;
    deletionTime: moment.Moment | undefined;
    type: CreateOrEditWorkDtoType | undefined;
    status: CreateOrEditWorkDtoStatus | undefined;
    solicitedPresentationType: CreateOrEditWorkDtoSolicitedPresentationType | undefined;
    resumeGrade: number | undefined;
    presentationGrade: number | undefined;
    finalGrade: number | undefined;
    presentationEvaluationEnabled: boolean | undefined;
    institutionWorkId: number | undefined;
    specialityId: number | undefined;
    subspecialityId: number | undefined;
    eventWorkId: number | undefined;
    institutionWork: InstitutionWorkDto | undefined;
    authors: AuthorDto[] | undefined;
    approvals: CreateOrEditWorkApprovalDto[] | undefined;
    keyWords: KeyWordDto[] | undefined;
    references: ReferenceDto[] | undefined;
    resumeEvaluations: WorkResumeEvaluationDto[] | undefined;
    presentationEvaluations: WorkPresentationEvaluationDto[] | undefined;
    id: number | undefined;
}

export class UpdateWorkImageInput implements IUpdateWorkImageInput {
    workId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IUpdateWorkImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workId = data["workId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateWorkImageInput {
        let result = new UpdateWorkImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateWorkImageInput {
    workId: number | undefined;
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class CreateOrEditWorkApprovalDto implements ICreateOrEditWorkApprovalDto {
    typeId: number | undefined;
    type: WorkApprovalTypeDto | undefined;
    approved: CreateOrEditWorkApprovalDtoApproved | undefined;
    file: string | undefined;
    inputFile: UploadFileWorkDto | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrEditWorkApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeId = data["typeId"];
            this.type = data["type"] ? WorkApprovalTypeDto.fromJS(data["type"]) : <any>undefined;
            this.approved = data["approved"];
            this.file = data["file"];
            this.inputFile = data["inputFile"] ? UploadFileWorkDto.fromJS(data["inputFile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditWorkApprovalDto {
        let result = new CreateOrEditWorkApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["approved"] = this.approved;
        data["file"] = this.file;
        data["inputFile"] = this.inputFile ? this.inputFile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditWorkApprovalDto {
    typeId: number | undefined;
    type: WorkApprovalTypeDto | undefined;
    approved: CreateOrEditWorkApprovalDtoApproved | undefined;
    file: string | undefined;
    inputFile: UploadFileWorkDto | undefined;
    id: number | undefined;
}

export class UploadFileWorkDto implements IUploadFileWorkDto {
    workId: number | undefined;
    approvalId: number | undefined;
    fileName: string | undefined;
    input: UpdateModelFileInput | undefined;

    constructor(data?: IUploadFileWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workId = data["workId"];
            this.approvalId = data["approvalId"];
            this.fileName = data["fileName"];
            this.input = data["input"] ? UpdateModelFileInput.fromJS(data["input"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadFileWorkDto {
        let result = new UploadFileWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["approvalId"] = this.approvalId;
        data["fileName"] = this.fileName;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUploadFileWorkDto {
    workId: number | undefined;
    approvalId: number | undefined;
    fileName: string | undefined;
    input: UpdateModelFileInput | undefined;
}

export class CheckWorksPresenterInput implements ICheckWorksPresenterInput {
    eventWorkId: number | undefined;
    userId: number | undefined;
    workId: number | undefined;

    constructor(data?: ICheckWorksPresenterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventWorkId = data["eventWorkId"];
            this.userId = data["userId"];
            this.workId = data["workId"];
        }
    }

    static fromJS(data: any): CheckWorksPresenterInput {
        let result = new CheckWorksPresenterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventWorkId"] = this.eventWorkId;
        data["userId"] = this.userId;
        data["workId"] = this.workId;
        return data; 
    }
}

export interface ICheckWorksPresenterInput {
    eventWorkId: number | undefined;
    userId: number | undefined;
    workId: number | undefined;
}

export class UpdateWorkEvaluatorsInput implements IUpdateWorkEvaluatorsInput {
    workId: number | undefined;
    resumeEvaluations: WorkResumeEvaluationDto[] | undefined;

    constructor(data?: IUpdateWorkEvaluatorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workId = data["workId"];
            if (data["resumeEvaluations"] && data["resumeEvaluations"].constructor === Array) {
                this.resumeEvaluations = [];
                for (let item of data["resumeEvaluations"])
                    this.resumeEvaluations.push(WorkResumeEvaluationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateWorkEvaluatorsInput {
        let result = new UpdateWorkEvaluatorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        if (this.resumeEvaluations && this.resumeEvaluations.constructor === Array) {
            data["resumeEvaluations"] = [];
            for (let item of this.resumeEvaluations)
                data["resumeEvaluations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateWorkEvaluatorsInput {
    workId: number | undefined;
    resumeEvaluations: WorkResumeEvaluationDto[] | undefined;
}

export class UpdateWorkEvaluationInput implements IUpdateWorkEvaluationInput {
    workId: number | undefined;
    status: number | undefined;

    constructor(data?: IUpdateWorkEvaluationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workId = data["workId"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): UpdateWorkEvaluationInput {
        let result = new UpdateWorkEvaluationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUpdateWorkEvaluationInput {
    workId: number | undefined;
    status: number | undefined;
}

export class ListResultDtoOfWorkDto implements IListResultDtoOfWorkDto {
    items: WorkDto[] | undefined;

    constructor(data?: IListResultDtoOfWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(WorkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfWorkDto {
        let result = new ListResultDtoOfWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfWorkDto {
    items: WorkDto[] | undefined;
}

export class PagedResultDtoOfEPosterWorkDto implements IPagedResultDtoOfEPosterWorkDto {
    totalCount: number | undefined;
    items: EPosterWorkDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEPosterWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EPosterWorkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEPosterWorkDto {
        let result = new PagedResultDtoOfEPosterWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEPosterWorkDto {
    totalCount: number | undefined;
    items: EPosterWorkDto[] | undefined;
}

export class EPosterWorkDto implements IEPosterWorkDto {
    id: number | undefined;
    title: string | undefined;
    viewFile: string | undefined;
    type: EPosterWorkDtoType | undefined;
    specialityDescription: string | undefined;
    subspecialityDescription: string | undefined;
    authors: EPosterAuthorDto[] | undefined;

    constructor(data?: IEPosterWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.viewFile = data["viewFile"];
            this.type = data["type"];
            this.specialityDescription = data["specialityDescription"];
            this.subspecialityDescription = data["subspecialityDescription"];
            if (data["authors"] && data["authors"].constructor === Array) {
                this.authors = [];
                for (let item of data["authors"])
                    this.authors.push(EPosterAuthorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EPosterWorkDto {
        let result = new EPosterWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["viewFile"] = this.viewFile;
        data["type"] = this.type;
        data["specialityDescription"] = this.specialityDescription;
        data["subspecialityDescription"] = this.subspecialityDescription;
        if (this.authors && this.authors.constructor === Array) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEPosterWorkDto {
    id: number | undefined;
    title: string | undefined;
    viewFile: string | undefined;
    type: EPosterWorkDtoType | undefined;
    specialityDescription: string | undefined;
    subspecialityDescription: string | undefined;
    authors: EPosterAuthorDto[] | undefined;
}

export class EPosterAuthorDto implements IEPosterAuthorDto {
    id: number | undefined;
    isCoauthor: boolean | undefined;
    nameUser: string | undefined;

    constructor(data?: IEPosterAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isCoauthor = data["isCoauthor"];
            this.nameUser = data["nameUser"];
        }
    }

    static fromJS(data: any): EPosterAuthorDto {
        let result = new EPosterAuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCoauthor"] = this.isCoauthor;
        data["nameUser"] = this.nameUser;
        return data; 
    }
}

export interface IEPosterAuthorDto {
    id: number | undefined;
    isCoauthor: boolean | undefined;
    nameUser: string | undefined;
}

export class EnabledPresentationEvaluationWorkDto implements IEnabledPresentationEvaluationWorkDto {
    workId: number | undefined;
    enabled: boolean | undefined;

    constructor(data?: IEnabledPresentationEvaluationWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workId = data["workId"];
            this.enabled = data["enabled"];
        }
    }

    static fromJS(data: any): EnabledPresentationEvaluationWorkDto {
        let result = new EnabledPresentationEvaluationWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["enabled"] = this.enabled;
        return data; 
    }
}

export interface IEnabledPresentationEvaluationWorkDto {
    workId: number | undefined;
    enabled: boolean | undefined;
}

export enum Status {
    _0 = 0, 
    _1 = 1, 
}

export enum Status2 {
    _0 = 0, 
    _1 = 1, 
}

export enum StatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum StatusIntegracao2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FilterType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Status3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Status4 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FilterType2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FilterType3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Type {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum StatusIntegracao3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Type2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum StatusIntegracao4 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum StatusIntegracao5 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum InvitationStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum InvitationStatus2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum IncomeStatisticsDateInterval {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum IncomeStatisticsDateInterval2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum Status5 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CashFlowStatisticsDateInterval {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CashFlowStatisticsDateInterval2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum PaymentStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DocumentationStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum Gender {
    _0 = 0, 
    _1 = 1, 
}

export enum StatusIntegracao6 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentStatus2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentStatus3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DocumentationStatus2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum Gender2 {
    _0 = 0, 
    _1 = 1, 
}

export enum StatusIntegracao7 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum State {
    _0 = 0, 
    _1 = 1, 
}

export enum Status6 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum StatusIntegracao8 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Status7 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Status8 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum StatusIntegracao9 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Status9 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum StatusIntegracao10 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Status10 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum StatusIntegracao11 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Type3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum Status11 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Type4 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum Status12 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum EnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum EnvironmentType2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentStatus4 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Situation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum StatusIntegracao12 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentStatus5 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Situation2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum StatusIntegracao13 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentStatus6 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Situation3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum StatusIntegracao14 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentStatus7 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Situation4 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum StatusIntegracao15 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Type5 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum Situation5 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum PaymentStatus8 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Type6 {
    _0 = 0, 
    _1 = 1, 
}

export enum Category {
    _0 = 0, 
    _1 = 1, 
}

export enum SalesSummaryDatePeriod {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum SalesSummaryDatePeriod2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum DefaultTimezoneScope {
    _1 = 1, 
    _2 = 2, 
    _4 = 4, 
    _7 = 7, 
}

export enum CorrespondenceSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum DocumentationStatus3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StatusCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum SituationCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum StatusIntegracao16 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CorrespondenceSituation2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum DocumentationStatus4 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StatusCpf2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum SituationCpf2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum StatusIntegracao17 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CorrespondenceSituation3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum DocumentationStatus5 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StatusCpf3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum SituationCpf3 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum StatusIntegracao18 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum Type7 {
    _0 = 0, 
    _1 = 1, 
}

export enum Type8 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum IsTenantAvailableOutputState {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum TopicDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum InvitationActivityDtoApproved {
    _0 = 0, 
    _1 = 1, 
}

export enum GuestAddressDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum GuestPhoneDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum CreateOrEditTopicDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum WorkDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum WorkDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum WorkDtoSolicitedPresentationType {
    _0 = 0, 
}

export enum AuthorDtoCategory {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum WorkApprovalDtoApproved {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditSurveyAnswerWorkDtoAnswerWork {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum AnnuityDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentMethodEditDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CostCenterListDtoFilterType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditAnnuityDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DocumentationDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum GetCertificatePreviewInputType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum EventAddressDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum CertificateConfigTextDtoCertificateType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum FriendDtoState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoSide {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReceiverReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum CnabDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditCnabDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CostCenterDtoFilterType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CostCenterPaymentChargeListDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CostCenterWithLevelDtoFilterType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateCostCenterInputFilterType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentChargeDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserListDtoStatusCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserListDtoSituationCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum UserListDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum EnterpriseListDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum UserListPhoneDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum UserAddressDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum UserMemberEditDtoCorrespondenceSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum UserMemberEditDtoGender {
    _0 = 0, 
    _1 = 1, 
}

export enum EnterprisePhoneDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum MemberComplementaryDataItemEditDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum UpdateCostCenterInputFilterType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FindCostCenterPaymentChargesInputStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CouponResponsibleDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum RegistrationDtoSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum RegistrationDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RegistrationDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum NoteEditDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CouponResponsibleSelectListDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum EnterpriseDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum EnterpriseDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum SituationDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum EnterpriseAddressDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum UpdateEnterpriseInputType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum UpdateEnterpriseInputStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ContactPhoneDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum CreateEnterpriseInputType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum GetEvaluatorForViewDtoInvitationWorkStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum InstitutionWorkDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum EventDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum EventRegistrationListDtoSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum EventRegistrationListDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditEventDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RegistrationToTransferDtoSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum RegistrationToTransferDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RegistrationToTransferDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum GetGuestForViewDtoInvitationStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum ReceivableListDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum GetCertificateInputType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum InvitationDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum InvitationWorkDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum InvitationWorkResponseDtoApproved {
    _0 = 0, 
    _1 = 1, 
}

export enum MemberAnnuityDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum MemberAnnuityDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PayableDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum PayableDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditInstitutionWorkDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditInvitationDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum CreateOrEditInvitationWorkDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum MemberAnnuityListDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserPhoneDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum UserNotificationState {
    _0 = 0, 
    _1 = 1, 
}

export enum TenantNotificationSeverity {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum OrderDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum OrderDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum MemberAnnuityOrderItemDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum MemberAnnuityOrderItemDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RegistrationOrderItemDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RegistrationOrderItemDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ReceivableDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ReceivableDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export class AdditionalData implements IAdditionalData {
    paypal: { [key: string] : string; } | undefined;

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (let key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        return data; 
    }
}

export interface IAdditionalData {
    paypal: { [key: string] : string; } | undefined;
}

export enum CreatePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreatePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum CreatePaymentDtoSubscriptionPaymentGatewayType {
    _1 = 1, 
}

export enum ExecutePaymentDtoGateway {
    _1 = 1, 
}

export enum ExecutePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum ExecutePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum CreateOrEditReceivableDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditReceivableDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditPayableDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum CreateOrEditPayableDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum TicketPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreditCardPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DebitCardPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DepositPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum MoneyPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CheckPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum BankTransferPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CouponPaymentMethodDtoEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PaymentMethodEnvironmentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RegionalPhoneDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum RegionalAddressDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum UserRegistrationListDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserRegistrationListDtoSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum RegistrationEventDtoSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum UserEditDtoStatusCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserEditDtoSituationCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum UserEditDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CancelRegistrationInputSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum QuestionTabulationOutputType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum ReceiptsPaymentChargeDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum TenantLoginInfoDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum CreateOrEditSituationDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum SurveyDtoCategory {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum QuestionDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum CreateOrEditSurveyDtoCategory {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateOrEditQuestionDtoType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum SurveyWorkDtoCategory {
    _0 = 0, 
    _1 = 1, 
}

export enum CreateOrEditSurveyWorkDtoCategory {
    _0 = 0, 
    _1 = 1, 
}

export enum CreateOrEditQuestionWorkDtoType {
    _0 = 0, 
}

export enum RegisterTenantInputSubscriptionStartType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RegisterTenantInputGateway {
    _1 = 1, 
}

export enum UserListForImportDtoStatusCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserListForImportDtoSituationCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum UserListForImportDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserMemberEditForImportDtoCorrespondenceSituation {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum UserMemberEditForImportDtoGender {
    _0 = 0, 
    _1 = 1, 
}

export enum UserViewDtoStatusCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserViewDtoSituationCpf {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum UserViewDtoStatusIntegracao {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DocumentationEditDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreateOrEditWorkDtoType {
    _0 = 0, 
    _1 = 1, 
}

export enum CreateOrEditWorkDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum CreateOrEditWorkDtoSolicitedPresentationType {
    _0 = 0, 
}

export enum CreateOrEditWorkApprovalDtoApproved {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum EPosterWorkDtoType {
    _0 = 0, 
    _1 = 1, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = function() { 
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob); 
        }
    });
}


// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxies.ts